/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type { paths } from "../schema";
import type { DeepReadonly, InvalidateQueryFilters, MutationFiltersByMutationKey, MutationFiltersByParameters, MutationVariables, OperationError, OperationInfiniteData, PartialParameters, QueryFiltersByParameters, QueryFiltersByQueryKey, QueryFnOptionsByParameters, QueryFnOptionsByQueryKey, RequestFnResponse, ServiceOperationEnsureInfiniteQueryDataOptions, ServiceOperationEnsureQueryDataOptions, ServiceOperationFetchInfiniteQueryOptions, ServiceOperationFetchQueryOptions, ServiceOperationInfiniteQueryKey, ServiceOperationMutationFnOptions, ServiceOperationMutationKey, ServiceOperationQueryKey, ServiceOperationUseMutationOptions, UseQueryOptionsForUseQueries, UseQueryOptionsForUseSuspenseQuery, WithOptional, QraftServiceOperationsToken } from "@openapi-qraft/tanstack-query-react-types";
import type { CancelOptions, DefinedInitialDataInfiniteOptions, DefinedInitialDataOptions, DefinedUseInfiniteQueryResult, DefinedUseQueryResult, InfiniteQueryPageParamsOptions, InvalidateOptions, Mutation, MutationCache, MutationState, NoInfer, QueryState, RefetchOptions, ResetOptions, SetDataOptions, UndefinedInitialDataInfiniteOptions, UndefinedInitialDataOptions, Updater, UseInfiniteQueryResult, UseMutationResult, UseQueryResult, UseSuspenseInfiniteQueryOptions, UseSuspenseInfiniteQueryResult, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";
export interface FullappApiService {
    /**
     * @summary Admin Forced
     * @description Admin/dev impersonation login: return a target user's auth token + profile.
     *
     * The target is restricted to the student/study-helper groups. The token is
     * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
     * gate guarded non-local envs only and the app never sends a passcode, so this
     * is treated as the dev/local-bypass path.
     */
    adminForcedFullappApiAuthAdminForcedPost: {
        /**
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostParameters, TMeta, TSignal>, client?: (schema: AdminForcedFullappApiAuthAdminForcedPostSchema, options: ServiceOperationMutationFnOptions<AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostError>>): Promise<RequestFnResponse<AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostError>>;
        /**
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         */
        getMutationKey(parameters: DeepReadonly<AdminForcedFullappApiAuthAdminForcedPostParameters> | void): ServiceOperationMutationKey<AdminForcedFullappApiAuthAdminForcedPostSchema, AdminForcedFullappApiAuthAdminForcedPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.adminForcedFullappApiAuthAdminForcedPost.useMutation({
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.adminForcedFullappApiAuthAdminForcedPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminForcedFullappApiAuthAdminForcedPostBody, TContext = unknown>(parameters: DeepReadonly<AdminForcedFullappApiAuthAdminForcedPostParameters>, options?: ServiceOperationUseMutationOptions<AdminForcedFullappApiAuthAdminForcedPostSchema, AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostParameters, TVariables, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, TContext>): UseMutationResult<AdminForcedFullappApiAuthAdminForcedPostData, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.adminForcedFullappApiAuthAdminForcedPost.useMutation({
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.adminForcedFullappApiAuthAdminForcedPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminForcedFullappApiAuthAdminForcedPostSchema, AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostParameters, TVariables, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, TContext>): UseMutationResult<AdminForcedFullappApiAuthAdminForcedPostData, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminForcedFullappApiAuthAdminForcedPostTotal = qraft.fullappApiService.adminForcedFullappApiAuthAdminForcedPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminForcedFullappApiAuthAdminForcedPostTotal = qraft.fullappApiService.adminForcedFullappApiAuthAdminForcedPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-device-token": xWbsDeviceToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostParameters, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, TContext> | MutationFiltersByMutationKey<AdminForcedFullappApiAuthAdminForcedPostSchema, AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostParameters, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminForcedFullappApiAuthAdminForcedPostPendingMutationVariables = qraft.fullappApiService.adminForcedFullappApiAuthAdminForcedPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminForcedFullappApiAuthAdminForcedPostMutationData = qraft.fullappApiService.adminForcedFullappApiAuthAdminForcedPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-device-token": xWbsDeviceToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminForcedFullappApiAuthAdminForcedPostData, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, MutationVariables<AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostParameters, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, TContext> | MutationFiltersByMutationKey<AdminForcedFullappApiAuthAdminForcedPostSchema, AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostParameters, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, TContext>;
            select?: (mutation: Mutation<AdminForcedFullappApiAuthAdminForcedPostData, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, MutationVariables<AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostParameters, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, TContext> | MutationFiltersByMutationKey<AdminForcedFullappApiAuthAdminForcedPostSchema, AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostParameters, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.adminForcedFullappApiAuthAdminForcedPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-device-token": xWbsDeviceToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.adminForcedFullappApiAuthAdminForcedPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostParameters, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, TContext> | MutationFiltersByMutationKey<AdminForcedFullappApiAuthAdminForcedPostSchema, AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostParameters, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, TContext>): Mutation<AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostError, MutationVariables<AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostParameters, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, TContext> | MutationFiltersByMutationKey<AdminForcedFullappApiAuthAdminForcedPostSchema, AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostParameters, OperationError<AdminForcedFullappApiAuthAdminForcedPostError>, TContext>): Array<Mutation<AdminForcedFullappApiAuthAdminForcedPostData, AdminForcedFullappApiAuthAdminForcedPostError, MutationVariables<AdminForcedFullappApiAuthAdminForcedPostBody, AdminForcedFullappApiAuthAdminForcedPostParameters>, TContext>>;
        };
        schema: AdminForcedFullappApiAuthAdminForcedPostSchema;
        types: {
            parameters: AdminForcedFullappApiAuthAdminForcedPostParameters;
            data: AdminForcedFullappApiAuthAdminForcedPostData;
            error: AdminForcedFullappApiAuthAdminForcedPostError;
            body: AdminForcedFullappApiAuthAdminForcedPostBody;
        };
    };
    /**
     * @summary Forget Password
     * @description Request a password reset (pre-auth, device-verified only).
     *
     * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
     * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
     * so this endpoint builds the envelope directly via ``JSONResponse``.
     */
    forgetPasswordFullappApiAuthForgetPasswordPost: {
        /**
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostParameters, TMeta, TSignal>, client?: (schema: ForgetPasswordFullappApiAuthForgetPasswordPostSchema, options: ServiceOperationMutationFnOptions<ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostError>>): Promise<RequestFnResponse<ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostError>>;
        /**
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         */
        getMutationKey(parameters: DeepReadonly<ForgetPasswordFullappApiAuthForgetPasswordPostParameters> | void): ServiceOperationMutationKey<ForgetPasswordFullappApiAuthForgetPasswordPostSchema, ForgetPasswordFullappApiAuthForgetPasswordPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.forgetPasswordFullappApiAuthForgetPasswordPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.forgetPasswordFullappApiAuthForgetPasswordPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ForgetPasswordFullappApiAuthForgetPasswordPostBody, TContext = unknown>(parameters: DeepReadonly<ForgetPasswordFullappApiAuthForgetPasswordPostParameters>, options?: ServiceOperationUseMutationOptions<ForgetPasswordFullappApiAuthForgetPasswordPostSchema, ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostParameters, TVariables, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, TContext>): UseMutationResult<ForgetPasswordFullappApiAuthForgetPasswordPostData, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.forgetPasswordFullappApiAuthForgetPasswordPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.forgetPasswordFullappApiAuthForgetPasswordPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ForgetPasswordFullappApiAuthForgetPasswordPostSchema, ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostParameters, TVariables, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, TContext>): UseMutationResult<ForgetPasswordFullappApiAuthForgetPasswordPostData, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const forgetPasswordFullappApiAuthForgetPasswordPostTotal = qraft.fullappApiService.forgetPasswordFullappApiAuthForgetPasswordPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const forgetPasswordFullappApiAuthForgetPasswordPostTotal = qraft.fullappApiService.forgetPasswordFullappApiAuthForgetPasswordPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, TContext> | MutationFiltersByMutationKey<ForgetPasswordFullappApiAuthForgetPasswordPostSchema, ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const forgetPasswordFullappApiAuthForgetPasswordPostPendingMutationVariables = qraft.fullappApiService.forgetPasswordFullappApiAuthForgetPasswordPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const forgetPasswordFullappApiAuthForgetPasswordPostMutationData = qraft.fullappApiService.forgetPasswordFullappApiAuthForgetPasswordPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ForgetPasswordFullappApiAuthForgetPasswordPostData, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, MutationVariables<ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, TContext> | MutationFiltersByMutationKey<ForgetPasswordFullappApiAuthForgetPasswordPostSchema, ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, TContext>;
            select?: (mutation: Mutation<ForgetPasswordFullappApiAuthForgetPasswordPostData, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, MutationVariables<ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, TContext> | MutationFiltersByMutationKey<ForgetPasswordFullappApiAuthForgetPasswordPostSchema, ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.forgetPasswordFullappApiAuthForgetPasswordPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.forgetPasswordFullappApiAuthForgetPasswordPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, TContext> | MutationFiltersByMutationKey<ForgetPasswordFullappApiAuthForgetPasswordPostSchema, ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, TContext>): Mutation<ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostError, MutationVariables<ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, TContext> | MutationFiltersByMutationKey<ForgetPasswordFullappApiAuthForgetPasswordPostSchema, ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordFullappApiAuthForgetPasswordPostError>, TContext>): Array<Mutation<ForgetPasswordFullappApiAuthForgetPasswordPostData, ForgetPasswordFullappApiAuthForgetPasswordPostError, MutationVariables<ForgetPasswordFullappApiAuthForgetPasswordPostBody, ForgetPasswordFullappApiAuthForgetPasswordPostParameters>, TContext>>;
        };
        schema: ForgetPasswordFullappApiAuthForgetPasswordPostSchema;
        types: {
            parameters: ForgetPasswordFullappApiAuthForgetPasswordPostParameters;
            data: ForgetPasswordFullappApiAuthForgetPasswordPostData;
            error: ForgetPasswordFullappApiAuthForgetPasswordPostError;
            body: ForgetPasswordFullappApiAuthForgetPasswordPostBody;
        };
    };
    /**
     * @summary Login
     * @description Email/password login.
     *
     * Order: validate user_login/password -> verify password (wrong password is
     * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
     * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
     * device token.
     *
     * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
     * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
     * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
     */
    loginFullappApiAuthLoginPost: {
        /**
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostParameters, TMeta, TSignal>, client?: (schema: LoginFullappApiAuthLoginPostSchema, options: ServiceOperationMutationFnOptions<LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostError>>): Promise<RequestFnResponse<LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostError>>;
        /**
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         */
        getMutationKey(parameters: DeepReadonly<LoginFullappApiAuthLoginPostParameters> | void): ServiceOperationMutationKey<LoginFullappApiAuthLoginPostSchema, LoginFullappApiAuthLoginPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.loginFullappApiAuthLoginPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.loginFullappApiAuthLoginPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends LoginFullappApiAuthLoginPostBody, TContext = unknown>(parameters: DeepReadonly<LoginFullappApiAuthLoginPostParameters>, options?: ServiceOperationUseMutationOptions<LoginFullappApiAuthLoginPostSchema, LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostParameters, TVariables, OperationError<LoginFullappApiAuthLoginPostError>, TContext>): UseMutationResult<LoginFullappApiAuthLoginPostData, OperationError<LoginFullappApiAuthLoginPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.loginFullappApiAuthLoginPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.loginFullappApiAuthLoginPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<LoginFullappApiAuthLoginPostSchema, LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostParameters, TVariables, OperationError<LoginFullappApiAuthLoginPostError>, TContext>): UseMutationResult<LoginFullappApiAuthLoginPostData, OperationError<LoginFullappApiAuthLoginPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const loginFullappApiAuthLoginPostTotal = qraft.fullappApiService.loginFullappApiAuthLoginPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const loginFullappApiAuthLoginPostTotal = qraft.fullappApiService.loginFullappApiAuthLoginPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostParameters, OperationError<LoginFullappApiAuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginFullappApiAuthLoginPostSchema, LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostParameters, OperationError<LoginFullappApiAuthLoginPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const loginFullappApiAuthLoginPostPendingMutationVariables = qraft.fullappApiService.loginFullappApiAuthLoginPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const loginFullappApiAuthLoginPostMutationData = qraft.fullappApiService.loginFullappApiAuthLoginPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<LoginFullappApiAuthLoginPostData, OperationError<LoginFullappApiAuthLoginPostError>, MutationVariables<LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostParameters, OperationError<LoginFullappApiAuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginFullappApiAuthLoginPostSchema, LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostParameters, OperationError<LoginFullappApiAuthLoginPostError>, TContext>;
            select?: (mutation: Mutation<LoginFullappApiAuthLoginPostData, OperationError<LoginFullappApiAuthLoginPostError>, MutationVariables<LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostParameters, OperationError<LoginFullappApiAuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginFullappApiAuthLoginPostSchema, LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostParameters, OperationError<LoginFullappApiAuthLoginPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.loginFullappApiAuthLoginPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.loginFullappApiAuthLoginPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostParameters, OperationError<LoginFullappApiAuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginFullappApiAuthLoginPostSchema, LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostParameters, OperationError<LoginFullappApiAuthLoginPostError>, TContext>): Mutation<LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostError, MutationVariables<LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostParameters, OperationError<LoginFullappApiAuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginFullappApiAuthLoginPostSchema, LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostParameters, OperationError<LoginFullappApiAuthLoginPostError>, TContext>): Array<Mutation<LoginFullappApiAuthLoginPostData, LoginFullappApiAuthLoginPostError, MutationVariables<LoginFullappApiAuthLoginPostBody, LoginFullappApiAuthLoginPostParameters>, TContext>>;
        };
        schema: LoginFullappApiAuthLoginPostSchema;
        types: {
            parameters: LoginFullappApiAuthLoginPostParameters;
            data: LoginFullappApiAuthLoginPostData;
            error: LoginFullappApiAuthLoginPostError;
            body: LoginFullappApiAuthLoginPostBody;
        };
    };
    /**
     * @summary Register User
     * @description Register a new student.
     *
     * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
     * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
     * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
     * builds the envelope directly via ``JSONResponse`` rather than the shared
     * ``{data: ...}`` handler.
     */
    registerUserFullappApiAuthRegisterPost: {
        /**
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostParameters, TMeta, TSignal>, client?: (schema: RegisterUserFullappApiAuthRegisterPostSchema, options: ServiceOperationMutationFnOptions<RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostError>>): Promise<RequestFnResponse<RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostError>>;
        /**
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         */
        getMutationKey(parameters: DeepReadonly<RegisterUserFullappApiAuthRegisterPostParameters> | void): ServiceOperationMutationKey<RegisterUserFullappApiAuthRegisterPostSchema, RegisterUserFullappApiAuthRegisterPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.registerUserFullappApiAuthRegisterPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.registerUserFullappApiAuthRegisterPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends RegisterUserFullappApiAuthRegisterPostBody, TContext = unknown>(parameters: DeepReadonly<RegisterUserFullappApiAuthRegisterPostParameters>, options?: ServiceOperationUseMutationOptions<RegisterUserFullappApiAuthRegisterPostSchema, RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostParameters, TVariables, OperationError<RegisterUserFullappApiAuthRegisterPostError>, TContext>): UseMutationResult<RegisterUserFullappApiAuthRegisterPostData, OperationError<RegisterUserFullappApiAuthRegisterPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.registerUserFullappApiAuthRegisterPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.registerUserFullappApiAuthRegisterPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<RegisterUserFullappApiAuthRegisterPostSchema, RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostParameters, TVariables, OperationError<RegisterUserFullappApiAuthRegisterPostError>, TContext>): UseMutationResult<RegisterUserFullappApiAuthRegisterPostData, OperationError<RegisterUserFullappApiAuthRegisterPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const registerUserFullappApiAuthRegisterPostTotal = qraft.fullappApiService.registerUserFullappApiAuthRegisterPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const registerUserFullappApiAuthRegisterPostTotal = qraft.fullappApiService.registerUserFullappApiAuthRegisterPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostParameters, OperationError<RegisterUserFullappApiAuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserFullappApiAuthRegisterPostSchema, RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostParameters, OperationError<RegisterUserFullappApiAuthRegisterPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const registerUserFullappApiAuthRegisterPostPendingMutationVariables = qraft.fullappApiService.registerUserFullappApiAuthRegisterPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const registerUserFullappApiAuthRegisterPostMutationData = qraft.fullappApiService.registerUserFullappApiAuthRegisterPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<RegisterUserFullappApiAuthRegisterPostData, OperationError<RegisterUserFullappApiAuthRegisterPostError>, MutationVariables<RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostParameters, OperationError<RegisterUserFullappApiAuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserFullappApiAuthRegisterPostSchema, RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostParameters, OperationError<RegisterUserFullappApiAuthRegisterPostError>, TContext>;
            select?: (mutation: Mutation<RegisterUserFullappApiAuthRegisterPostData, OperationError<RegisterUserFullappApiAuthRegisterPostError>, MutationVariables<RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostParameters, OperationError<RegisterUserFullappApiAuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserFullappApiAuthRegisterPostSchema, RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostParameters, OperationError<RegisterUserFullappApiAuthRegisterPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.registerUserFullappApiAuthRegisterPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.registerUserFullappApiAuthRegisterPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostParameters, OperationError<RegisterUserFullappApiAuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserFullappApiAuthRegisterPostSchema, RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostParameters, OperationError<RegisterUserFullappApiAuthRegisterPostError>, TContext>): Mutation<RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostError, MutationVariables<RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostParameters, OperationError<RegisterUserFullappApiAuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserFullappApiAuthRegisterPostSchema, RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostParameters, OperationError<RegisterUserFullappApiAuthRegisterPostError>, TContext>): Array<Mutation<RegisterUserFullappApiAuthRegisterPostData, RegisterUserFullappApiAuthRegisterPostError, MutationVariables<RegisterUserFullappApiAuthRegisterPostBody, RegisterUserFullappApiAuthRegisterPostParameters>, TContext>>;
        };
        schema: RegisterUserFullappApiAuthRegisterPostSchema;
        types: {
            parameters: RegisterUserFullappApiAuthRegisterPostParameters;
            data: RegisterUserFullappApiAuthRegisterPostData;
            error: RegisterUserFullappApiAuthRegisterPostError;
            body: RegisterUserFullappApiAuthRegisterPostBody;
        };
    };
    /** @summary Logout */
    logoutFullappApiAuthLogoutPost: {
        /** @summary Logout */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostParameters, TMeta, TSignal>, client?: (schema: LogoutFullappApiAuthLogoutPostSchema, options: ServiceOperationMutationFnOptions<LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostError>>): Promise<RequestFnResponse<LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostError>>;
        /** @summary Logout */
        getMutationKey(parameters: DeepReadonly<LogoutFullappApiAuthLogoutPostParameters> | void): ServiceOperationMutationKey<LogoutFullappApiAuthLogoutPostSchema, LogoutFullappApiAuthLogoutPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.logoutFullappApiAuthLogoutPost.useMutation({
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.logoutFullappApiAuthLogoutPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends LogoutFullappApiAuthLogoutPostBody, TContext = unknown>(parameters: DeepReadonly<LogoutFullappApiAuthLogoutPostParameters>, options?: ServiceOperationUseMutationOptions<LogoutFullappApiAuthLogoutPostSchema, LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostParameters, TVariables, OperationError<LogoutFullappApiAuthLogoutPostError>, TContext>): UseMutationResult<LogoutFullappApiAuthLogoutPostData, OperationError<LogoutFullappApiAuthLogoutPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.logoutFullappApiAuthLogoutPost.useMutation({
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.logoutFullappApiAuthLogoutPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<LogoutFullappApiAuthLogoutPostSchema, LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostParameters, TVariables, OperationError<LogoutFullappApiAuthLogoutPostError>, TContext>): UseMutationResult<LogoutFullappApiAuthLogoutPostData, OperationError<LogoutFullappApiAuthLogoutPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const logoutFullappApiAuthLogoutPostTotal = qraft.fullappApiService.logoutFullappApiAuthLogoutPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const logoutFullappApiAuthLogoutPostTotal = qraft.fullappApiService.logoutFullappApiAuthLogoutPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-device-token": xWbsDeviceToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostParameters, OperationError<LogoutFullappApiAuthLogoutPostError>, TContext> | MutationFiltersByMutationKey<LogoutFullappApiAuthLogoutPostSchema, LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostParameters, OperationError<LogoutFullappApiAuthLogoutPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const logoutFullappApiAuthLogoutPostPendingMutationVariables = qraft.fullappApiService.logoutFullappApiAuthLogoutPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const logoutFullappApiAuthLogoutPostMutationData = qraft.fullappApiService.logoutFullappApiAuthLogoutPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-device-token": xWbsDeviceToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<LogoutFullappApiAuthLogoutPostData, OperationError<LogoutFullappApiAuthLogoutPostError>, MutationVariables<LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostParameters, OperationError<LogoutFullappApiAuthLogoutPostError>, TContext> | MutationFiltersByMutationKey<LogoutFullappApiAuthLogoutPostSchema, LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostParameters, OperationError<LogoutFullappApiAuthLogoutPostError>, TContext>;
            select?: (mutation: Mutation<LogoutFullappApiAuthLogoutPostData, OperationError<LogoutFullappApiAuthLogoutPostError>, MutationVariables<LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Logout */
        isMutating<TContext>(filters?: MutationFiltersByParameters<LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostParameters, OperationError<LogoutFullappApiAuthLogoutPostError>, TContext> | MutationFiltersByMutationKey<LogoutFullappApiAuthLogoutPostSchema, LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostParameters, OperationError<LogoutFullappApiAuthLogoutPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.logoutFullappApiAuthLogoutPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-device-token": xWbsDeviceToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.logoutFullappApiAuthLogoutPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostParameters, OperationError<LogoutFullappApiAuthLogoutPostError>, TContext> | MutationFiltersByMutationKey<LogoutFullappApiAuthLogoutPostSchema, LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostParameters, OperationError<LogoutFullappApiAuthLogoutPostError>, TContext>): Mutation<LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostError, MutationVariables<LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostParameters, OperationError<LogoutFullappApiAuthLogoutPostError>, TContext> | MutationFiltersByMutationKey<LogoutFullappApiAuthLogoutPostSchema, LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostParameters, OperationError<LogoutFullappApiAuthLogoutPostError>, TContext>): Array<Mutation<LogoutFullappApiAuthLogoutPostData, LogoutFullappApiAuthLogoutPostError, MutationVariables<LogoutFullappApiAuthLogoutPostBody, LogoutFullappApiAuthLogoutPostParameters>, TContext>>;
        };
        schema: LogoutFullappApiAuthLogoutPostSchema;
        types: {
            parameters: LogoutFullappApiAuthLogoutPostParameters;
            data: LogoutFullappApiAuthLogoutPostData;
            error: LogoutFullappApiAuthLogoutPostError;
            body: LogoutFullappApiAuthLogoutPostBody;
        };
    };
    /** @summary Register Device */
    registerDeviceFullappApiDevicesRegisterPost: {
        /** @summary Register Device */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostParameters, TMeta, TSignal>, client?: (schema: RegisterDeviceFullappApiDevicesRegisterPostSchema, options: ServiceOperationMutationFnOptions<RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostError>>): Promise<RequestFnResponse<RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostError>>;
        /** @summary Register Device */
        getMutationKey(parameters: DeepReadonly<RegisterDeviceFullappApiDevicesRegisterPostParameters> | void): ServiceOperationMutationKey<RegisterDeviceFullappApiDevicesRegisterPostSchema, RegisterDeviceFullappApiDevicesRegisterPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Register Device
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.registerDeviceFullappApiDevicesRegisterPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.registerDeviceFullappApiDevicesRegisterPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends RegisterDeviceFullappApiDevicesRegisterPostBody, TContext = unknown>(parameters: DeepReadonly<RegisterDeviceFullappApiDevicesRegisterPostParameters>, options?: ServiceOperationUseMutationOptions<RegisterDeviceFullappApiDevicesRegisterPostSchema, RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostParameters, TVariables, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, TContext>): UseMutationResult<RegisterDeviceFullappApiDevicesRegisterPostData, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Register Device
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.registerDeviceFullappApiDevicesRegisterPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.registerDeviceFullappApiDevicesRegisterPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<RegisterDeviceFullappApiDevicesRegisterPostSchema, RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostParameters, TVariables, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, TContext>): UseMutationResult<RegisterDeviceFullappApiDevicesRegisterPostData, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Register Device
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const registerDeviceFullappApiDevicesRegisterPostTotal = qraft.fullappApiService.registerDeviceFullappApiDevicesRegisterPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const registerDeviceFullappApiDevicesRegisterPostTotal = qraft.fullappApiService.registerDeviceFullappApiDevicesRegisterPost.useIsMutating({
         *     parameters: {}
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterDeviceFullappApiDevicesRegisterPostSchema, RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Register Device
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const registerDeviceFullappApiDevicesRegisterPostPendingMutationVariables = qraft.fullappApiService.registerDeviceFullappApiDevicesRegisterPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const registerDeviceFullappApiDevicesRegisterPostMutationData = qraft.fullappApiService.registerDeviceFullappApiDevicesRegisterPost.useMutationState({
         *     filters: {
         *         parameters: {}
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<RegisterDeviceFullappApiDevicesRegisterPostData, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, MutationVariables<RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterDeviceFullappApiDevicesRegisterPostSchema, RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, TContext>;
            select?: (mutation: Mutation<RegisterDeviceFullappApiDevicesRegisterPostData, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, MutationVariables<RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Register Device */
        isMutating<TContext>(filters?: MutationFiltersByParameters<RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterDeviceFullappApiDevicesRegisterPostSchema, RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Register Device
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.registerDeviceFullappApiDevicesRegisterPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {}
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.registerDeviceFullappApiDevicesRegisterPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterDeviceFullappApiDevicesRegisterPostSchema, RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, TContext>): Mutation<RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostError, MutationVariables<RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterDeviceFullappApiDevicesRegisterPostSchema, RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceFullappApiDevicesRegisterPostError>, TContext>): Array<Mutation<RegisterDeviceFullappApiDevicesRegisterPostData, RegisterDeviceFullappApiDevicesRegisterPostError, MutationVariables<RegisterDeviceFullappApiDevicesRegisterPostBody, RegisterDeviceFullappApiDevicesRegisterPostParameters>, TContext>>;
        };
        schema: RegisterDeviceFullappApiDevicesRegisterPostSchema;
        types: {
            parameters: RegisterDeviceFullappApiDevicesRegisterPostParameters;
            data: RegisterDeviceFullappApiDevicesRegisterPostData;
            error: RegisterDeviceFullappApiDevicesRegisterPostError;
            body: RegisterDeviceFullappApiDevicesRegisterPostBody;
        };
    };
    /**
     * @summary Installs
     * @description Return the fullapp active-install count over the last 60 days.
     *
     * Requires a valid x-wbs-fullapp-token (app identity) and a valid device token
     * (DeviceDependency) but NOT a logged-in user (login_required=false in legacy).
     * The response `data` is a bare int scalar.
     */
    installsFullappApiAppInfosInstallsPost: {
        /**
         * @summary Installs
         * @description Return the fullapp active-install count over the last 60 days.
         *
         * Requires a valid x-wbs-fullapp-token (app identity) and a valid device token
         * (DeviceDependency) but NOT a logged-in user (login_required=false in legacy).
         * The response `data` is a bare int scalar.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostParameters, TMeta, TSignal>, client?: (schema: InstallsFullappApiAppInfosInstallsPostSchema, options: ServiceOperationMutationFnOptions<InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostError>>): Promise<RequestFnResponse<InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostError>>;
        /**
         * @summary Installs
         * @description Return the fullapp active-install count over the last 60 days.
         *
         * Requires a valid x-wbs-fullapp-token (app identity) and a valid device token
         * (DeviceDependency) but NOT a logged-in user (login_required=false in legacy).
         * The response `data` is a bare int scalar.
         */
        getMutationKey(parameters: DeepReadonly<InstallsFullappApiAppInfosInstallsPostParameters> | void): ServiceOperationMutationKey<InstallsFullappApiAppInfosInstallsPostSchema, InstallsFullappApiAppInfosInstallsPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Installs
         * @description Return the fullapp active-install count over the last 60 days.
         *
         * Requires a valid x-wbs-fullapp-token (app identity) and a valid device token
         * (DeviceDependency) but NOT a logged-in user (login_required=false in legacy).
         * The response `data` is a bare int scalar.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.installsFullappApiAppInfosInstallsPost.useMutation({
         *     header: {
         *         "x-wbs-fullapp-token": xWbsFullappToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.installsFullappApiAppInfosInstallsPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-fullapp-token": xWbsFullappToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends InstallsFullappApiAppInfosInstallsPostBody, TContext = unknown>(parameters: DeepReadonly<InstallsFullappApiAppInfosInstallsPostParameters>, options?: ServiceOperationUseMutationOptions<InstallsFullappApiAppInfosInstallsPostSchema, InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostParameters, TVariables, OperationError<InstallsFullappApiAppInfosInstallsPostError>, TContext>): UseMutationResult<InstallsFullappApiAppInfosInstallsPostData, OperationError<InstallsFullappApiAppInfosInstallsPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Installs
         * @description Return the fullapp active-install count over the last 60 days.
         *
         * Requires a valid x-wbs-fullapp-token (app identity) and a valid device token
         * (DeviceDependency) but NOT a logged-in user (login_required=false in legacy).
         * The response `data` is a bare int scalar.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.installsFullappApiAppInfosInstallsPost.useMutation({
         *     header: {
         *         "x-wbs-fullapp-token": xWbsFullappToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.installsFullappApiAppInfosInstallsPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-fullapp-token": xWbsFullappToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<InstallsFullappApiAppInfosInstallsPostSchema, InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostParameters, TVariables, OperationError<InstallsFullappApiAppInfosInstallsPostError>, TContext>): UseMutationResult<InstallsFullappApiAppInfosInstallsPostData, OperationError<InstallsFullappApiAppInfosInstallsPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Installs
         * @description Return the fullapp active-install count over the last 60 days.
         *
         * Requires a valid x-wbs-fullapp-token (app identity) and a valid device token
         * (DeviceDependency) but NOT a logged-in user (login_required=false in legacy).
         * The response `data` is a bare int scalar.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const installsFullappApiAppInfosInstallsPostTotal = qraft.fullappApiService.installsFullappApiAppInfosInstallsPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const installsFullappApiAppInfosInstallsPostTotal = qraft.fullappApiService.installsFullappApiAppInfosInstallsPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-fullapp-token": xWbsFullappToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostParameters, OperationError<InstallsFullappApiAppInfosInstallsPostError>, TContext> | MutationFiltersByMutationKey<InstallsFullappApiAppInfosInstallsPostSchema, InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostParameters, OperationError<InstallsFullappApiAppInfosInstallsPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Installs
         * @description Return the fullapp active-install count over the last 60 days.
         *
         * Requires a valid x-wbs-fullapp-token (app identity) and a valid device token
         * (DeviceDependency) but NOT a logged-in user (login_required=false in legacy).
         * The response `data` is a bare int scalar.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const installsFullappApiAppInfosInstallsPostPendingMutationVariables = qraft.fullappApiService.installsFullappApiAppInfosInstallsPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const installsFullappApiAppInfosInstallsPostMutationData = qraft.fullappApiService.installsFullappApiAppInfosInstallsPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-fullapp-token": xWbsFullappToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<InstallsFullappApiAppInfosInstallsPostData, OperationError<InstallsFullappApiAppInfosInstallsPostError>, MutationVariables<InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostParameters, OperationError<InstallsFullappApiAppInfosInstallsPostError>, TContext> | MutationFiltersByMutationKey<InstallsFullappApiAppInfosInstallsPostSchema, InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostParameters, OperationError<InstallsFullappApiAppInfosInstallsPostError>, TContext>;
            select?: (mutation: Mutation<InstallsFullappApiAppInfosInstallsPostData, OperationError<InstallsFullappApiAppInfosInstallsPostError>, MutationVariables<InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Installs
         * @description Return the fullapp active-install count over the last 60 days.
         *
         * Requires a valid x-wbs-fullapp-token (app identity) and a valid device token
         * (DeviceDependency) but NOT a logged-in user (login_required=false in legacy).
         * The response `data` is a bare int scalar.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostParameters, OperationError<InstallsFullappApiAppInfosInstallsPostError>, TContext> | MutationFiltersByMutationKey<InstallsFullappApiAppInfosInstallsPostSchema, InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostParameters, OperationError<InstallsFullappApiAppInfosInstallsPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Installs
         * @description Return the fullapp active-install count over the last 60 days.
         *
         * Requires a valid x-wbs-fullapp-token (app identity) and a valid device token
         * (DeviceDependency) but NOT a logged-in user (login_required=false in legacy).
         * The response `data` is a bare int scalar.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.installsFullappApiAppInfosInstallsPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-fullapp-token": xWbsFullappToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.installsFullappApiAppInfosInstallsPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostParameters, OperationError<InstallsFullappApiAppInfosInstallsPostError>, TContext> | MutationFiltersByMutationKey<InstallsFullappApiAppInfosInstallsPostSchema, InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostParameters, OperationError<InstallsFullappApiAppInfosInstallsPostError>, TContext>): Mutation<InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostError, MutationVariables<InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostParameters, OperationError<InstallsFullappApiAppInfosInstallsPostError>, TContext> | MutationFiltersByMutationKey<InstallsFullappApiAppInfosInstallsPostSchema, InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostParameters, OperationError<InstallsFullappApiAppInfosInstallsPostError>, TContext>): Array<Mutation<InstallsFullappApiAppInfosInstallsPostData, InstallsFullappApiAppInfosInstallsPostError, MutationVariables<InstallsFullappApiAppInfosInstallsPostBody, InstallsFullappApiAppInfosInstallsPostParameters>, TContext>>;
        };
        schema: InstallsFullappApiAppInfosInstallsPostSchema;
        types: {
            parameters: InstallsFullappApiAppInfosInstallsPostParameters;
            data: InstallsFullappApiAppInfosInstallsPostData;
            error: InstallsFullappApiAppInfosInstallsPostError;
            body: InstallsFullappApiAppInfosInstallsPostBody;
        };
    };
    /** @summary Translations */
    translationsFullappApiLanguagesTranslationsPost: {
        /** @summary Translations */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostParameters, TMeta, TSignal>, client?: (schema: TranslationsFullappApiLanguagesTranslationsPostSchema, options: ServiceOperationMutationFnOptions<TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostError>>): Promise<RequestFnResponse<TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostError>>;
        /** @summary Translations */
        getMutationKey(parameters: DeepReadonly<TranslationsFullappApiLanguagesTranslationsPostParameters> | void): ServiceOperationMutationKey<TranslationsFullappApiLanguagesTranslationsPostSchema, TranslationsFullappApiLanguagesTranslationsPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsPost.useMutation({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends TranslationsFullappApiLanguagesTranslationsPostBody, TContext = unknown>(parameters: DeepReadonly<TranslationsFullappApiLanguagesTranslationsPostParameters>, options?: ServiceOperationUseMutationOptions<TranslationsFullappApiLanguagesTranslationsPostSchema, TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostParameters, TVariables, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, TContext>): UseMutationResult<TranslationsFullappApiLanguagesTranslationsPostData, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsPost.useMutation({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<TranslationsFullappApiLanguagesTranslationsPostSchema, TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostParameters, TVariables, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, TContext>): UseMutationResult<TranslationsFullappApiLanguagesTranslationsPostData, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const translationsFullappApiLanguagesTranslationsPostTotal = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const translationsFullappApiLanguagesTranslationsPostTotal = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-maintenance": xWbsMaintenance
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostParameters, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, TContext> | MutationFiltersByMutationKey<TranslationsFullappApiLanguagesTranslationsPostSchema, TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostParameters, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const translationsFullappApiLanguagesTranslationsPostPendingMutationVariables = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const translationsFullappApiLanguagesTranslationsPostMutationData = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<TranslationsFullappApiLanguagesTranslationsPostData, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, MutationVariables<TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostParameters, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, TContext> | MutationFiltersByMutationKey<TranslationsFullappApiLanguagesTranslationsPostSchema, TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostParameters, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, TContext>;
            select?: (mutation: Mutation<TranslationsFullappApiLanguagesTranslationsPostData, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, MutationVariables<TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Translations */
        isMutating<TContext>(filters?: MutationFiltersByParameters<TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostParameters, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, TContext> | MutationFiltersByMutationKey<TranslationsFullappApiLanguagesTranslationsPostSchema, TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostParameters, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-maintenance": xWbsMaintenance
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostParameters, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, TContext> | MutationFiltersByMutationKey<TranslationsFullappApiLanguagesTranslationsPostSchema, TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostParameters, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, TContext>): Mutation<TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostError, MutationVariables<TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostParameters, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, TContext> | MutationFiltersByMutationKey<TranslationsFullappApiLanguagesTranslationsPostSchema, TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostParameters, OperationError<TranslationsFullappApiLanguagesTranslationsPostError>, TContext>): Array<Mutation<TranslationsFullappApiLanguagesTranslationsPostData, TranslationsFullappApiLanguagesTranslationsPostError, MutationVariables<TranslationsFullappApiLanguagesTranslationsPostBody, TranslationsFullappApiLanguagesTranslationsPostParameters>, TContext>>;
        };
        schema: TranslationsFullappApiLanguagesTranslationsPostSchema;
        types: {
            parameters: TranslationsFullappApiLanguagesTranslationsPostParameters;
            data: TranslationsFullappApiLanguagesTranslationsPostData;
            error: TranslationsFullappApiLanguagesTranslationsPostError;
            body: TranslationsFullappApiLanguagesTranslationsPostBody;
        };
    };
    /** @summary Translations */
    translationsFullappApiLanguagesTranslationsGet: {
        /** @summary Translations */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<TranslationsFullappApiLanguagesTranslationsGetParameters, TMeta, TSignal> | void), client?: (schema: TranslationsFullappApiLanguagesTranslationsGetSchema, options: {
            parameters: TranslationsFullappApiLanguagesTranslationsGetParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetError>>): Promise<RequestFnResponse<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetError>>;
        /** @summary Translations */
        getQueryKey(parameters: DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetParameters> | void): ServiceOperationQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useQuery({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * })
         * ```
         */
        useQuery<TData = TranslationsFullappApiLanguagesTranslationsGetData>(parameters: ServiceOperationQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters> | (DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetParameters> | void), options?: Omit<UndefinedInitialDataOptions<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetError, TData, ServiceOperationQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters>>, "queryKey">): UseQueryResult<TData, OperationError<TranslationsFullappApiLanguagesTranslationsGetError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useQuery({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * })
         * ```
         */
        useQuery<TData = TranslationsFullappApiLanguagesTranslationsGetData>(parameters: ServiceOperationQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters> | (DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetParameters> | void), options: Omit<DefinedInitialDataOptions<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetError, TData, ServiceOperationQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<TranslationsFullappApiLanguagesTranslationsGetError>>;
        /** @summary Translations */
        getInfiniteQueryKey(parameters: DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetParameters> | void): ServiceOperationInfiniteQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useInfiniteQuery({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends TranslationsFullappApiLanguagesTranslationsGetParameters, TQueryFnData = TranslationsFullappApiLanguagesTranslationsGetData, TData = OperationInfiniteData<TQueryFnData, TranslationsFullappApiLanguagesTranslationsGetParameters>>(parameters: ServiceOperationInfiniteQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters> | (DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, TranslationsFullappApiLanguagesTranslationsGetError, TData, ServiceOperationInfiniteQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<TranslationsFullappApiLanguagesTranslationsGetError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useInfiniteQuery({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends TranslationsFullappApiLanguagesTranslationsGetParameters, TQueryFnData = TranslationsFullappApiLanguagesTranslationsGetData, TData = OperationInfiniteData<TQueryFnData, TranslationsFullappApiLanguagesTranslationsGetParameters>>(parameters: ServiceOperationInfiniteQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters> | (DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, TranslationsFullappApiLanguagesTranslationsGetError, TData, ServiceOperationInfiniteQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TranslationsFullappApiLanguagesTranslationsGetData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<TranslationsFullappApiLanguagesTranslationsGetError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const translationsFullappApiLanguagesTranslationsGetTotal = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const translationsFullappApiLanguagesTranslationsGetByParametersTotal = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-maintenance": xWbsMaintenance
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError> | QueryFiltersByQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const translationsFullappApiLanguagesTranslationsGetResults = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance2
         *             }
         *         }
         *     ]
         * });
         * translationsFullappApiLanguagesTranslationsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const translationsFullappApiLanguagesTranslationsGetCombinedResults = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance2
         *             }
         *         }
         *     ]
         * });
         * translationsFullappApiLanguagesTranslationsGetCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetError>>, TCombinedResult = Array<UseQueryResult<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useSuspenseQuery({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = TranslationsFullappApiLanguagesTranslationsGetData>(parameters: ServiceOperationQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters> | (DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetParameters> | void), options?: Omit<UseSuspenseQueryOptions<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetError, TData, ServiceOperationQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<TranslationsFullappApiLanguagesTranslationsGetError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends TranslationsFullappApiLanguagesTranslationsGetParameters, TData = TranslationsFullappApiLanguagesTranslationsGetData>(parameters: ServiceOperationInfiniteQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters> | (DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetError, OperationInfiniteData<TData, TranslationsFullappApiLanguagesTranslationsGetParameters>, ServiceOperationInfiniteQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TranslationsFullappApiLanguagesTranslationsGetData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, TranslationsFullappApiLanguagesTranslationsGetParameters>, OperationError<TranslationsFullappApiLanguagesTranslationsGetError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const translationsFullappApiLanguagesTranslationsGetData = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance2
         *             }
         *         }
         *     ]
         * });
         * translationsFullappApiLanguagesTranslationsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const translationsFullappApiLanguagesTranslationsGetCombinedData = qraft.fullappApiService.translationsFullappApiLanguagesTranslationsGet.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance2
         *             }
         *         }
         *     ]
         * });
         * translationsFullappApiLanguagesTranslationsGetCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetError>>, TCombinedResult = Array<UseSuspenseQueryResult<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Translations */
        fetchQuery(options: ServiceOperationFetchQueryOptions<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError> | void): Promise<TranslationsFullappApiLanguagesTranslationsGetData>;
        /** @summary Translations */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError> | void): Promise<void>;
        /** @summary Translations */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError> | void): Promise<TranslationsFullappApiLanguagesTranslationsGetData>;
        /** @summary Translations */
        fetchInfiniteQuery<TPageParam extends TranslationsFullappApiLanguagesTranslationsGetParameters>(options: ServiceOperationFetchInfiniteQueryOptions<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetParameters, DeepReadonly<TPageParam>, TranslationsFullappApiLanguagesTranslationsGetError> | void): Promise<OperationInfiniteData<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetParameters>>;
        /** @summary Translations */
        prefetchInfiniteQuery<TPageParam extends TranslationsFullappApiLanguagesTranslationsGetParameters>(options: ServiceOperationFetchInfiniteQueryOptions<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetParameters, DeepReadonly<TPageParam>, TranslationsFullappApiLanguagesTranslationsGetError> | void): Promise<void>;
        /** @summary Translations */
        ensureInfiniteQueryData<TPageParam extends TranslationsFullappApiLanguagesTranslationsGetParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetParameters, DeepReadonly<TPageParam>, TranslationsFullappApiLanguagesTranslationsGetError> | void): Promise<OperationInfiniteData<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetParameters>>;
        /** @summary Translations */
        getQueryData(parameters: ServiceOperationQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters> | (DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetParameters> | void)): TranslationsFullappApiLanguagesTranslationsGetData | undefined;
        /** @summary Translations */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters> | (DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetParameters> | void)): OperationInfiniteData<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetParameters> | undefined;
        /** @summary Translations */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError> | QueryFiltersByQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters>,
            data: NoInfer<OperationInfiniteData<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters>,
            data: TranslationsFullappApiLanguagesTranslationsGetData | undefined
        ]>;
        /** @summary Translations */
        getQueryState(parameters: ServiceOperationQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters> | (DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetParameters> | void)): QueryState<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetError> | undefined;
        /** @summary Translations */
        getInfiniteQueryState(parameters: DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetParameters> | ServiceOperationInfiniteQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters> | void): QueryState<OperationInfiniteData<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetParameters>, TranslationsFullappApiLanguagesTranslationsGetError> | undefined;
        /** @summary Translations */
        setQueryData(parameters: (DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetParameters> | undefined) | ServiceOperationQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters>, updater: Updater<NoInfer<TranslationsFullappApiLanguagesTranslationsGetData> | undefined, NoInfer<DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetData>> | undefined>, options?: SetDataOptions): TranslationsFullappApiLanguagesTranslationsGetData | undefined;
        /** @summary Translations */
        setInfiniteQueryData(parameters: (DeepReadonly<TranslationsFullappApiLanguagesTranslationsGetParameters> | undefined) | ServiceOperationInfiniteQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetParameters>, updater: Updater<NoInfer<OperationInfiniteData<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<TranslationsFullappApiLanguagesTranslationsGetData, TranslationsFullappApiLanguagesTranslationsGetParameters> | undefined;
        /** @summary Translations */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError> | QueryFiltersByQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError>, updater: Updater<NoInfer<TranslationsFullappApiLanguagesTranslationsGetData> | undefined, NoInfer<TranslationsFullappApiLanguagesTranslationsGetData> | undefined>, options?: SetDataOptions): Array<TranslationsFullappApiLanguagesTranslationsGetData | undefined>;
        /** @summary Translations */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Translations */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError> | QueryFiltersByQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError>, options?: RefetchOptions): Promise<void>;
        /** @summary Translations */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError> | QueryFiltersByQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError>, options?: CancelOptions): Promise<void>;
        /** @summary Translations */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError> | QueryFiltersByQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError>): void;
        /** @summary Translations */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError> | QueryFiltersByQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError>, options?: ResetOptions): Promise<void>;
        /** @summary Translations */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError> | QueryFiltersByQueryKey<TranslationsFullappApiLanguagesTranslationsGetSchema, TranslationsFullappApiLanguagesTranslationsGetData, TInfinite, TranslationsFullappApiLanguagesTranslationsGetParameters, TranslationsFullappApiLanguagesTranslationsGetError>): number;
        schema: TranslationsFullappApiLanguagesTranslationsGetSchema;
        types: {
            parameters: TranslationsFullappApiLanguagesTranslationsGetParameters;
            data: TranslationsFullappApiLanguagesTranslationsGetData;
            error: TranslationsFullappApiLanguagesTranslationsGetError;
            body: TranslationsFullappApiLanguagesTranslationsGetBody;
        };
    };
    /** @summary All Languages */
    allLanguagesFullappApiLanguagesAllPost: {
        /** @summary All Languages */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostParameters, TMeta, TSignal>, client?: (schema: AllLanguagesFullappApiLanguagesAllPostSchema, options: ServiceOperationMutationFnOptions<AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostError>>): Promise<RequestFnResponse<AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostError>>;
        /** @summary All Languages */
        getMutationKey(parameters: DeepReadonly<AllLanguagesFullappApiLanguagesAllPostParameters> | void): ServiceOperationMutationKey<AllLanguagesFullappApiLanguagesAllPostSchema, AllLanguagesFullappApiLanguagesAllPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary All Languages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllPost.useMutation({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AllLanguagesFullappApiLanguagesAllPostBody, TContext = unknown>(parameters: DeepReadonly<AllLanguagesFullappApiLanguagesAllPostParameters>, options?: ServiceOperationUseMutationOptions<AllLanguagesFullappApiLanguagesAllPostSchema, AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostParameters, TVariables, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, TContext>): UseMutationResult<AllLanguagesFullappApiLanguagesAllPostData, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary All Languages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllPost.useMutation({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AllLanguagesFullappApiLanguagesAllPostSchema, AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostParameters, TVariables, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, TContext>): UseMutationResult<AllLanguagesFullappApiLanguagesAllPostData, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary All Languages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const allLanguagesFullappApiLanguagesAllPostTotal = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const allLanguagesFullappApiLanguagesAllPostTotal = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-maintenance": xWbsMaintenance
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostParameters, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, TContext> | MutationFiltersByMutationKey<AllLanguagesFullappApiLanguagesAllPostSchema, AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostParameters, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary All Languages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const allLanguagesFullappApiLanguagesAllPostPendingMutationVariables = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const allLanguagesFullappApiLanguagesAllPostMutationData = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AllLanguagesFullappApiLanguagesAllPostData, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, MutationVariables<AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostParameters, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, TContext> | MutationFiltersByMutationKey<AllLanguagesFullappApiLanguagesAllPostSchema, AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostParameters, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, TContext>;
            select?: (mutation: Mutation<AllLanguagesFullappApiLanguagesAllPostData, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, MutationVariables<AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary All Languages */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostParameters, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, TContext> | MutationFiltersByMutationKey<AllLanguagesFullappApiLanguagesAllPostSchema, AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostParameters, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary All Languages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-maintenance": xWbsMaintenance
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostParameters, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, TContext> | MutationFiltersByMutationKey<AllLanguagesFullappApiLanguagesAllPostSchema, AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostParameters, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, TContext>): Mutation<AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostError, MutationVariables<AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostParameters, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, TContext> | MutationFiltersByMutationKey<AllLanguagesFullappApiLanguagesAllPostSchema, AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostParameters, OperationError<AllLanguagesFullappApiLanguagesAllPostError>, TContext>): Array<Mutation<AllLanguagesFullappApiLanguagesAllPostData, AllLanguagesFullappApiLanguagesAllPostError, MutationVariables<AllLanguagesFullappApiLanguagesAllPostBody, AllLanguagesFullappApiLanguagesAllPostParameters>, TContext>>;
        };
        schema: AllLanguagesFullappApiLanguagesAllPostSchema;
        types: {
            parameters: AllLanguagesFullappApiLanguagesAllPostParameters;
            data: AllLanguagesFullappApiLanguagesAllPostData;
            error: AllLanguagesFullappApiLanguagesAllPostError;
            body: AllLanguagesFullappApiLanguagesAllPostBody;
        };
    };
    /** @summary All Languages */
    allLanguagesFullappApiLanguagesAllGet: {
        /** @summary All Languages */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<AllLanguagesFullappApiLanguagesAllGetParameters, TMeta, TSignal> | void), client?: (schema: AllLanguagesFullappApiLanguagesAllGetSchema, options: {
            parameters: AllLanguagesFullappApiLanguagesAllGetParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetError>>): Promise<RequestFnResponse<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetError>>;
        /** @summary All Languages */
        getQueryKey(parameters: DeepReadonly<AllLanguagesFullappApiLanguagesAllGetParameters> | void): ServiceOperationQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary All Languages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useQuery({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * })
         * ```
         */
        useQuery<TData = AllLanguagesFullappApiLanguagesAllGetData>(parameters: ServiceOperationQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters> | (DeepReadonly<AllLanguagesFullappApiLanguagesAllGetParameters> | void), options?: Omit<UndefinedInitialDataOptions<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetError, TData, ServiceOperationQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters>>, "queryKey">): UseQueryResult<TData, OperationError<AllLanguagesFullappApiLanguagesAllGetError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary All Languages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useQuery({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * })
         * ```
         */
        useQuery<TData = AllLanguagesFullappApiLanguagesAllGetData>(parameters: ServiceOperationQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters> | (DeepReadonly<AllLanguagesFullappApiLanguagesAllGetParameters> | void), options: Omit<DefinedInitialDataOptions<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetError, TData, ServiceOperationQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<AllLanguagesFullappApiLanguagesAllGetError>>;
        /** @summary All Languages */
        getInfiniteQueryKey(parameters: DeepReadonly<AllLanguagesFullappApiLanguagesAllGetParameters> | void): ServiceOperationInfiniteQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary All Languages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useInfiniteQuery({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AllLanguagesFullappApiLanguagesAllGetParameters, TQueryFnData = AllLanguagesFullappApiLanguagesAllGetData, TData = OperationInfiniteData<TQueryFnData, AllLanguagesFullappApiLanguagesAllGetParameters>>(parameters: ServiceOperationInfiniteQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters> | (DeepReadonly<AllLanguagesFullappApiLanguagesAllGetParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, AllLanguagesFullappApiLanguagesAllGetError, TData, ServiceOperationInfiniteQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<AllLanguagesFullappApiLanguagesAllGetError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary All Languages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useInfiniteQuery({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends AllLanguagesFullappApiLanguagesAllGetParameters, TQueryFnData = AllLanguagesFullappApiLanguagesAllGetData, TData = OperationInfiniteData<TQueryFnData, AllLanguagesFullappApiLanguagesAllGetParameters>>(parameters: ServiceOperationInfiniteQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters> | (DeepReadonly<AllLanguagesFullappApiLanguagesAllGetParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, AllLanguagesFullappApiLanguagesAllGetError, TData, ServiceOperationInfiniteQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AllLanguagesFullappApiLanguagesAllGetData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<AllLanguagesFullappApiLanguagesAllGetError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary All Languages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const allLanguagesFullappApiLanguagesAllGetTotal = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const allLanguagesFullappApiLanguagesAllGetByParametersTotal = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-maintenance": xWbsMaintenance
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError> | QueryFiltersByQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary All Languages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const allLanguagesFullappApiLanguagesAllGetResults = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance2
         *             }
         *         }
         *     ]
         * });
         * allLanguagesFullappApiLanguagesAllGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const allLanguagesFullappApiLanguagesAllGetCombinedResults = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance2
         *             }
         *         }
         *     ]
         * });
         * allLanguagesFullappApiLanguagesAllGetCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetError>>, TCombinedResult = Array<UseQueryResult<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary All Languages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useSuspenseQuery({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = AllLanguagesFullappApiLanguagesAllGetData>(parameters: ServiceOperationQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters> | (DeepReadonly<AllLanguagesFullappApiLanguagesAllGetParameters> | void), options?: Omit<UseSuspenseQueryOptions<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetError, TData, ServiceOperationQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<AllLanguagesFullappApiLanguagesAllGetError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary All Languages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-maintenance": xWbsMaintenance
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends AllLanguagesFullappApiLanguagesAllGetParameters, TData = AllLanguagesFullappApiLanguagesAllGetData>(parameters: ServiceOperationInfiniteQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters> | (DeepReadonly<AllLanguagesFullappApiLanguagesAllGetParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetError, OperationInfiniteData<TData, AllLanguagesFullappApiLanguagesAllGetParameters>, ServiceOperationInfiniteQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<AllLanguagesFullappApiLanguagesAllGetData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, AllLanguagesFullappApiLanguagesAllGetParameters>, OperationError<AllLanguagesFullappApiLanguagesAllGetError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary All Languages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const allLanguagesFullappApiLanguagesAllGetData = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance2
         *             }
         *         }
         *     ]
         * });
         * allLanguagesFullappApiLanguagesAllGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const allLanguagesFullappApiLanguagesAllGetCombinedData = qraft.fullappApiService.allLanguagesFullappApiLanguagesAllGet.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-maintenance": xWbsMaintenance2
         *             }
         *         }
         *     ]
         * });
         * allLanguagesFullappApiLanguagesAllGetCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetError>>, TCombinedResult = Array<UseSuspenseQueryResult<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary All Languages */
        fetchQuery(options: ServiceOperationFetchQueryOptions<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError> | void): Promise<AllLanguagesFullappApiLanguagesAllGetData>;
        /** @summary All Languages */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError> | void): Promise<void>;
        /** @summary All Languages */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError> | void): Promise<AllLanguagesFullappApiLanguagesAllGetData>;
        /** @summary All Languages */
        fetchInfiniteQuery<TPageParam extends AllLanguagesFullappApiLanguagesAllGetParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetParameters, DeepReadonly<TPageParam>, AllLanguagesFullappApiLanguagesAllGetError> | void): Promise<OperationInfiniteData<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetParameters>>;
        /** @summary All Languages */
        prefetchInfiniteQuery<TPageParam extends AllLanguagesFullappApiLanguagesAllGetParameters>(options: ServiceOperationFetchInfiniteQueryOptions<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetParameters, DeepReadonly<TPageParam>, AllLanguagesFullappApiLanguagesAllGetError> | void): Promise<void>;
        /** @summary All Languages */
        ensureInfiniteQueryData<TPageParam extends AllLanguagesFullappApiLanguagesAllGetParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetParameters, DeepReadonly<TPageParam>, AllLanguagesFullappApiLanguagesAllGetError> | void): Promise<OperationInfiniteData<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetParameters>>;
        /** @summary All Languages */
        getQueryData(parameters: ServiceOperationQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters> | (DeepReadonly<AllLanguagesFullappApiLanguagesAllGetParameters> | void)): AllLanguagesFullappApiLanguagesAllGetData | undefined;
        /** @summary All Languages */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters> | (DeepReadonly<AllLanguagesFullappApiLanguagesAllGetParameters> | void)): OperationInfiniteData<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetParameters> | undefined;
        /** @summary All Languages */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError> | QueryFiltersByQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters>,
            data: NoInfer<OperationInfiniteData<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters>,
            data: AllLanguagesFullappApiLanguagesAllGetData | undefined
        ]>;
        /** @summary All Languages */
        getQueryState(parameters: ServiceOperationQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters> | (DeepReadonly<AllLanguagesFullappApiLanguagesAllGetParameters> | void)): QueryState<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetError> | undefined;
        /** @summary All Languages */
        getInfiniteQueryState(parameters: DeepReadonly<AllLanguagesFullappApiLanguagesAllGetParameters> | ServiceOperationInfiniteQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters> | void): QueryState<OperationInfiniteData<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetParameters>, AllLanguagesFullappApiLanguagesAllGetError> | undefined;
        /** @summary All Languages */
        setQueryData(parameters: (DeepReadonly<AllLanguagesFullappApiLanguagesAllGetParameters> | undefined) | ServiceOperationQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters>, updater: Updater<NoInfer<AllLanguagesFullappApiLanguagesAllGetData> | undefined, NoInfer<DeepReadonly<AllLanguagesFullappApiLanguagesAllGetData>> | undefined>, options?: SetDataOptions): AllLanguagesFullappApiLanguagesAllGetData | undefined;
        /** @summary All Languages */
        setInfiniteQueryData(parameters: (DeepReadonly<AllLanguagesFullappApiLanguagesAllGetParameters> | undefined) | ServiceOperationInfiniteQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetParameters>, updater: Updater<NoInfer<OperationInfiniteData<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<AllLanguagesFullappApiLanguagesAllGetData, AllLanguagesFullappApiLanguagesAllGetParameters> | undefined;
        /** @summary All Languages */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError> | QueryFiltersByQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError>, updater: Updater<NoInfer<AllLanguagesFullappApiLanguagesAllGetData> | undefined, NoInfer<AllLanguagesFullappApiLanguagesAllGetData> | undefined>, options?: SetDataOptions): Array<AllLanguagesFullappApiLanguagesAllGetData | undefined>;
        /** @summary All Languages */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError>, options?: InvalidateOptions): Promise<void>;
        /** @summary All Languages */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError> | QueryFiltersByQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError>, options?: RefetchOptions): Promise<void>;
        /** @summary All Languages */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError> | QueryFiltersByQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError>, options?: CancelOptions): Promise<void>;
        /** @summary All Languages */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError> | QueryFiltersByQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError>): void;
        /** @summary All Languages */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError> | QueryFiltersByQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError>, options?: ResetOptions): Promise<void>;
        /** @summary All Languages */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError> | QueryFiltersByQueryKey<AllLanguagesFullappApiLanguagesAllGetSchema, AllLanguagesFullappApiLanguagesAllGetData, TInfinite, AllLanguagesFullappApiLanguagesAllGetParameters, AllLanguagesFullappApiLanguagesAllGetError>): number;
        schema: AllLanguagesFullappApiLanguagesAllGetSchema;
        types: {
            parameters: AllLanguagesFullappApiLanguagesAllGetParameters;
            data: AllLanguagesFullappApiLanguagesAllGetData;
            error: AllLanguagesFullappApiLanguagesAllGetError;
        };
    };
    /** @summary Detail */
    detailFullappApiPagesDetailPost: {
        /** @summary Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostParameters, TMeta, TSignal>, client?: (schema: DetailFullappApiPagesDetailPostSchema, options: ServiceOperationMutationFnOptions<DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostError>>): Promise<RequestFnResponse<DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostError>>;
        /** @summary Detail */
        getMutationKey(parameters: DeepReadonly<DetailFullappApiPagesDetailPostParameters> | void): ServiceOperationMutationKey<DetailFullappApiPagesDetailPostSchema, DetailFullappApiPagesDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.detailFullappApiPagesDetailPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.detailFullappApiPagesDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DetailFullappApiPagesDetailPostBody, TContext = unknown>(parameters: DeepReadonly<DetailFullappApiPagesDetailPostParameters>, options?: ServiceOperationUseMutationOptions<DetailFullappApiPagesDetailPostSchema, DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostParameters, TVariables, OperationError<DetailFullappApiPagesDetailPostError>, TContext>): UseMutationResult<DetailFullappApiPagesDetailPostData, OperationError<DetailFullappApiPagesDetailPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.detailFullappApiPagesDetailPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.detailFullappApiPagesDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DetailFullappApiPagesDetailPostSchema, DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostParameters, TVariables, OperationError<DetailFullappApiPagesDetailPostError>, TContext>): UseMutationResult<DetailFullappApiPagesDetailPostData, OperationError<DetailFullappApiPagesDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const detailFullappApiPagesDetailPostTotal = qraft.fullappApiService.detailFullappApiPagesDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const detailFullappApiPagesDetailPostTotal = qraft.fullappApiService.detailFullappApiPagesDetailPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostParameters, OperationError<DetailFullappApiPagesDetailPostError>, TContext> | MutationFiltersByMutationKey<DetailFullappApiPagesDetailPostSchema, DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostParameters, OperationError<DetailFullappApiPagesDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const detailFullappApiPagesDetailPostPendingMutationVariables = qraft.fullappApiService.detailFullappApiPagesDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const detailFullappApiPagesDetailPostMutationData = qraft.fullappApiService.detailFullappApiPagesDetailPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DetailFullappApiPagesDetailPostData, OperationError<DetailFullappApiPagesDetailPostError>, MutationVariables<DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostParameters, OperationError<DetailFullappApiPagesDetailPostError>, TContext> | MutationFiltersByMutationKey<DetailFullappApiPagesDetailPostSchema, DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostParameters, OperationError<DetailFullappApiPagesDetailPostError>, TContext>;
            select?: (mutation: Mutation<DetailFullappApiPagesDetailPostData, OperationError<DetailFullappApiPagesDetailPostError>, MutationVariables<DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Detail */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostParameters, OperationError<DetailFullappApiPagesDetailPostError>, TContext> | MutationFiltersByMutationKey<DetailFullappApiPagesDetailPostSchema, DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostParameters, OperationError<DetailFullappApiPagesDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.detailFullappApiPagesDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.detailFullappApiPagesDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostParameters, OperationError<DetailFullappApiPagesDetailPostError>, TContext> | MutationFiltersByMutationKey<DetailFullappApiPagesDetailPostSchema, DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostParameters, OperationError<DetailFullappApiPagesDetailPostError>, TContext>): Mutation<DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostError, MutationVariables<DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostParameters, OperationError<DetailFullappApiPagesDetailPostError>, TContext> | MutationFiltersByMutationKey<DetailFullappApiPagesDetailPostSchema, DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostParameters, OperationError<DetailFullappApiPagesDetailPostError>, TContext>): Array<Mutation<DetailFullappApiPagesDetailPostData, DetailFullappApiPagesDetailPostError, MutationVariables<DetailFullappApiPagesDetailPostBody, DetailFullappApiPagesDetailPostParameters>, TContext>>;
        };
        schema: DetailFullappApiPagesDetailPostSchema;
        types: {
            parameters: DetailFullappApiPagesDetailPostParameters;
            data: DetailFullappApiPagesDetailPostData;
            error: DetailFullappApiPagesDetailPostError;
            body: DetailFullappApiPagesDetailPostBody;
        };
    };
    /**
     * @summary Study Helper
     * @description Pre-auth WebView links for a study-helper (groups + group follow-up-requests).
     *
     * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
     * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
     * only and would drop the top-level ``success``.
     */
    studyHelperFullappApiInAppLinksStudyHelperPost: {
        /**
         * @summary Study Helper
         * @description Pre-auth WebView links for a study-helper (groups + group follow-up-requests).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostParameters, TMeta, TSignal>, client?: (schema: StudyHelperFullappApiInAppLinksStudyHelperPostSchema, options: ServiceOperationMutationFnOptions<StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostError>>): Promise<RequestFnResponse<StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostError>>;
        /**
         * @summary Study Helper
         * @description Pre-auth WebView links for a study-helper (groups + group follow-up-requests).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         */
        getMutationKey(parameters: DeepReadonly<StudyHelperFullappApiInAppLinksStudyHelperPostParameters> | void): ServiceOperationMutationKey<StudyHelperFullappApiInAppLinksStudyHelperPostSchema, StudyHelperFullappApiInAppLinksStudyHelperPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Study Helper
         * @description Pre-auth WebView links for a study-helper (groups + group follow-up-requests).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperFullappApiInAppLinksStudyHelperPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperFullappApiInAppLinksStudyHelperPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends StudyHelperFullappApiInAppLinksStudyHelperPostBody, TContext = unknown>(parameters: DeepReadonly<StudyHelperFullappApiInAppLinksStudyHelperPostParameters>, options?: ServiceOperationUseMutationOptions<StudyHelperFullappApiInAppLinksStudyHelperPostSchema, StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostParameters, TVariables, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, TContext>): UseMutationResult<StudyHelperFullappApiInAppLinksStudyHelperPostData, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Study Helper
         * @description Pre-auth WebView links for a study-helper (groups + group follow-up-requests).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperFullappApiInAppLinksStudyHelperPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperFullappApiInAppLinksStudyHelperPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<StudyHelperFullappApiInAppLinksStudyHelperPostSchema, StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostParameters, TVariables, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, TContext>): UseMutationResult<StudyHelperFullappApiInAppLinksStudyHelperPostData, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Study Helper
         * @description Pre-auth WebView links for a study-helper (groups + group follow-up-requests).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const studyHelperFullappApiInAppLinksStudyHelperPostTotal = qraft.fullappApiService.studyHelperFullappApiInAppLinksStudyHelperPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const studyHelperFullappApiInAppLinksStudyHelperPostTotal = qraft.fullappApiService.studyHelperFullappApiInAppLinksStudyHelperPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostParameters, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperFullappApiInAppLinksStudyHelperPostSchema, StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostParameters, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Study Helper
         * @description Pre-auth WebView links for a study-helper (groups + group follow-up-requests).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const studyHelperFullappApiInAppLinksStudyHelperPostPendingMutationVariables = qraft.fullappApiService.studyHelperFullappApiInAppLinksStudyHelperPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const studyHelperFullappApiInAppLinksStudyHelperPostMutationData = qraft.fullappApiService.studyHelperFullappApiInAppLinksStudyHelperPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<StudyHelperFullappApiInAppLinksStudyHelperPostData, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, MutationVariables<StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostParameters, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperFullappApiInAppLinksStudyHelperPostSchema, StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostParameters, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, TContext>;
            select?: (mutation: Mutation<StudyHelperFullappApiInAppLinksStudyHelperPostData, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, MutationVariables<StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Study Helper
         * @description Pre-auth WebView links for a study-helper (groups + group follow-up-requests).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostParameters, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperFullappApiInAppLinksStudyHelperPostSchema, StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostParameters, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Study Helper
         * @description Pre-auth WebView links for a study-helper (groups + group follow-up-requests).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.studyHelperFullappApiInAppLinksStudyHelperPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.studyHelperFullappApiInAppLinksStudyHelperPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostParameters, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperFullappApiInAppLinksStudyHelperPostSchema, StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostParameters, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, TContext>): Mutation<StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostError, MutationVariables<StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostParameters, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperFullappApiInAppLinksStudyHelperPostSchema, StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostParameters, OperationError<StudyHelperFullappApiInAppLinksStudyHelperPostError>, TContext>): Array<Mutation<StudyHelperFullappApiInAppLinksStudyHelperPostData, StudyHelperFullappApiInAppLinksStudyHelperPostError, MutationVariables<StudyHelperFullappApiInAppLinksStudyHelperPostBody, StudyHelperFullappApiInAppLinksStudyHelperPostParameters>, TContext>>;
        };
        schema: StudyHelperFullappApiInAppLinksStudyHelperPostSchema;
        types: {
            parameters: StudyHelperFullappApiInAppLinksStudyHelperPostParameters;
            data: StudyHelperFullappApiInAppLinksStudyHelperPostData;
            error: StudyHelperFullappApiInAppLinksStudyHelperPostError;
            body: StudyHelperFullappApiInAppLinksStudyHelperPostBody;
        };
    };
    /**
     * @summary Student
     * @description Pre-auth WebView links for a student (study-helper-board + follow-ups).
     *
     * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
     * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
     * only and would drop the top-level ``success``.
     */
    studentFullappApiInAppLinksStudentPost: {
        /**
         * @summary Student
         * @description Pre-auth WebView links for a student (study-helper-board + follow-ups).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostParameters, TMeta, TSignal>, client?: (schema: StudentFullappApiInAppLinksStudentPostSchema, options: ServiceOperationMutationFnOptions<StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostError>>): Promise<RequestFnResponse<StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostError>>;
        /**
         * @summary Student
         * @description Pre-auth WebView links for a student (study-helper-board + follow-ups).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         */
        getMutationKey(parameters: DeepReadonly<StudentFullappApiInAppLinksStudentPostParameters> | void): ServiceOperationMutationKey<StudentFullappApiInAppLinksStudentPostSchema, StudentFullappApiInAppLinksStudentPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Student
         * @description Pre-auth WebView links for a student (study-helper-board + follow-ups).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentFullappApiInAppLinksStudentPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentFullappApiInAppLinksStudentPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends StudentFullappApiInAppLinksStudentPostBody, TContext = unknown>(parameters: DeepReadonly<StudentFullappApiInAppLinksStudentPostParameters>, options?: ServiceOperationUseMutationOptions<StudentFullappApiInAppLinksStudentPostSchema, StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostParameters, TVariables, OperationError<StudentFullappApiInAppLinksStudentPostError>, TContext>): UseMutationResult<StudentFullappApiInAppLinksStudentPostData, OperationError<StudentFullappApiInAppLinksStudentPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Student
         * @description Pre-auth WebView links for a student (study-helper-board + follow-ups).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentFullappApiInAppLinksStudentPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentFullappApiInAppLinksStudentPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<StudentFullappApiInAppLinksStudentPostSchema, StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostParameters, TVariables, OperationError<StudentFullappApiInAppLinksStudentPostError>, TContext>): UseMutationResult<StudentFullappApiInAppLinksStudentPostData, OperationError<StudentFullappApiInAppLinksStudentPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Student
         * @description Pre-auth WebView links for a student (study-helper-board + follow-ups).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const studentFullappApiInAppLinksStudentPostTotal = qraft.fullappApiService.studentFullappApiInAppLinksStudentPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const studentFullappApiInAppLinksStudentPostTotal = qraft.fullappApiService.studentFullappApiInAppLinksStudentPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostParameters, OperationError<StudentFullappApiInAppLinksStudentPostError>, TContext> | MutationFiltersByMutationKey<StudentFullappApiInAppLinksStudentPostSchema, StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostParameters, OperationError<StudentFullappApiInAppLinksStudentPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Student
         * @description Pre-auth WebView links for a student (study-helper-board + follow-ups).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const studentFullappApiInAppLinksStudentPostPendingMutationVariables = qraft.fullappApiService.studentFullappApiInAppLinksStudentPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const studentFullappApiInAppLinksStudentPostMutationData = qraft.fullappApiService.studentFullappApiInAppLinksStudentPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<StudentFullappApiInAppLinksStudentPostData, OperationError<StudentFullappApiInAppLinksStudentPostError>, MutationVariables<StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostParameters, OperationError<StudentFullappApiInAppLinksStudentPostError>, TContext> | MutationFiltersByMutationKey<StudentFullappApiInAppLinksStudentPostSchema, StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostParameters, OperationError<StudentFullappApiInAppLinksStudentPostError>, TContext>;
            select?: (mutation: Mutation<StudentFullappApiInAppLinksStudentPostData, OperationError<StudentFullappApiInAppLinksStudentPostError>, MutationVariables<StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Student
         * @description Pre-auth WebView links for a student (study-helper-board + follow-ups).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostParameters, OperationError<StudentFullappApiInAppLinksStudentPostError>, TContext> | MutationFiltersByMutationKey<StudentFullappApiInAppLinksStudentPostSchema, StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostParameters, OperationError<StudentFullappApiInAppLinksStudentPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Student
         * @description Pre-auth WebView links for a student (study-helper-board + follow-ups).
         *
         * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
         * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
         * only and would drop the top-level ``success``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.studentFullappApiInAppLinksStudentPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.studentFullappApiInAppLinksStudentPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostParameters, OperationError<StudentFullappApiInAppLinksStudentPostError>, TContext> | MutationFiltersByMutationKey<StudentFullappApiInAppLinksStudentPostSchema, StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostParameters, OperationError<StudentFullappApiInAppLinksStudentPostError>, TContext>): Mutation<StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostError, MutationVariables<StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostParameters, OperationError<StudentFullappApiInAppLinksStudentPostError>, TContext> | MutationFiltersByMutationKey<StudentFullappApiInAppLinksStudentPostSchema, StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostParameters, OperationError<StudentFullappApiInAppLinksStudentPostError>, TContext>): Array<Mutation<StudentFullappApiInAppLinksStudentPostData, StudentFullappApiInAppLinksStudentPostError, MutationVariables<StudentFullappApiInAppLinksStudentPostBody, StudentFullappApiInAppLinksStudentPostParameters>, TContext>>;
        };
        schema: StudentFullappApiInAppLinksStudentPostSchema;
        types: {
            parameters: StudentFullappApiInAppLinksStudentPostParameters;
            data: StudentFullappApiInAppLinksStudentPostData;
            error: StudentFullappApiInAppLinksStudentPostError;
            body: StudentFullappApiInAppLinksStudentPostBody;
        };
    };
    /** @summary Student News Detail */
    studentNewsDetailFullappApiStudentNewsDetailPost: {
        /** @summary Student News Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostParameters, TMeta, TSignal>, client?: (schema: StudentNewsDetailFullappApiStudentNewsDetailPostSchema, options: ServiceOperationMutationFnOptions<StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostError>>): Promise<RequestFnResponse<StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostError>>;
        /** @summary Student News Detail */
        getMutationKey(parameters: DeepReadonly<StudentNewsDetailFullappApiStudentNewsDetailPostParameters> | void): ServiceOperationMutationKey<StudentNewsDetailFullappApiStudentNewsDetailPostSchema, StudentNewsDetailFullappApiStudentNewsDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Student News Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentNewsDetailFullappApiStudentNewsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentNewsDetailFullappApiStudentNewsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends StudentNewsDetailFullappApiStudentNewsDetailPostBody, TContext = unknown>(parameters: DeepReadonly<StudentNewsDetailFullappApiStudentNewsDetailPostParameters>, options?: ServiceOperationUseMutationOptions<StudentNewsDetailFullappApiStudentNewsDetailPostSchema, StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostParameters, TVariables, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, TContext>): UseMutationResult<StudentNewsDetailFullappApiStudentNewsDetailPostData, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Student News Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentNewsDetailFullappApiStudentNewsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentNewsDetailFullappApiStudentNewsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<StudentNewsDetailFullappApiStudentNewsDetailPostSchema, StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostParameters, TVariables, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, TContext>): UseMutationResult<StudentNewsDetailFullappApiStudentNewsDetailPostData, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Student News Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const studentNewsDetailFullappApiStudentNewsDetailPostTotal = qraft.fullappApiService.studentNewsDetailFullappApiStudentNewsDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const studentNewsDetailFullappApiStudentNewsDetailPostTotal = qraft.fullappApiService.studentNewsDetailFullappApiStudentNewsDetailPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostParameters, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudentNewsDetailFullappApiStudentNewsDetailPostSchema, StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostParameters, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Student News Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const studentNewsDetailFullappApiStudentNewsDetailPostPendingMutationVariables = qraft.fullappApiService.studentNewsDetailFullappApiStudentNewsDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const studentNewsDetailFullappApiStudentNewsDetailPostMutationData = qraft.fullappApiService.studentNewsDetailFullappApiStudentNewsDetailPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<StudentNewsDetailFullappApiStudentNewsDetailPostData, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, MutationVariables<StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostParameters, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudentNewsDetailFullappApiStudentNewsDetailPostSchema, StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostParameters, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, TContext>;
            select?: (mutation: Mutation<StudentNewsDetailFullappApiStudentNewsDetailPostData, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, MutationVariables<StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Student News Detail */
        isMutating<TContext>(filters?: MutationFiltersByParameters<StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostParameters, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudentNewsDetailFullappApiStudentNewsDetailPostSchema, StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostParameters, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Student News Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.studentNewsDetailFullappApiStudentNewsDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.studentNewsDetailFullappApiStudentNewsDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostParameters, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudentNewsDetailFullappApiStudentNewsDetailPostSchema, StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostParameters, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, TContext>): Mutation<StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostError, MutationVariables<StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostParameters, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudentNewsDetailFullappApiStudentNewsDetailPostSchema, StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostParameters, OperationError<StudentNewsDetailFullappApiStudentNewsDetailPostError>, TContext>): Array<Mutation<StudentNewsDetailFullappApiStudentNewsDetailPostData, StudentNewsDetailFullappApiStudentNewsDetailPostError, MutationVariables<StudentNewsDetailFullappApiStudentNewsDetailPostBody, StudentNewsDetailFullappApiStudentNewsDetailPostParameters>, TContext>>;
        };
        schema: StudentNewsDetailFullappApiStudentNewsDetailPostSchema;
        types: {
            parameters: StudentNewsDetailFullappApiStudentNewsDetailPostParameters;
            data: StudentNewsDetailFullappApiStudentNewsDetailPostData;
            error: StudentNewsDetailFullappApiStudentNewsDetailPostError;
            body: StudentNewsDetailFullappApiStudentNewsDetailPostBody;
        };
    };
    /** @summary Student News List */
    studentNewsListFullappApiStudentNewsListPost: {
        /** @summary Student News List */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostParameters, TMeta, TSignal>, client?: (schema: StudentNewsListFullappApiStudentNewsListPostSchema, options: ServiceOperationMutationFnOptions<StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostError>>): Promise<RequestFnResponse<StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostError>>;
        /** @summary Student News List */
        getMutationKey(parameters: DeepReadonly<StudentNewsListFullappApiStudentNewsListPostParameters> | void): ServiceOperationMutationKey<StudentNewsListFullappApiStudentNewsListPostSchema, StudentNewsListFullappApiStudentNewsListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Student News List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentNewsListFullappApiStudentNewsListPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentNewsListFullappApiStudentNewsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends StudentNewsListFullappApiStudentNewsListPostBody, TContext = unknown>(parameters: DeepReadonly<StudentNewsListFullappApiStudentNewsListPostParameters>, options?: ServiceOperationUseMutationOptions<StudentNewsListFullappApiStudentNewsListPostSchema, StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostParameters, TVariables, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, TContext>): UseMutationResult<StudentNewsListFullappApiStudentNewsListPostData, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Student News List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentNewsListFullappApiStudentNewsListPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentNewsListFullappApiStudentNewsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<StudentNewsListFullappApiStudentNewsListPostSchema, StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostParameters, TVariables, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, TContext>): UseMutationResult<StudentNewsListFullappApiStudentNewsListPostData, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Student News List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const studentNewsListFullappApiStudentNewsListPostTotal = qraft.fullappApiService.studentNewsListFullappApiStudentNewsListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const studentNewsListFullappApiStudentNewsListPostTotal = qraft.fullappApiService.studentNewsListFullappApiStudentNewsListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostParameters, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, TContext> | MutationFiltersByMutationKey<StudentNewsListFullappApiStudentNewsListPostSchema, StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostParameters, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Student News List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const studentNewsListFullappApiStudentNewsListPostPendingMutationVariables = qraft.fullappApiService.studentNewsListFullappApiStudentNewsListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const studentNewsListFullappApiStudentNewsListPostMutationData = qraft.fullappApiService.studentNewsListFullappApiStudentNewsListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<StudentNewsListFullappApiStudentNewsListPostData, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, MutationVariables<StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostParameters, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, TContext> | MutationFiltersByMutationKey<StudentNewsListFullappApiStudentNewsListPostSchema, StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostParameters, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, TContext>;
            select?: (mutation: Mutation<StudentNewsListFullappApiStudentNewsListPostData, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, MutationVariables<StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Student News List */
        isMutating<TContext>(filters?: MutationFiltersByParameters<StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostParameters, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, TContext> | MutationFiltersByMutationKey<StudentNewsListFullappApiStudentNewsListPostSchema, StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostParameters, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Student News List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.studentNewsListFullappApiStudentNewsListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.studentNewsListFullappApiStudentNewsListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostParameters, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, TContext> | MutationFiltersByMutationKey<StudentNewsListFullappApiStudentNewsListPostSchema, StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostParameters, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, TContext>): Mutation<StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostError, MutationVariables<StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostParameters, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, TContext> | MutationFiltersByMutationKey<StudentNewsListFullappApiStudentNewsListPostSchema, StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostParameters, OperationError<StudentNewsListFullappApiStudentNewsListPostError>, TContext>): Array<Mutation<StudentNewsListFullappApiStudentNewsListPostData, StudentNewsListFullappApiStudentNewsListPostError, MutationVariables<StudentNewsListFullappApiStudentNewsListPostBody, StudentNewsListFullappApiStudentNewsListPostParameters>, TContext>>;
        };
        schema: StudentNewsListFullappApiStudentNewsListPostSchema;
        types: {
            parameters: StudentNewsListFullappApiStudentNewsListPostParameters;
            data: StudentNewsListFullappApiStudentNewsListPostData;
            error: StudentNewsListFullappApiStudentNewsListPostError;
            body: StudentNewsListFullappApiStudentNewsListPostBody;
        };
    };
    /** @summary Study Helper News Detail */
    studyHelperNewsDetailFullappApiStudyHelperNewsDetailPost: {
        /** @summary Study Helper News Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters, TMeta, TSignal>, client?: (schema: StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostSchema, options: ServiceOperationMutationFnOptions<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>>): Promise<RequestFnResponse<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>>;
        /** @summary Study Helper News Detail */
        getMutationKey(parameters: DeepReadonly<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters> | void): ServiceOperationMutationKey<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostSchema, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Study Helper News Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperNewsDetailFullappApiStudyHelperNewsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperNewsDetailFullappApiStudyHelperNewsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, TContext = unknown>(parameters: DeepReadonly<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters>, options?: ServiceOperationUseMutationOptions<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostSchema, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters, TVariables, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, TContext>): UseMutationResult<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Study Helper News Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperNewsDetailFullappApiStudyHelperNewsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperNewsDetailFullappApiStudyHelperNewsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostSchema, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters, TVariables, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, TContext>): UseMutationResult<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Study Helper News Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const studyHelperNewsDetailFullappApiStudyHelperNewsDetailPostTotal = qraft.fullappApiService.studyHelperNewsDetailFullappApiStudyHelperNewsDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const studyHelperNewsDetailFullappApiStudyHelperNewsDetailPostTotal = qraft.fullappApiService.studyHelperNewsDetailFullappApiStudyHelperNewsDetailPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostSchema, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Study Helper News Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const studyHelperNewsDetailFullappApiStudyHelperNewsDetailPostPendingMutationVariables = qraft.fullappApiService.studyHelperNewsDetailFullappApiStudyHelperNewsDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const studyHelperNewsDetailFullappApiStudyHelperNewsDetailPostMutationData = qraft.fullappApiService.studyHelperNewsDetailFullappApiStudyHelperNewsDetailPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, MutationVariables<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostSchema, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, TContext>;
            select?: (mutation: Mutation<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, MutationVariables<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Study Helper News Detail */
        isMutating<TContext>(filters?: MutationFiltersByParameters<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostSchema, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Study Helper News Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.studyHelperNewsDetailFullappApiStudyHelperNewsDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.studyHelperNewsDetailFullappApiStudyHelperNewsDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostSchema, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, TContext>): Mutation<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError, MutationVariables<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostSchema, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters, OperationError<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError>, TContext>): Array<Mutation<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError, MutationVariables<StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody, StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters>, TContext>>;
        };
        schema: StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostSchema;
        types: {
            parameters: StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters;
            data: StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData;
            error: StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError;
            body: StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody;
        };
    };
    /** @summary Study Helper News List */
    studyHelperNewsListFullappApiStudyHelperNewsListPost: {
        /** @summary Study Helper News List */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters, TMeta, TSignal>, client?: (schema: StudyHelperNewsListFullappApiStudyHelperNewsListPostSchema, options: ServiceOperationMutationFnOptions<StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostError>>): Promise<RequestFnResponse<StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostError>>;
        /** @summary Study Helper News List */
        getMutationKey(parameters: DeepReadonly<StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters> | void): ServiceOperationMutationKey<StudyHelperNewsListFullappApiStudyHelperNewsListPostSchema, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Study Helper News List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperNewsListFullappApiStudyHelperNewsListPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperNewsListFullappApiStudyHelperNewsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, TContext = unknown>(parameters: DeepReadonly<StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters>, options?: ServiceOperationUseMutationOptions<StudyHelperNewsListFullappApiStudyHelperNewsListPostSchema, StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters, TVariables, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, TContext>): UseMutationResult<StudyHelperNewsListFullappApiStudyHelperNewsListPostData, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Study Helper News List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperNewsListFullappApiStudyHelperNewsListPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperNewsListFullappApiStudyHelperNewsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<StudyHelperNewsListFullappApiStudyHelperNewsListPostSchema, StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters, TVariables, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, TContext>): UseMutationResult<StudyHelperNewsListFullappApiStudyHelperNewsListPostData, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Study Helper News List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const studyHelperNewsListFullappApiStudyHelperNewsListPostTotal = qraft.fullappApiService.studyHelperNewsListFullappApiStudyHelperNewsListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const studyHelperNewsListFullappApiStudyHelperNewsListPostTotal = qraft.fullappApiService.studyHelperNewsListFullappApiStudyHelperNewsListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperNewsListFullappApiStudyHelperNewsListPostSchema, StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Study Helper News List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const studyHelperNewsListFullappApiStudyHelperNewsListPostPendingMutationVariables = qraft.fullappApiService.studyHelperNewsListFullappApiStudyHelperNewsListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const studyHelperNewsListFullappApiStudyHelperNewsListPostMutationData = qraft.fullappApiService.studyHelperNewsListFullappApiStudyHelperNewsListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<StudyHelperNewsListFullappApiStudyHelperNewsListPostData, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, MutationVariables<StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperNewsListFullappApiStudyHelperNewsListPostSchema, StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, TContext>;
            select?: (mutation: Mutation<StudyHelperNewsListFullappApiStudyHelperNewsListPostData, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, MutationVariables<StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Study Helper News List */
        isMutating<TContext>(filters?: MutationFiltersByParameters<StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperNewsListFullappApiStudyHelperNewsListPostSchema, StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Study Helper News List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.studyHelperNewsListFullappApiStudyHelperNewsListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.studyHelperNewsListFullappApiStudyHelperNewsListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperNewsListFullappApiStudyHelperNewsListPostSchema, StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, TContext>): Mutation<StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostError, MutationVariables<StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperNewsListFullappApiStudyHelperNewsListPostSchema, StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters, OperationError<StudyHelperNewsListFullappApiStudyHelperNewsListPostError>, TContext>): Array<Mutation<StudyHelperNewsListFullappApiStudyHelperNewsListPostData, StudyHelperNewsListFullappApiStudyHelperNewsListPostError, MutationVariables<StudyHelperNewsListFullappApiStudyHelperNewsListPostBody, StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters>, TContext>>;
        };
        schema: StudyHelperNewsListFullappApiStudyHelperNewsListPostSchema;
        types: {
            parameters: StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters;
            data: StudyHelperNewsListFullappApiStudyHelperNewsListPostData;
            error: StudyHelperNewsListFullappApiStudyHelperNewsListPostError;
            body: StudyHelperNewsListFullappApiStudyHelperNewsListPostBody;
        };
    };
    /** @summary Student Tutorials Detail */
    studentTutorialsDetailFullappApiStudentTutorialsDetailPost: {
        /** @summary Student Tutorials Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters, TMeta, TSignal>, client?: (schema: StudentTutorialsDetailFullappApiStudentTutorialsDetailPostSchema, options: ServiceOperationMutationFnOptions<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>>): Promise<RequestFnResponse<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>>;
        /** @summary Student Tutorials Detail */
        getMutationKey(parameters: DeepReadonly<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters> | void): ServiceOperationMutationKey<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostSchema, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Student Tutorials Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentTutorialsDetailFullappApiStudentTutorialsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentTutorialsDetailFullappApiStudentTutorialsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, TContext = unknown>(parameters: DeepReadonly<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters>, options?: ServiceOperationUseMutationOptions<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostSchema, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters, TVariables, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, TContext>): UseMutationResult<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Student Tutorials Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentTutorialsDetailFullappApiStudentTutorialsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentTutorialsDetailFullappApiStudentTutorialsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostSchema, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters, TVariables, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, TContext>): UseMutationResult<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Student Tutorials Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const studentTutorialsDetailFullappApiStudentTutorialsDetailPostTotal = qraft.fullappApiService.studentTutorialsDetailFullappApiStudentTutorialsDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const studentTutorialsDetailFullappApiStudentTutorialsDetailPostTotal = qraft.fullappApiService.studentTutorialsDetailFullappApiStudentTutorialsDetailPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostSchema, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Student Tutorials Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const studentTutorialsDetailFullappApiStudentTutorialsDetailPostPendingMutationVariables = qraft.fullappApiService.studentTutorialsDetailFullappApiStudentTutorialsDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const studentTutorialsDetailFullappApiStudentTutorialsDetailPostMutationData = qraft.fullappApiService.studentTutorialsDetailFullappApiStudentTutorialsDetailPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, MutationVariables<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostSchema, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, TContext>;
            select?: (mutation: Mutation<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, MutationVariables<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Student Tutorials Detail */
        isMutating<TContext>(filters?: MutationFiltersByParameters<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostSchema, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Student Tutorials Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.studentTutorialsDetailFullappApiStudentTutorialsDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.studentTutorialsDetailFullappApiStudentTutorialsDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostSchema, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, TContext>): Mutation<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError, MutationVariables<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostSchema, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters, OperationError<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError>, TContext>): Array<Mutation<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError, MutationVariables<StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody, StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters>, TContext>>;
        };
        schema: StudentTutorialsDetailFullappApiStudentTutorialsDetailPostSchema;
        types: {
            parameters: StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters;
            data: StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData;
            error: StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError;
            body: StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody;
        };
    };
    /** @summary Student Tutorials List */
    studentTutorialsListFullappApiStudentTutorialsListPost: {
        /** @summary Student Tutorials List */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostParameters, TMeta, TSignal>, client?: (schema: StudentTutorialsListFullappApiStudentTutorialsListPostSchema, options: ServiceOperationMutationFnOptions<StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostError>>): Promise<RequestFnResponse<StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostError>>;
        /** @summary Student Tutorials List */
        getMutationKey(parameters: DeepReadonly<StudentTutorialsListFullappApiStudentTutorialsListPostParameters> | void): ServiceOperationMutationKey<StudentTutorialsListFullappApiStudentTutorialsListPostSchema, StudentTutorialsListFullappApiStudentTutorialsListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Student Tutorials List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentTutorialsListFullappApiStudentTutorialsListPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentTutorialsListFullappApiStudentTutorialsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends StudentTutorialsListFullappApiStudentTutorialsListPostBody, TContext = unknown>(parameters: DeepReadonly<StudentTutorialsListFullappApiStudentTutorialsListPostParameters>, options?: ServiceOperationUseMutationOptions<StudentTutorialsListFullappApiStudentTutorialsListPostSchema, StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostParameters, TVariables, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, TContext>): UseMutationResult<StudentTutorialsListFullappApiStudentTutorialsListPostData, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Student Tutorials List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentTutorialsListFullappApiStudentTutorialsListPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentTutorialsListFullappApiStudentTutorialsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<StudentTutorialsListFullappApiStudentTutorialsListPostSchema, StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostParameters, TVariables, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, TContext>): UseMutationResult<StudentTutorialsListFullappApiStudentTutorialsListPostData, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Student Tutorials List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const studentTutorialsListFullappApiStudentTutorialsListPostTotal = qraft.fullappApiService.studentTutorialsListFullappApiStudentTutorialsListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const studentTutorialsListFullappApiStudentTutorialsListPostTotal = qraft.fullappApiService.studentTutorialsListFullappApiStudentTutorialsListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostParameters, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, TContext> | MutationFiltersByMutationKey<StudentTutorialsListFullappApiStudentTutorialsListPostSchema, StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostParameters, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Student Tutorials List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const studentTutorialsListFullappApiStudentTutorialsListPostPendingMutationVariables = qraft.fullappApiService.studentTutorialsListFullappApiStudentTutorialsListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const studentTutorialsListFullappApiStudentTutorialsListPostMutationData = qraft.fullappApiService.studentTutorialsListFullappApiStudentTutorialsListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<StudentTutorialsListFullappApiStudentTutorialsListPostData, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, MutationVariables<StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostParameters, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, TContext> | MutationFiltersByMutationKey<StudentTutorialsListFullappApiStudentTutorialsListPostSchema, StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostParameters, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, TContext>;
            select?: (mutation: Mutation<StudentTutorialsListFullappApiStudentTutorialsListPostData, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, MutationVariables<StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Student Tutorials List */
        isMutating<TContext>(filters?: MutationFiltersByParameters<StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostParameters, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, TContext> | MutationFiltersByMutationKey<StudentTutorialsListFullappApiStudentTutorialsListPostSchema, StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostParameters, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Student Tutorials List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.studentTutorialsListFullappApiStudentTutorialsListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.studentTutorialsListFullappApiStudentTutorialsListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostParameters, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, TContext> | MutationFiltersByMutationKey<StudentTutorialsListFullappApiStudentTutorialsListPostSchema, StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostParameters, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, TContext>): Mutation<StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostError, MutationVariables<StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostParameters, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, TContext> | MutationFiltersByMutationKey<StudentTutorialsListFullappApiStudentTutorialsListPostSchema, StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostParameters, OperationError<StudentTutorialsListFullappApiStudentTutorialsListPostError>, TContext>): Array<Mutation<StudentTutorialsListFullappApiStudentTutorialsListPostData, StudentTutorialsListFullappApiStudentTutorialsListPostError, MutationVariables<StudentTutorialsListFullappApiStudentTutorialsListPostBody, StudentTutorialsListFullappApiStudentTutorialsListPostParameters>, TContext>>;
        };
        schema: StudentTutorialsListFullappApiStudentTutorialsListPostSchema;
        types: {
            parameters: StudentTutorialsListFullappApiStudentTutorialsListPostParameters;
            data: StudentTutorialsListFullappApiStudentTutorialsListPostData;
            error: StudentTutorialsListFullappApiStudentTutorialsListPostError;
            body: StudentTutorialsListFullappApiStudentTutorialsListPostBody;
        };
    };
    /** @summary Study Helper Tutorials Detail */
    studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPost: {
        /** @summary Study Helper Tutorials Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters, TMeta, TSignal>, client?: (schema: StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostSchema, options: ServiceOperationMutationFnOptions<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>>): Promise<RequestFnResponse<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>>;
        /** @summary Study Helper Tutorials Detail */
        getMutationKey(parameters: DeepReadonly<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters> | void): ServiceOperationMutationKey<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostSchema, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Study Helper Tutorials Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, TContext = unknown>(parameters: DeepReadonly<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters>, options?: ServiceOperationUseMutationOptions<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostSchema, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters, TVariables, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, TContext>): UseMutationResult<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Study Helper Tutorials Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostSchema, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters, TVariables, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, TContext>): UseMutationResult<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Study Helper Tutorials Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostTotal = qraft.fullappApiService.studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostTotal = qraft.fullappApiService.studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostSchema, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Study Helper Tutorials Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostPendingMutationVariables = qraft.fullappApiService.studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostMutationData = qraft.fullappApiService.studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, MutationVariables<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostSchema, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, TContext>;
            select?: (mutation: Mutation<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, MutationVariables<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Study Helper Tutorials Detail */
        isMutating<TContext>(filters?: MutationFiltersByParameters<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostSchema, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Study Helper Tutorials Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostSchema, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, TContext>): Mutation<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError, MutationVariables<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostSchema, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters, OperationError<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError>, TContext>): Array<Mutation<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError, MutationVariables<StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody, StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters>, TContext>>;
        };
        schema: StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostSchema;
        types: {
            parameters: StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters;
            data: StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData;
            error: StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError;
            body: StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody;
        };
    };
    /** @summary Study Helper Tutorials List */
    studyHelperTutorialsListFullappApiStudyHelperTutorialsListPost: {
        /** @summary Study Helper Tutorials List */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters, TMeta, TSignal>, client?: (schema: StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostSchema, options: ServiceOperationMutationFnOptions<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>>): Promise<RequestFnResponse<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>>;
        /** @summary Study Helper Tutorials List */
        getMutationKey(parameters: DeepReadonly<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters> | void): ServiceOperationMutationKey<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostSchema, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Study Helper Tutorials List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperTutorialsListFullappApiStudyHelperTutorialsListPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperTutorialsListFullappApiStudyHelperTutorialsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, TContext = unknown>(parameters: DeepReadonly<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters>, options?: ServiceOperationUseMutationOptions<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostSchema, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters, TVariables, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, TContext>): UseMutationResult<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Study Helper Tutorials List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperTutorialsListFullappApiStudyHelperTutorialsListPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyHelperTutorialsListFullappApiStudyHelperTutorialsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostSchema, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters, TVariables, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, TContext>): UseMutationResult<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Study Helper Tutorials List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const studyHelperTutorialsListFullappApiStudyHelperTutorialsListPostTotal = qraft.fullappApiService.studyHelperTutorialsListFullappApiStudyHelperTutorialsListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const studyHelperTutorialsListFullappApiStudyHelperTutorialsListPostTotal = qraft.fullappApiService.studyHelperTutorialsListFullappApiStudyHelperTutorialsListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostSchema, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Study Helper Tutorials List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const studyHelperTutorialsListFullappApiStudyHelperTutorialsListPostPendingMutationVariables = qraft.fullappApiService.studyHelperTutorialsListFullappApiStudyHelperTutorialsListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const studyHelperTutorialsListFullappApiStudyHelperTutorialsListPostMutationData = qraft.fullappApiService.studyHelperTutorialsListFullappApiStudyHelperTutorialsListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, MutationVariables<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostSchema, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, TContext>;
            select?: (mutation: Mutation<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, MutationVariables<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Study Helper Tutorials List */
        isMutating<TContext>(filters?: MutationFiltersByParameters<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostSchema, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Study Helper Tutorials List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.studyHelperTutorialsListFullappApiStudyHelperTutorialsListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.studyHelperTutorialsListFullappApiStudyHelperTutorialsListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostSchema, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, TContext>): Mutation<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError, MutationVariables<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, TContext> | MutationFiltersByMutationKey<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostSchema, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters, OperationError<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError>, TContext>): Array<Mutation<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError, MutationVariables<StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody, StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters>, TContext>>;
        };
        schema: StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostSchema;
        types: {
            parameters: StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters;
            data: StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData;
            error: StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError;
            body: StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody;
        };
    };
    /** @summary Adopt Student */
    adoptStudentFullappApiAdoptionsAdoptPost: {
        /** @summary Adopt Student */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostParameters, TMeta, TSignal>, client?: (schema: AdoptStudentFullappApiAdoptionsAdoptPostSchema, options: ServiceOperationMutationFnOptions<AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostError>>): Promise<RequestFnResponse<AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostError>>;
        /** @summary Adopt Student */
        getMutationKey(parameters: DeepReadonly<AdoptStudentFullappApiAdoptionsAdoptPostParameters> | void): ServiceOperationMutationKey<AdoptStudentFullappApiAdoptionsAdoptPostSchema, AdoptStudentFullappApiAdoptionsAdoptPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.adoptStudentFullappApiAdoptionsAdoptPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.adoptStudentFullappApiAdoptionsAdoptPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdoptStudentFullappApiAdoptionsAdoptPostBody, TContext = unknown>(parameters: DeepReadonly<AdoptStudentFullappApiAdoptionsAdoptPostParameters>, options?: ServiceOperationUseMutationOptions<AdoptStudentFullappApiAdoptionsAdoptPostSchema, AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostParameters, TVariables, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, TContext>): UseMutationResult<AdoptStudentFullappApiAdoptionsAdoptPostData, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.adoptStudentFullappApiAdoptionsAdoptPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.adoptStudentFullappApiAdoptionsAdoptPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdoptStudentFullappApiAdoptionsAdoptPostSchema, AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostParameters, TVariables, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, TContext>): UseMutationResult<AdoptStudentFullappApiAdoptionsAdoptPostData, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adoptStudentFullappApiAdoptionsAdoptPostTotal = qraft.fullappApiService.adoptStudentFullappApiAdoptionsAdoptPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adoptStudentFullappApiAdoptionsAdoptPostTotal = qraft.fullappApiService.adoptStudentFullappApiAdoptionsAdoptPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostParameters, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, TContext> | MutationFiltersByMutationKey<AdoptStudentFullappApiAdoptionsAdoptPostSchema, AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostParameters, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adoptStudentFullappApiAdoptionsAdoptPostPendingMutationVariables = qraft.fullappApiService.adoptStudentFullappApiAdoptionsAdoptPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adoptStudentFullappApiAdoptionsAdoptPostMutationData = qraft.fullappApiService.adoptStudentFullappApiAdoptionsAdoptPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdoptStudentFullappApiAdoptionsAdoptPostData, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, MutationVariables<AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostParameters, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, TContext> | MutationFiltersByMutationKey<AdoptStudentFullappApiAdoptionsAdoptPostSchema, AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostParameters, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, TContext>;
            select?: (mutation: Mutation<AdoptStudentFullappApiAdoptionsAdoptPostData, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, MutationVariables<AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Adopt Student */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostParameters, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, TContext> | MutationFiltersByMutationKey<AdoptStudentFullappApiAdoptionsAdoptPostSchema, AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostParameters, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.adoptStudentFullappApiAdoptionsAdoptPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.adoptStudentFullappApiAdoptionsAdoptPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostParameters, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, TContext> | MutationFiltersByMutationKey<AdoptStudentFullappApiAdoptionsAdoptPostSchema, AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostParameters, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, TContext>): Mutation<AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostError, MutationVariables<AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostParameters, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, TContext> | MutationFiltersByMutationKey<AdoptStudentFullappApiAdoptionsAdoptPostSchema, AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostParameters, OperationError<AdoptStudentFullappApiAdoptionsAdoptPostError>, TContext>): Array<Mutation<AdoptStudentFullappApiAdoptionsAdoptPostData, AdoptStudentFullappApiAdoptionsAdoptPostError, MutationVariables<AdoptStudentFullappApiAdoptionsAdoptPostBody, AdoptStudentFullappApiAdoptionsAdoptPostParameters>, TContext>>;
        };
        schema: AdoptStudentFullappApiAdoptionsAdoptPostSchema;
        types: {
            parameters: AdoptStudentFullappApiAdoptionsAdoptPostParameters;
            data: AdoptStudentFullappApiAdoptionsAdoptPostData;
            error: AdoptStudentFullappApiAdoptionsAdoptPostError;
            body: AdoptStudentFullappApiAdoptionsAdoptPostBody;
        };
    };
    /** @summary Connect Adopt Student */
    connectAdoptStudentFullappApiAdoptionsConnectAdoptionPost: {
        /** @summary Connect Adopt Student */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters, TMeta, TSignal>, client?: (schema: ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostSchema, options: ServiceOperationMutationFnOptions<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>>): Promise<RequestFnResponse<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>>;
        /** @summary Connect Adopt Student */
        getMutationKey(parameters: DeepReadonly<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters> | void): ServiceOperationMutationKey<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostSchema, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Connect Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.connectAdoptStudentFullappApiAdoptionsConnectAdoptionPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.connectAdoptStudentFullappApiAdoptionsConnectAdoptionPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, TContext = unknown>(parameters: DeepReadonly<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters>, options?: ServiceOperationUseMutationOptions<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostSchema, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters, TVariables, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, TContext>): UseMutationResult<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Connect Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.connectAdoptStudentFullappApiAdoptionsConnectAdoptionPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.connectAdoptStudentFullappApiAdoptionsConnectAdoptionPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostSchema, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters, TVariables, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, TContext>): UseMutationResult<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Connect Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const connectAdoptStudentFullappApiAdoptionsConnectAdoptionPostTotal = qraft.fullappApiService.connectAdoptStudentFullappApiAdoptionsConnectAdoptionPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const connectAdoptStudentFullappApiAdoptionsConnectAdoptionPostTotal = qraft.fullappApiService.connectAdoptStudentFullappApiAdoptionsConnectAdoptionPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, TContext> | MutationFiltersByMutationKey<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostSchema, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Connect Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const connectAdoptStudentFullappApiAdoptionsConnectAdoptionPostPendingMutationVariables = qraft.fullappApiService.connectAdoptStudentFullappApiAdoptionsConnectAdoptionPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const connectAdoptStudentFullappApiAdoptionsConnectAdoptionPostMutationData = qraft.fullappApiService.connectAdoptStudentFullappApiAdoptionsConnectAdoptionPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, MutationVariables<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, TContext> | MutationFiltersByMutationKey<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostSchema, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, TContext>;
            select?: (mutation: Mutation<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, MutationVariables<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Connect Adopt Student */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, TContext> | MutationFiltersByMutationKey<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostSchema, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Connect Adopt Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.connectAdoptStudentFullappApiAdoptionsConnectAdoptionPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.connectAdoptStudentFullappApiAdoptionsConnectAdoptionPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, TContext> | MutationFiltersByMutationKey<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostSchema, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, TContext>): Mutation<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError, MutationVariables<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, TContext> | MutationFiltersByMutationKey<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostSchema, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters, OperationError<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError>, TContext>): Array<Mutation<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError, MutationVariables<ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody, ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters>, TContext>>;
        };
        schema: ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostSchema;
        types: {
            parameters: ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters;
            data: ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData;
            error: ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError;
            body: ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody;
        };
    };
    /** @summary Get Adoption Info */
    getAdoptionInfoFullappApiAdoptionsInfoPost: {
        /** @summary Get Adoption Info */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters, TMeta, TSignal>, client?: (schema: GetAdoptionInfoFullappApiAdoptionsInfoPostSchema, options: ServiceOperationMutationFnOptions<GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostError>>): Promise<RequestFnResponse<GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostError>>;
        /** @summary Get Adoption Info */
        getMutationKey(parameters: DeepReadonly<GetAdoptionInfoFullappApiAdoptionsInfoPostParameters> | void): ServiceOperationMutationKey<GetAdoptionInfoFullappApiAdoptionsInfoPostSchema, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Adoption Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getAdoptionInfoFullappApiAdoptionsInfoPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getAdoptionInfoFullappApiAdoptionsInfoPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends GetAdoptionInfoFullappApiAdoptionsInfoPostBody, TContext = unknown>(parameters: DeepReadonly<GetAdoptionInfoFullappApiAdoptionsInfoPostParameters>, options?: ServiceOperationUseMutationOptions<GetAdoptionInfoFullappApiAdoptionsInfoPostSchema, GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters, TVariables, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, TContext>): UseMutationResult<GetAdoptionInfoFullappApiAdoptionsInfoPostData, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Adoption Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getAdoptionInfoFullappApiAdoptionsInfoPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getAdoptionInfoFullappApiAdoptionsInfoPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GetAdoptionInfoFullappApiAdoptionsInfoPostSchema, GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters, TVariables, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, TContext>): UseMutationResult<GetAdoptionInfoFullappApiAdoptionsInfoPostData, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Get Adoption Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const getAdoptionInfoFullappApiAdoptionsInfoPostTotal = qraft.fullappApiService.getAdoptionInfoFullappApiAdoptionsInfoPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const getAdoptionInfoFullappApiAdoptionsInfoPostTotal = qraft.fullappApiService.getAdoptionInfoFullappApiAdoptionsInfoPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, TContext> | MutationFiltersByMutationKey<GetAdoptionInfoFullappApiAdoptionsInfoPostSchema, GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Get Adoption Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const getAdoptionInfoFullappApiAdoptionsInfoPostPendingMutationVariables = qraft.fullappApiService.getAdoptionInfoFullappApiAdoptionsInfoPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const getAdoptionInfoFullappApiAdoptionsInfoPostMutationData = qraft.fullappApiService.getAdoptionInfoFullappApiAdoptionsInfoPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GetAdoptionInfoFullappApiAdoptionsInfoPostData, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, MutationVariables<GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, TContext> | MutationFiltersByMutationKey<GetAdoptionInfoFullappApiAdoptionsInfoPostSchema, GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, TContext>;
            select?: (mutation: Mutation<GetAdoptionInfoFullappApiAdoptionsInfoPostData, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, MutationVariables<GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Get Adoption Info */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, TContext> | MutationFiltersByMutationKey<GetAdoptionInfoFullappApiAdoptionsInfoPostSchema, GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Get Adoption Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.getAdoptionInfoFullappApiAdoptionsInfoPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.getAdoptionInfoFullappApiAdoptionsInfoPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, TContext> | MutationFiltersByMutationKey<GetAdoptionInfoFullappApiAdoptionsInfoPostSchema, GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, TContext>): Mutation<GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostError, MutationVariables<GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, TContext> | MutationFiltersByMutationKey<GetAdoptionInfoFullappApiAdoptionsInfoPostSchema, GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters, OperationError<GetAdoptionInfoFullappApiAdoptionsInfoPostError>, TContext>): Array<Mutation<GetAdoptionInfoFullappApiAdoptionsInfoPostData, GetAdoptionInfoFullappApiAdoptionsInfoPostError, MutationVariables<GetAdoptionInfoFullappApiAdoptionsInfoPostBody, GetAdoptionInfoFullappApiAdoptionsInfoPostParameters>, TContext>>;
        };
        schema: GetAdoptionInfoFullappApiAdoptionsInfoPostSchema;
        types: {
            parameters: GetAdoptionInfoFullappApiAdoptionsInfoPostParameters;
            data: GetAdoptionInfoFullappApiAdoptionsInfoPostData;
            error: GetAdoptionInfoFullappApiAdoptionsInfoPostError;
            body: GetAdoptionInfoFullappApiAdoptionsInfoPostBody;
        };
    };
    /** @summary Pass On Student Fullapp */
    passOnStudentFullappFullappApiAdoptionsPassonPost: {
        /** @summary Pass On Student Fullapp */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters, TMeta, TSignal>, client?: (schema: PassOnStudentFullappFullappApiAdoptionsPassonPostSchema, options: ServiceOperationMutationFnOptions<PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostError>>): Promise<RequestFnResponse<PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostError>>;
        /** @summary Pass On Student Fullapp */
        getMutationKey(parameters: DeepReadonly<PassOnStudentFullappFullappApiAdoptionsPassonPostParameters> | void): ServiceOperationMutationKey<PassOnStudentFullappFullappApiAdoptionsPassonPostSchema, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Pass On Student Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.passOnStudentFullappFullappApiAdoptionsPassonPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.passOnStudentFullappFullappApiAdoptionsPassonPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends PassOnStudentFullappFullappApiAdoptionsPassonPostBody, TContext = unknown>(parameters: DeepReadonly<PassOnStudentFullappFullappApiAdoptionsPassonPostParameters>, options?: ServiceOperationUseMutationOptions<PassOnStudentFullappFullappApiAdoptionsPassonPostSchema, PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters, TVariables, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, TContext>): UseMutationResult<PassOnStudentFullappFullappApiAdoptionsPassonPostData, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Pass On Student Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.passOnStudentFullappFullappApiAdoptionsPassonPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.passOnStudentFullappFullappApiAdoptionsPassonPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<PassOnStudentFullappFullappApiAdoptionsPassonPostSchema, PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters, TVariables, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, TContext>): UseMutationResult<PassOnStudentFullappFullappApiAdoptionsPassonPostData, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Pass On Student Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const passOnStudentFullappFullappApiAdoptionsPassonPostTotal = qraft.fullappApiService.passOnStudentFullappFullappApiAdoptionsPassonPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const passOnStudentFullappFullappApiAdoptionsPassonPostTotal = qraft.fullappApiService.passOnStudentFullappFullappApiAdoptionsPassonPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, TContext> | MutationFiltersByMutationKey<PassOnStudentFullappFullappApiAdoptionsPassonPostSchema, PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Pass On Student Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const passOnStudentFullappFullappApiAdoptionsPassonPostPendingMutationVariables = qraft.fullappApiService.passOnStudentFullappFullappApiAdoptionsPassonPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const passOnStudentFullappFullappApiAdoptionsPassonPostMutationData = qraft.fullappApiService.passOnStudentFullappFullappApiAdoptionsPassonPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<PassOnStudentFullappFullappApiAdoptionsPassonPostData, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, MutationVariables<PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, TContext> | MutationFiltersByMutationKey<PassOnStudentFullappFullappApiAdoptionsPassonPostSchema, PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, TContext>;
            select?: (mutation: Mutation<PassOnStudentFullappFullappApiAdoptionsPassonPostData, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, MutationVariables<PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Pass On Student Fullapp */
        isMutating<TContext>(filters?: MutationFiltersByParameters<PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, TContext> | MutationFiltersByMutationKey<PassOnStudentFullappFullappApiAdoptionsPassonPostSchema, PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Pass On Student Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.passOnStudentFullappFullappApiAdoptionsPassonPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.passOnStudentFullappFullappApiAdoptionsPassonPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, TContext> | MutationFiltersByMutationKey<PassOnStudentFullappFullappApiAdoptionsPassonPostSchema, PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, TContext>): Mutation<PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostError, MutationVariables<PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, TContext> | MutationFiltersByMutationKey<PassOnStudentFullappFullappApiAdoptionsPassonPostSchema, PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters, OperationError<PassOnStudentFullappFullappApiAdoptionsPassonPostError>, TContext>): Array<Mutation<PassOnStudentFullappFullappApiAdoptionsPassonPostData, PassOnStudentFullappFullappApiAdoptionsPassonPostError, MutationVariables<PassOnStudentFullappFullappApiAdoptionsPassonPostBody, PassOnStudentFullappFullappApiAdoptionsPassonPostParameters>, TContext>>;
        };
        schema: PassOnStudentFullappFullappApiAdoptionsPassonPostSchema;
        types: {
            parameters: PassOnStudentFullappFullappApiAdoptionsPassonPostParameters;
            data: PassOnStudentFullappFullappApiAdoptionsPassonPostData;
            error: PassOnStudentFullappFullappApiAdoptionsPassonPostError;
            body: PassOnStudentFullappFullappApiAdoptionsPassonPostBody;
        };
    };
    /** @summary Check Adoptability */
    checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPost: {
        /** @summary Check Adoptability */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters, TMeta, TSignal>, client?: (schema: CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostSchema, options: ServiceOperationMutationFnOptions<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>>): Promise<RequestFnResponse<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>>;
        /** @summary Check Adoptability */
        getMutationKey(parameters: DeepReadonly<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters> | void): ServiceOperationMutationKey<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostSchema, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Check Adoptability
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, TContext = unknown>(parameters: DeepReadonly<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters>, options?: ServiceOperationUseMutationOptions<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostSchema, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters, TVariables, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, TContext>): UseMutationResult<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Check Adoptability
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostSchema, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters, TVariables, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, TContext>): UseMutationResult<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Check Adoptability
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostTotal = qraft.fullappApiService.checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostTotal = qraft.fullappApiService.checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, TContext> | MutationFiltersByMutationKey<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostSchema, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Check Adoptability
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostPendingMutationVariables = qraft.fullappApiService.checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostMutationData = qraft.fullappApiService.checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, MutationVariables<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, TContext> | MutationFiltersByMutationKey<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostSchema, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, TContext>;
            select?: (mutation: Mutation<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, MutationVariables<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Check Adoptability */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, TContext> | MutationFiltersByMutationKey<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostSchema, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Check Adoptability
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, TContext> | MutationFiltersByMutationKey<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostSchema, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, TContext>): Mutation<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError, MutationVariables<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, TContext> | MutationFiltersByMutationKey<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostSchema, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters, OperationError<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError>, TContext>): Array<Mutation<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError, MutationVariables<CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody, CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters>, TContext>>;
        };
        schema: CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostSchema;
        types: {
            parameters: CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters;
            data: CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData;
            error: CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError;
            body: CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody;
        };
    };
    /** @summary Get Adoption Request Info */
    getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPost: {
        /** @summary Get Adoption Request Info */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters, TMeta, TSignal>, client?: (schema: GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostSchema, options: ServiceOperationMutationFnOptions<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>>): Promise<RequestFnResponse<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>>;
        /** @summary Get Adoption Request Info */
        getMutationKey(parameters: DeepReadonly<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters> | void): ServiceOperationMutationKey<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostSchema, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Adoption Request Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, TContext = unknown>(parameters: DeepReadonly<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters>, options?: ServiceOperationUseMutationOptions<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostSchema, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters, TVariables, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, TContext>): UseMutationResult<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Adoption Request Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostSchema, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters, TVariables, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, TContext>): UseMutationResult<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Get Adoption Request Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostTotal = qraft.fullappApiService.getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostTotal = qraft.fullappApiService.getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, TContext> | MutationFiltersByMutationKey<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostSchema, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Get Adoption Request Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostPendingMutationVariables = qraft.fullappApiService.getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostMutationData = qraft.fullappApiService.getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, MutationVariables<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, TContext> | MutationFiltersByMutationKey<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostSchema, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, TContext>;
            select?: (mutation: Mutation<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, MutationVariables<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Get Adoption Request Info */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, TContext> | MutationFiltersByMutationKey<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostSchema, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Get Adoption Request Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, TContext> | MutationFiltersByMutationKey<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostSchema, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, TContext>): Mutation<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError, MutationVariables<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, TContext> | MutationFiltersByMutationKey<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostSchema, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters, OperationError<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError>, TContext>): Array<Mutation<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError, MutationVariables<GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody, GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters>, TContext>>;
        };
        schema: GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostSchema;
        types: {
            parameters: GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters;
            data: GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData;
            error: GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError;
            body: GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody;
        };
    };
    /** @summary Accept Adoption Request Fullapp */
    acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPost: {
        /** @summary Accept Adoption Request Fullapp */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters, TMeta, TSignal>, client?: (schema: AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostSchema, options: ServiceOperationMutationFnOptions<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>>): Promise<RequestFnResponse<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>>;
        /** @summary Accept Adoption Request Fullapp */
        getMutationKey(parameters: DeepReadonly<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters> | void): ServiceOperationMutationKey<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostSchema, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Accept Adoption Request Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, TContext = unknown>(parameters: DeepReadonly<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters>, options?: ServiceOperationUseMutationOptions<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostSchema, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters, TVariables, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, TContext>): UseMutationResult<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Accept Adoption Request Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostSchema, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters, TVariables, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, TContext>): UseMutationResult<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Accept Adoption Request Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostTotal = qraft.fullappApiService.acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostTotal = qraft.fullappApiService.acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, TContext> | MutationFiltersByMutationKey<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostSchema, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Accept Adoption Request Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostPendingMutationVariables = qraft.fullappApiService.acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostMutationData = qraft.fullappApiService.acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, MutationVariables<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, TContext> | MutationFiltersByMutationKey<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostSchema, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, TContext>;
            select?: (mutation: Mutation<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, MutationVariables<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Accept Adoption Request Fullapp */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, TContext> | MutationFiltersByMutationKey<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostSchema, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Accept Adoption Request Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, TContext> | MutationFiltersByMutationKey<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostSchema, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, TContext>): Mutation<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError, MutationVariables<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, TContext> | MutationFiltersByMutationKey<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostSchema, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters, OperationError<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError>, TContext>): Array<Mutation<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError, MutationVariables<AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody, AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters>, TContext>>;
        };
        schema: AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostSchema;
        types: {
            parameters: AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters;
            data: AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData;
            error: AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError;
            body: AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody;
        };
    };
    /** @summary Decline Adoption Request Fullapp */
    declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePost: {
        /** @summary Decline Adoption Request Fullapp */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters, TMeta, TSignal>, client?: (schema: DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostSchema, options: ServiceOperationMutationFnOptions<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>>): Promise<RequestFnResponse<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>>;
        /** @summary Decline Adoption Request Fullapp */
        getMutationKey(parameters: DeepReadonly<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters> | void): ServiceOperationMutationKey<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostSchema, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Decline Adoption Request Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, TContext = unknown>(parameters: DeepReadonly<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters>, options?: ServiceOperationUseMutationOptions<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostSchema, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters, TVariables, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, TContext>): UseMutationResult<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Decline Adoption Request Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostSchema, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters, TVariables, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, TContext>): UseMutationResult<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Decline Adoption Request Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostTotal = qraft.fullappApiService.declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostTotal = qraft.fullappApiService.declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, TContext> | MutationFiltersByMutationKey<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostSchema, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Decline Adoption Request Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostPendingMutationVariables = qraft.fullappApiService.declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostMutationData = qraft.fullappApiService.declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, MutationVariables<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, TContext> | MutationFiltersByMutationKey<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostSchema, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, TContext>;
            select?: (mutation: Mutation<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, MutationVariables<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Decline Adoption Request Fullapp */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, TContext> | MutationFiltersByMutationKey<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostSchema, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Decline Adoption Request Fullapp
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, TContext> | MutationFiltersByMutationKey<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostSchema, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, TContext>): Mutation<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError, MutationVariables<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, TContext> | MutationFiltersByMutationKey<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostSchema, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters, OperationError<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError>, TContext>): Array<Mutation<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError, MutationVariables<DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody, DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters>, TContext>>;
        };
        schema: DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostSchema;
        types: {
            parameters: DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters;
            data: DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData;
            error: DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError;
            body: DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody;
        };
    };
    /** @summary Fullapp User Me */
    fullappUserMeFullappApiUsersMeGet: {
        /** @summary Fullapp User Me */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<FullappUserMeFullappApiUsersMeGetParameters, TMeta, TSignal> | void), client?: (schema: FullappUserMeFullappApiUsersMeGetSchema, options: {
            parameters: FullappUserMeFullappApiUsersMeGetParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetError>>): Promise<RequestFnResponse<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetError>>;
        /** @summary Fullapp User Me */
        getQueryKey(parameters: DeepReadonly<FullappUserMeFullappApiUsersMeGetParameters> | void): ServiceOperationQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Fullapp User Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = FullappUserMeFullappApiUsersMeGetData>(parameters: ServiceOperationQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters> | (DeepReadonly<FullappUserMeFullappApiUsersMeGetParameters> | void), options?: Omit<UndefinedInitialDataOptions<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetError, TData, ServiceOperationQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters>>, "queryKey">): UseQueryResult<TData, OperationError<FullappUserMeFullappApiUsersMeGetError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Fullapp User Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query without parameters
         * ```ts
         * const { data, isLoading } = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useQuery()
         * ```
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useQuery<TData = FullappUserMeFullappApiUsersMeGetData>(parameters: ServiceOperationQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters> | (DeepReadonly<FullappUserMeFullappApiUsersMeGetParameters> | void), options: Omit<DefinedInitialDataOptions<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetError, TData, ServiceOperationQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<FullappUserMeFullappApiUsersMeGetError>>;
        /** @summary Fullapp User Me */
        getInfiniteQueryKey(parameters: DeepReadonly<FullappUserMeFullappApiUsersMeGetParameters> | void): ServiceOperationInfiniteQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Fullapp User Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends FullappUserMeFullappApiUsersMeGetParameters, TQueryFnData = FullappUserMeFullappApiUsersMeGetData, TData = OperationInfiniteData<TQueryFnData, FullappUserMeFullappApiUsersMeGetParameters>>(parameters: ServiceOperationInfiniteQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters> | (DeepReadonly<FullappUserMeFullappApiUsersMeGetParameters> | void), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, FullappUserMeFullappApiUsersMeGetError, TData, ServiceOperationInfiniteQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<FullappUserMeFullappApiUsersMeGetError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Fullapp User Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends FullappUserMeFullappApiUsersMeGetParameters, TQueryFnData = FullappUserMeFullappApiUsersMeGetData, TData = OperationInfiniteData<TQueryFnData, FullappUserMeFullappApiUsersMeGetParameters>>(parameters: ServiceOperationInfiniteQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters> | (DeepReadonly<FullappUserMeFullappApiUsersMeGetParameters> | void), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, FullappUserMeFullappApiUsersMeGetError, TData, ServiceOperationInfiniteQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<FullappUserMeFullappApiUsersMeGetData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<FullappUserMeFullappApiUsersMeGetError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Fullapp User Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const fullappUserMeFullappApiUsersMeGetTotal = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const fullappUserMeFullappApiUsersMeGetByParametersTotal = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError> | QueryFiltersByQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Fullapp User Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const fullappUserMeFullappApiUsersMeGetResults = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * fullappUserMeFullappApiUsersMeGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const fullappUserMeFullappApiUsersMeGetCombinedResults = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * fullappUserMeFullappApiUsersMeGetCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetError>>, TCombinedResult = Array<UseQueryResult<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Fullapp User Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query without parameters
         * ```ts
         * const data = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useSuspenseQuery()
         * ```
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useSuspenseQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = FullappUserMeFullappApiUsersMeGetData>(parameters: ServiceOperationQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters> | (DeepReadonly<FullappUserMeFullappApiUsersMeGetParameters> | void), options?: Omit<UseSuspenseQueryOptions<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetError, TData, ServiceOperationQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<FullappUserMeFullappApiUsersMeGetError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Fullapp User Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useSuspenseInfiniteQuery({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends FullappUserMeFullappApiUsersMeGetParameters, TData = FullappUserMeFullappApiUsersMeGetData>(parameters: ServiceOperationInfiniteQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters> | (DeepReadonly<FullappUserMeFullappApiUsersMeGetParameters> | void), options: Omit<UseSuspenseInfiniteQueryOptions<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetError, OperationInfiniteData<TData, FullappUserMeFullappApiUsersMeGetParameters>, ServiceOperationInfiniteQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<FullappUserMeFullappApiUsersMeGetData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, FullappUserMeFullappApiUsersMeGetParameters>, OperationError<FullappUserMeFullappApiUsersMeGetError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Fullapp User Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const fullappUserMeFullappApiUsersMeGetData = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useSuspenseQueries({
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * fullappUserMeFullappApiUsersMeGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const fullappUserMeFullappApiUsersMeGetCombinedData = qraft.fullappApiService.fullappUserMeFullappApiUsersMeGet.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken1
         *             }
         *         },
         *         {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken2
         *             }
         *         }
         *     ]
         * });
         * fullappUserMeFullappApiUsersMeGetCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetError>>, TCombinedResult = Array<UseSuspenseQueryResult<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Fullapp User Me */
        fetchQuery(options: ServiceOperationFetchQueryOptions<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError> | void): Promise<FullappUserMeFullappApiUsersMeGetData>;
        /** @summary Fullapp User Me */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError> | void): Promise<void>;
        /** @summary Fullapp User Me */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError> | void): Promise<FullappUserMeFullappApiUsersMeGetData>;
        /** @summary Fullapp User Me */
        fetchInfiniteQuery<TPageParam extends FullappUserMeFullappApiUsersMeGetParameters>(options: ServiceOperationFetchInfiniteQueryOptions<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetParameters, DeepReadonly<TPageParam>, FullappUserMeFullappApiUsersMeGetError> | void): Promise<OperationInfiniteData<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetParameters>>;
        /** @summary Fullapp User Me */
        prefetchInfiniteQuery<TPageParam extends FullappUserMeFullappApiUsersMeGetParameters>(options: ServiceOperationFetchInfiniteQueryOptions<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetParameters, DeepReadonly<TPageParam>, FullappUserMeFullappApiUsersMeGetError> | void): Promise<void>;
        /** @summary Fullapp User Me */
        ensureInfiniteQueryData<TPageParam extends FullappUserMeFullappApiUsersMeGetParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetParameters, DeepReadonly<TPageParam>, FullappUserMeFullappApiUsersMeGetError> | void): Promise<OperationInfiniteData<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetParameters>>;
        /** @summary Fullapp User Me */
        getQueryData(parameters: ServiceOperationQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters> | (DeepReadonly<FullappUserMeFullappApiUsersMeGetParameters> | void)): FullappUserMeFullappApiUsersMeGetData | undefined;
        /** @summary Fullapp User Me */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters> | (DeepReadonly<FullappUserMeFullappApiUsersMeGetParameters> | void)): OperationInfiniteData<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetParameters> | undefined;
        /** @summary Fullapp User Me */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError> | QueryFiltersByQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters>,
            data: NoInfer<OperationInfiniteData<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters>,
            data: FullappUserMeFullappApiUsersMeGetData | undefined
        ]>;
        /** @summary Fullapp User Me */
        getQueryState(parameters: ServiceOperationQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters> | (DeepReadonly<FullappUserMeFullappApiUsersMeGetParameters> | void)): QueryState<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetError> | undefined;
        /** @summary Fullapp User Me */
        getInfiniteQueryState(parameters: DeepReadonly<FullappUserMeFullappApiUsersMeGetParameters> | ServiceOperationInfiniteQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters> | void): QueryState<OperationInfiniteData<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetParameters>, FullappUserMeFullappApiUsersMeGetError> | undefined;
        /** @summary Fullapp User Me */
        setQueryData(parameters: (DeepReadonly<FullappUserMeFullappApiUsersMeGetParameters> | undefined) | ServiceOperationQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters>, updater: Updater<NoInfer<FullappUserMeFullappApiUsersMeGetData> | undefined, NoInfer<DeepReadonly<FullappUserMeFullappApiUsersMeGetData>> | undefined>, options?: SetDataOptions): FullappUserMeFullappApiUsersMeGetData | undefined;
        /** @summary Fullapp User Me */
        setInfiniteQueryData(parameters: (DeepReadonly<FullappUserMeFullappApiUsersMeGetParameters> | undefined) | ServiceOperationInfiniteQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetParameters>, updater: Updater<NoInfer<OperationInfiniteData<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<FullappUserMeFullappApiUsersMeGetData, FullappUserMeFullappApiUsersMeGetParameters> | undefined;
        /** @summary Fullapp User Me */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError> | QueryFiltersByQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError>, updater: Updater<NoInfer<FullappUserMeFullappApiUsersMeGetData> | undefined, NoInfer<FullappUserMeFullappApiUsersMeGetData> | undefined>, options?: SetDataOptions): Array<FullappUserMeFullappApiUsersMeGetData | undefined>;
        /** @summary Fullapp User Me */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Fullapp User Me */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError> | QueryFiltersByQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError>, options?: RefetchOptions): Promise<void>;
        /** @summary Fullapp User Me */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError> | QueryFiltersByQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError>, options?: CancelOptions): Promise<void>;
        /** @summary Fullapp User Me */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError> | QueryFiltersByQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError>): void;
        /** @summary Fullapp User Me */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError> | QueryFiltersByQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError>, options?: ResetOptions): Promise<void>;
        /** @summary Fullapp User Me */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError> | QueryFiltersByQueryKey<FullappUserMeFullappApiUsersMeGetSchema, FullappUserMeFullappApiUsersMeGetData, TInfinite, FullappUserMeFullappApiUsersMeGetParameters, FullappUserMeFullappApiUsersMeGetError>): number;
        schema: FullappUserMeFullappApiUsersMeGetSchema;
        types: {
            parameters: FullappUserMeFullappApiUsersMeGetParameters;
            data: FullappUserMeFullappApiUsersMeGetData;
            error: FullappUserMeFullappApiUsersMeGetError;
        };
    };
    /** @summary Fullapp User Me */
    fullappUserMeFullappApiUsersMePost: {
        /** @summary Fullapp User Me */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostParameters, TMeta, TSignal>, client?: (schema: FullappUserMeFullappApiUsersMePostSchema, options: ServiceOperationMutationFnOptions<FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostError>>): Promise<RequestFnResponse<FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostError>>;
        /** @summary Fullapp User Me */
        getMutationKey(parameters: DeepReadonly<FullappUserMeFullappApiUsersMePostParameters> | void): ServiceOperationMutationKey<FullappUserMeFullappApiUsersMePostSchema, FullappUserMeFullappApiUsersMePostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fullapp User Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUserMeFullappApiUsersMePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUserMeFullappApiUsersMePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends FullappUserMeFullappApiUsersMePostBody, TContext = unknown>(parameters: DeepReadonly<FullappUserMeFullappApiUsersMePostParameters>, options?: ServiceOperationUseMutationOptions<FullappUserMeFullappApiUsersMePostSchema, FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostParameters, TVariables, OperationError<FullappUserMeFullappApiUsersMePostError>, TContext>): UseMutationResult<FullappUserMeFullappApiUsersMePostData, OperationError<FullappUserMeFullappApiUsersMePostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fullapp User Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUserMeFullappApiUsersMePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUserMeFullappApiUsersMePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<FullappUserMeFullappApiUsersMePostSchema, FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostParameters, TVariables, OperationError<FullappUserMeFullappApiUsersMePostError>, TContext>): UseMutationResult<FullappUserMeFullappApiUsersMePostData, OperationError<FullappUserMeFullappApiUsersMePostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Fullapp User Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const fullappUserMeFullappApiUsersMePostTotal = qraft.fullappApiService.fullappUserMeFullappApiUsersMePost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const fullappUserMeFullappApiUsersMePostTotal = qraft.fullappApiService.fullappUserMeFullappApiUsersMePost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostParameters, OperationError<FullappUserMeFullappApiUsersMePostError>, TContext> | MutationFiltersByMutationKey<FullappUserMeFullappApiUsersMePostSchema, FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostParameters, OperationError<FullappUserMeFullappApiUsersMePostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Fullapp User Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const fullappUserMeFullappApiUsersMePostPendingMutationVariables = qraft.fullappApiService.fullappUserMeFullappApiUsersMePost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const fullappUserMeFullappApiUsersMePostMutationData = qraft.fullappApiService.fullappUserMeFullappApiUsersMePost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<FullappUserMeFullappApiUsersMePostData, OperationError<FullappUserMeFullappApiUsersMePostError>, MutationVariables<FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostParameters, OperationError<FullappUserMeFullappApiUsersMePostError>, TContext> | MutationFiltersByMutationKey<FullappUserMeFullappApiUsersMePostSchema, FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostParameters, OperationError<FullappUserMeFullappApiUsersMePostError>, TContext>;
            select?: (mutation: Mutation<FullappUserMeFullappApiUsersMePostData, OperationError<FullappUserMeFullappApiUsersMePostError>, MutationVariables<FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Fullapp User Me */
        isMutating<TContext>(filters?: MutationFiltersByParameters<FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostParameters, OperationError<FullappUserMeFullappApiUsersMePostError>, TContext> | MutationFiltersByMutationKey<FullappUserMeFullappApiUsersMePostSchema, FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostParameters, OperationError<FullappUserMeFullappApiUsersMePostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Fullapp User Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.fullappUserMeFullappApiUsersMePost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.fullappUserMeFullappApiUsersMePost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostParameters, OperationError<FullappUserMeFullappApiUsersMePostError>, TContext> | MutationFiltersByMutationKey<FullappUserMeFullappApiUsersMePostSchema, FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostParameters, OperationError<FullappUserMeFullappApiUsersMePostError>, TContext>): Mutation<FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostError, MutationVariables<FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostParameters, OperationError<FullappUserMeFullappApiUsersMePostError>, TContext> | MutationFiltersByMutationKey<FullappUserMeFullappApiUsersMePostSchema, FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostParameters, OperationError<FullappUserMeFullappApiUsersMePostError>, TContext>): Array<Mutation<FullappUserMeFullappApiUsersMePostData, FullappUserMeFullappApiUsersMePostError, MutationVariables<FullappUserMeFullappApiUsersMePostBody, FullappUserMeFullappApiUsersMePostParameters>, TContext>>;
        };
        schema: FullappUserMeFullappApiUsersMePostSchema;
        types: {
            parameters: FullappUserMeFullappApiUsersMePostParameters;
            data: FullappUserMeFullappApiUsersMePostData;
            error: FullappUserMeFullappApiUsersMePostError;
            body: FullappUserMeFullappApiUsersMePostBody;
        };
    };
    /** @summary Fullapp Change Password */
    fullappChangePasswordFullappApiUsersChangePasswordPost: {
        /** @summary Fullapp Change Password */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostParameters, TMeta, TSignal>, client?: (schema: FullappChangePasswordFullappApiUsersChangePasswordPostSchema, options: ServiceOperationMutationFnOptions<FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostError>>): Promise<RequestFnResponse<FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostError>>;
        /** @summary Fullapp Change Password */
        getMutationKey(parameters: DeepReadonly<FullappChangePasswordFullappApiUsersChangePasswordPostParameters> | void): ServiceOperationMutationKey<FullappChangePasswordFullappApiUsersChangePasswordPostSchema, FullappChangePasswordFullappApiUsersChangePasswordPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fullapp Change Password
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappChangePasswordFullappApiUsersChangePasswordPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappChangePasswordFullappApiUsersChangePasswordPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends FullappChangePasswordFullappApiUsersChangePasswordPostBody, TContext = unknown>(parameters: DeepReadonly<FullappChangePasswordFullappApiUsersChangePasswordPostParameters>, options?: ServiceOperationUseMutationOptions<FullappChangePasswordFullappApiUsersChangePasswordPostSchema, FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostParameters, TVariables, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, TContext>): UseMutationResult<FullappChangePasswordFullappApiUsersChangePasswordPostData, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fullapp Change Password
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappChangePasswordFullappApiUsersChangePasswordPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappChangePasswordFullappApiUsersChangePasswordPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<FullappChangePasswordFullappApiUsersChangePasswordPostSchema, FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostParameters, TVariables, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, TContext>): UseMutationResult<FullappChangePasswordFullappApiUsersChangePasswordPostData, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Fullapp Change Password
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const fullappChangePasswordFullappApiUsersChangePasswordPostTotal = qraft.fullappApiService.fullappChangePasswordFullappApiUsersChangePasswordPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const fullappChangePasswordFullappApiUsersChangePasswordPostTotal = qraft.fullappApiService.fullappChangePasswordFullappApiUsersChangePasswordPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostParameters, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, TContext> | MutationFiltersByMutationKey<FullappChangePasswordFullappApiUsersChangePasswordPostSchema, FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostParameters, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Fullapp Change Password
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const fullappChangePasswordFullappApiUsersChangePasswordPostPendingMutationVariables = qraft.fullappApiService.fullappChangePasswordFullappApiUsersChangePasswordPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const fullappChangePasswordFullappApiUsersChangePasswordPostMutationData = qraft.fullappApiService.fullappChangePasswordFullappApiUsersChangePasswordPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<FullappChangePasswordFullappApiUsersChangePasswordPostData, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, MutationVariables<FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostParameters, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, TContext> | MutationFiltersByMutationKey<FullappChangePasswordFullappApiUsersChangePasswordPostSchema, FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostParameters, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, TContext>;
            select?: (mutation: Mutation<FullappChangePasswordFullappApiUsersChangePasswordPostData, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, MutationVariables<FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Fullapp Change Password */
        isMutating<TContext>(filters?: MutationFiltersByParameters<FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostParameters, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, TContext> | MutationFiltersByMutationKey<FullappChangePasswordFullappApiUsersChangePasswordPostSchema, FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostParameters, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Fullapp Change Password
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.fullappChangePasswordFullappApiUsersChangePasswordPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.fullappChangePasswordFullappApiUsersChangePasswordPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostParameters, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, TContext> | MutationFiltersByMutationKey<FullappChangePasswordFullappApiUsersChangePasswordPostSchema, FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostParameters, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, TContext>): Mutation<FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostError, MutationVariables<FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostParameters, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, TContext> | MutationFiltersByMutationKey<FullappChangePasswordFullappApiUsersChangePasswordPostSchema, FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostParameters, OperationError<FullappChangePasswordFullappApiUsersChangePasswordPostError>, TContext>): Array<Mutation<FullappChangePasswordFullappApiUsersChangePasswordPostData, FullappChangePasswordFullappApiUsersChangePasswordPostError, MutationVariables<FullappChangePasswordFullappApiUsersChangePasswordPostBody, FullappChangePasswordFullappApiUsersChangePasswordPostParameters>, TContext>>;
        };
        schema: FullappChangePasswordFullappApiUsersChangePasswordPostSchema;
        types: {
            parameters: FullappChangePasswordFullappApiUsersChangePasswordPostParameters;
            data: FullappChangePasswordFullappApiUsersChangePasswordPostData;
            error: FullappChangePasswordFullappApiUsersChangePasswordPostError;
            body: FullappChangePasswordFullappApiUsersChangePasswordPostBody;
        };
    };
    /** @summary Fullapp Update Profiles */
    fullappUpdateProfilesFullappApiUsersUpdateProfilesPost: {
        /** @summary Fullapp Update Profiles */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters, TMeta, TSignal>, client?: (schema: FullappUpdateProfilesFullappApiUsersUpdateProfilesPostSchema, options: ServiceOperationMutationFnOptions<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>>): Promise<RequestFnResponse<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>>;
        /** @summary Fullapp Update Profiles */
        getMutationKey(parameters: DeepReadonly<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters> | void): ServiceOperationMutationKey<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostSchema, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fullapp Update Profiles
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUpdateProfilesFullappApiUsersUpdateProfilesPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUpdateProfilesFullappApiUsersUpdateProfilesPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, TContext = unknown>(parameters: DeepReadonly<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters>, options?: ServiceOperationUseMutationOptions<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostSchema, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters, TVariables, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, TContext>): UseMutationResult<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fullapp Update Profiles
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUpdateProfilesFullappApiUsersUpdateProfilesPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUpdateProfilesFullappApiUsersUpdateProfilesPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostSchema, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters, TVariables, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, TContext>): UseMutationResult<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Fullapp Update Profiles
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const fullappUpdateProfilesFullappApiUsersUpdateProfilesPostTotal = qraft.fullappApiService.fullappUpdateProfilesFullappApiUsersUpdateProfilesPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const fullappUpdateProfilesFullappApiUsersUpdateProfilesPostTotal = qraft.fullappApiService.fullappUpdateProfilesFullappApiUsersUpdateProfilesPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, TContext> | MutationFiltersByMutationKey<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostSchema, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Fullapp Update Profiles
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const fullappUpdateProfilesFullappApiUsersUpdateProfilesPostPendingMutationVariables = qraft.fullappApiService.fullappUpdateProfilesFullappApiUsersUpdateProfilesPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const fullappUpdateProfilesFullappApiUsersUpdateProfilesPostMutationData = qraft.fullappApiService.fullappUpdateProfilesFullappApiUsersUpdateProfilesPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, MutationVariables<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, TContext> | MutationFiltersByMutationKey<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostSchema, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, TContext>;
            select?: (mutation: Mutation<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, MutationVariables<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Fullapp Update Profiles */
        isMutating<TContext>(filters?: MutationFiltersByParameters<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, TContext> | MutationFiltersByMutationKey<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostSchema, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Fullapp Update Profiles
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.fullappUpdateProfilesFullappApiUsersUpdateProfilesPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.fullappUpdateProfilesFullappApiUsersUpdateProfilesPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, TContext> | MutationFiltersByMutationKey<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostSchema, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, TContext>): Mutation<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError, MutationVariables<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, TContext> | MutationFiltersByMutationKey<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostSchema, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters, OperationError<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError>, TContext>): Array<Mutation<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError, MutationVariables<FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody, FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters>, TContext>>;
        };
        schema: FullappUpdateProfilesFullappApiUsersUpdateProfilesPostSchema;
        types: {
            parameters: FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters;
            data: FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData;
            error: FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError;
            body: FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody;
        };
    };
    /** @summary Fullapp User Info */
    fullappUserInfoFullappApiUsersInfoPost: {
        /** @summary Fullapp User Info */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostParameters, TMeta, TSignal>, client?: (schema: FullappUserInfoFullappApiUsersInfoPostSchema, options: ServiceOperationMutationFnOptions<FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostError>>): Promise<RequestFnResponse<FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostError>>;
        /** @summary Fullapp User Info */
        getMutationKey(parameters: DeepReadonly<FullappUserInfoFullappApiUsersInfoPostParameters> | void): ServiceOperationMutationKey<FullappUserInfoFullappApiUsersInfoPostSchema, FullappUserInfoFullappApiUsersInfoPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fullapp User Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUserInfoFullappApiUsersInfoPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUserInfoFullappApiUsersInfoPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends FullappUserInfoFullappApiUsersInfoPostBody, TContext = unknown>(parameters: DeepReadonly<FullappUserInfoFullappApiUsersInfoPostParameters>, options?: ServiceOperationUseMutationOptions<FullappUserInfoFullappApiUsersInfoPostSchema, FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostParameters, TVariables, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, TContext>): UseMutationResult<FullappUserInfoFullappApiUsersInfoPostData, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fullapp User Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUserInfoFullappApiUsersInfoPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUserInfoFullappApiUsersInfoPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<FullappUserInfoFullappApiUsersInfoPostSchema, FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostParameters, TVariables, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, TContext>): UseMutationResult<FullappUserInfoFullappApiUsersInfoPostData, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Fullapp User Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const fullappUserInfoFullappApiUsersInfoPostTotal = qraft.fullappApiService.fullappUserInfoFullappApiUsersInfoPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const fullappUserInfoFullappApiUsersInfoPostTotal = qraft.fullappApiService.fullappUserInfoFullappApiUsersInfoPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostParameters, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, TContext> | MutationFiltersByMutationKey<FullappUserInfoFullappApiUsersInfoPostSchema, FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostParameters, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Fullapp User Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const fullappUserInfoFullappApiUsersInfoPostPendingMutationVariables = qraft.fullappApiService.fullappUserInfoFullappApiUsersInfoPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const fullappUserInfoFullappApiUsersInfoPostMutationData = qraft.fullappApiService.fullappUserInfoFullappApiUsersInfoPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<FullappUserInfoFullappApiUsersInfoPostData, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, MutationVariables<FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostParameters, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, TContext> | MutationFiltersByMutationKey<FullappUserInfoFullappApiUsersInfoPostSchema, FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostParameters, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, TContext>;
            select?: (mutation: Mutation<FullappUserInfoFullappApiUsersInfoPostData, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, MutationVariables<FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Fullapp User Info */
        isMutating<TContext>(filters?: MutationFiltersByParameters<FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostParameters, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, TContext> | MutationFiltersByMutationKey<FullappUserInfoFullappApiUsersInfoPostSchema, FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostParameters, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Fullapp User Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.fullappUserInfoFullappApiUsersInfoPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.fullappUserInfoFullappApiUsersInfoPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostParameters, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, TContext> | MutationFiltersByMutationKey<FullappUserInfoFullappApiUsersInfoPostSchema, FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostParameters, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, TContext>): Mutation<FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostError, MutationVariables<FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostParameters, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, TContext> | MutationFiltersByMutationKey<FullappUserInfoFullappApiUsersInfoPostSchema, FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostParameters, OperationError<FullappUserInfoFullappApiUsersInfoPostError>, TContext>): Array<Mutation<FullappUserInfoFullappApiUsersInfoPostData, FullappUserInfoFullappApiUsersInfoPostError, MutationVariables<FullappUserInfoFullappApiUsersInfoPostBody, FullappUserInfoFullappApiUsersInfoPostParameters>, TContext>>;
        };
        schema: FullappUserInfoFullappApiUsersInfoPostSchema;
        types: {
            parameters: FullappUserInfoFullappApiUsersInfoPostParameters;
            data: FullappUserInfoFullappApiUsersInfoPostData;
            error: FullappUserInfoFullappApiUsersInfoPostError;
            body: FullappUserInfoFullappApiUsersInfoPostBody;
        };
    };
    /**
     * @summary Fullapp Upload Avatar
     * @description Upload the current user's avatar (the app's one multipart endpoint).
     *
     * Stores the image at ``avatars/{id}/full.{ext}`` and points ``User.avatar`` at
     * it; the per-request commit middleware persists the change. Returns the new
     * avatar URL, matching the legacy ``{id, avatar}`` shape.
     */
    fullappUploadAvatarFullappApiUsersAvatarPost: {
        /**
         * @summary Fullapp Upload Avatar
         * @description Upload the current user's avatar (the app's one multipart endpoint).
         *
         * Stores the image at ``avatars/{id}/full.{ext}`` and points ``User.avatar`` at
         * it; the per-request commit middleware persists the change. Returns the new
         * avatar URL, matching the legacy ``{id, avatar}`` shape.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostParameters, TMeta, TSignal>, client?: (schema: FullappUploadAvatarFullappApiUsersAvatarPostSchema, options: ServiceOperationMutationFnOptions<FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostError>>): Promise<RequestFnResponse<FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostError>>;
        /**
         * @summary Fullapp Upload Avatar
         * @description Upload the current user's avatar (the app's one multipart endpoint).
         *
         * Stores the image at ``avatars/{id}/full.{ext}`` and points ``User.avatar`` at
         * it; the per-request commit middleware persists the change. Returns the new
         * avatar URL, matching the legacy ``{id, avatar}`` shape.
         */
        getMutationKey(parameters: DeepReadonly<FullappUploadAvatarFullappApiUsersAvatarPostParameters> | void): ServiceOperationMutationKey<FullappUploadAvatarFullappApiUsersAvatarPostSchema, FullappUploadAvatarFullappApiUsersAvatarPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fullapp Upload Avatar
         * @description Upload the current user's avatar (the app's one multipart endpoint).
         *
         * Stores the image at ``avatars/{id}/full.{ext}`` and points ``User.avatar`` at
         * it; the per-request commit middleware persists the change. Returns the new
         * avatar URL, matching the legacy ``{id, avatar}`` shape.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUploadAvatarFullappApiUsersAvatarPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUploadAvatarFullappApiUsersAvatarPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends FullappUploadAvatarFullappApiUsersAvatarPostBody, TContext = unknown>(parameters: DeepReadonly<FullappUploadAvatarFullappApiUsersAvatarPostParameters>, options?: ServiceOperationUseMutationOptions<FullappUploadAvatarFullappApiUsersAvatarPostSchema, FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostParameters, TVariables, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, TContext>): UseMutationResult<FullappUploadAvatarFullappApiUsersAvatarPostData, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fullapp Upload Avatar
         * @description Upload the current user's avatar (the app's one multipart endpoint).
         *
         * Stores the image at ``avatars/{id}/full.{ext}`` and points ``User.avatar`` at
         * it; the per-request commit middleware persists the change. Returns the new
         * avatar URL, matching the legacy ``{id, avatar}`` shape.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUploadAvatarFullappApiUsersAvatarPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappUploadAvatarFullappApiUsersAvatarPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<FullappUploadAvatarFullappApiUsersAvatarPostSchema, FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostParameters, TVariables, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, TContext>): UseMutationResult<FullappUploadAvatarFullappApiUsersAvatarPostData, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Fullapp Upload Avatar
         * @description Upload the current user's avatar (the app's one multipart endpoint).
         *
         * Stores the image at ``avatars/{id}/full.{ext}`` and points ``User.avatar`` at
         * it; the per-request commit middleware persists the change. Returns the new
         * avatar URL, matching the legacy ``{id, avatar}`` shape.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const fullappUploadAvatarFullappApiUsersAvatarPostTotal = qraft.fullappApiService.fullappUploadAvatarFullappApiUsersAvatarPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const fullappUploadAvatarFullappApiUsersAvatarPostTotal = qraft.fullappApiService.fullappUploadAvatarFullappApiUsersAvatarPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostParameters, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, TContext> | MutationFiltersByMutationKey<FullappUploadAvatarFullappApiUsersAvatarPostSchema, FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostParameters, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Fullapp Upload Avatar
         * @description Upload the current user's avatar (the app's one multipart endpoint).
         *
         * Stores the image at ``avatars/{id}/full.{ext}`` and points ``User.avatar`` at
         * it; the per-request commit middleware persists the change. Returns the new
         * avatar URL, matching the legacy ``{id, avatar}`` shape.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const fullappUploadAvatarFullappApiUsersAvatarPostPendingMutationVariables = qraft.fullappApiService.fullappUploadAvatarFullappApiUsersAvatarPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const fullappUploadAvatarFullappApiUsersAvatarPostMutationData = qraft.fullappApiService.fullappUploadAvatarFullappApiUsersAvatarPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<FullappUploadAvatarFullappApiUsersAvatarPostData, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, MutationVariables<FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostParameters, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, TContext> | MutationFiltersByMutationKey<FullappUploadAvatarFullappApiUsersAvatarPostSchema, FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostParameters, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, TContext>;
            select?: (mutation: Mutation<FullappUploadAvatarFullappApiUsersAvatarPostData, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, MutationVariables<FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Fullapp Upload Avatar
         * @description Upload the current user's avatar (the app's one multipart endpoint).
         *
         * Stores the image at ``avatars/{id}/full.{ext}`` and points ``User.avatar`` at
         * it; the per-request commit middleware persists the change. Returns the new
         * avatar URL, matching the legacy ``{id, avatar}`` shape.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostParameters, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, TContext> | MutationFiltersByMutationKey<FullappUploadAvatarFullappApiUsersAvatarPostSchema, FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostParameters, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Fullapp Upload Avatar
         * @description Upload the current user's avatar (the app's one multipart endpoint).
         *
         * Stores the image at ``avatars/{id}/full.{ext}`` and points ``User.avatar`` at
         * it; the per-request commit middleware persists the change. Returns the new
         * avatar URL, matching the legacy ``{id, avatar}`` shape.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.fullappUploadAvatarFullappApiUsersAvatarPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.fullappUploadAvatarFullappApiUsersAvatarPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostParameters, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, TContext> | MutationFiltersByMutationKey<FullappUploadAvatarFullappApiUsersAvatarPostSchema, FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostParameters, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, TContext>): Mutation<FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostError, MutationVariables<FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostParameters, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, TContext> | MutationFiltersByMutationKey<FullappUploadAvatarFullappApiUsersAvatarPostSchema, FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostParameters, OperationError<FullappUploadAvatarFullappApiUsersAvatarPostError>, TContext>): Array<Mutation<FullappUploadAvatarFullappApiUsersAvatarPostData, FullappUploadAvatarFullappApiUsersAvatarPostError, MutationVariables<FullappUploadAvatarFullappApiUsersAvatarPostBody, FullappUploadAvatarFullappApiUsersAvatarPostParameters>, TContext>>;
        };
        schema: FullappUploadAvatarFullappApiUsersAvatarPostSchema;
        types: {
            parameters: FullappUploadAvatarFullappApiUsersAvatarPostParameters;
            data: FullappUploadAvatarFullappApiUsersAvatarPostData;
            error: FullappUploadAvatarFullappApiUsersAvatarPostError;
            body: FullappUploadAvatarFullappApiUsersAvatarPostBody;
        };
    };
    /** @summary Fullapp Sms Status */
    fullappSmsStatusFullappApiSmsStatusPost: {
        /** @summary Fullapp Sms Status */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostParameters, TMeta, TSignal>, client?: (schema: FullappSmsStatusFullappApiSmsStatusPostSchema, options: ServiceOperationMutationFnOptions<FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostError>>): Promise<RequestFnResponse<FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostError>>;
        /** @summary Fullapp Sms Status */
        getMutationKey(parameters: DeepReadonly<FullappSmsStatusFullappApiSmsStatusPostParameters> | void): ServiceOperationMutationKey<FullappSmsStatusFullappApiSmsStatusPostSchema, FullappSmsStatusFullappApiSmsStatusPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fullapp Sms Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappSmsStatusFullappApiSmsStatusPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappSmsStatusFullappApiSmsStatusPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends FullappSmsStatusFullappApiSmsStatusPostBody, TContext = unknown>(parameters: DeepReadonly<FullappSmsStatusFullappApiSmsStatusPostParameters>, options?: ServiceOperationUseMutationOptions<FullappSmsStatusFullappApiSmsStatusPostSchema, FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostParameters, TVariables, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, TContext>): UseMutationResult<FullappSmsStatusFullappApiSmsStatusPostData, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fullapp Sms Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappSmsStatusFullappApiSmsStatusPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappSmsStatusFullappApiSmsStatusPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<FullappSmsStatusFullappApiSmsStatusPostSchema, FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostParameters, TVariables, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, TContext>): UseMutationResult<FullappSmsStatusFullappApiSmsStatusPostData, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Fullapp Sms Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const fullappSmsStatusFullappApiSmsStatusPostTotal = qraft.fullappApiService.fullappSmsStatusFullappApiSmsStatusPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const fullappSmsStatusFullappApiSmsStatusPostTotal = qraft.fullappApiService.fullappSmsStatusFullappApiSmsStatusPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostParameters, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, TContext> | MutationFiltersByMutationKey<FullappSmsStatusFullappApiSmsStatusPostSchema, FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostParameters, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Fullapp Sms Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const fullappSmsStatusFullappApiSmsStatusPostPendingMutationVariables = qraft.fullappApiService.fullappSmsStatusFullappApiSmsStatusPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const fullappSmsStatusFullappApiSmsStatusPostMutationData = qraft.fullappApiService.fullappSmsStatusFullappApiSmsStatusPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<FullappSmsStatusFullappApiSmsStatusPostData, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, MutationVariables<FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostParameters, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, TContext> | MutationFiltersByMutationKey<FullappSmsStatusFullappApiSmsStatusPostSchema, FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostParameters, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, TContext>;
            select?: (mutation: Mutation<FullappSmsStatusFullappApiSmsStatusPostData, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, MutationVariables<FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Fullapp Sms Status */
        isMutating<TContext>(filters?: MutationFiltersByParameters<FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostParameters, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, TContext> | MutationFiltersByMutationKey<FullappSmsStatusFullappApiSmsStatusPostSchema, FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostParameters, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Fullapp Sms Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.fullappSmsStatusFullappApiSmsStatusPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.fullappSmsStatusFullappApiSmsStatusPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostParameters, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, TContext> | MutationFiltersByMutationKey<FullappSmsStatusFullappApiSmsStatusPostSchema, FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostParameters, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, TContext>): Mutation<FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostError, MutationVariables<FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostParameters, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, TContext> | MutationFiltersByMutationKey<FullappSmsStatusFullappApiSmsStatusPostSchema, FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostParameters, OperationError<FullappSmsStatusFullappApiSmsStatusPostError>, TContext>): Array<Mutation<FullappSmsStatusFullappApiSmsStatusPostData, FullappSmsStatusFullappApiSmsStatusPostError, MutationVariables<FullappSmsStatusFullappApiSmsStatusPostBody, FullappSmsStatusFullappApiSmsStatusPostParameters>, TContext>>;
        };
        schema: FullappSmsStatusFullappApiSmsStatusPostSchema;
        types: {
            parameters: FullappSmsStatusFullappApiSmsStatusPostParameters;
            data: FullappSmsStatusFullappApiSmsStatusPostData;
            error: FullappSmsStatusFullappApiSmsStatusPostError;
            body: FullappSmsStatusFullappApiSmsStatusPostBody;
        };
    };
    /** @summary Fullapp Whatsapp Status */
    fullappWhatsappStatusFullappApiWhatsappStatusPost: {
        /** @summary Fullapp Whatsapp Status */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters, TMeta, TSignal>, client?: (schema: FullappWhatsappStatusFullappApiWhatsappStatusPostSchema, options: ServiceOperationMutationFnOptions<FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostError>>): Promise<RequestFnResponse<FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostError>>;
        /** @summary Fullapp Whatsapp Status */
        getMutationKey(parameters: DeepReadonly<FullappWhatsappStatusFullappApiWhatsappStatusPostParameters> | void): ServiceOperationMutationKey<FullappWhatsappStatusFullappApiWhatsappStatusPostSchema, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fullapp Whatsapp Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappWhatsappStatusFullappApiWhatsappStatusPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappWhatsappStatusFullappApiWhatsappStatusPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends FullappWhatsappStatusFullappApiWhatsappStatusPostBody, TContext = unknown>(parameters: DeepReadonly<FullappWhatsappStatusFullappApiWhatsappStatusPostParameters>, options?: ServiceOperationUseMutationOptions<FullappWhatsappStatusFullappApiWhatsappStatusPostSchema, FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters, TVariables, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, TContext>): UseMutationResult<FullappWhatsappStatusFullappApiWhatsappStatusPostData, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fullapp Whatsapp Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappWhatsappStatusFullappApiWhatsappStatusPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fullappWhatsappStatusFullappApiWhatsappStatusPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<FullappWhatsappStatusFullappApiWhatsappStatusPostSchema, FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters, TVariables, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, TContext>): UseMutationResult<FullappWhatsappStatusFullappApiWhatsappStatusPostData, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Fullapp Whatsapp Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const fullappWhatsappStatusFullappApiWhatsappStatusPostTotal = qraft.fullappApiService.fullappWhatsappStatusFullappApiWhatsappStatusPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const fullappWhatsappStatusFullappApiWhatsappStatusPostTotal = qraft.fullappApiService.fullappWhatsappStatusFullappApiWhatsappStatusPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, TContext> | MutationFiltersByMutationKey<FullappWhatsappStatusFullappApiWhatsappStatusPostSchema, FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Fullapp Whatsapp Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const fullappWhatsappStatusFullappApiWhatsappStatusPostPendingMutationVariables = qraft.fullappApiService.fullappWhatsappStatusFullappApiWhatsappStatusPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const fullappWhatsappStatusFullappApiWhatsappStatusPostMutationData = qraft.fullappApiService.fullappWhatsappStatusFullappApiWhatsappStatusPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<FullappWhatsappStatusFullappApiWhatsappStatusPostData, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, MutationVariables<FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, TContext> | MutationFiltersByMutationKey<FullappWhatsappStatusFullappApiWhatsappStatusPostSchema, FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, TContext>;
            select?: (mutation: Mutation<FullappWhatsappStatusFullappApiWhatsappStatusPostData, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, MutationVariables<FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Fullapp Whatsapp Status */
        isMutating<TContext>(filters?: MutationFiltersByParameters<FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, TContext> | MutationFiltersByMutationKey<FullappWhatsappStatusFullappApiWhatsappStatusPostSchema, FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Fullapp Whatsapp Status
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.fullappWhatsappStatusFullappApiWhatsappStatusPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.fullappWhatsappStatusFullappApiWhatsappStatusPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, TContext> | MutationFiltersByMutationKey<FullappWhatsappStatusFullappApiWhatsappStatusPostSchema, FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, TContext>): Mutation<FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostError, MutationVariables<FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, TContext> | MutationFiltersByMutationKey<FullappWhatsappStatusFullappApiWhatsappStatusPostSchema, FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters, OperationError<FullappWhatsappStatusFullappApiWhatsappStatusPostError>, TContext>): Array<Mutation<FullappWhatsappStatusFullappApiWhatsappStatusPostData, FullappWhatsappStatusFullappApiWhatsappStatusPostError, MutationVariables<FullappWhatsappStatusFullappApiWhatsappStatusPostBody, FullappWhatsappStatusFullappApiWhatsappStatusPostParameters>, TContext>>;
        };
        schema: FullappWhatsappStatusFullappApiWhatsappStatusPostSchema;
        types: {
            parameters: FullappWhatsappStatusFullappApiWhatsappStatusPostParameters;
            data: FullappWhatsappStatusFullappApiWhatsappStatusPostData;
            error: FullappWhatsappStatusFullappApiWhatsappStatusPostError;
            body: FullappWhatsappStatusFullappApiWhatsappStatusPostBody;
        };
    };
    /**
     * @summary Get Onboarding Status
     * @description Get current user's onboarding status.
     *
     * Status should be checked when:
     *
     * App start (if logged in)
     * Course Completed
     * Another Onboarding Completed (some will chain)
     * Logged In/Registered
     */
    getOnboardingStatusFullappApiOnboardingsStatusPost: {
        /**
         * @summary Get Onboarding Status
         * @description Get current user's onboarding status.
         *
         * Status should be checked when:
         *
         * App start (if logged in)
         * Course Completed
         * Another Onboarding Completed (some will chain)
         * Logged In/Registered
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters, TMeta, TSignal>, client?: (schema: GetOnboardingStatusFullappApiOnboardingsStatusPostSchema, options: ServiceOperationMutationFnOptions<GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostError>>): Promise<RequestFnResponse<GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostError>>;
        /**
         * @summary Get Onboarding Status
         * @description Get current user's onboarding status.
         *
         * Status should be checked when:
         *
         * App start (if logged in)
         * Course Completed
         * Another Onboarding Completed (some will chain)
         * Logged In/Registered
         */
        getMutationKey(parameters: DeepReadonly<GetOnboardingStatusFullappApiOnboardingsStatusPostParameters> | void): ServiceOperationMutationKey<GetOnboardingStatusFullappApiOnboardingsStatusPostSchema, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Onboarding Status
         * @description Get current user's onboarding status.
         *
         * Status should be checked when:
         *
         * App start (if logged in)
         * Course Completed
         * Another Onboarding Completed (some will chain)
         * Logged In/Registered
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getOnboardingStatusFullappApiOnboardingsStatusPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getOnboardingStatusFullappApiOnboardingsStatusPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends GetOnboardingStatusFullappApiOnboardingsStatusPostBody, TContext = unknown>(parameters: DeepReadonly<GetOnboardingStatusFullappApiOnboardingsStatusPostParameters>, options?: ServiceOperationUseMutationOptions<GetOnboardingStatusFullappApiOnboardingsStatusPostSchema, GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters, TVariables, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, TContext>): UseMutationResult<GetOnboardingStatusFullappApiOnboardingsStatusPostData, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Onboarding Status
         * @description Get current user's onboarding status.
         *
         * Status should be checked when:
         *
         * App start (if logged in)
         * Course Completed
         * Another Onboarding Completed (some will chain)
         * Logged In/Registered
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getOnboardingStatusFullappApiOnboardingsStatusPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getOnboardingStatusFullappApiOnboardingsStatusPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GetOnboardingStatusFullappApiOnboardingsStatusPostSchema, GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters, TVariables, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, TContext>): UseMutationResult<GetOnboardingStatusFullappApiOnboardingsStatusPostData, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Get Onboarding Status
         * @description Get current user's onboarding status.
         *
         * Status should be checked when:
         *
         * App start (if logged in)
         * Course Completed
         * Another Onboarding Completed (some will chain)
         * Logged In/Registered
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const getOnboardingStatusFullappApiOnboardingsStatusPostTotal = qraft.fullappApiService.getOnboardingStatusFullappApiOnboardingsStatusPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const getOnboardingStatusFullappApiOnboardingsStatusPostTotal = qraft.fullappApiService.getOnboardingStatusFullappApiOnboardingsStatusPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, TContext> | MutationFiltersByMutationKey<GetOnboardingStatusFullappApiOnboardingsStatusPostSchema, GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Get Onboarding Status
         * @description Get current user's onboarding status.
         *
         * Status should be checked when:
         *
         * App start (if logged in)
         * Course Completed
         * Another Onboarding Completed (some will chain)
         * Logged In/Registered
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const getOnboardingStatusFullappApiOnboardingsStatusPostPendingMutationVariables = qraft.fullappApiService.getOnboardingStatusFullappApiOnboardingsStatusPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const getOnboardingStatusFullappApiOnboardingsStatusPostMutationData = qraft.fullappApiService.getOnboardingStatusFullappApiOnboardingsStatusPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GetOnboardingStatusFullappApiOnboardingsStatusPostData, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, MutationVariables<GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, TContext> | MutationFiltersByMutationKey<GetOnboardingStatusFullappApiOnboardingsStatusPostSchema, GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, TContext>;
            select?: (mutation: Mutation<GetOnboardingStatusFullappApiOnboardingsStatusPostData, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, MutationVariables<GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Get Onboarding Status
         * @description Get current user's onboarding status.
         *
         * Status should be checked when:
         *
         * App start (if logged in)
         * Course Completed
         * Another Onboarding Completed (some will chain)
         * Logged In/Registered
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, TContext> | MutationFiltersByMutationKey<GetOnboardingStatusFullappApiOnboardingsStatusPostSchema, GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Get Onboarding Status
         * @description Get current user's onboarding status.
         *
         * Status should be checked when:
         *
         * App start (if logged in)
         * Course Completed
         * Another Onboarding Completed (some will chain)
         * Logged In/Registered
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.getOnboardingStatusFullappApiOnboardingsStatusPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.getOnboardingStatusFullappApiOnboardingsStatusPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, TContext> | MutationFiltersByMutationKey<GetOnboardingStatusFullappApiOnboardingsStatusPostSchema, GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, TContext>): Mutation<GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostError, MutationVariables<GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, TContext> | MutationFiltersByMutationKey<GetOnboardingStatusFullappApiOnboardingsStatusPostSchema, GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters, OperationError<GetOnboardingStatusFullappApiOnboardingsStatusPostError>, TContext>): Array<Mutation<GetOnboardingStatusFullappApiOnboardingsStatusPostData, GetOnboardingStatusFullappApiOnboardingsStatusPostError, MutationVariables<GetOnboardingStatusFullappApiOnboardingsStatusPostBody, GetOnboardingStatusFullappApiOnboardingsStatusPostParameters>, TContext>>;
        };
        schema: GetOnboardingStatusFullappApiOnboardingsStatusPostSchema;
        types: {
            parameters: GetOnboardingStatusFullappApiOnboardingsStatusPostParameters;
            data: GetOnboardingStatusFullappApiOnboardingsStatusPostData;
            error: GetOnboardingStatusFullappApiOnboardingsStatusPostError;
            body: GetOnboardingStatusFullappApiOnboardingsStatusPostBody;
        };
    };
    /**
     * @summary Get Onboarding Details
     * @description Get an onboarding slides detail.
     */
    getOnboardingDetailsFullappApiOnboardingsDetailPost: {
        /**
         * @summary Get Onboarding Details
         * @description Get an onboarding slides detail.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters, TMeta, TSignal>, client?: (schema: GetOnboardingDetailsFullappApiOnboardingsDetailPostSchema, options: ServiceOperationMutationFnOptions<GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostError>>): Promise<RequestFnResponse<GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostError>>;
        /**
         * @summary Get Onboarding Details
         * @description Get an onboarding slides detail.
         */
        getMutationKey(parameters: DeepReadonly<GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters> | void): ServiceOperationMutationKey<GetOnboardingDetailsFullappApiOnboardingsDetailPostSchema, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Onboarding Details
         * @description Get an onboarding slides detail.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getOnboardingDetailsFullappApiOnboardingsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getOnboardingDetailsFullappApiOnboardingsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, TContext = unknown>(parameters: DeepReadonly<GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters>, options?: ServiceOperationUseMutationOptions<GetOnboardingDetailsFullappApiOnboardingsDetailPostSchema, GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters, TVariables, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, TContext>): UseMutationResult<GetOnboardingDetailsFullappApiOnboardingsDetailPostData, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Onboarding Details
         * @description Get an onboarding slides detail.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getOnboardingDetailsFullappApiOnboardingsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getOnboardingDetailsFullappApiOnboardingsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GetOnboardingDetailsFullappApiOnboardingsDetailPostSchema, GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters, TVariables, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, TContext>): UseMutationResult<GetOnboardingDetailsFullappApiOnboardingsDetailPostData, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Get Onboarding Details
         * @description Get an onboarding slides detail.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const getOnboardingDetailsFullappApiOnboardingsDetailPostTotal = qraft.fullappApiService.getOnboardingDetailsFullappApiOnboardingsDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const getOnboardingDetailsFullappApiOnboardingsDetailPostTotal = qraft.fullappApiService.getOnboardingDetailsFullappApiOnboardingsDetailPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, TContext> | MutationFiltersByMutationKey<GetOnboardingDetailsFullappApiOnboardingsDetailPostSchema, GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Get Onboarding Details
         * @description Get an onboarding slides detail.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const getOnboardingDetailsFullappApiOnboardingsDetailPostPendingMutationVariables = qraft.fullappApiService.getOnboardingDetailsFullappApiOnboardingsDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const getOnboardingDetailsFullappApiOnboardingsDetailPostMutationData = qraft.fullappApiService.getOnboardingDetailsFullappApiOnboardingsDetailPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GetOnboardingDetailsFullappApiOnboardingsDetailPostData, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, MutationVariables<GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, TContext> | MutationFiltersByMutationKey<GetOnboardingDetailsFullappApiOnboardingsDetailPostSchema, GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, TContext>;
            select?: (mutation: Mutation<GetOnboardingDetailsFullappApiOnboardingsDetailPostData, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, MutationVariables<GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Get Onboarding Details
         * @description Get an onboarding slides detail.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, TContext> | MutationFiltersByMutationKey<GetOnboardingDetailsFullappApiOnboardingsDetailPostSchema, GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Get Onboarding Details
         * @description Get an onboarding slides detail.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.getOnboardingDetailsFullappApiOnboardingsDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.getOnboardingDetailsFullappApiOnboardingsDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, TContext> | MutationFiltersByMutationKey<GetOnboardingDetailsFullappApiOnboardingsDetailPostSchema, GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, TContext>): Mutation<GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostError, MutationVariables<GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, TContext> | MutationFiltersByMutationKey<GetOnboardingDetailsFullappApiOnboardingsDetailPostSchema, GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters, OperationError<GetOnboardingDetailsFullappApiOnboardingsDetailPostError>, TContext>): Array<Mutation<GetOnboardingDetailsFullappApiOnboardingsDetailPostData, GetOnboardingDetailsFullappApiOnboardingsDetailPostError, MutationVariables<GetOnboardingDetailsFullappApiOnboardingsDetailPostBody, GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters>, TContext>>;
        };
        schema: GetOnboardingDetailsFullappApiOnboardingsDetailPostSchema;
        types: {
            parameters: GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters;
            data: GetOnboardingDetailsFullappApiOnboardingsDetailPostData;
            error: GetOnboardingDetailsFullappApiOnboardingsDetailPostError;
            body: GetOnboardingDetailsFullappApiOnboardingsDetailPostBody;
        };
    };
    /**
     * @summary Onboarding Submit
     * @description Submit an onboarding slide.
     *
     * Not role-gated: it targets the authenticated user, and a study helper may submit
     * targeting themselves. A body `user_id` is ignored.
     */
    onboardingSubmitFullappApiOnboardingsSubmitPost: {
        /**
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Not role-gated: it targets the authenticated user, and a study helper may submit
         * targeting themselves. A body `user_id` is ignored.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters, TMeta, TSignal>, client?: (schema: OnboardingSubmitFullappApiOnboardingsSubmitPostSchema, options: ServiceOperationMutationFnOptions<OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostError>>): Promise<RequestFnResponse<OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostError>>;
        /**
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Not role-gated: it targets the authenticated user, and a study helper may submit
         * targeting themselves. A body `user_id` is ignored.
         */
        getMutationKey(parameters: DeepReadonly<OnboardingSubmitFullappApiOnboardingsSubmitPostParameters> | void): ServiceOperationMutationKey<OnboardingSubmitFullappApiOnboardingsSubmitPostSchema, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Not role-gated: it targets the authenticated user, and a study helper may submit
         * targeting themselves. A body `user_id` is ignored.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.onboardingSubmitFullappApiOnboardingsSubmitPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.onboardingSubmitFullappApiOnboardingsSubmitPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends OnboardingSubmitFullappApiOnboardingsSubmitPostBody, TContext = unknown>(parameters: DeepReadonly<OnboardingSubmitFullappApiOnboardingsSubmitPostParameters>, options?: ServiceOperationUseMutationOptions<OnboardingSubmitFullappApiOnboardingsSubmitPostSchema, OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters, TVariables, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, TContext>): UseMutationResult<OnboardingSubmitFullappApiOnboardingsSubmitPostData, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Not role-gated: it targets the authenticated user, and a study helper may submit
         * targeting themselves. A body `user_id` is ignored.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.onboardingSubmitFullappApiOnboardingsSubmitPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.onboardingSubmitFullappApiOnboardingsSubmitPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<OnboardingSubmitFullappApiOnboardingsSubmitPostSchema, OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters, TVariables, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, TContext>): UseMutationResult<OnboardingSubmitFullappApiOnboardingsSubmitPostData, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Not role-gated: it targets the authenticated user, and a study helper may submit
         * targeting themselves. A body `user_id` is ignored.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const onboardingSubmitFullappApiOnboardingsSubmitPostTotal = qraft.fullappApiService.onboardingSubmitFullappApiOnboardingsSubmitPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const onboardingSubmitFullappApiOnboardingsSubmitPostTotal = qraft.fullappApiService.onboardingSubmitFullappApiOnboardingsSubmitPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, TContext> | MutationFiltersByMutationKey<OnboardingSubmitFullappApiOnboardingsSubmitPostSchema, OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Not role-gated: it targets the authenticated user, and a study helper may submit
         * targeting themselves. A body `user_id` is ignored.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const onboardingSubmitFullappApiOnboardingsSubmitPostPendingMutationVariables = qraft.fullappApiService.onboardingSubmitFullappApiOnboardingsSubmitPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const onboardingSubmitFullappApiOnboardingsSubmitPostMutationData = qraft.fullappApiService.onboardingSubmitFullappApiOnboardingsSubmitPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<OnboardingSubmitFullappApiOnboardingsSubmitPostData, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, MutationVariables<OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, TContext> | MutationFiltersByMutationKey<OnboardingSubmitFullappApiOnboardingsSubmitPostSchema, OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, TContext>;
            select?: (mutation: Mutation<OnboardingSubmitFullappApiOnboardingsSubmitPostData, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, MutationVariables<OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Not role-gated: it targets the authenticated user, and a study helper may submit
         * targeting themselves. A body `user_id` is ignored.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, TContext> | MutationFiltersByMutationKey<OnboardingSubmitFullappApiOnboardingsSubmitPostSchema, OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Onboarding Submit
         * @description Submit an onboarding slide.
         *
         * Not role-gated: it targets the authenticated user, and a study helper may submit
         * targeting themselves. A body `user_id` is ignored.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.onboardingSubmitFullappApiOnboardingsSubmitPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.onboardingSubmitFullappApiOnboardingsSubmitPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, TContext> | MutationFiltersByMutationKey<OnboardingSubmitFullappApiOnboardingsSubmitPostSchema, OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, TContext>): Mutation<OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostError, MutationVariables<OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, TContext> | MutationFiltersByMutationKey<OnboardingSubmitFullappApiOnboardingsSubmitPostSchema, OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters, OperationError<OnboardingSubmitFullappApiOnboardingsSubmitPostError>, TContext>): Array<Mutation<OnboardingSubmitFullappApiOnboardingsSubmitPostData, OnboardingSubmitFullappApiOnboardingsSubmitPostError, MutationVariables<OnboardingSubmitFullappApiOnboardingsSubmitPostBody, OnboardingSubmitFullappApiOnboardingsSubmitPostParameters>, TContext>>;
        };
        schema: OnboardingSubmitFullappApiOnboardingsSubmitPostSchema;
        types: {
            parameters: OnboardingSubmitFullappApiOnboardingsSubmitPostParameters;
            data: OnboardingSubmitFullappApiOnboardingsSubmitPostData;
            error: OnboardingSubmitFullappApiOnboardingsSubmitPostError;
            body: OnboardingSubmitFullappApiOnboardingsSubmitPostBody;
        };
    };
    /**
     * @summary Xprofiles List
     * @description List the selected or all xprofile field settings.
     *
     * Filtering only applies when the parsed id list is non-empty, so empty / absent /
     * non-numeric input returns all fields, and a requested id that does not exist is
     * silently ignored (never a 404).
     */
    xprofilesListFullappApiXprofilesListPost: {
        /**
         * @summary Xprofiles List
         * @description List the selected or all xprofile field settings.
         *
         * Filtering only applies when the parsed id list is non-empty, so empty / absent /
         * non-numeric input returns all fields, and a requested id that does not exist is
         * silently ignored (never a 404).
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostParameters, TMeta, TSignal>, client?: (schema: XprofilesListFullappApiXprofilesListPostSchema, options: ServiceOperationMutationFnOptions<XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostError>>): Promise<RequestFnResponse<XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostError>>;
        /**
         * @summary Xprofiles List
         * @description List the selected or all xprofile field settings.
         *
         * Filtering only applies when the parsed id list is non-empty, so empty / absent /
         * non-numeric input returns all fields, and a requested id that does not exist is
         * silently ignored (never a 404).
         */
        getMutationKey(parameters: DeepReadonly<XprofilesListFullappApiXprofilesListPostParameters> | void): ServiceOperationMutationKey<XprofilesListFullappApiXprofilesListPostSchema, XprofilesListFullappApiXprofilesListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Xprofiles List
         * @description List the selected or all xprofile field settings.
         *
         * Filtering only applies when the parsed id list is non-empty, so empty / absent /
         * non-numeric input returns all fields, and a requested id that does not exist is
         * silently ignored (never a 404).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.xprofilesListFullappApiXprofilesListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.xprofilesListFullappApiXprofilesListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends XprofilesListFullappApiXprofilesListPostBody, TContext = unknown>(parameters: DeepReadonly<XprofilesListFullappApiXprofilesListPostParameters>, options?: ServiceOperationUseMutationOptions<XprofilesListFullappApiXprofilesListPostSchema, XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostParameters, TVariables, OperationError<XprofilesListFullappApiXprofilesListPostError>, TContext>): UseMutationResult<XprofilesListFullappApiXprofilesListPostData, OperationError<XprofilesListFullappApiXprofilesListPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Xprofiles List
         * @description List the selected or all xprofile field settings.
         *
         * Filtering only applies when the parsed id list is non-empty, so empty / absent /
         * non-numeric input returns all fields, and a requested id that does not exist is
         * silently ignored (never a 404).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.xprofilesListFullappApiXprofilesListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.xprofilesListFullappApiXprofilesListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<XprofilesListFullappApiXprofilesListPostSchema, XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostParameters, TVariables, OperationError<XprofilesListFullappApiXprofilesListPostError>, TContext>): UseMutationResult<XprofilesListFullappApiXprofilesListPostData, OperationError<XprofilesListFullappApiXprofilesListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Xprofiles List
         * @description List the selected or all xprofile field settings.
         *
         * Filtering only applies when the parsed id list is non-empty, so empty / absent /
         * non-numeric input returns all fields, and a requested id that does not exist is
         * silently ignored (never a 404).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const xprofilesListFullappApiXprofilesListPostTotal = qraft.fullappApiService.xprofilesListFullappApiXprofilesListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const xprofilesListFullappApiXprofilesListPostTotal = qraft.fullappApiService.xprofilesListFullappApiXprofilesListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostParameters, OperationError<XprofilesListFullappApiXprofilesListPostError>, TContext> | MutationFiltersByMutationKey<XprofilesListFullappApiXprofilesListPostSchema, XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostParameters, OperationError<XprofilesListFullappApiXprofilesListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Xprofiles List
         * @description List the selected or all xprofile field settings.
         *
         * Filtering only applies when the parsed id list is non-empty, so empty / absent /
         * non-numeric input returns all fields, and a requested id that does not exist is
         * silently ignored (never a 404).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const xprofilesListFullappApiXprofilesListPostPendingMutationVariables = qraft.fullappApiService.xprofilesListFullappApiXprofilesListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const xprofilesListFullappApiXprofilesListPostMutationData = qraft.fullappApiService.xprofilesListFullappApiXprofilesListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<XprofilesListFullappApiXprofilesListPostData, OperationError<XprofilesListFullappApiXprofilesListPostError>, MutationVariables<XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostParameters, OperationError<XprofilesListFullappApiXprofilesListPostError>, TContext> | MutationFiltersByMutationKey<XprofilesListFullappApiXprofilesListPostSchema, XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostParameters, OperationError<XprofilesListFullappApiXprofilesListPostError>, TContext>;
            select?: (mutation: Mutation<XprofilesListFullappApiXprofilesListPostData, OperationError<XprofilesListFullappApiXprofilesListPostError>, MutationVariables<XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Xprofiles List
         * @description List the selected or all xprofile field settings.
         *
         * Filtering only applies when the parsed id list is non-empty, so empty / absent /
         * non-numeric input returns all fields, and a requested id that does not exist is
         * silently ignored (never a 404).
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostParameters, OperationError<XprofilesListFullappApiXprofilesListPostError>, TContext> | MutationFiltersByMutationKey<XprofilesListFullappApiXprofilesListPostSchema, XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostParameters, OperationError<XprofilesListFullappApiXprofilesListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Xprofiles List
         * @description List the selected or all xprofile field settings.
         *
         * Filtering only applies when the parsed id list is non-empty, so empty / absent /
         * non-numeric input returns all fields, and a requested id that does not exist is
         * silently ignored (never a 404).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.xprofilesListFullappApiXprofilesListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.xprofilesListFullappApiXprofilesListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostParameters, OperationError<XprofilesListFullappApiXprofilesListPostError>, TContext> | MutationFiltersByMutationKey<XprofilesListFullappApiXprofilesListPostSchema, XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostParameters, OperationError<XprofilesListFullappApiXprofilesListPostError>, TContext>): Mutation<XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostError, MutationVariables<XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostParameters, OperationError<XprofilesListFullappApiXprofilesListPostError>, TContext> | MutationFiltersByMutationKey<XprofilesListFullappApiXprofilesListPostSchema, XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostParameters, OperationError<XprofilesListFullappApiXprofilesListPostError>, TContext>): Array<Mutation<XprofilesListFullappApiXprofilesListPostData, XprofilesListFullappApiXprofilesListPostError, MutationVariables<XprofilesListFullappApiXprofilesListPostBody, XprofilesListFullappApiXprofilesListPostParameters>, TContext>>;
        };
        schema: XprofilesListFullappApiXprofilesListPostSchema;
        types: {
            parameters: XprofilesListFullappApiXprofilesListPostParameters;
            data: XprofilesListFullappApiXprofilesListPostData;
            error: XprofilesListFullappApiXprofilesListPostError;
            body: XprofilesListFullappApiXprofilesListPostBody;
        };
    };
    /** @summary Courses List */
    coursesListFullappApiCoursesListPost: {
        /** @summary Courses List */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostParameters, TMeta, TSignal>, client?: (schema: CoursesListFullappApiCoursesListPostSchema, options: ServiceOperationMutationFnOptions<CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostError>>): Promise<RequestFnResponse<CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostError>>;
        /** @summary Courses List */
        getMutationKey(parameters: DeepReadonly<CoursesListFullappApiCoursesListPostParameters> | void): ServiceOperationMutationKey<CoursesListFullappApiCoursesListPostSchema, CoursesListFullappApiCoursesListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Courses List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.coursesListFullappApiCoursesListPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.coursesListFullappApiCoursesListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CoursesListFullappApiCoursesListPostBody, TContext = unknown>(parameters: DeepReadonly<CoursesListFullappApiCoursesListPostParameters>, options?: ServiceOperationUseMutationOptions<CoursesListFullappApiCoursesListPostSchema, CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostParameters, TVariables, OperationError<CoursesListFullappApiCoursesListPostError>, TContext>): UseMutationResult<CoursesListFullappApiCoursesListPostData, OperationError<CoursesListFullappApiCoursesListPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Courses List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.coursesListFullappApiCoursesListPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.coursesListFullappApiCoursesListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CoursesListFullappApiCoursesListPostSchema, CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostParameters, TVariables, OperationError<CoursesListFullappApiCoursesListPostError>, TContext>): UseMutationResult<CoursesListFullappApiCoursesListPostData, OperationError<CoursesListFullappApiCoursesListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Courses List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const coursesListFullappApiCoursesListPostTotal = qraft.fullappApiService.coursesListFullappApiCoursesListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const coursesListFullappApiCoursesListPostTotal = qraft.fullappApiService.coursesListFullappApiCoursesListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostParameters, OperationError<CoursesListFullappApiCoursesListPostError>, TContext> | MutationFiltersByMutationKey<CoursesListFullappApiCoursesListPostSchema, CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostParameters, OperationError<CoursesListFullappApiCoursesListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Courses List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const coursesListFullappApiCoursesListPostPendingMutationVariables = qraft.fullappApiService.coursesListFullappApiCoursesListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const coursesListFullappApiCoursesListPostMutationData = qraft.fullappApiService.coursesListFullappApiCoursesListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CoursesListFullappApiCoursesListPostData, OperationError<CoursesListFullappApiCoursesListPostError>, MutationVariables<CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostParameters, OperationError<CoursesListFullappApiCoursesListPostError>, TContext> | MutationFiltersByMutationKey<CoursesListFullappApiCoursesListPostSchema, CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostParameters, OperationError<CoursesListFullappApiCoursesListPostError>, TContext>;
            select?: (mutation: Mutation<CoursesListFullappApiCoursesListPostData, OperationError<CoursesListFullappApiCoursesListPostError>, MutationVariables<CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Courses List */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostParameters, OperationError<CoursesListFullappApiCoursesListPostError>, TContext> | MutationFiltersByMutationKey<CoursesListFullappApiCoursesListPostSchema, CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostParameters, OperationError<CoursesListFullappApiCoursesListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Courses List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.coursesListFullappApiCoursesListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.coursesListFullappApiCoursesListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostParameters, OperationError<CoursesListFullappApiCoursesListPostError>, TContext> | MutationFiltersByMutationKey<CoursesListFullappApiCoursesListPostSchema, CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostParameters, OperationError<CoursesListFullappApiCoursesListPostError>, TContext>): Mutation<CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostError, MutationVariables<CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostParameters, OperationError<CoursesListFullappApiCoursesListPostError>, TContext> | MutationFiltersByMutationKey<CoursesListFullappApiCoursesListPostSchema, CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostParameters, OperationError<CoursesListFullappApiCoursesListPostError>, TContext>): Array<Mutation<CoursesListFullappApiCoursesListPostData, CoursesListFullappApiCoursesListPostError, MutationVariables<CoursesListFullappApiCoursesListPostBody, CoursesListFullappApiCoursesListPostParameters>, TContext>>;
        };
        schema: CoursesListFullappApiCoursesListPostSchema;
        types: {
            parameters: CoursesListFullappApiCoursesListPostParameters;
            data: CoursesListFullappApiCoursesListPostData;
            error: CoursesListFullappApiCoursesListPostError;
            body: CoursesListFullappApiCoursesListPostBody;
        };
    };
    /** @summary Course Detail */
    courseDetailFullappApiCoursesDetailPost: {
        /** @summary Course Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostParameters, TMeta, TSignal>, client?: (schema: CourseDetailFullappApiCoursesDetailPostSchema, options: ServiceOperationMutationFnOptions<CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostError>>): Promise<RequestFnResponse<CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostError>>;
        /** @summary Course Detail */
        getMutationKey(parameters: DeepReadonly<CourseDetailFullappApiCoursesDetailPostParameters> | void): ServiceOperationMutationKey<CourseDetailFullappApiCoursesDetailPostSchema, CourseDetailFullappApiCoursesDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Course Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.courseDetailFullappApiCoursesDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.courseDetailFullappApiCoursesDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CourseDetailFullappApiCoursesDetailPostBody, TContext = unknown>(parameters: DeepReadonly<CourseDetailFullappApiCoursesDetailPostParameters>, options?: ServiceOperationUseMutationOptions<CourseDetailFullappApiCoursesDetailPostSchema, CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostParameters, TVariables, OperationError<CourseDetailFullappApiCoursesDetailPostError>, TContext>): UseMutationResult<CourseDetailFullappApiCoursesDetailPostData, OperationError<CourseDetailFullappApiCoursesDetailPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Course Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.courseDetailFullappApiCoursesDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.courseDetailFullappApiCoursesDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CourseDetailFullappApiCoursesDetailPostSchema, CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostParameters, TVariables, OperationError<CourseDetailFullappApiCoursesDetailPostError>, TContext>): UseMutationResult<CourseDetailFullappApiCoursesDetailPostData, OperationError<CourseDetailFullappApiCoursesDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Course Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const courseDetailFullappApiCoursesDetailPostTotal = qraft.fullappApiService.courseDetailFullappApiCoursesDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const courseDetailFullappApiCoursesDetailPostTotal = qraft.fullappApiService.courseDetailFullappApiCoursesDetailPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostParameters, OperationError<CourseDetailFullappApiCoursesDetailPostError>, TContext> | MutationFiltersByMutationKey<CourseDetailFullappApiCoursesDetailPostSchema, CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostParameters, OperationError<CourseDetailFullappApiCoursesDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Course Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const courseDetailFullappApiCoursesDetailPostPendingMutationVariables = qraft.fullappApiService.courseDetailFullappApiCoursesDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const courseDetailFullappApiCoursesDetailPostMutationData = qraft.fullappApiService.courseDetailFullappApiCoursesDetailPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CourseDetailFullappApiCoursesDetailPostData, OperationError<CourseDetailFullappApiCoursesDetailPostError>, MutationVariables<CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostParameters, OperationError<CourseDetailFullappApiCoursesDetailPostError>, TContext> | MutationFiltersByMutationKey<CourseDetailFullappApiCoursesDetailPostSchema, CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostParameters, OperationError<CourseDetailFullappApiCoursesDetailPostError>, TContext>;
            select?: (mutation: Mutation<CourseDetailFullappApiCoursesDetailPostData, OperationError<CourseDetailFullappApiCoursesDetailPostError>, MutationVariables<CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Course Detail */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostParameters, OperationError<CourseDetailFullappApiCoursesDetailPostError>, TContext> | MutationFiltersByMutationKey<CourseDetailFullappApiCoursesDetailPostSchema, CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostParameters, OperationError<CourseDetailFullappApiCoursesDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Course Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.courseDetailFullappApiCoursesDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.courseDetailFullappApiCoursesDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostParameters, OperationError<CourseDetailFullappApiCoursesDetailPostError>, TContext> | MutationFiltersByMutationKey<CourseDetailFullappApiCoursesDetailPostSchema, CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostParameters, OperationError<CourseDetailFullappApiCoursesDetailPostError>, TContext>): Mutation<CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostError, MutationVariables<CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostParameters, OperationError<CourseDetailFullappApiCoursesDetailPostError>, TContext> | MutationFiltersByMutationKey<CourseDetailFullappApiCoursesDetailPostSchema, CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostParameters, OperationError<CourseDetailFullappApiCoursesDetailPostError>, TContext>): Array<Mutation<CourseDetailFullappApiCoursesDetailPostData, CourseDetailFullappApiCoursesDetailPostError, MutationVariables<CourseDetailFullappApiCoursesDetailPostBody, CourseDetailFullappApiCoursesDetailPostParameters>, TContext>>;
        };
        schema: CourseDetailFullappApiCoursesDetailPostSchema;
        types: {
            parameters: CourseDetailFullappApiCoursesDetailPostParameters;
            data: CourseDetailFullappApiCoursesDetailPostData;
            error: CourseDetailFullappApiCoursesDetailPostError;
            body: CourseDetailFullappApiCoursesDetailPostBody;
        };
    };
    /** @summary Lessons List */
    lessonsListFullappApiLessonsListPost: {
        /** @summary Lessons List */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostParameters, TMeta, TSignal>, client?: (schema: LessonsListFullappApiLessonsListPostSchema, options: ServiceOperationMutationFnOptions<LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostError>>): Promise<RequestFnResponse<LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostError>>;
        /** @summary Lessons List */
        getMutationKey(parameters: DeepReadonly<LessonsListFullappApiLessonsListPostParameters> | void): ServiceOperationMutationKey<LessonsListFullappApiLessonsListPostSchema, LessonsListFullappApiLessonsListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Lessons List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.lessonsListFullappApiLessonsListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.lessonsListFullappApiLessonsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends LessonsListFullappApiLessonsListPostBody, TContext = unknown>(parameters: DeepReadonly<LessonsListFullappApiLessonsListPostParameters>, options?: ServiceOperationUseMutationOptions<LessonsListFullappApiLessonsListPostSchema, LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostParameters, TVariables, OperationError<LessonsListFullappApiLessonsListPostError>, TContext>): UseMutationResult<LessonsListFullappApiLessonsListPostData, OperationError<LessonsListFullappApiLessonsListPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Lessons List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.lessonsListFullappApiLessonsListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.lessonsListFullappApiLessonsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<LessonsListFullappApiLessonsListPostSchema, LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostParameters, TVariables, OperationError<LessonsListFullappApiLessonsListPostError>, TContext>): UseMutationResult<LessonsListFullappApiLessonsListPostData, OperationError<LessonsListFullappApiLessonsListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Lessons List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const lessonsListFullappApiLessonsListPostTotal = qraft.fullappApiService.lessonsListFullappApiLessonsListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const lessonsListFullappApiLessonsListPostTotal = qraft.fullappApiService.lessonsListFullappApiLessonsListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostParameters, OperationError<LessonsListFullappApiLessonsListPostError>, TContext> | MutationFiltersByMutationKey<LessonsListFullappApiLessonsListPostSchema, LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostParameters, OperationError<LessonsListFullappApiLessonsListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Lessons List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const lessonsListFullappApiLessonsListPostPendingMutationVariables = qraft.fullappApiService.lessonsListFullappApiLessonsListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const lessonsListFullappApiLessonsListPostMutationData = qraft.fullappApiService.lessonsListFullappApiLessonsListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<LessonsListFullappApiLessonsListPostData, OperationError<LessonsListFullappApiLessonsListPostError>, MutationVariables<LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostParameters, OperationError<LessonsListFullappApiLessonsListPostError>, TContext> | MutationFiltersByMutationKey<LessonsListFullappApiLessonsListPostSchema, LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostParameters, OperationError<LessonsListFullappApiLessonsListPostError>, TContext>;
            select?: (mutation: Mutation<LessonsListFullappApiLessonsListPostData, OperationError<LessonsListFullappApiLessonsListPostError>, MutationVariables<LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Lessons List */
        isMutating<TContext>(filters?: MutationFiltersByParameters<LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostParameters, OperationError<LessonsListFullappApiLessonsListPostError>, TContext> | MutationFiltersByMutationKey<LessonsListFullappApiLessonsListPostSchema, LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostParameters, OperationError<LessonsListFullappApiLessonsListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Lessons List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.lessonsListFullappApiLessonsListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.lessonsListFullappApiLessonsListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostParameters, OperationError<LessonsListFullappApiLessonsListPostError>, TContext> | MutationFiltersByMutationKey<LessonsListFullappApiLessonsListPostSchema, LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostParameters, OperationError<LessonsListFullappApiLessonsListPostError>, TContext>): Mutation<LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostError, MutationVariables<LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostParameters, OperationError<LessonsListFullappApiLessonsListPostError>, TContext> | MutationFiltersByMutationKey<LessonsListFullappApiLessonsListPostSchema, LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostParameters, OperationError<LessonsListFullappApiLessonsListPostError>, TContext>): Array<Mutation<LessonsListFullappApiLessonsListPostData, LessonsListFullappApiLessonsListPostError, MutationVariables<LessonsListFullappApiLessonsListPostBody, LessonsListFullappApiLessonsListPostParameters>, TContext>>;
        };
        schema: LessonsListFullappApiLessonsListPostSchema;
        types: {
            parameters: LessonsListFullappApiLessonsListPostParameters;
            data: LessonsListFullappApiLessonsListPostData;
            error: LessonsListFullappApiLessonsListPostError;
            body: LessonsListFullappApiLessonsListPostBody;
        };
    };
    /** @summary Lesson Detail */
    lessonDetailFullappApiLessonsDetailPost: {
        /** @summary Lesson Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostParameters, TMeta, TSignal>, client?: (schema: LessonDetailFullappApiLessonsDetailPostSchema, options: ServiceOperationMutationFnOptions<LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostError>>): Promise<RequestFnResponse<LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostError>>;
        /** @summary Lesson Detail */
        getMutationKey(parameters: DeepReadonly<LessonDetailFullappApiLessonsDetailPostParameters> | void): ServiceOperationMutationKey<LessonDetailFullappApiLessonsDetailPostSchema, LessonDetailFullappApiLessonsDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Lesson Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.lessonDetailFullappApiLessonsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.lessonDetailFullappApiLessonsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends LessonDetailFullappApiLessonsDetailPostBody, TContext = unknown>(parameters: DeepReadonly<LessonDetailFullappApiLessonsDetailPostParameters>, options?: ServiceOperationUseMutationOptions<LessonDetailFullappApiLessonsDetailPostSchema, LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostParameters, TVariables, OperationError<LessonDetailFullappApiLessonsDetailPostError>, TContext>): UseMutationResult<LessonDetailFullappApiLessonsDetailPostData, OperationError<LessonDetailFullappApiLessonsDetailPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Lesson Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.lessonDetailFullappApiLessonsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.lessonDetailFullappApiLessonsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<LessonDetailFullappApiLessonsDetailPostSchema, LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostParameters, TVariables, OperationError<LessonDetailFullappApiLessonsDetailPostError>, TContext>): UseMutationResult<LessonDetailFullappApiLessonsDetailPostData, OperationError<LessonDetailFullappApiLessonsDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Lesson Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const lessonDetailFullappApiLessonsDetailPostTotal = qraft.fullappApiService.lessonDetailFullappApiLessonsDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const lessonDetailFullappApiLessonsDetailPostTotal = qraft.fullappApiService.lessonDetailFullappApiLessonsDetailPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostParameters, OperationError<LessonDetailFullappApiLessonsDetailPostError>, TContext> | MutationFiltersByMutationKey<LessonDetailFullappApiLessonsDetailPostSchema, LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostParameters, OperationError<LessonDetailFullappApiLessonsDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Lesson Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const lessonDetailFullappApiLessonsDetailPostPendingMutationVariables = qraft.fullappApiService.lessonDetailFullappApiLessonsDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const lessonDetailFullappApiLessonsDetailPostMutationData = qraft.fullappApiService.lessonDetailFullappApiLessonsDetailPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<LessonDetailFullappApiLessonsDetailPostData, OperationError<LessonDetailFullappApiLessonsDetailPostError>, MutationVariables<LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostParameters, OperationError<LessonDetailFullappApiLessonsDetailPostError>, TContext> | MutationFiltersByMutationKey<LessonDetailFullappApiLessonsDetailPostSchema, LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostParameters, OperationError<LessonDetailFullappApiLessonsDetailPostError>, TContext>;
            select?: (mutation: Mutation<LessonDetailFullappApiLessonsDetailPostData, OperationError<LessonDetailFullappApiLessonsDetailPostError>, MutationVariables<LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Lesson Detail */
        isMutating<TContext>(filters?: MutationFiltersByParameters<LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostParameters, OperationError<LessonDetailFullappApiLessonsDetailPostError>, TContext> | MutationFiltersByMutationKey<LessonDetailFullappApiLessonsDetailPostSchema, LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostParameters, OperationError<LessonDetailFullappApiLessonsDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Lesson Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.lessonDetailFullappApiLessonsDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.lessonDetailFullappApiLessonsDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostParameters, OperationError<LessonDetailFullappApiLessonsDetailPostError>, TContext> | MutationFiltersByMutationKey<LessonDetailFullappApiLessonsDetailPostSchema, LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostParameters, OperationError<LessonDetailFullappApiLessonsDetailPostError>, TContext>): Mutation<LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostError, MutationVariables<LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostParameters, OperationError<LessonDetailFullappApiLessonsDetailPostError>, TContext> | MutationFiltersByMutationKey<LessonDetailFullappApiLessonsDetailPostSchema, LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostParameters, OperationError<LessonDetailFullappApiLessonsDetailPostError>, TContext>): Array<Mutation<LessonDetailFullappApiLessonsDetailPostData, LessonDetailFullappApiLessonsDetailPostError, MutationVariables<LessonDetailFullappApiLessonsDetailPostBody, LessonDetailFullappApiLessonsDetailPostParameters>, TContext>>;
        };
        schema: LessonDetailFullappApiLessonsDetailPostSchema;
        types: {
            parameters: LessonDetailFullappApiLessonsDetailPostParameters;
            data: LessonDetailFullappApiLessonsDetailPostData;
            error: LessonDetailFullappApiLessonsDetailPostError;
            body: LessonDetailFullappApiLessonsDetailPostBody;
        };
    };
    /** @summary Topics List */
    topicsListFullappApiTopicsListPost: {
        /** @summary Topics List */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostParameters, TMeta, TSignal>, client?: (schema: TopicsListFullappApiTopicsListPostSchema, options: ServiceOperationMutationFnOptions<TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostError>>): Promise<RequestFnResponse<TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostError>>;
        /** @summary Topics List */
        getMutationKey(parameters: DeepReadonly<TopicsListFullappApiTopicsListPostParameters> | void): ServiceOperationMutationKey<TopicsListFullappApiTopicsListPostSchema, TopicsListFullappApiTopicsListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Topics List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.topicsListFullappApiTopicsListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.topicsListFullappApiTopicsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends TopicsListFullappApiTopicsListPostBody, TContext = unknown>(parameters: DeepReadonly<TopicsListFullappApiTopicsListPostParameters>, options?: ServiceOperationUseMutationOptions<TopicsListFullappApiTopicsListPostSchema, TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostParameters, TVariables, OperationError<TopicsListFullappApiTopicsListPostError>, TContext>): UseMutationResult<TopicsListFullappApiTopicsListPostData, OperationError<TopicsListFullappApiTopicsListPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Topics List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.topicsListFullappApiTopicsListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.topicsListFullappApiTopicsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<TopicsListFullappApiTopicsListPostSchema, TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostParameters, TVariables, OperationError<TopicsListFullappApiTopicsListPostError>, TContext>): UseMutationResult<TopicsListFullappApiTopicsListPostData, OperationError<TopicsListFullappApiTopicsListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Topics List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const topicsListFullappApiTopicsListPostTotal = qraft.fullappApiService.topicsListFullappApiTopicsListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const topicsListFullappApiTopicsListPostTotal = qraft.fullappApiService.topicsListFullappApiTopicsListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostParameters, OperationError<TopicsListFullappApiTopicsListPostError>, TContext> | MutationFiltersByMutationKey<TopicsListFullappApiTopicsListPostSchema, TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostParameters, OperationError<TopicsListFullappApiTopicsListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Topics List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const topicsListFullappApiTopicsListPostPendingMutationVariables = qraft.fullappApiService.topicsListFullappApiTopicsListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const topicsListFullappApiTopicsListPostMutationData = qraft.fullappApiService.topicsListFullappApiTopicsListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<TopicsListFullappApiTopicsListPostData, OperationError<TopicsListFullappApiTopicsListPostError>, MutationVariables<TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostParameters, OperationError<TopicsListFullappApiTopicsListPostError>, TContext> | MutationFiltersByMutationKey<TopicsListFullappApiTopicsListPostSchema, TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostParameters, OperationError<TopicsListFullappApiTopicsListPostError>, TContext>;
            select?: (mutation: Mutation<TopicsListFullappApiTopicsListPostData, OperationError<TopicsListFullappApiTopicsListPostError>, MutationVariables<TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Topics List */
        isMutating<TContext>(filters?: MutationFiltersByParameters<TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostParameters, OperationError<TopicsListFullappApiTopicsListPostError>, TContext> | MutationFiltersByMutationKey<TopicsListFullappApiTopicsListPostSchema, TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostParameters, OperationError<TopicsListFullappApiTopicsListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Topics List
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.topicsListFullappApiTopicsListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.topicsListFullappApiTopicsListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostParameters, OperationError<TopicsListFullappApiTopicsListPostError>, TContext> | MutationFiltersByMutationKey<TopicsListFullappApiTopicsListPostSchema, TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostParameters, OperationError<TopicsListFullappApiTopicsListPostError>, TContext>): Mutation<TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostError, MutationVariables<TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostParameters, OperationError<TopicsListFullappApiTopicsListPostError>, TContext> | MutationFiltersByMutationKey<TopicsListFullappApiTopicsListPostSchema, TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostParameters, OperationError<TopicsListFullappApiTopicsListPostError>, TContext>): Array<Mutation<TopicsListFullappApiTopicsListPostData, TopicsListFullappApiTopicsListPostError, MutationVariables<TopicsListFullappApiTopicsListPostBody, TopicsListFullappApiTopicsListPostParameters>, TContext>>;
        };
        schema: TopicsListFullappApiTopicsListPostSchema;
        types: {
            parameters: TopicsListFullappApiTopicsListPostParameters;
            data: TopicsListFullappApiTopicsListPostData;
            error: TopicsListFullappApiTopicsListPostError;
            body: TopicsListFullappApiTopicsListPostBody;
        };
    };
    /** @summary Topic Detail */
    topicDetailFullappApiTopicsDetailPost: {
        /** @summary Topic Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostParameters, TMeta, TSignal>, client?: (schema: TopicDetailFullappApiTopicsDetailPostSchema, options: ServiceOperationMutationFnOptions<TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostError>>): Promise<RequestFnResponse<TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostError>>;
        /** @summary Topic Detail */
        getMutationKey(parameters: DeepReadonly<TopicDetailFullappApiTopicsDetailPostParameters> | void): ServiceOperationMutationKey<TopicDetailFullappApiTopicsDetailPostSchema, TopicDetailFullappApiTopicsDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Topic Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.topicDetailFullappApiTopicsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.topicDetailFullappApiTopicsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends TopicDetailFullappApiTopicsDetailPostBody, TContext = unknown>(parameters: DeepReadonly<TopicDetailFullappApiTopicsDetailPostParameters>, options?: ServiceOperationUseMutationOptions<TopicDetailFullappApiTopicsDetailPostSchema, TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostParameters, TVariables, OperationError<TopicDetailFullappApiTopicsDetailPostError>, TContext>): UseMutationResult<TopicDetailFullappApiTopicsDetailPostData, OperationError<TopicDetailFullappApiTopicsDetailPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Topic Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.topicDetailFullappApiTopicsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.topicDetailFullappApiTopicsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<TopicDetailFullappApiTopicsDetailPostSchema, TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostParameters, TVariables, OperationError<TopicDetailFullappApiTopicsDetailPostError>, TContext>): UseMutationResult<TopicDetailFullappApiTopicsDetailPostData, OperationError<TopicDetailFullappApiTopicsDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Topic Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const topicDetailFullappApiTopicsDetailPostTotal = qraft.fullappApiService.topicDetailFullappApiTopicsDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const topicDetailFullappApiTopicsDetailPostTotal = qraft.fullappApiService.topicDetailFullappApiTopicsDetailPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostParameters, OperationError<TopicDetailFullappApiTopicsDetailPostError>, TContext> | MutationFiltersByMutationKey<TopicDetailFullappApiTopicsDetailPostSchema, TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostParameters, OperationError<TopicDetailFullappApiTopicsDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Topic Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const topicDetailFullappApiTopicsDetailPostPendingMutationVariables = qraft.fullappApiService.topicDetailFullappApiTopicsDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const topicDetailFullappApiTopicsDetailPostMutationData = qraft.fullappApiService.topicDetailFullappApiTopicsDetailPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<TopicDetailFullappApiTopicsDetailPostData, OperationError<TopicDetailFullappApiTopicsDetailPostError>, MutationVariables<TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostParameters, OperationError<TopicDetailFullappApiTopicsDetailPostError>, TContext> | MutationFiltersByMutationKey<TopicDetailFullappApiTopicsDetailPostSchema, TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostParameters, OperationError<TopicDetailFullappApiTopicsDetailPostError>, TContext>;
            select?: (mutation: Mutation<TopicDetailFullappApiTopicsDetailPostData, OperationError<TopicDetailFullappApiTopicsDetailPostError>, MutationVariables<TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Topic Detail */
        isMutating<TContext>(filters?: MutationFiltersByParameters<TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostParameters, OperationError<TopicDetailFullappApiTopicsDetailPostError>, TContext> | MutationFiltersByMutationKey<TopicDetailFullappApiTopicsDetailPostSchema, TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostParameters, OperationError<TopicDetailFullappApiTopicsDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Topic Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.topicDetailFullappApiTopicsDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.topicDetailFullappApiTopicsDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostParameters, OperationError<TopicDetailFullappApiTopicsDetailPostError>, TContext> | MutationFiltersByMutationKey<TopicDetailFullappApiTopicsDetailPostSchema, TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostParameters, OperationError<TopicDetailFullappApiTopicsDetailPostError>, TContext>): Mutation<TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostError, MutationVariables<TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostParameters, OperationError<TopicDetailFullappApiTopicsDetailPostError>, TContext> | MutationFiltersByMutationKey<TopicDetailFullappApiTopicsDetailPostSchema, TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostParameters, OperationError<TopicDetailFullappApiTopicsDetailPostError>, TContext>): Array<Mutation<TopicDetailFullappApiTopicsDetailPostData, TopicDetailFullappApiTopicsDetailPostError, MutationVariables<TopicDetailFullappApiTopicsDetailPostBody, TopicDetailFullappApiTopicsDetailPostParameters>, TContext>>;
        };
        schema: TopicDetailFullappApiTopicsDetailPostSchema;
        types: {
            parameters: TopicDetailFullappApiTopicsDetailPostParameters;
            data: TopicDetailFullappApiTopicsDetailPostData;
            error: TopicDetailFullappApiTopicsDetailPostError;
            body: TopicDetailFullappApiTopicsDetailPostBody;
        };
    };
    /** @summary Quiz Detail */
    quizDetailFullappApiQuizzesDetailPost: {
        /** @summary Quiz Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostParameters, TMeta, TSignal>, client?: (schema: QuizDetailFullappApiQuizzesDetailPostSchema, options: ServiceOperationMutationFnOptions<QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostError>>): Promise<RequestFnResponse<QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostError>>;
        /** @summary Quiz Detail */
        getMutationKey(parameters: DeepReadonly<QuizDetailFullappApiQuizzesDetailPostParameters> | void): ServiceOperationMutationKey<QuizDetailFullappApiQuizzesDetailPostSchema, QuizDetailFullappApiQuizzesDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Quiz Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.quizDetailFullappApiQuizzesDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.quizDetailFullappApiQuizzesDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends QuizDetailFullappApiQuizzesDetailPostBody, TContext = unknown>(parameters: DeepReadonly<QuizDetailFullappApiQuizzesDetailPostParameters>, options?: ServiceOperationUseMutationOptions<QuizDetailFullappApiQuizzesDetailPostSchema, QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostParameters, TVariables, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, TContext>): UseMutationResult<QuizDetailFullappApiQuizzesDetailPostData, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Quiz Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.quizDetailFullappApiQuizzesDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.quizDetailFullappApiQuizzesDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<QuizDetailFullappApiQuizzesDetailPostSchema, QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostParameters, TVariables, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, TContext>): UseMutationResult<QuizDetailFullappApiQuizzesDetailPostData, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Quiz Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const quizDetailFullappApiQuizzesDetailPostTotal = qraft.fullappApiService.quizDetailFullappApiQuizzesDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const quizDetailFullappApiQuizzesDetailPostTotal = qraft.fullappApiService.quizDetailFullappApiQuizzesDetailPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostParameters, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, TContext> | MutationFiltersByMutationKey<QuizDetailFullappApiQuizzesDetailPostSchema, QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostParameters, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Quiz Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const quizDetailFullappApiQuizzesDetailPostPendingMutationVariables = qraft.fullappApiService.quizDetailFullappApiQuizzesDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const quizDetailFullappApiQuizzesDetailPostMutationData = qraft.fullappApiService.quizDetailFullappApiQuizzesDetailPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<QuizDetailFullappApiQuizzesDetailPostData, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, MutationVariables<QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostParameters, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, TContext> | MutationFiltersByMutationKey<QuizDetailFullappApiQuizzesDetailPostSchema, QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostParameters, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, TContext>;
            select?: (mutation: Mutation<QuizDetailFullappApiQuizzesDetailPostData, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, MutationVariables<QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Quiz Detail */
        isMutating<TContext>(filters?: MutationFiltersByParameters<QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostParameters, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, TContext> | MutationFiltersByMutationKey<QuizDetailFullappApiQuizzesDetailPostSchema, QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostParameters, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Quiz Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.quizDetailFullappApiQuizzesDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.quizDetailFullappApiQuizzesDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostParameters, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, TContext> | MutationFiltersByMutationKey<QuizDetailFullappApiQuizzesDetailPostSchema, QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostParameters, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, TContext>): Mutation<QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostError, MutationVariables<QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostParameters, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, TContext> | MutationFiltersByMutationKey<QuizDetailFullappApiQuizzesDetailPostSchema, QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostParameters, OperationError<QuizDetailFullappApiQuizzesDetailPostError>, TContext>): Array<Mutation<QuizDetailFullappApiQuizzesDetailPostData, QuizDetailFullappApiQuizzesDetailPostError, MutationVariables<QuizDetailFullappApiQuizzesDetailPostBody, QuizDetailFullappApiQuizzesDetailPostParameters>, TContext>>;
        };
        schema: QuizDetailFullappApiQuizzesDetailPostSchema;
        types: {
            parameters: QuizDetailFullappApiQuizzesDetailPostParameters;
            data: QuizDetailFullappApiQuizzesDetailPostData;
            error: QuizDetailFullappApiQuizzesDetailPostError;
            body: QuizDetailFullappApiQuizzesDetailPostBody;
        };
    };
    /**
     * @summary Guides List
     * @description Published bible-study guides ordered by menu_order ASC, scoped to the request
     * language. Not role-sensitive.
     */
    guidesListFullappApiGuidesListPost: {
        /**
         * @summary Guides List
         * @description Published bible-study guides ordered by menu_order ASC, scoped to the request
         * language. Not role-sensitive.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostParameters, TMeta, TSignal>, client?: (schema: GuidesListFullappApiGuidesListPostSchema, options: ServiceOperationMutationFnOptions<GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostError>>): Promise<RequestFnResponse<GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostError>>;
        /**
         * @summary Guides List
         * @description Published bible-study guides ordered by menu_order ASC, scoped to the request
         * language. Not role-sensitive.
         */
        getMutationKey(parameters: DeepReadonly<GuidesListFullappApiGuidesListPostParameters> | void): ServiceOperationMutationKey<GuidesListFullappApiGuidesListPostSchema, GuidesListFullappApiGuidesListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Guides List
         * @description Published bible-study guides ordered by menu_order ASC, scoped to the request
         * language. Not role-sensitive.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.guidesListFullappApiGuidesListPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.guidesListFullappApiGuidesListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends GuidesListFullappApiGuidesListPostBody, TContext = unknown>(parameters: DeepReadonly<GuidesListFullappApiGuidesListPostParameters>, options?: ServiceOperationUseMutationOptions<GuidesListFullappApiGuidesListPostSchema, GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostParameters, TVariables, OperationError<GuidesListFullappApiGuidesListPostError>, TContext>): UseMutationResult<GuidesListFullappApiGuidesListPostData, OperationError<GuidesListFullappApiGuidesListPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Guides List
         * @description Published bible-study guides ordered by menu_order ASC, scoped to the request
         * language. Not role-sensitive.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.guidesListFullappApiGuidesListPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.guidesListFullappApiGuidesListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GuidesListFullappApiGuidesListPostSchema, GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostParameters, TVariables, OperationError<GuidesListFullappApiGuidesListPostError>, TContext>): UseMutationResult<GuidesListFullappApiGuidesListPostData, OperationError<GuidesListFullappApiGuidesListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Guides List
         * @description Published bible-study guides ordered by menu_order ASC, scoped to the request
         * language. Not role-sensitive.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const guidesListFullappApiGuidesListPostTotal = qraft.fullappApiService.guidesListFullappApiGuidesListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const guidesListFullappApiGuidesListPostTotal = qraft.fullappApiService.guidesListFullappApiGuidesListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostParameters, OperationError<GuidesListFullappApiGuidesListPostError>, TContext> | MutationFiltersByMutationKey<GuidesListFullappApiGuidesListPostSchema, GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostParameters, OperationError<GuidesListFullappApiGuidesListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Guides List
         * @description Published bible-study guides ordered by menu_order ASC, scoped to the request
         * language. Not role-sensitive.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const guidesListFullappApiGuidesListPostPendingMutationVariables = qraft.fullappApiService.guidesListFullappApiGuidesListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const guidesListFullappApiGuidesListPostMutationData = qraft.fullappApiService.guidesListFullappApiGuidesListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GuidesListFullappApiGuidesListPostData, OperationError<GuidesListFullappApiGuidesListPostError>, MutationVariables<GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostParameters, OperationError<GuidesListFullappApiGuidesListPostError>, TContext> | MutationFiltersByMutationKey<GuidesListFullappApiGuidesListPostSchema, GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostParameters, OperationError<GuidesListFullappApiGuidesListPostError>, TContext>;
            select?: (mutation: Mutation<GuidesListFullappApiGuidesListPostData, OperationError<GuidesListFullappApiGuidesListPostError>, MutationVariables<GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Guides List
         * @description Published bible-study guides ordered by menu_order ASC, scoped to the request
         * language. Not role-sensitive.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostParameters, OperationError<GuidesListFullappApiGuidesListPostError>, TContext> | MutationFiltersByMutationKey<GuidesListFullappApiGuidesListPostSchema, GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostParameters, OperationError<GuidesListFullappApiGuidesListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Guides List
         * @description Published bible-study guides ordered by menu_order ASC, scoped to the request
         * language. Not role-sensitive.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.guidesListFullappApiGuidesListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.guidesListFullappApiGuidesListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostParameters, OperationError<GuidesListFullappApiGuidesListPostError>, TContext> | MutationFiltersByMutationKey<GuidesListFullappApiGuidesListPostSchema, GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostParameters, OperationError<GuidesListFullappApiGuidesListPostError>, TContext>): Mutation<GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostError, MutationVariables<GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostParameters, OperationError<GuidesListFullappApiGuidesListPostError>, TContext> | MutationFiltersByMutationKey<GuidesListFullappApiGuidesListPostSchema, GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostParameters, OperationError<GuidesListFullappApiGuidesListPostError>, TContext>): Array<Mutation<GuidesListFullappApiGuidesListPostData, GuidesListFullappApiGuidesListPostError, MutationVariables<GuidesListFullappApiGuidesListPostBody, GuidesListFullappApiGuidesListPostParameters>, TContext>>;
        };
        schema: GuidesListFullappApiGuidesListPostSchema;
        types: {
            parameters: GuidesListFullappApiGuidesListPostParameters;
            data: GuidesListFullappApiGuidesListPostData;
            error: GuidesListFullappApiGuidesListPostError;
            body: GuidesListFullappApiGuidesListPostBody;
        };
    };
    /**
     * @summary Guides Detail
     * @description Guide detail (title/order/intro/content/excerpt). Not role-sensitive: no
     * user_id / resolve_student.
     */
    guidesDetailFullappApiGuidesDetailPost: {
        /**
         * @summary Guides Detail
         * @description Guide detail (title/order/intro/content/excerpt). Not role-sensitive: no
         * user_id / resolve_student.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostParameters, TMeta, TSignal>, client?: (schema: GuidesDetailFullappApiGuidesDetailPostSchema, options: ServiceOperationMutationFnOptions<GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostError>>): Promise<RequestFnResponse<GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostError>>;
        /**
         * @summary Guides Detail
         * @description Guide detail (title/order/intro/content/excerpt). Not role-sensitive: no
         * user_id / resolve_student.
         */
        getMutationKey(parameters: DeepReadonly<GuidesDetailFullappApiGuidesDetailPostParameters> | void): ServiceOperationMutationKey<GuidesDetailFullappApiGuidesDetailPostSchema, GuidesDetailFullappApiGuidesDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Guides Detail
         * @description Guide detail (title/order/intro/content/excerpt). Not role-sensitive: no
         * user_id / resolve_student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.guidesDetailFullappApiGuidesDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.guidesDetailFullappApiGuidesDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends GuidesDetailFullappApiGuidesDetailPostBody, TContext = unknown>(parameters: DeepReadonly<GuidesDetailFullappApiGuidesDetailPostParameters>, options?: ServiceOperationUseMutationOptions<GuidesDetailFullappApiGuidesDetailPostSchema, GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostParameters, TVariables, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, TContext>): UseMutationResult<GuidesDetailFullappApiGuidesDetailPostData, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Guides Detail
         * @description Guide detail (title/order/intro/content/excerpt). Not role-sensitive: no
         * user_id / resolve_student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.guidesDetailFullappApiGuidesDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.guidesDetailFullappApiGuidesDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GuidesDetailFullappApiGuidesDetailPostSchema, GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostParameters, TVariables, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, TContext>): UseMutationResult<GuidesDetailFullappApiGuidesDetailPostData, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Guides Detail
         * @description Guide detail (title/order/intro/content/excerpt). Not role-sensitive: no
         * user_id / resolve_student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const guidesDetailFullappApiGuidesDetailPostTotal = qraft.fullappApiService.guidesDetailFullappApiGuidesDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const guidesDetailFullappApiGuidesDetailPostTotal = qraft.fullappApiService.guidesDetailFullappApiGuidesDetailPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostParameters, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, TContext> | MutationFiltersByMutationKey<GuidesDetailFullappApiGuidesDetailPostSchema, GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostParameters, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Guides Detail
         * @description Guide detail (title/order/intro/content/excerpt). Not role-sensitive: no
         * user_id / resolve_student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const guidesDetailFullappApiGuidesDetailPostPendingMutationVariables = qraft.fullappApiService.guidesDetailFullappApiGuidesDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const guidesDetailFullappApiGuidesDetailPostMutationData = qraft.fullappApiService.guidesDetailFullappApiGuidesDetailPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GuidesDetailFullappApiGuidesDetailPostData, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, MutationVariables<GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostParameters, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, TContext> | MutationFiltersByMutationKey<GuidesDetailFullappApiGuidesDetailPostSchema, GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostParameters, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, TContext>;
            select?: (mutation: Mutation<GuidesDetailFullappApiGuidesDetailPostData, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, MutationVariables<GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Guides Detail
         * @description Guide detail (title/order/intro/content/excerpt). Not role-sensitive: no
         * user_id / resolve_student.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostParameters, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, TContext> | MutationFiltersByMutationKey<GuidesDetailFullappApiGuidesDetailPostSchema, GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostParameters, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Guides Detail
         * @description Guide detail (title/order/intro/content/excerpt). Not role-sensitive: no
         * user_id / resolve_student.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.guidesDetailFullappApiGuidesDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.guidesDetailFullappApiGuidesDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostParameters, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, TContext> | MutationFiltersByMutationKey<GuidesDetailFullappApiGuidesDetailPostSchema, GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostParameters, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, TContext>): Mutation<GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostError, MutationVariables<GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostParameters, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, TContext> | MutationFiltersByMutationKey<GuidesDetailFullappApiGuidesDetailPostSchema, GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostParameters, OperationError<GuidesDetailFullappApiGuidesDetailPostError>, TContext>): Array<Mutation<GuidesDetailFullappApiGuidesDetailPostData, GuidesDetailFullappApiGuidesDetailPostError, MutationVariables<GuidesDetailFullappApiGuidesDetailPostBody, GuidesDetailFullappApiGuidesDetailPostParameters>, TContext>>;
        };
        schema: GuidesDetailFullappApiGuidesDetailPostSchema;
        types: {
            parameters: GuidesDetailFullappApiGuidesDetailPostParameters;
            data: GuidesDetailFullappApiGuidesDetailPostData;
            error: GuidesDetailFullappApiGuidesDetailPostError;
            body: GuidesDetailFullappApiGuidesDetailPostBody;
        };
    };
    /** @summary List Certificates */
    listCertificatesFullappApiCertificatesListPost: {
        /** @summary List Certificates */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostParameters, TMeta, TSignal>, client?: (schema: ListCertificatesFullappApiCertificatesListPostSchema, options: ServiceOperationMutationFnOptions<ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostError>>): Promise<RequestFnResponse<ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostError>>;
        /** @summary List Certificates */
        getMutationKey(parameters: DeepReadonly<ListCertificatesFullappApiCertificatesListPostParameters> | void): ServiceOperationMutationKey<ListCertificatesFullappApiCertificatesListPostSchema, ListCertificatesFullappApiCertificatesListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary List Certificates
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listCertificatesFullappApiCertificatesListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listCertificatesFullappApiCertificatesListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ListCertificatesFullappApiCertificatesListPostBody, TContext = unknown>(parameters: DeepReadonly<ListCertificatesFullappApiCertificatesListPostParameters>, options?: ServiceOperationUseMutationOptions<ListCertificatesFullappApiCertificatesListPostSchema, ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostParameters, TVariables, OperationError<ListCertificatesFullappApiCertificatesListPostError>, TContext>): UseMutationResult<ListCertificatesFullappApiCertificatesListPostData, OperationError<ListCertificatesFullappApiCertificatesListPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary List Certificates
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listCertificatesFullappApiCertificatesListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listCertificatesFullappApiCertificatesListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ListCertificatesFullappApiCertificatesListPostSchema, ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostParameters, TVariables, OperationError<ListCertificatesFullappApiCertificatesListPostError>, TContext>): UseMutationResult<ListCertificatesFullappApiCertificatesListPostData, OperationError<ListCertificatesFullappApiCertificatesListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary List Certificates
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const listCertificatesFullappApiCertificatesListPostTotal = qraft.fullappApiService.listCertificatesFullappApiCertificatesListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const listCertificatesFullappApiCertificatesListPostTotal = qraft.fullappApiService.listCertificatesFullappApiCertificatesListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostParameters, OperationError<ListCertificatesFullappApiCertificatesListPostError>, TContext> | MutationFiltersByMutationKey<ListCertificatesFullappApiCertificatesListPostSchema, ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostParameters, OperationError<ListCertificatesFullappApiCertificatesListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary List Certificates
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const listCertificatesFullappApiCertificatesListPostPendingMutationVariables = qraft.fullappApiService.listCertificatesFullappApiCertificatesListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const listCertificatesFullappApiCertificatesListPostMutationData = qraft.fullappApiService.listCertificatesFullappApiCertificatesListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ListCertificatesFullappApiCertificatesListPostData, OperationError<ListCertificatesFullappApiCertificatesListPostError>, MutationVariables<ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostParameters, OperationError<ListCertificatesFullappApiCertificatesListPostError>, TContext> | MutationFiltersByMutationKey<ListCertificatesFullappApiCertificatesListPostSchema, ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostParameters, OperationError<ListCertificatesFullappApiCertificatesListPostError>, TContext>;
            select?: (mutation: Mutation<ListCertificatesFullappApiCertificatesListPostData, OperationError<ListCertificatesFullappApiCertificatesListPostError>, MutationVariables<ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary List Certificates */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostParameters, OperationError<ListCertificatesFullappApiCertificatesListPostError>, TContext> | MutationFiltersByMutationKey<ListCertificatesFullappApiCertificatesListPostSchema, ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostParameters, OperationError<ListCertificatesFullappApiCertificatesListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary List Certificates
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.listCertificatesFullappApiCertificatesListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.listCertificatesFullappApiCertificatesListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostParameters, OperationError<ListCertificatesFullappApiCertificatesListPostError>, TContext> | MutationFiltersByMutationKey<ListCertificatesFullappApiCertificatesListPostSchema, ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostParameters, OperationError<ListCertificatesFullappApiCertificatesListPostError>, TContext>): Mutation<ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostError, MutationVariables<ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostParameters, OperationError<ListCertificatesFullappApiCertificatesListPostError>, TContext> | MutationFiltersByMutationKey<ListCertificatesFullappApiCertificatesListPostSchema, ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostParameters, OperationError<ListCertificatesFullappApiCertificatesListPostError>, TContext>): Array<Mutation<ListCertificatesFullappApiCertificatesListPostData, ListCertificatesFullappApiCertificatesListPostError, MutationVariables<ListCertificatesFullappApiCertificatesListPostBody, ListCertificatesFullappApiCertificatesListPostParameters>, TContext>>;
        };
        schema: ListCertificatesFullappApiCertificatesListPostSchema;
        types: {
            parameters: ListCertificatesFullappApiCertificatesListPostParameters;
            data: ListCertificatesFullappApiCertificatesListPostData;
            error: ListCertificatesFullappApiCertificatesListPostError;
            body: ListCertificatesFullappApiCertificatesListPostBody;
        };
    };
    /** @summary Award Certificate */
    awardCertificateFullappApiCertificatesAwardPost: {
        /** @summary Award Certificate */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostParameters, TMeta, TSignal>, client?: (schema: AwardCertificateFullappApiCertificatesAwardPostSchema, options: ServiceOperationMutationFnOptions<AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostError>>): Promise<RequestFnResponse<AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostError>>;
        /** @summary Award Certificate */
        getMutationKey(parameters: DeepReadonly<AwardCertificateFullappApiCertificatesAwardPostParameters> | void): ServiceOperationMutationKey<AwardCertificateFullappApiCertificatesAwardPostSchema, AwardCertificateFullappApiCertificatesAwardPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Award Certificate
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.awardCertificateFullappApiCertificatesAwardPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.awardCertificateFullappApiCertificatesAwardPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AwardCertificateFullappApiCertificatesAwardPostBody, TContext = unknown>(parameters: DeepReadonly<AwardCertificateFullappApiCertificatesAwardPostParameters>, options?: ServiceOperationUseMutationOptions<AwardCertificateFullappApiCertificatesAwardPostSchema, AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostParameters, TVariables, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, TContext>): UseMutationResult<AwardCertificateFullappApiCertificatesAwardPostData, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Award Certificate
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.awardCertificateFullappApiCertificatesAwardPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.awardCertificateFullappApiCertificatesAwardPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AwardCertificateFullappApiCertificatesAwardPostSchema, AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostParameters, TVariables, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, TContext>): UseMutationResult<AwardCertificateFullappApiCertificatesAwardPostData, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Award Certificate
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const awardCertificateFullappApiCertificatesAwardPostTotal = qraft.fullappApiService.awardCertificateFullappApiCertificatesAwardPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const awardCertificateFullappApiCertificatesAwardPostTotal = qraft.fullappApiService.awardCertificateFullappApiCertificatesAwardPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostParameters, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, TContext> | MutationFiltersByMutationKey<AwardCertificateFullappApiCertificatesAwardPostSchema, AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostParameters, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Award Certificate
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const awardCertificateFullappApiCertificatesAwardPostPendingMutationVariables = qraft.fullappApiService.awardCertificateFullappApiCertificatesAwardPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const awardCertificateFullappApiCertificatesAwardPostMutationData = qraft.fullappApiService.awardCertificateFullappApiCertificatesAwardPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AwardCertificateFullappApiCertificatesAwardPostData, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, MutationVariables<AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostParameters, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, TContext> | MutationFiltersByMutationKey<AwardCertificateFullappApiCertificatesAwardPostSchema, AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostParameters, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, TContext>;
            select?: (mutation: Mutation<AwardCertificateFullappApiCertificatesAwardPostData, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, MutationVariables<AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Award Certificate */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostParameters, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, TContext> | MutationFiltersByMutationKey<AwardCertificateFullappApiCertificatesAwardPostSchema, AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostParameters, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Award Certificate
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.awardCertificateFullappApiCertificatesAwardPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.awardCertificateFullappApiCertificatesAwardPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostParameters, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, TContext> | MutationFiltersByMutationKey<AwardCertificateFullappApiCertificatesAwardPostSchema, AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostParameters, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, TContext>): Mutation<AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostError, MutationVariables<AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostParameters, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, TContext> | MutationFiltersByMutationKey<AwardCertificateFullappApiCertificatesAwardPostSchema, AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostParameters, OperationError<AwardCertificateFullappApiCertificatesAwardPostError>, TContext>): Array<Mutation<AwardCertificateFullappApiCertificatesAwardPostData, AwardCertificateFullappApiCertificatesAwardPostError, MutationVariables<AwardCertificateFullappApiCertificatesAwardPostBody, AwardCertificateFullappApiCertificatesAwardPostParameters>, TContext>>;
        };
        schema: AwardCertificateFullappApiCertificatesAwardPostSchema;
        types: {
            parameters: AwardCertificateFullappApiCertificatesAwardPostParameters;
            data: AwardCertificateFullappApiCertificatesAwardPostData;
            error: AwardCertificateFullappApiCertificatesAwardPostError;
            body: AwardCertificateFullappApiCertificatesAwardPostBody;
        };
    };
    /** @summary Topic Mark Complete */
    topicMarkCompleteFullappApiTopicsMarkCompletePost: {
        /** @summary Topic Mark Complete */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters, TMeta, TSignal>, client?: (schema: TopicMarkCompleteFullappApiTopicsMarkCompletePostSchema, options: ServiceOperationMutationFnOptions<TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostError>>): Promise<RequestFnResponse<TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostError>>;
        /** @summary Topic Mark Complete */
        getMutationKey(parameters: DeepReadonly<TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters> | void): ServiceOperationMutationKey<TopicMarkCompleteFullappApiTopicsMarkCompletePostSchema, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Topic Mark Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.topicMarkCompleteFullappApiTopicsMarkCompletePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.topicMarkCompleteFullappApiTopicsMarkCompletePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TContext = unknown>(parameters: DeepReadonly<TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters>, options?: ServiceOperationUseMutationOptions<TopicMarkCompleteFullappApiTopicsMarkCompletePostSchema, TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters, TVariables, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, TContext>): UseMutationResult<TopicMarkCompleteFullappApiTopicsMarkCompletePostData, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Topic Mark Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.topicMarkCompleteFullappApiTopicsMarkCompletePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.topicMarkCompleteFullappApiTopicsMarkCompletePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<TopicMarkCompleteFullappApiTopicsMarkCompletePostSchema, TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters, TVariables, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, TContext>): UseMutationResult<TopicMarkCompleteFullappApiTopicsMarkCompletePostData, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Topic Mark Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const topicMarkCompleteFullappApiTopicsMarkCompletePostTotal = qraft.fullappApiService.topicMarkCompleteFullappApiTopicsMarkCompletePost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const topicMarkCompleteFullappApiTopicsMarkCompletePostTotal = qraft.fullappApiService.topicMarkCompleteFullappApiTopicsMarkCompletePost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, TContext> | MutationFiltersByMutationKey<TopicMarkCompleteFullappApiTopicsMarkCompletePostSchema, TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Topic Mark Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const topicMarkCompleteFullappApiTopicsMarkCompletePostPendingMutationVariables = qraft.fullappApiService.topicMarkCompleteFullappApiTopicsMarkCompletePost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const topicMarkCompleteFullappApiTopicsMarkCompletePostMutationData = qraft.fullappApiService.topicMarkCompleteFullappApiTopicsMarkCompletePost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<TopicMarkCompleteFullappApiTopicsMarkCompletePostData, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, MutationVariables<TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, TContext> | MutationFiltersByMutationKey<TopicMarkCompleteFullappApiTopicsMarkCompletePostSchema, TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, TContext>;
            select?: (mutation: Mutation<TopicMarkCompleteFullappApiTopicsMarkCompletePostData, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, MutationVariables<TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Topic Mark Complete */
        isMutating<TContext>(filters?: MutationFiltersByParameters<TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, TContext> | MutationFiltersByMutationKey<TopicMarkCompleteFullappApiTopicsMarkCompletePostSchema, TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Topic Mark Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.topicMarkCompleteFullappApiTopicsMarkCompletePost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.topicMarkCompleteFullappApiTopicsMarkCompletePost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, TContext> | MutationFiltersByMutationKey<TopicMarkCompleteFullappApiTopicsMarkCompletePostSchema, TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, TContext>): Mutation<TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostError, MutationVariables<TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, TContext> | MutationFiltersByMutationKey<TopicMarkCompleteFullappApiTopicsMarkCompletePostSchema, TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters, OperationError<TopicMarkCompleteFullappApiTopicsMarkCompletePostError>, TContext>): Array<Mutation<TopicMarkCompleteFullappApiTopicsMarkCompletePostData, TopicMarkCompleteFullappApiTopicsMarkCompletePostError, MutationVariables<TopicMarkCompleteFullappApiTopicsMarkCompletePostBody, TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters>, TContext>>;
        };
        schema: TopicMarkCompleteFullappApiTopicsMarkCompletePostSchema;
        types: {
            parameters: TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters;
            data: TopicMarkCompleteFullappApiTopicsMarkCompletePostData;
            error: TopicMarkCompleteFullappApiTopicsMarkCompletePostError;
            body: TopicMarkCompleteFullappApiTopicsMarkCompletePostBody;
        };
    };
    /** @summary Submit Quiz */
    submitQuizFullappApiQuizzesSubmitPost: {
        /** @summary Submit Quiz */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostParameters, TMeta, TSignal>, client?: (schema: SubmitQuizFullappApiQuizzesSubmitPostSchema, options: ServiceOperationMutationFnOptions<SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostError>>): Promise<RequestFnResponse<SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostError>>;
        /** @summary Submit Quiz */
        getMutationKey(parameters: DeepReadonly<SubmitQuizFullappApiQuizzesSubmitPostParameters> | void): ServiceOperationMutationKey<SubmitQuizFullappApiQuizzesSubmitPostSchema, SubmitQuizFullappApiQuizzesSubmitPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Submit Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.submitQuizFullappApiQuizzesSubmitPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.submitQuizFullappApiQuizzesSubmitPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SubmitQuizFullappApiQuizzesSubmitPostBody, TContext = unknown>(parameters: DeepReadonly<SubmitQuizFullappApiQuizzesSubmitPostParameters>, options?: ServiceOperationUseMutationOptions<SubmitQuizFullappApiQuizzesSubmitPostSchema, SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostParameters, TVariables, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, TContext>): UseMutationResult<SubmitQuizFullappApiQuizzesSubmitPostData, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Submit Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.submitQuizFullappApiQuizzesSubmitPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.submitQuizFullappApiQuizzesSubmitPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SubmitQuizFullappApiQuizzesSubmitPostSchema, SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostParameters, TVariables, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, TContext>): UseMutationResult<SubmitQuizFullappApiQuizzesSubmitPostData, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Submit Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const submitQuizFullappApiQuizzesSubmitPostTotal = qraft.fullappApiService.submitQuizFullappApiQuizzesSubmitPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const submitQuizFullappApiQuizzesSubmitPostTotal = qraft.fullappApiService.submitQuizFullappApiQuizzesSubmitPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostParameters, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, TContext> | MutationFiltersByMutationKey<SubmitQuizFullappApiQuizzesSubmitPostSchema, SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostParameters, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Submit Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const submitQuizFullappApiQuizzesSubmitPostPendingMutationVariables = qraft.fullappApiService.submitQuizFullappApiQuizzesSubmitPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const submitQuizFullappApiQuizzesSubmitPostMutationData = qraft.fullappApiService.submitQuizFullappApiQuizzesSubmitPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SubmitQuizFullappApiQuizzesSubmitPostData, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, MutationVariables<SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostParameters, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, TContext> | MutationFiltersByMutationKey<SubmitQuizFullappApiQuizzesSubmitPostSchema, SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostParameters, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, TContext>;
            select?: (mutation: Mutation<SubmitQuizFullappApiQuizzesSubmitPostData, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, MutationVariables<SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Submit Quiz */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostParameters, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, TContext> | MutationFiltersByMutationKey<SubmitQuizFullappApiQuizzesSubmitPostSchema, SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostParameters, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Submit Quiz
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.submitQuizFullappApiQuizzesSubmitPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.submitQuizFullappApiQuizzesSubmitPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostParameters, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, TContext> | MutationFiltersByMutationKey<SubmitQuizFullappApiQuizzesSubmitPostSchema, SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostParameters, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, TContext>): Mutation<SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostError, MutationVariables<SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostParameters, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, TContext> | MutationFiltersByMutationKey<SubmitQuizFullappApiQuizzesSubmitPostSchema, SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostParameters, OperationError<SubmitQuizFullappApiQuizzesSubmitPostError>, TContext>): Array<Mutation<SubmitQuizFullappApiQuizzesSubmitPostData, SubmitQuizFullappApiQuizzesSubmitPostError, MutationVariables<SubmitQuizFullappApiQuizzesSubmitPostBody, SubmitQuizFullappApiQuizzesSubmitPostParameters>, TContext>>;
        };
        schema: SubmitQuizFullappApiQuizzesSubmitPostSchema;
        types: {
            parameters: SubmitQuizFullappApiQuizzesSubmitPostParameters;
            data: SubmitQuizFullappApiQuizzesSubmitPostData;
            error: SubmitQuizFullappApiQuizzesSubmitPostError;
            body: SubmitQuizFullappApiQuizzesSubmitPostBody;
        };
    };
    /** @summary Course Unlock */
    courseUnlockFullappApiCoursesUnlockPost: {
        /** @summary Course Unlock */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostParameters, TMeta, TSignal>, client?: (schema: CourseUnlockFullappApiCoursesUnlockPostSchema, options: ServiceOperationMutationFnOptions<CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostError>>): Promise<RequestFnResponse<CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostError>>;
        /** @summary Course Unlock */
        getMutationKey(parameters: DeepReadonly<CourseUnlockFullappApiCoursesUnlockPostParameters> | void): ServiceOperationMutationKey<CourseUnlockFullappApiCoursesUnlockPostSchema, CourseUnlockFullappApiCoursesUnlockPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Course Unlock
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.courseUnlockFullappApiCoursesUnlockPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.courseUnlockFullappApiCoursesUnlockPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends CourseUnlockFullappApiCoursesUnlockPostBody, TContext = unknown>(parameters: DeepReadonly<CourseUnlockFullappApiCoursesUnlockPostParameters>, options?: ServiceOperationUseMutationOptions<CourseUnlockFullappApiCoursesUnlockPostSchema, CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostParameters, TVariables, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, TContext>): UseMutationResult<CourseUnlockFullappApiCoursesUnlockPostData, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Course Unlock
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.courseUnlockFullappApiCoursesUnlockPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.courseUnlockFullappApiCoursesUnlockPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<CourseUnlockFullappApiCoursesUnlockPostSchema, CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostParameters, TVariables, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, TContext>): UseMutationResult<CourseUnlockFullappApiCoursesUnlockPostData, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Course Unlock
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const courseUnlockFullappApiCoursesUnlockPostTotal = qraft.fullappApiService.courseUnlockFullappApiCoursesUnlockPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const courseUnlockFullappApiCoursesUnlockPostTotal = qraft.fullappApiService.courseUnlockFullappApiCoursesUnlockPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostParameters, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, TContext> | MutationFiltersByMutationKey<CourseUnlockFullappApiCoursesUnlockPostSchema, CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostParameters, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Course Unlock
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const courseUnlockFullappApiCoursesUnlockPostPendingMutationVariables = qraft.fullappApiService.courseUnlockFullappApiCoursesUnlockPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const courseUnlockFullappApiCoursesUnlockPostMutationData = qraft.fullappApiService.courseUnlockFullappApiCoursesUnlockPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<CourseUnlockFullappApiCoursesUnlockPostData, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, MutationVariables<CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostParameters, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, TContext> | MutationFiltersByMutationKey<CourseUnlockFullappApiCoursesUnlockPostSchema, CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostParameters, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, TContext>;
            select?: (mutation: Mutation<CourseUnlockFullappApiCoursesUnlockPostData, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, MutationVariables<CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Course Unlock */
        isMutating<TContext>(filters?: MutationFiltersByParameters<CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostParameters, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, TContext> | MutationFiltersByMutationKey<CourseUnlockFullappApiCoursesUnlockPostSchema, CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostParameters, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Course Unlock
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.courseUnlockFullappApiCoursesUnlockPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.courseUnlockFullappApiCoursesUnlockPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostParameters, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, TContext> | MutationFiltersByMutationKey<CourseUnlockFullappApiCoursesUnlockPostSchema, CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostParameters, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, TContext>): Mutation<CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostError, MutationVariables<CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostParameters, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, TContext> | MutationFiltersByMutationKey<CourseUnlockFullappApiCoursesUnlockPostSchema, CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostParameters, OperationError<CourseUnlockFullappApiCoursesUnlockPostError>, TContext>): Array<Mutation<CourseUnlockFullappApiCoursesUnlockPostData, CourseUnlockFullappApiCoursesUnlockPostError, MutationVariables<CourseUnlockFullappApiCoursesUnlockPostBody, CourseUnlockFullappApiCoursesUnlockPostParameters>, TContext>>;
        };
        schema: CourseUnlockFullappApiCoursesUnlockPostSchema;
        types: {
            parameters: CourseUnlockFullappApiCoursesUnlockPostParameters;
            data: CourseUnlockFullappApiCoursesUnlockPostData;
            error: CourseUnlockFullappApiCoursesUnlockPostError;
            body: CourseUnlockFullappApiCoursesUnlockPostBody;
        };
    };
    /**
     * @summary List Bibles
     * @description Get all Bible testaments with their books and chapter counts.
     */
    listBiblesFullappApiBiblesListPost: {
        /**
         * @summary List Bibles
         * @description Get all Bible testaments with their books and chapter counts.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostParameters, TMeta, TSignal>, client?: (schema: ListBiblesFullappApiBiblesListPostSchema, options: ServiceOperationMutationFnOptions<ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostError>>): Promise<RequestFnResponse<ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostError>>;
        /**
         * @summary List Bibles
         * @description Get all Bible testaments with their books and chapter counts.
         */
        getMutationKey(parameters: DeepReadonly<ListBiblesFullappApiBiblesListPostParameters> | void): ServiceOperationMutationKey<ListBiblesFullappApiBiblesListPostSchema, ListBiblesFullappApiBiblesListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary List Bibles
         * @description Get all Bible testaments with their books and chapter counts.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listBiblesFullappApiBiblesListPost.useMutation({
         *     query: {
         *         language: language
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listBiblesFullappApiBiblesListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     query: {
         *         language: language
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ListBiblesFullappApiBiblesListPostBody, TContext = unknown>(parameters: DeepReadonly<ListBiblesFullappApiBiblesListPostParameters>, options?: ServiceOperationUseMutationOptions<ListBiblesFullappApiBiblesListPostSchema, ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostParameters, TVariables, OperationError<ListBiblesFullappApiBiblesListPostError>, TContext>): UseMutationResult<ListBiblesFullappApiBiblesListPostData, OperationError<ListBiblesFullappApiBiblesListPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary List Bibles
         * @description Get all Bible testaments with their books and chapter counts.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listBiblesFullappApiBiblesListPost.useMutation({
         *     query: {
         *         language: language
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listBiblesFullappApiBiblesListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     query: {
         *         language: language
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ListBiblesFullappApiBiblesListPostSchema, ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostParameters, TVariables, OperationError<ListBiblesFullappApiBiblesListPostError>, TContext>): UseMutationResult<ListBiblesFullappApiBiblesListPostData, OperationError<ListBiblesFullappApiBiblesListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary List Bibles
         * @description Get all Bible testaments with their books and chapter counts.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const listBiblesFullappApiBiblesListPostTotal = qraft.fullappApiService.listBiblesFullappApiBiblesListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const listBiblesFullappApiBiblesListPostTotal = qraft.fullappApiService.listBiblesFullappApiBiblesListPost.useIsMutating({
         *     parameters: {
         *         query: {
         *             language: language
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostParameters, OperationError<ListBiblesFullappApiBiblesListPostError>, TContext> | MutationFiltersByMutationKey<ListBiblesFullappApiBiblesListPostSchema, ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostParameters, OperationError<ListBiblesFullappApiBiblesListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary List Bibles
         * @description Get all Bible testaments with their books and chapter counts.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const listBiblesFullappApiBiblesListPostPendingMutationVariables = qraft.fullappApiService.listBiblesFullappApiBiblesListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const listBiblesFullappApiBiblesListPostMutationData = qraft.fullappApiService.listBiblesFullappApiBiblesListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             query: {
         *                 language: language
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ListBiblesFullappApiBiblesListPostData, OperationError<ListBiblesFullappApiBiblesListPostError>, MutationVariables<ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostParameters, OperationError<ListBiblesFullappApiBiblesListPostError>, TContext> | MutationFiltersByMutationKey<ListBiblesFullappApiBiblesListPostSchema, ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostParameters, OperationError<ListBiblesFullappApiBiblesListPostError>, TContext>;
            select?: (mutation: Mutation<ListBiblesFullappApiBiblesListPostData, OperationError<ListBiblesFullappApiBiblesListPostError>, MutationVariables<ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary List Bibles
         * @description Get all Bible testaments with their books and chapter counts.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostParameters, OperationError<ListBiblesFullappApiBiblesListPostError>, TContext> | MutationFiltersByMutationKey<ListBiblesFullappApiBiblesListPostSchema, ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostParameters, OperationError<ListBiblesFullappApiBiblesListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary List Bibles
         * @description Get all Bible testaments with their books and chapter counts.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.listBiblesFullappApiBiblesListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         query: {
         *             language: language
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.listBiblesFullappApiBiblesListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostParameters, OperationError<ListBiblesFullappApiBiblesListPostError>, TContext> | MutationFiltersByMutationKey<ListBiblesFullappApiBiblesListPostSchema, ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostParameters, OperationError<ListBiblesFullappApiBiblesListPostError>, TContext>): Mutation<ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostError, MutationVariables<ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostParameters, OperationError<ListBiblesFullappApiBiblesListPostError>, TContext> | MutationFiltersByMutationKey<ListBiblesFullappApiBiblesListPostSchema, ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostParameters, OperationError<ListBiblesFullappApiBiblesListPostError>, TContext>): Array<Mutation<ListBiblesFullappApiBiblesListPostData, ListBiblesFullappApiBiblesListPostError, MutationVariables<ListBiblesFullappApiBiblesListPostBody, ListBiblesFullappApiBiblesListPostParameters>, TContext>>;
        };
        schema: ListBiblesFullappApiBiblesListPostSchema;
        types: {
            parameters: ListBiblesFullappApiBiblesListPostParameters;
            data: ListBiblesFullappApiBiblesListPostData;
            error: ListBiblesFullappApiBiblesListPostError;
            body: ListBiblesFullappApiBiblesListPostBody;
        };
    };
    /**
     * @summary Get Chapters
     * @description Get a book with all its chapters.
     */
    getChaptersFullappApiBiblesChaptersPost: {
        /**
         * @summary Get Chapters
         * @description Get a book with all its chapters.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostParameters, TMeta, TSignal>, client?: (schema: GetChaptersFullappApiBiblesChaptersPostSchema, options: ServiceOperationMutationFnOptions<GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostError>>): Promise<RequestFnResponse<GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostError>>;
        /**
         * @summary Get Chapters
         * @description Get a book with all its chapters.
         */
        getMutationKey(parameters: DeepReadonly<GetChaptersFullappApiBiblesChaptersPostParameters> | void): ServiceOperationMutationKey<GetChaptersFullappApiBiblesChaptersPostSchema, GetChaptersFullappApiBiblesChaptersPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Chapters
         * @description Get a book with all its chapters.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getChaptersFullappApiBiblesChaptersPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getChaptersFullappApiBiblesChaptersPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends GetChaptersFullappApiBiblesChaptersPostBody, TContext = unknown>(parameters: DeepReadonly<GetChaptersFullappApiBiblesChaptersPostParameters>, options?: ServiceOperationUseMutationOptions<GetChaptersFullappApiBiblesChaptersPostSchema, GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostParameters, TVariables, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, TContext>): UseMutationResult<GetChaptersFullappApiBiblesChaptersPostData, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Chapters
         * @description Get a book with all its chapters.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getChaptersFullappApiBiblesChaptersPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getChaptersFullappApiBiblesChaptersPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GetChaptersFullappApiBiblesChaptersPostSchema, GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostParameters, TVariables, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, TContext>): UseMutationResult<GetChaptersFullappApiBiblesChaptersPostData, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Get Chapters
         * @description Get a book with all its chapters.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const getChaptersFullappApiBiblesChaptersPostTotal = qraft.fullappApiService.getChaptersFullappApiBiblesChaptersPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const getChaptersFullappApiBiblesChaptersPostTotal = qraft.fullappApiService.getChaptersFullappApiBiblesChaptersPost.useIsMutating({
         *     parameters: {}
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostParameters, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, TContext> | MutationFiltersByMutationKey<GetChaptersFullappApiBiblesChaptersPostSchema, GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostParameters, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Get Chapters
         * @description Get a book with all its chapters.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const getChaptersFullappApiBiblesChaptersPostPendingMutationVariables = qraft.fullappApiService.getChaptersFullappApiBiblesChaptersPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const getChaptersFullappApiBiblesChaptersPostMutationData = qraft.fullappApiService.getChaptersFullappApiBiblesChaptersPost.useMutationState({
         *     filters: {
         *         parameters: {}
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GetChaptersFullappApiBiblesChaptersPostData, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, MutationVariables<GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostParameters, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, TContext> | MutationFiltersByMutationKey<GetChaptersFullappApiBiblesChaptersPostSchema, GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostParameters, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, TContext>;
            select?: (mutation: Mutation<GetChaptersFullappApiBiblesChaptersPostData, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, MutationVariables<GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Get Chapters
         * @description Get a book with all its chapters.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostParameters, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, TContext> | MutationFiltersByMutationKey<GetChaptersFullappApiBiblesChaptersPostSchema, GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostParameters, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Get Chapters
         * @description Get a book with all its chapters.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.getChaptersFullappApiBiblesChaptersPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {}
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.getChaptersFullappApiBiblesChaptersPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostParameters, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, TContext> | MutationFiltersByMutationKey<GetChaptersFullappApiBiblesChaptersPostSchema, GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostParameters, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, TContext>): Mutation<GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostError, MutationVariables<GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostParameters, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, TContext> | MutationFiltersByMutationKey<GetChaptersFullappApiBiblesChaptersPostSchema, GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostParameters, OperationError<GetChaptersFullappApiBiblesChaptersPostError>, TContext>): Array<Mutation<GetChaptersFullappApiBiblesChaptersPostData, GetChaptersFullappApiBiblesChaptersPostError, MutationVariables<GetChaptersFullappApiBiblesChaptersPostBody, GetChaptersFullappApiBiblesChaptersPostParameters>, TContext>>;
        };
        schema: GetChaptersFullappApiBiblesChaptersPostSchema;
        types: {
            parameters: GetChaptersFullappApiBiblesChaptersPostParameters;
            data: GetChaptersFullappApiBiblesChaptersPostData;
            error: GetChaptersFullappApiBiblesChaptersPostError;
            body: GetChaptersFullappApiBiblesChaptersPostBody;
        };
    };
    /**
     * @summary Get Chapter Detail
     * @description Get detailed chapter content with verses.
     */
    getChapterDetailFullappApiChaptersDetailPost: {
        /**
         * @summary Get Chapter Detail
         * @description Get detailed chapter content with verses.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostParameters, TMeta, TSignal>, client?: (schema: GetChapterDetailFullappApiChaptersDetailPostSchema, options: ServiceOperationMutationFnOptions<GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostError>>): Promise<RequestFnResponse<GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostError>>;
        /**
         * @summary Get Chapter Detail
         * @description Get detailed chapter content with verses.
         */
        getMutationKey(parameters: DeepReadonly<GetChapterDetailFullappApiChaptersDetailPostParameters> | void): ServiceOperationMutationKey<GetChapterDetailFullappApiChaptersDetailPostSchema, GetChapterDetailFullappApiChaptersDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Chapter Detail
         * @description Get detailed chapter content with verses.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getChapterDetailFullappApiChaptersDetailPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getChapterDetailFullappApiChaptersDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends GetChapterDetailFullappApiChaptersDetailPostBody, TContext = unknown>(parameters: DeepReadonly<GetChapterDetailFullappApiChaptersDetailPostParameters>, options?: ServiceOperationUseMutationOptions<GetChapterDetailFullappApiChaptersDetailPostSchema, GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostParameters, TVariables, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, TContext>): UseMutationResult<GetChapterDetailFullappApiChaptersDetailPostData, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Chapter Detail
         * @description Get detailed chapter content with verses.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getChapterDetailFullappApiChaptersDetailPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getChapterDetailFullappApiChaptersDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GetChapterDetailFullappApiChaptersDetailPostSchema, GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostParameters, TVariables, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, TContext>): UseMutationResult<GetChapterDetailFullappApiChaptersDetailPostData, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Get Chapter Detail
         * @description Get detailed chapter content with verses.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const getChapterDetailFullappApiChaptersDetailPostTotal = qraft.fullappApiService.getChapterDetailFullappApiChaptersDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const getChapterDetailFullappApiChaptersDetailPostTotal = qraft.fullappApiService.getChapterDetailFullappApiChaptersDetailPost.useIsMutating({
         *     parameters: {}
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostParameters, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, TContext> | MutationFiltersByMutationKey<GetChapterDetailFullappApiChaptersDetailPostSchema, GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostParameters, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Get Chapter Detail
         * @description Get detailed chapter content with verses.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const getChapterDetailFullappApiChaptersDetailPostPendingMutationVariables = qraft.fullappApiService.getChapterDetailFullappApiChaptersDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const getChapterDetailFullappApiChaptersDetailPostMutationData = qraft.fullappApiService.getChapterDetailFullappApiChaptersDetailPost.useMutationState({
         *     filters: {
         *         parameters: {}
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GetChapterDetailFullappApiChaptersDetailPostData, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, MutationVariables<GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostParameters, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, TContext> | MutationFiltersByMutationKey<GetChapterDetailFullappApiChaptersDetailPostSchema, GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostParameters, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, TContext>;
            select?: (mutation: Mutation<GetChapterDetailFullappApiChaptersDetailPostData, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, MutationVariables<GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Get Chapter Detail
         * @description Get detailed chapter content with verses.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostParameters, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, TContext> | MutationFiltersByMutationKey<GetChapterDetailFullappApiChaptersDetailPostSchema, GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostParameters, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Get Chapter Detail
         * @description Get detailed chapter content with verses.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.getChapterDetailFullappApiChaptersDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {}
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.getChapterDetailFullappApiChaptersDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostParameters, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, TContext> | MutationFiltersByMutationKey<GetChapterDetailFullappApiChaptersDetailPostSchema, GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostParameters, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, TContext>): Mutation<GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostError, MutationVariables<GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostParameters, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, TContext> | MutationFiltersByMutationKey<GetChapterDetailFullappApiChaptersDetailPostSchema, GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostParameters, OperationError<GetChapterDetailFullappApiChaptersDetailPostError>, TContext>): Array<Mutation<GetChapterDetailFullappApiChaptersDetailPostData, GetChapterDetailFullappApiChaptersDetailPostError, MutationVariables<GetChapterDetailFullappApiChaptersDetailPostBody, GetChapterDetailFullappApiChaptersDetailPostParameters>, TContext>>;
        };
        schema: GetChapterDetailFullappApiChaptersDetailPostSchema;
        types: {
            parameters: GetChapterDetailFullappApiChaptersDetailPostParameters;
            data: GetChapterDetailFullappApiChaptersDetailPostData;
            error: GetChapterDetailFullappApiChaptersDetailPostError;
            body: GetChapterDetailFullappApiChaptersDetailPostBody;
        };
    };
    /** @summary Register */
    registerFullappApiPushNotificationsRegisterPost: {
        /** @summary Register */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostParameters, TMeta, TSignal>, client?: (schema: RegisterFullappApiPushNotificationsRegisterPostSchema, options: ServiceOperationMutationFnOptions<RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostError>>): Promise<RequestFnResponse<RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostError>>;
        /** @summary Register */
        getMutationKey(parameters: DeepReadonly<RegisterFullappApiPushNotificationsRegisterPostParameters> | void): ServiceOperationMutationKey<RegisterFullappApiPushNotificationsRegisterPostSchema, RegisterFullappApiPushNotificationsRegisterPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Register
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.registerFullappApiPushNotificationsRegisterPost.useMutation({
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.registerFullappApiPushNotificationsRegisterPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends RegisterFullappApiPushNotificationsRegisterPostBody, TContext = unknown>(parameters: DeepReadonly<RegisterFullappApiPushNotificationsRegisterPostParameters>, options?: ServiceOperationUseMutationOptions<RegisterFullappApiPushNotificationsRegisterPostSchema, RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostParameters, TVariables, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, TContext>): UseMutationResult<RegisterFullappApiPushNotificationsRegisterPostData, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Register
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.registerFullappApiPushNotificationsRegisterPost.useMutation({
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.registerFullappApiPushNotificationsRegisterPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<RegisterFullappApiPushNotificationsRegisterPostSchema, RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostParameters, TVariables, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, TContext>): UseMutationResult<RegisterFullappApiPushNotificationsRegisterPostData, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Register
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const registerFullappApiPushNotificationsRegisterPostTotal = qraft.fullappApiService.registerFullappApiPushNotificationsRegisterPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const registerFullappApiPushNotificationsRegisterPostTotal = qraft.fullappApiService.registerFullappApiPushNotificationsRegisterPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-device-token": xWbsDeviceToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostParameters, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterFullappApiPushNotificationsRegisterPostSchema, RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostParameters, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Register
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const registerFullappApiPushNotificationsRegisterPostPendingMutationVariables = qraft.fullappApiService.registerFullappApiPushNotificationsRegisterPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const registerFullappApiPushNotificationsRegisterPostMutationData = qraft.fullappApiService.registerFullappApiPushNotificationsRegisterPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-device-token": xWbsDeviceToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<RegisterFullappApiPushNotificationsRegisterPostData, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, MutationVariables<RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostParameters, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterFullappApiPushNotificationsRegisterPostSchema, RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostParameters, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, TContext>;
            select?: (mutation: Mutation<RegisterFullappApiPushNotificationsRegisterPostData, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, MutationVariables<RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Register */
        isMutating<TContext>(filters?: MutationFiltersByParameters<RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostParameters, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterFullappApiPushNotificationsRegisterPostSchema, RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostParameters, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Register
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.registerFullappApiPushNotificationsRegisterPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-device-token": xWbsDeviceToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.registerFullappApiPushNotificationsRegisterPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostParameters, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterFullappApiPushNotificationsRegisterPostSchema, RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostParameters, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, TContext>): Mutation<RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostError, MutationVariables<RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostParameters, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterFullappApiPushNotificationsRegisterPostSchema, RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostParameters, OperationError<RegisterFullappApiPushNotificationsRegisterPostError>, TContext>): Array<Mutation<RegisterFullappApiPushNotificationsRegisterPostData, RegisterFullappApiPushNotificationsRegisterPostError, MutationVariables<RegisterFullappApiPushNotificationsRegisterPostBody, RegisterFullappApiPushNotificationsRegisterPostParameters>, TContext>>;
        };
        schema: RegisterFullappApiPushNotificationsRegisterPostSchema;
        types: {
            parameters: RegisterFullappApiPushNotificationsRegisterPostParameters;
            data: RegisterFullappApiPushNotificationsRegisterPostData;
            error: RegisterFullappApiPushNotificationsRegisterPostError;
            body: RegisterFullappApiPushNotificationsRegisterPostBody;
        };
    };
    /**
     * @summary Status
     * @description Read the current (device, user) push-notification status.
     *
     * Returns ``token`` plus ``enabled = !notification_disabled``. A missing row
     * yields ``enabled=false``/``token=null`` (the app only reads ``enabled``).
     */
    statusFullappApiPushNotificationsStatusPost: {
        /**
         * @summary Status
         * @description Read the current (device, user) push-notification status.
         *
         * Returns ``token`` plus ``enabled = !notification_disabled``. A missing row
         * yields ``enabled=false``/``token=null`` (the app only reads ``enabled``).
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostParameters, TMeta, TSignal>, client?: (schema: StatusFullappApiPushNotificationsStatusPostSchema, options: ServiceOperationMutationFnOptions<StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostError>>): Promise<RequestFnResponse<StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostError>>;
        /**
         * @summary Status
         * @description Read the current (device, user) push-notification status.
         *
         * Returns ``token`` plus ``enabled = !notification_disabled``. A missing row
         * yields ``enabled=false``/``token=null`` (the app only reads ``enabled``).
         */
        getMutationKey(parameters: DeepReadonly<StatusFullappApiPushNotificationsStatusPostParameters> | void): ServiceOperationMutationKey<StatusFullappApiPushNotificationsStatusPostSchema, StatusFullappApiPushNotificationsStatusPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Status
         * @description Read the current (device, user) push-notification status.
         *
         * Returns ``token`` plus ``enabled = !notification_disabled``. A missing row
         * yields ``enabled=false``/``token=null`` (the app only reads ``enabled``).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.statusFullappApiPushNotificationsStatusPost.useMutation({
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.statusFullappApiPushNotificationsStatusPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends StatusFullappApiPushNotificationsStatusPostBody, TContext = unknown>(parameters: DeepReadonly<StatusFullappApiPushNotificationsStatusPostParameters>, options?: ServiceOperationUseMutationOptions<StatusFullappApiPushNotificationsStatusPostSchema, StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostParameters, TVariables, OperationError<StatusFullappApiPushNotificationsStatusPostError>, TContext>): UseMutationResult<StatusFullappApiPushNotificationsStatusPostData, OperationError<StatusFullappApiPushNotificationsStatusPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Status
         * @description Read the current (device, user) push-notification status.
         *
         * Returns ``token`` plus ``enabled = !notification_disabled``. A missing row
         * yields ``enabled=false``/``token=null`` (the app only reads ``enabled``).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.statusFullappApiPushNotificationsStatusPost.useMutation({
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.statusFullappApiPushNotificationsStatusPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<StatusFullappApiPushNotificationsStatusPostSchema, StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostParameters, TVariables, OperationError<StatusFullappApiPushNotificationsStatusPostError>, TContext>): UseMutationResult<StatusFullappApiPushNotificationsStatusPostData, OperationError<StatusFullappApiPushNotificationsStatusPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Status
         * @description Read the current (device, user) push-notification status.
         *
         * Returns ``token`` plus ``enabled = !notification_disabled``. A missing row
         * yields ``enabled=false``/``token=null`` (the app only reads ``enabled``).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const statusFullappApiPushNotificationsStatusPostTotal = qraft.fullappApiService.statusFullappApiPushNotificationsStatusPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const statusFullappApiPushNotificationsStatusPostTotal = qraft.fullappApiService.statusFullappApiPushNotificationsStatusPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-device-token": xWbsDeviceToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostParameters, OperationError<StatusFullappApiPushNotificationsStatusPostError>, TContext> | MutationFiltersByMutationKey<StatusFullappApiPushNotificationsStatusPostSchema, StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostParameters, OperationError<StatusFullappApiPushNotificationsStatusPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Status
         * @description Read the current (device, user) push-notification status.
         *
         * Returns ``token`` plus ``enabled = !notification_disabled``. A missing row
         * yields ``enabled=false``/``token=null`` (the app only reads ``enabled``).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const statusFullappApiPushNotificationsStatusPostPendingMutationVariables = qraft.fullappApiService.statusFullappApiPushNotificationsStatusPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const statusFullappApiPushNotificationsStatusPostMutationData = qraft.fullappApiService.statusFullappApiPushNotificationsStatusPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-device-token": xWbsDeviceToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<StatusFullappApiPushNotificationsStatusPostData, OperationError<StatusFullappApiPushNotificationsStatusPostError>, MutationVariables<StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostParameters, OperationError<StatusFullappApiPushNotificationsStatusPostError>, TContext> | MutationFiltersByMutationKey<StatusFullappApiPushNotificationsStatusPostSchema, StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostParameters, OperationError<StatusFullappApiPushNotificationsStatusPostError>, TContext>;
            select?: (mutation: Mutation<StatusFullappApiPushNotificationsStatusPostData, OperationError<StatusFullappApiPushNotificationsStatusPostError>, MutationVariables<StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Status
         * @description Read the current (device, user) push-notification status.
         *
         * Returns ``token`` plus ``enabled = !notification_disabled``. A missing row
         * yields ``enabled=false``/``token=null`` (the app only reads ``enabled``).
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostParameters, OperationError<StatusFullappApiPushNotificationsStatusPostError>, TContext> | MutationFiltersByMutationKey<StatusFullappApiPushNotificationsStatusPostSchema, StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostParameters, OperationError<StatusFullappApiPushNotificationsStatusPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Status
         * @description Read the current (device, user) push-notification status.
         *
         * Returns ``token`` plus ``enabled = !notification_disabled``. A missing row
         * yields ``enabled=false``/``token=null`` (the app only reads ``enabled``).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.statusFullappApiPushNotificationsStatusPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-device-token": xWbsDeviceToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.statusFullappApiPushNotificationsStatusPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostParameters, OperationError<StatusFullappApiPushNotificationsStatusPostError>, TContext> | MutationFiltersByMutationKey<StatusFullappApiPushNotificationsStatusPostSchema, StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostParameters, OperationError<StatusFullappApiPushNotificationsStatusPostError>, TContext>): Mutation<StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostError, MutationVariables<StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostParameters, OperationError<StatusFullappApiPushNotificationsStatusPostError>, TContext> | MutationFiltersByMutationKey<StatusFullappApiPushNotificationsStatusPostSchema, StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostParameters, OperationError<StatusFullappApiPushNotificationsStatusPostError>, TContext>): Array<Mutation<StatusFullappApiPushNotificationsStatusPostData, StatusFullappApiPushNotificationsStatusPostError, MutationVariables<StatusFullappApiPushNotificationsStatusPostBody, StatusFullappApiPushNotificationsStatusPostParameters>, TContext>>;
        };
        schema: StatusFullappApiPushNotificationsStatusPostSchema;
        types: {
            parameters: StatusFullappApiPushNotificationsStatusPostParameters;
            data: StatusFullappApiPushNotificationsStatusPostData;
            error: StatusFullappApiPushNotificationsStatusPostError;
            body: StatusFullappApiPushNotificationsStatusPostBody;
        };
    };
    /** @summary Deregister */
    deregisterFullappApiPushNotificationsDeregisterPost: {
        /** @summary Deregister */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostParameters, TMeta, TSignal>, client?: (schema: DeregisterFullappApiPushNotificationsDeregisterPostSchema, options: ServiceOperationMutationFnOptions<DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostError>>): Promise<RequestFnResponse<DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostError>>;
        /** @summary Deregister */
        getMutationKey(parameters: DeepReadonly<DeregisterFullappApiPushNotificationsDeregisterPostParameters> | void): ServiceOperationMutationKey<DeregisterFullappApiPushNotificationsDeregisterPostSchema, DeregisterFullappApiPushNotificationsDeregisterPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Deregister
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deregisterFullappApiPushNotificationsDeregisterPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deregisterFullappApiPushNotificationsDeregisterPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends DeregisterFullappApiPushNotificationsDeregisterPostBody, TContext = unknown>(parameters: DeepReadonly<DeregisterFullappApiPushNotificationsDeregisterPostParameters>, options?: ServiceOperationUseMutationOptions<DeregisterFullappApiPushNotificationsDeregisterPostSchema, DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostParameters, TVariables, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, TContext>): UseMutationResult<DeregisterFullappApiPushNotificationsDeregisterPostData, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Deregister
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deregisterFullappApiPushNotificationsDeregisterPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deregisterFullappApiPushNotificationsDeregisterPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeregisterFullappApiPushNotificationsDeregisterPostSchema, DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostParameters, TVariables, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, TContext>): UseMutationResult<DeregisterFullappApiPushNotificationsDeregisterPostData, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Deregister
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const deregisterFullappApiPushNotificationsDeregisterPostTotal = qraft.fullappApiService.deregisterFullappApiPushNotificationsDeregisterPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const deregisterFullappApiPushNotificationsDeregisterPostTotal = qraft.fullappApiService.deregisterFullappApiPushNotificationsDeregisterPost.useIsMutating({
         *     parameters: {}
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostParameters, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, TContext> | MutationFiltersByMutationKey<DeregisterFullappApiPushNotificationsDeregisterPostSchema, DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostParameters, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Deregister
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const deregisterFullappApiPushNotificationsDeregisterPostPendingMutationVariables = qraft.fullappApiService.deregisterFullappApiPushNotificationsDeregisterPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const deregisterFullappApiPushNotificationsDeregisterPostMutationData = qraft.fullappApiService.deregisterFullappApiPushNotificationsDeregisterPost.useMutationState({
         *     filters: {
         *         parameters: {}
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeregisterFullappApiPushNotificationsDeregisterPostData, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, MutationVariables<DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostParameters, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, TContext> | MutationFiltersByMutationKey<DeregisterFullappApiPushNotificationsDeregisterPostSchema, DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostParameters, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, TContext>;
            select?: (mutation: Mutation<DeregisterFullappApiPushNotificationsDeregisterPostData, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, MutationVariables<DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Deregister */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostParameters, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, TContext> | MutationFiltersByMutationKey<DeregisterFullappApiPushNotificationsDeregisterPostSchema, DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostParameters, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Deregister
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.deregisterFullappApiPushNotificationsDeregisterPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {}
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.deregisterFullappApiPushNotificationsDeregisterPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostParameters, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, TContext> | MutationFiltersByMutationKey<DeregisterFullappApiPushNotificationsDeregisterPostSchema, DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostParameters, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, TContext>): Mutation<DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostError, MutationVariables<DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostParameters, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, TContext> | MutationFiltersByMutationKey<DeregisterFullappApiPushNotificationsDeregisterPostSchema, DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostParameters, OperationError<DeregisterFullappApiPushNotificationsDeregisterPostError>, TContext>): Array<Mutation<DeregisterFullappApiPushNotificationsDeregisterPostData, DeregisterFullappApiPushNotificationsDeregisterPostError, MutationVariables<DeregisterFullappApiPushNotificationsDeregisterPostBody, DeregisterFullappApiPushNotificationsDeregisterPostParameters>, TContext>>;
        };
        schema: DeregisterFullappApiPushNotificationsDeregisterPostSchema;
        types: {
            parameters: DeregisterFullappApiPushNotificationsDeregisterPostParameters;
            data: DeregisterFullappApiPushNotificationsDeregisterPostData;
            error: DeregisterFullappApiPushNotificationsDeregisterPostError;
            body: DeregisterFullappApiPushNotificationsDeregisterPostBody;
        };
    };
    /**
     * @summary Fetch
     * @description Fetch the auth user's notifications.
     *
     * Returns a flat JSON array (the app flattens ``r.data``), filtered by ``is_new``
     * (1=unread, 0=read) and paginated by ``per_page``/``page``, newest first. Always
     * the auth user's own rows; there is no ``user_id`` param.
     */
    fetchFullappApiNotificationsFetchPost: {
        /**
         * @summary Fetch
         * @description Fetch the auth user's notifications.
         *
         * Returns a flat JSON array (the app flattens ``r.data``), filtered by ``is_new``
         * (1=unread, 0=read) and paginated by ``per_page``/``page``, newest first. Always
         * the auth user's own rows; there is no ``user_id`` param.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostParameters, TMeta, TSignal>, client?: (schema: FetchFullappApiNotificationsFetchPostSchema, options: ServiceOperationMutationFnOptions<FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostError>>): Promise<RequestFnResponse<FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostError>>;
        /**
         * @summary Fetch
         * @description Fetch the auth user's notifications.
         *
         * Returns a flat JSON array (the app flattens ``r.data``), filtered by ``is_new``
         * (1=unread, 0=read) and paginated by ``per_page``/``page``, newest first. Always
         * the auth user's own rows; there is no ``user_id`` param.
         */
        getMutationKey(parameters: DeepReadonly<FetchFullappApiNotificationsFetchPostParameters> | void): ServiceOperationMutationKey<FetchFullappApiNotificationsFetchPostSchema, FetchFullappApiNotificationsFetchPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fetch
         * @description Fetch the auth user's notifications.
         *
         * Returns a flat JSON array (the app flattens ``r.data``), filtered by ``is_new``
         * (1=unread, 0=read) and paginated by ``per_page``/``page``, newest first. Always
         * the auth user's own rows; there is no ``user_id`` param.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchFullappApiNotificationsFetchPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchFullappApiNotificationsFetchPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends FetchFullappApiNotificationsFetchPostBody, TContext = unknown>(parameters: DeepReadonly<FetchFullappApiNotificationsFetchPostParameters>, options?: ServiceOperationUseMutationOptions<FetchFullappApiNotificationsFetchPostSchema, FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostParameters, TVariables, OperationError<FetchFullappApiNotificationsFetchPostError>, TContext>): UseMutationResult<FetchFullappApiNotificationsFetchPostData, OperationError<FetchFullappApiNotificationsFetchPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fetch
         * @description Fetch the auth user's notifications.
         *
         * Returns a flat JSON array (the app flattens ``r.data``), filtered by ``is_new``
         * (1=unread, 0=read) and paginated by ``per_page``/``page``, newest first. Always
         * the auth user's own rows; there is no ``user_id`` param.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchFullappApiNotificationsFetchPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchFullappApiNotificationsFetchPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<FetchFullappApiNotificationsFetchPostSchema, FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostParameters, TVariables, OperationError<FetchFullappApiNotificationsFetchPostError>, TContext>): UseMutationResult<FetchFullappApiNotificationsFetchPostData, OperationError<FetchFullappApiNotificationsFetchPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Fetch
         * @description Fetch the auth user's notifications.
         *
         * Returns a flat JSON array (the app flattens ``r.data``), filtered by ``is_new``
         * (1=unread, 0=read) and paginated by ``per_page``/``page``, newest first. Always
         * the auth user's own rows; there is no ``user_id`` param.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const fetchFullappApiNotificationsFetchPostTotal = qraft.fullappApiService.fetchFullappApiNotificationsFetchPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const fetchFullappApiNotificationsFetchPostTotal = qraft.fullappApiService.fetchFullappApiNotificationsFetchPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostParameters, OperationError<FetchFullappApiNotificationsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiNotificationsFetchPostSchema, FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostParameters, OperationError<FetchFullappApiNotificationsFetchPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Fetch
         * @description Fetch the auth user's notifications.
         *
         * Returns a flat JSON array (the app flattens ``r.data``), filtered by ``is_new``
         * (1=unread, 0=read) and paginated by ``per_page``/``page``, newest first. Always
         * the auth user's own rows; there is no ``user_id`` param.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const fetchFullappApiNotificationsFetchPostPendingMutationVariables = qraft.fullappApiService.fetchFullappApiNotificationsFetchPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const fetchFullappApiNotificationsFetchPostMutationData = qraft.fullappApiService.fetchFullappApiNotificationsFetchPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<FetchFullappApiNotificationsFetchPostData, OperationError<FetchFullappApiNotificationsFetchPostError>, MutationVariables<FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostParameters, OperationError<FetchFullappApiNotificationsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiNotificationsFetchPostSchema, FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostParameters, OperationError<FetchFullappApiNotificationsFetchPostError>, TContext>;
            select?: (mutation: Mutation<FetchFullappApiNotificationsFetchPostData, OperationError<FetchFullappApiNotificationsFetchPostError>, MutationVariables<FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Fetch
         * @description Fetch the auth user's notifications.
         *
         * Returns a flat JSON array (the app flattens ``r.data``), filtered by ``is_new``
         * (1=unread, 0=read) and paginated by ``per_page``/``page``, newest first. Always
         * the auth user's own rows; there is no ``user_id`` param.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostParameters, OperationError<FetchFullappApiNotificationsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiNotificationsFetchPostSchema, FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostParameters, OperationError<FetchFullappApiNotificationsFetchPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Fetch
         * @description Fetch the auth user's notifications.
         *
         * Returns a flat JSON array (the app flattens ``r.data``), filtered by ``is_new``
         * (1=unread, 0=read) and paginated by ``per_page``/``page``, newest first. Always
         * the auth user's own rows; there is no ``user_id`` param.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.fetchFullappApiNotificationsFetchPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.fetchFullappApiNotificationsFetchPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostParameters, OperationError<FetchFullappApiNotificationsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiNotificationsFetchPostSchema, FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostParameters, OperationError<FetchFullappApiNotificationsFetchPostError>, TContext>): Mutation<FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostError, MutationVariables<FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostParameters, OperationError<FetchFullappApiNotificationsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiNotificationsFetchPostSchema, FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostParameters, OperationError<FetchFullappApiNotificationsFetchPostError>, TContext>): Array<Mutation<FetchFullappApiNotificationsFetchPostData, FetchFullappApiNotificationsFetchPostError, MutationVariables<FetchFullappApiNotificationsFetchPostBody, FetchFullappApiNotificationsFetchPostParameters>, TContext>>;
        };
        schema: FetchFullappApiNotificationsFetchPostSchema;
        types: {
            parameters: FetchFullappApiNotificationsFetchPostParameters;
            data: FetchFullappApiNotificationsFetchPostData;
            error: FetchFullappApiNotificationsFetchPostError;
            body: FetchFullappApiNotificationsFetchPostBody;
        };
    };
    /**
     * @summary Mark
     * @description Mark the auth user's notification read (``is_new`` -> 0) and echo ``{id, is_new}``.
     *
     * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
     * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
     * Idempotent: a second call still returns ``is_new:0``.
     */
    markFullappApiNotificationsMarkPost: {
        /**
         * @summary Mark
         * @description Mark the auth user's notification read (``is_new`` -> 0) and echo ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:0``.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostParameters, TMeta, TSignal>, client?: (schema: MarkFullappApiNotificationsMarkPostSchema, options: ServiceOperationMutationFnOptions<MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostError>>): Promise<RequestFnResponse<MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostError>>;
        /**
         * @summary Mark
         * @description Mark the auth user's notification read (``is_new`` -> 0) and echo ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:0``.
         */
        getMutationKey(parameters: DeepReadonly<MarkFullappApiNotificationsMarkPostParameters> | void): ServiceOperationMutationKey<MarkFullappApiNotificationsMarkPostSchema, MarkFullappApiNotificationsMarkPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark
         * @description Mark the auth user's notification read (``is_new`` -> 0) and echo ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:0``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markFullappApiNotificationsMarkPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markFullappApiNotificationsMarkPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MarkFullappApiNotificationsMarkPostBody, TContext = unknown>(parameters: DeepReadonly<MarkFullappApiNotificationsMarkPostParameters>, options?: ServiceOperationUseMutationOptions<MarkFullappApiNotificationsMarkPostSchema, MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostParameters, TVariables, OperationError<MarkFullappApiNotificationsMarkPostError>, TContext>): UseMutationResult<MarkFullappApiNotificationsMarkPostData, OperationError<MarkFullappApiNotificationsMarkPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark
         * @description Mark the auth user's notification read (``is_new`` -> 0) and echo ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:0``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markFullappApiNotificationsMarkPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markFullappApiNotificationsMarkPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<MarkFullappApiNotificationsMarkPostSchema, MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostParameters, TVariables, OperationError<MarkFullappApiNotificationsMarkPostError>, TContext>): UseMutationResult<MarkFullappApiNotificationsMarkPostData, OperationError<MarkFullappApiNotificationsMarkPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Mark
         * @description Mark the auth user's notification read (``is_new`` -> 0) and echo ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:0``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const markFullappApiNotificationsMarkPostTotal = qraft.fullappApiService.markFullappApiNotificationsMarkPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const markFullappApiNotificationsMarkPostTotal = qraft.fullappApiService.markFullappApiNotificationsMarkPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostParameters, OperationError<MarkFullappApiNotificationsMarkPostError>, TContext> | MutationFiltersByMutationKey<MarkFullappApiNotificationsMarkPostSchema, MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostParameters, OperationError<MarkFullappApiNotificationsMarkPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Mark
         * @description Mark the auth user's notification read (``is_new`` -> 0) and echo ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:0``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const markFullappApiNotificationsMarkPostPendingMutationVariables = qraft.fullappApiService.markFullappApiNotificationsMarkPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const markFullappApiNotificationsMarkPostMutationData = qraft.fullappApiService.markFullappApiNotificationsMarkPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<MarkFullappApiNotificationsMarkPostData, OperationError<MarkFullappApiNotificationsMarkPostError>, MutationVariables<MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostParameters, OperationError<MarkFullappApiNotificationsMarkPostError>, TContext> | MutationFiltersByMutationKey<MarkFullappApiNotificationsMarkPostSchema, MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostParameters, OperationError<MarkFullappApiNotificationsMarkPostError>, TContext>;
            select?: (mutation: Mutation<MarkFullappApiNotificationsMarkPostData, OperationError<MarkFullappApiNotificationsMarkPostError>, MutationVariables<MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Mark
         * @description Mark the auth user's notification read (``is_new`` -> 0) and echo ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:0``.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostParameters, OperationError<MarkFullappApiNotificationsMarkPostError>, TContext> | MutationFiltersByMutationKey<MarkFullappApiNotificationsMarkPostSchema, MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostParameters, OperationError<MarkFullappApiNotificationsMarkPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Mark
         * @description Mark the auth user's notification read (``is_new`` -> 0) and echo ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:0``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.markFullappApiNotificationsMarkPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.markFullappApiNotificationsMarkPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostParameters, OperationError<MarkFullappApiNotificationsMarkPostError>, TContext> | MutationFiltersByMutationKey<MarkFullappApiNotificationsMarkPostSchema, MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostParameters, OperationError<MarkFullappApiNotificationsMarkPostError>, TContext>): Mutation<MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostError, MutationVariables<MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostParameters, OperationError<MarkFullappApiNotificationsMarkPostError>, TContext> | MutationFiltersByMutationKey<MarkFullappApiNotificationsMarkPostSchema, MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostParameters, OperationError<MarkFullappApiNotificationsMarkPostError>, TContext>): Array<Mutation<MarkFullappApiNotificationsMarkPostData, MarkFullappApiNotificationsMarkPostError, MutationVariables<MarkFullappApiNotificationsMarkPostBody, MarkFullappApiNotificationsMarkPostParameters>, TContext>>;
        };
        schema: MarkFullappApiNotificationsMarkPostSchema;
        types: {
            parameters: MarkFullappApiNotificationsMarkPostParameters;
            data: MarkFullappApiNotificationsMarkPostData;
            error: MarkFullappApiNotificationsMarkPostError;
            body: MarkFullappApiNotificationsMarkPostBody;
        };
    };
    /**
     * @summary Mark Unread
     * @description Inverse of ``mark``: mark the notification unread (``is_new`` -> 1) and echo
     * ``{id, is_new}``.
     *
     * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
     * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
     * Idempotent: a second call still returns ``is_new:1``.
     */
    markUnreadFullappApiNotificationsMarkUnreadPost: {
        /**
         * @summary Mark Unread
         * @description Inverse of ``mark``: mark the notification unread (``is_new`` -> 1) and echo
         * ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:1``.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters, TMeta, TSignal>, client?: (schema: MarkUnreadFullappApiNotificationsMarkUnreadPostSchema, options: ServiceOperationMutationFnOptions<MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostError>>): Promise<RequestFnResponse<MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostError>>;
        /**
         * @summary Mark Unread
         * @description Inverse of ``mark``: mark the notification unread (``is_new`` -> 1) and echo
         * ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:1``.
         */
        getMutationKey(parameters: DeepReadonly<MarkUnreadFullappApiNotificationsMarkUnreadPostParameters> | void): ServiceOperationMutationKey<MarkUnreadFullappApiNotificationsMarkUnreadPostSchema, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark Unread
         * @description Inverse of ``mark``: mark the notification unread (``is_new`` -> 1) and echo
         * ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:1``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markUnreadFullappApiNotificationsMarkUnreadPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markUnreadFullappApiNotificationsMarkUnreadPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MarkUnreadFullappApiNotificationsMarkUnreadPostBody, TContext = unknown>(parameters: DeepReadonly<MarkUnreadFullappApiNotificationsMarkUnreadPostParameters>, options?: ServiceOperationUseMutationOptions<MarkUnreadFullappApiNotificationsMarkUnreadPostSchema, MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters, TVariables, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, TContext>): UseMutationResult<MarkUnreadFullappApiNotificationsMarkUnreadPostData, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark Unread
         * @description Inverse of ``mark``: mark the notification unread (``is_new`` -> 1) and echo
         * ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:1``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markUnreadFullappApiNotificationsMarkUnreadPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markUnreadFullappApiNotificationsMarkUnreadPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<MarkUnreadFullappApiNotificationsMarkUnreadPostSchema, MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters, TVariables, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, TContext>): UseMutationResult<MarkUnreadFullappApiNotificationsMarkUnreadPostData, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Mark Unread
         * @description Inverse of ``mark``: mark the notification unread (``is_new`` -> 1) and echo
         * ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:1``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const markUnreadFullappApiNotificationsMarkUnreadPostTotal = qraft.fullappApiService.markUnreadFullappApiNotificationsMarkUnreadPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const markUnreadFullappApiNotificationsMarkUnreadPostTotal = qraft.fullappApiService.markUnreadFullappApiNotificationsMarkUnreadPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, TContext> | MutationFiltersByMutationKey<MarkUnreadFullappApiNotificationsMarkUnreadPostSchema, MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Mark Unread
         * @description Inverse of ``mark``: mark the notification unread (``is_new`` -> 1) and echo
         * ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:1``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const markUnreadFullappApiNotificationsMarkUnreadPostPendingMutationVariables = qraft.fullappApiService.markUnreadFullappApiNotificationsMarkUnreadPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const markUnreadFullappApiNotificationsMarkUnreadPostMutationData = qraft.fullappApiService.markUnreadFullappApiNotificationsMarkUnreadPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<MarkUnreadFullappApiNotificationsMarkUnreadPostData, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, MutationVariables<MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, TContext> | MutationFiltersByMutationKey<MarkUnreadFullappApiNotificationsMarkUnreadPostSchema, MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, TContext>;
            select?: (mutation: Mutation<MarkUnreadFullappApiNotificationsMarkUnreadPostData, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, MutationVariables<MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Mark Unread
         * @description Inverse of ``mark``: mark the notification unread (``is_new`` -> 1) and echo
         * ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:1``.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, TContext> | MutationFiltersByMutationKey<MarkUnreadFullappApiNotificationsMarkUnreadPostSchema, MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Mark Unread
         * @description Inverse of ``mark``: mark the notification unread (``is_new`` -> 1) and echo
         * ``{id, is_new}``.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
         * Idempotent: a second call still returns ``is_new:1``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.markUnreadFullappApiNotificationsMarkUnreadPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.markUnreadFullappApiNotificationsMarkUnreadPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, TContext> | MutationFiltersByMutationKey<MarkUnreadFullappApiNotificationsMarkUnreadPostSchema, MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, TContext>): Mutation<MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostError, MutationVariables<MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, TContext> | MutationFiltersByMutationKey<MarkUnreadFullappApiNotificationsMarkUnreadPostSchema, MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters, OperationError<MarkUnreadFullappApiNotificationsMarkUnreadPostError>, TContext>): Array<Mutation<MarkUnreadFullappApiNotificationsMarkUnreadPostData, MarkUnreadFullappApiNotificationsMarkUnreadPostError, MutationVariables<MarkUnreadFullappApiNotificationsMarkUnreadPostBody, MarkUnreadFullappApiNotificationsMarkUnreadPostParameters>, TContext>>;
        };
        schema: MarkUnreadFullappApiNotificationsMarkUnreadPostSchema;
        types: {
            parameters: MarkUnreadFullappApiNotificationsMarkUnreadPostParameters;
            data: MarkUnreadFullappApiNotificationsMarkUnreadPostData;
            error: MarkUnreadFullappApiNotificationsMarkUnreadPostError;
            body: MarkUnreadFullappApiNotificationsMarkUnreadPostBody;
        };
    };
    /**
     * @summary Mark By Props
     * @description Bulk-mark unread notifications matching component_name+component_action+item_id
     * (+ optional secondary_item_id) as read.
     *
     * Missing/null required fields -> 433 ``validation_error``; empty string / 0 pass.
     * Ownership is implicit via user_id scoping. Returns a flat array of
     * ``{id, is_new: 0}``; an empty match -> ``[]`` (no error).
     */
    markByPropsFullappApiNotificationsMarkByPropsPost: {
        /**
         * @summary Mark By Props
         * @description Bulk-mark unread notifications matching component_name+component_action+item_id
         * (+ optional secondary_item_id) as read.
         *
         * Missing/null required fields -> 433 ``validation_error``; empty string / 0 pass.
         * Ownership is implicit via user_id scoping. Returns a flat array of
         * ``{id, is_new: 0}``; an empty match -> ``[]`` (no error).
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters, TMeta, TSignal>, client?: (schema: MarkByPropsFullappApiNotificationsMarkByPropsPostSchema, options: ServiceOperationMutationFnOptions<MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostError>>): Promise<RequestFnResponse<MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostError>>;
        /**
         * @summary Mark By Props
         * @description Bulk-mark unread notifications matching component_name+component_action+item_id
         * (+ optional secondary_item_id) as read.
         *
         * Missing/null required fields -> 433 ``validation_error``; empty string / 0 pass.
         * Ownership is implicit via user_id scoping. Returns a flat array of
         * ``{id, is_new: 0}``; an empty match -> ``[]`` (no error).
         */
        getMutationKey(parameters: DeepReadonly<MarkByPropsFullappApiNotificationsMarkByPropsPostParameters> | void): ServiceOperationMutationKey<MarkByPropsFullappApiNotificationsMarkByPropsPostSchema, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark By Props
         * @description Bulk-mark unread notifications matching component_name+component_action+item_id
         * (+ optional secondary_item_id) as read.
         *
         * Missing/null required fields -> 433 ``validation_error``; empty string / 0 pass.
         * Ownership is implicit via user_id scoping. Returns a flat array of
         * ``{id, is_new: 0}``; an empty match -> ``[]`` (no error).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markByPropsFullappApiNotificationsMarkByPropsPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markByPropsFullappApiNotificationsMarkByPropsPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MarkByPropsFullappApiNotificationsMarkByPropsPostBody, TContext = unknown>(parameters: DeepReadonly<MarkByPropsFullappApiNotificationsMarkByPropsPostParameters>, options?: ServiceOperationUseMutationOptions<MarkByPropsFullappApiNotificationsMarkByPropsPostSchema, MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters, TVariables, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, TContext>): UseMutationResult<MarkByPropsFullappApiNotificationsMarkByPropsPostData, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark By Props
         * @description Bulk-mark unread notifications matching component_name+component_action+item_id
         * (+ optional secondary_item_id) as read.
         *
         * Missing/null required fields -> 433 ``validation_error``; empty string / 0 pass.
         * Ownership is implicit via user_id scoping. Returns a flat array of
         * ``{id, is_new: 0}``; an empty match -> ``[]`` (no error).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markByPropsFullappApiNotificationsMarkByPropsPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markByPropsFullappApiNotificationsMarkByPropsPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<MarkByPropsFullappApiNotificationsMarkByPropsPostSchema, MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters, TVariables, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, TContext>): UseMutationResult<MarkByPropsFullappApiNotificationsMarkByPropsPostData, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Mark By Props
         * @description Bulk-mark unread notifications matching component_name+component_action+item_id
         * (+ optional secondary_item_id) as read.
         *
         * Missing/null required fields -> 433 ``validation_error``; empty string / 0 pass.
         * Ownership is implicit via user_id scoping. Returns a flat array of
         * ``{id, is_new: 0}``; an empty match -> ``[]`` (no error).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const markByPropsFullappApiNotificationsMarkByPropsPostTotal = qraft.fullappApiService.markByPropsFullappApiNotificationsMarkByPropsPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const markByPropsFullappApiNotificationsMarkByPropsPostTotal = qraft.fullappApiService.markByPropsFullappApiNotificationsMarkByPropsPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, TContext> | MutationFiltersByMutationKey<MarkByPropsFullappApiNotificationsMarkByPropsPostSchema, MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Mark By Props
         * @description Bulk-mark unread notifications matching component_name+component_action+item_id
         * (+ optional secondary_item_id) as read.
         *
         * Missing/null required fields -> 433 ``validation_error``; empty string / 0 pass.
         * Ownership is implicit via user_id scoping. Returns a flat array of
         * ``{id, is_new: 0}``; an empty match -> ``[]`` (no error).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const markByPropsFullappApiNotificationsMarkByPropsPostPendingMutationVariables = qraft.fullappApiService.markByPropsFullappApiNotificationsMarkByPropsPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const markByPropsFullappApiNotificationsMarkByPropsPostMutationData = qraft.fullappApiService.markByPropsFullappApiNotificationsMarkByPropsPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<MarkByPropsFullappApiNotificationsMarkByPropsPostData, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, MutationVariables<MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, TContext> | MutationFiltersByMutationKey<MarkByPropsFullappApiNotificationsMarkByPropsPostSchema, MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, TContext>;
            select?: (mutation: Mutation<MarkByPropsFullappApiNotificationsMarkByPropsPostData, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, MutationVariables<MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Mark By Props
         * @description Bulk-mark unread notifications matching component_name+component_action+item_id
         * (+ optional secondary_item_id) as read.
         *
         * Missing/null required fields -> 433 ``validation_error``; empty string / 0 pass.
         * Ownership is implicit via user_id scoping. Returns a flat array of
         * ``{id, is_new: 0}``; an empty match -> ``[]`` (no error).
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, TContext> | MutationFiltersByMutationKey<MarkByPropsFullappApiNotificationsMarkByPropsPostSchema, MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Mark By Props
         * @description Bulk-mark unread notifications matching component_name+component_action+item_id
         * (+ optional secondary_item_id) as read.
         *
         * Missing/null required fields -> 433 ``validation_error``; empty string / 0 pass.
         * Ownership is implicit via user_id scoping. Returns a flat array of
         * ``{id, is_new: 0}``; an empty match -> ``[]`` (no error).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.markByPropsFullappApiNotificationsMarkByPropsPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.markByPropsFullappApiNotificationsMarkByPropsPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, TContext> | MutationFiltersByMutationKey<MarkByPropsFullappApiNotificationsMarkByPropsPostSchema, MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, TContext>): Mutation<MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostError, MutationVariables<MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, TContext> | MutationFiltersByMutationKey<MarkByPropsFullappApiNotificationsMarkByPropsPostSchema, MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters, OperationError<MarkByPropsFullappApiNotificationsMarkByPropsPostError>, TContext>): Array<Mutation<MarkByPropsFullappApiNotificationsMarkByPropsPostData, MarkByPropsFullappApiNotificationsMarkByPropsPostError, MutationVariables<MarkByPropsFullappApiNotificationsMarkByPropsPostBody, MarkByPropsFullappApiNotificationsMarkByPropsPostParameters>, TContext>>;
        };
        schema: MarkByPropsFullappApiNotificationsMarkByPropsPostSchema;
        types: {
            parameters: MarkByPropsFullappApiNotificationsMarkByPropsPostParameters;
            data: MarkByPropsFullappApiNotificationsMarkByPropsPostData;
            error: MarkByPropsFullappApiNotificationsMarkByPropsPostError;
            body: MarkByPropsFullappApiNotificationsMarkByPropsPostBody;
        };
    };
    /**
     * @summary Delete
     * @description Hard-delete the auth user's notification by id.
     *
     * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
     * ``invalid_ownership``. Success returns an empty data envelope.
     */
    deleteFullappApiNotificationsDeletePost: {
        /**
         * @summary Delete
         * @description Hard-delete the auth user's notification by id.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. Success returns an empty data envelope.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostParameters, TMeta, TSignal>, client?: (schema: DeleteFullappApiNotificationsDeletePostSchema, options: ServiceOperationMutationFnOptions<DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostError>>): Promise<RequestFnResponse<DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostError>>;
        /**
         * @summary Delete
         * @description Hard-delete the auth user's notification by id.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. Success returns an empty data envelope.
         */
        getMutationKey(parameters: DeepReadonly<DeleteFullappApiNotificationsDeletePostParameters> | void): ServiceOperationMutationKey<DeleteFullappApiNotificationsDeletePostSchema, DeleteFullappApiNotificationsDeletePostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete
         * @description Hard-delete the auth user's notification by id.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. Success returns an empty data envelope.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deleteFullappApiNotificationsDeletePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deleteFullappApiNotificationsDeletePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DeleteFullappApiNotificationsDeletePostBody, TContext = unknown>(parameters: DeepReadonly<DeleteFullappApiNotificationsDeletePostParameters>, options?: ServiceOperationUseMutationOptions<DeleteFullappApiNotificationsDeletePostSchema, DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostParameters, TVariables, OperationError<DeleteFullappApiNotificationsDeletePostError>, TContext>): UseMutationResult<DeleteFullappApiNotificationsDeletePostData, OperationError<DeleteFullappApiNotificationsDeletePostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete
         * @description Hard-delete the auth user's notification by id.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. Success returns an empty data envelope.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deleteFullappApiNotificationsDeletePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deleteFullappApiNotificationsDeletePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeleteFullappApiNotificationsDeletePostSchema, DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostParameters, TVariables, OperationError<DeleteFullappApiNotificationsDeletePostError>, TContext>): UseMutationResult<DeleteFullappApiNotificationsDeletePostData, OperationError<DeleteFullappApiNotificationsDeletePostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Delete
         * @description Hard-delete the auth user's notification by id.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. Success returns an empty data envelope.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const deleteFullappApiNotificationsDeletePostTotal = qraft.fullappApiService.deleteFullappApiNotificationsDeletePost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const deleteFullappApiNotificationsDeletePostTotal = qraft.fullappApiService.deleteFullappApiNotificationsDeletePost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostParameters, OperationError<DeleteFullappApiNotificationsDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteFullappApiNotificationsDeletePostSchema, DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostParameters, OperationError<DeleteFullappApiNotificationsDeletePostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Delete
         * @description Hard-delete the auth user's notification by id.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. Success returns an empty data envelope.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const deleteFullappApiNotificationsDeletePostPendingMutationVariables = qraft.fullappApiService.deleteFullappApiNotificationsDeletePost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const deleteFullappApiNotificationsDeletePostMutationData = qraft.fullappApiService.deleteFullappApiNotificationsDeletePost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeleteFullappApiNotificationsDeletePostData, OperationError<DeleteFullappApiNotificationsDeletePostError>, MutationVariables<DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostParameters, OperationError<DeleteFullappApiNotificationsDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteFullappApiNotificationsDeletePostSchema, DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostParameters, OperationError<DeleteFullappApiNotificationsDeletePostError>, TContext>;
            select?: (mutation: Mutation<DeleteFullappApiNotificationsDeletePostData, OperationError<DeleteFullappApiNotificationsDeletePostError>, MutationVariables<DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Delete
         * @description Hard-delete the auth user's notification by id.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. Success returns an empty data envelope.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostParameters, OperationError<DeleteFullappApiNotificationsDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteFullappApiNotificationsDeletePostSchema, DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostParameters, OperationError<DeleteFullappApiNotificationsDeletePostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Delete
         * @description Hard-delete the auth user's notification by id.
         *
         * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
         * ``invalid_ownership``. Success returns an empty data envelope.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.deleteFullappApiNotificationsDeletePost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.deleteFullappApiNotificationsDeletePost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostParameters, OperationError<DeleteFullappApiNotificationsDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteFullappApiNotificationsDeletePostSchema, DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostParameters, OperationError<DeleteFullappApiNotificationsDeletePostError>, TContext>): Mutation<DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostError, MutationVariables<DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostParameters, OperationError<DeleteFullappApiNotificationsDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteFullappApiNotificationsDeletePostSchema, DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostParameters, OperationError<DeleteFullappApiNotificationsDeletePostError>, TContext>): Array<Mutation<DeleteFullappApiNotificationsDeletePostData, DeleteFullappApiNotificationsDeletePostError, MutationVariables<DeleteFullappApiNotificationsDeletePostBody, DeleteFullappApiNotificationsDeletePostParameters>, TContext>>;
        };
        schema: DeleteFullappApiNotificationsDeletePostSchema;
        types: {
            parameters: DeleteFullappApiNotificationsDeletePostParameters;
            data: DeleteFullappApiNotificationsDeletePostData;
            error: DeleteFullappApiNotificationsDeletePostError;
            body: DeleteFullappApiNotificationsDeletePostBody;
        };
    };
    /** @summary Student */
    studentFullappApiDashboardWidgetsStudentPost: {
        /** @summary Student */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostParameters, TMeta, TSignal>, client?: (schema: StudentFullappApiDashboardWidgetsStudentPostSchema, options: ServiceOperationMutationFnOptions<StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostError>>): Promise<RequestFnResponse<StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostError>>;
        /** @summary Student */
        getMutationKey(parameters: DeepReadonly<StudentFullappApiDashboardWidgetsStudentPostParameters> | void): ServiceOperationMutationKey<StudentFullappApiDashboardWidgetsStudentPostSchema, StudentFullappApiDashboardWidgetsStudentPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentFullappApiDashboardWidgetsStudentPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentFullappApiDashboardWidgetsStudentPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends StudentFullappApiDashboardWidgetsStudentPostBody, TContext = unknown>(parameters: DeepReadonly<StudentFullappApiDashboardWidgetsStudentPostParameters>, options?: ServiceOperationUseMutationOptions<StudentFullappApiDashboardWidgetsStudentPostSchema, StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostParameters, TVariables, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, TContext>): UseMutationResult<StudentFullappApiDashboardWidgetsStudentPostData, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentFullappApiDashboardWidgetsStudentPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studentFullappApiDashboardWidgetsStudentPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<StudentFullappApiDashboardWidgetsStudentPostSchema, StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostParameters, TVariables, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, TContext>): UseMutationResult<StudentFullappApiDashboardWidgetsStudentPostData, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const studentFullappApiDashboardWidgetsStudentPostTotal = qraft.fullappApiService.studentFullappApiDashboardWidgetsStudentPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const studentFullappApiDashboardWidgetsStudentPostTotal = qraft.fullappApiService.studentFullappApiDashboardWidgetsStudentPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostParameters, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, TContext> | MutationFiltersByMutationKey<StudentFullappApiDashboardWidgetsStudentPostSchema, StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostParameters, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const studentFullappApiDashboardWidgetsStudentPostPendingMutationVariables = qraft.fullappApiService.studentFullappApiDashboardWidgetsStudentPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const studentFullappApiDashboardWidgetsStudentPostMutationData = qraft.fullappApiService.studentFullappApiDashboardWidgetsStudentPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<StudentFullappApiDashboardWidgetsStudentPostData, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, MutationVariables<StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostParameters, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, TContext> | MutationFiltersByMutationKey<StudentFullappApiDashboardWidgetsStudentPostSchema, StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostParameters, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, TContext>;
            select?: (mutation: Mutation<StudentFullappApiDashboardWidgetsStudentPostData, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, MutationVariables<StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Student */
        isMutating<TContext>(filters?: MutationFiltersByParameters<StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostParameters, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, TContext> | MutationFiltersByMutationKey<StudentFullappApiDashboardWidgetsStudentPostSchema, StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostParameters, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Student
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.studentFullappApiDashboardWidgetsStudentPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.studentFullappApiDashboardWidgetsStudentPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostParameters, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, TContext> | MutationFiltersByMutationKey<StudentFullappApiDashboardWidgetsStudentPostSchema, StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostParameters, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, TContext>): Mutation<StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostError, MutationVariables<StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostParameters, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, TContext> | MutationFiltersByMutationKey<StudentFullappApiDashboardWidgetsStudentPostSchema, StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostParameters, OperationError<StudentFullappApiDashboardWidgetsStudentPostError>, TContext>): Array<Mutation<StudentFullappApiDashboardWidgetsStudentPostData, StudentFullappApiDashboardWidgetsStudentPostError, MutationVariables<StudentFullappApiDashboardWidgetsStudentPostBody, StudentFullappApiDashboardWidgetsStudentPostParameters>, TContext>>;
        };
        schema: StudentFullappApiDashboardWidgetsStudentPostSchema;
        types: {
            parameters: StudentFullappApiDashboardWidgetsStudentPostParameters;
            data: StudentFullappApiDashboardWidgetsStudentPostData;
            error: StudentFullappApiDashboardWidgetsStudentPostError;
            body: StudentFullappApiDashboardWidgetsStudentPostBody;
        };
    };
    /**
     * @summary Study Group
     * @description Render errors as a top-level ``success:false`` with the error body under
     * ``detail``. Raising the HTTPException would hit the app-wide handler that wraps
     * the detail under ``data`` only, but the app's reader expects ``success`` +
     * ``detail`` at the top level, so we render it directly.
     */
    studyGroupFullappApiDashboardWidgetsStudyGroupPost: {
        /**
         * @summary Study Group
         * @description Render errors as a top-level ``success:false`` with the error body under
         * ``detail``. Raising the HTTPException would hit the app-wide handler that wraps
         * the detail under ``data`` only, but the app's reader expects ``success`` +
         * ``detail`` at the top level, so we render it directly.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters, TMeta, TSignal>, client?: (schema: StudyGroupFullappApiDashboardWidgetsStudyGroupPostSchema, options: ServiceOperationMutationFnOptions<StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>>): Promise<RequestFnResponse<StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>>;
        /**
         * @summary Study Group
         * @description Render errors as a top-level ``success:false`` with the error body under
         * ``detail``. Raising the HTTPException would hit the app-wide handler that wraps
         * the detail under ``data`` only, but the app's reader expects ``success`` +
         * ``detail`` at the top level, so we render it directly.
         */
        getMutationKey(parameters: DeepReadonly<StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters> | void): ServiceOperationMutationKey<StudyGroupFullappApiDashboardWidgetsStudyGroupPostSchema, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Study Group
         * @description Render errors as a top-level ``success:false`` with the error body under
         * ``detail``. Raising the HTTPException would hit the app-wide handler that wraps
         * the detail under ``data`` only, but the app's reader expects ``success`` +
         * ``detail`` at the top level, so we render it directly.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyGroupFullappApiDashboardWidgetsStudyGroupPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyGroupFullappApiDashboardWidgetsStudyGroupPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, TContext = unknown>(parameters: DeepReadonly<StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters>, options?: ServiceOperationUseMutationOptions<StudyGroupFullappApiDashboardWidgetsStudyGroupPostSchema, StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters, TVariables, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, TContext>): UseMutationResult<StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Study Group
         * @description Render errors as a top-level ``success:false`` with the error body under
         * ``detail``. Raising the HTTPException would hit the app-wide handler that wraps
         * the detail under ``data`` only, but the app's reader expects ``success`` +
         * ``detail`` at the top level, so we render it directly.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyGroupFullappApiDashboardWidgetsStudyGroupPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.studyGroupFullappApiDashboardWidgetsStudyGroupPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<StudyGroupFullappApiDashboardWidgetsStudyGroupPostSchema, StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters, TVariables, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, TContext>): UseMutationResult<StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Study Group
         * @description Render errors as a top-level ``success:false`` with the error body under
         * ``detail``. Raising the HTTPException would hit the app-wide handler that wraps
         * the detail under ``data`` only, but the app's reader expects ``success`` +
         * ``detail`` at the top level, so we render it directly.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const studyGroupFullappApiDashboardWidgetsStudyGroupPostTotal = qraft.fullappApiService.studyGroupFullappApiDashboardWidgetsStudyGroupPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const studyGroupFullappApiDashboardWidgetsStudyGroupPostTotal = qraft.fullappApiService.studyGroupFullappApiDashboardWidgetsStudyGroupPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, TContext> | MutationFiltersByMutationKey<StudyGroupFullappApiDashboardWidgetsStudyGroupPostSchema, StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Study Group
         * @description Render errors as a top-level ``success:false`` with the error body under
         * ``detail``. Raising the HTTPException would hit the app-wide handler that wraps
         * the detail under ``data`` only, but the app's reader expects ``success`` +
         * ``detail`` at the top level, so we render it directly.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const studyGroupFullappApiDashboardWidgetsStudyGroupPostPendingMutationVariables = qraft.fullappApiService.studyGroupFullappApiDashboardWidgetsStudyGroupPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const studyGroupFullappApiDashboardWidgetsStudyGroupPostMutationData = qraft.fullappApiService.studyGroupFullappApiDashboardWidgetsStudyGroupPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, MutationVariables<StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, TContext> | MutationFiltersByMutationKey<StudyGroupFullappApiDashboardWidgetsStudyGroupPostSchema, StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, TContext>;
            select?: (mutation: Mutation<StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, MutationVariables<StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Study Group
         * @description Render errors as a top-level ``success:false`` with the error body under
         * ``detail``. Raising the HTTPException would hit the app-wide handler that wraps
         * the detail under ``data`` only, but the app's reader expects ``success`` +
         * ``detail`` at the top level, so we render it directly.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, TContext> | MutationFiltersByMutationKey<StudyGroupFullappApiDashboardWidgetsStudyGroupPostSchema, StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Study Group
         * @description Render errors as a top-level ``success:false`` with the error body under
         * ``detail``. Raising the HTTPException would hit the app-wide handler that wraps
         * the detail under ``data`` only, but the app's reader expects ``success`` +
         * ``detail`` at the top level, so we render it directly.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.studyGroupFullappApiDashboardWidgetsStudyGroupPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.studyGroupFullappApiDashboardWidgetsStudyGroupPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, TContext> | MutationFiltersByMutationKey<StudyGroupFullappApiDashboardWidgetsStudyGroupPostSchema, StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, TContext>): Mutation<StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostError, MutationVariables<StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, TContext> | MutationFiltersByMutationKey<StudyGroupFullappApiDashboardWidgetsStudyGroupPostSchema, StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters, OperationError<StudyGroupFullappApiDashboardWidgetsStudyGroupPostError>, TContext>): Array<Mutation<StudyGroupFullappApiDashboardWidgetsStudyGroupPostData, StudyGroupFullappApiDashboardWidgetsStudyGroupPostError, MutationVariables<StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody, StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters>, TContext>>;
        };
        schema: StudyGroupFullappApiDashboardWidgetsStudyGroupPostSchema;
        types: {
            parameters: StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters;
            data: StudyGroupFullappApiDashboardWidgetsStudyGroupPostData;
            error: StudyGroupFullappApiDashboardWidgetsStudyGroupPostError;
            body: StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody;
        };
    };
    /**
     * @summary Get Student Dashboard Stats
     * @description Get a student's dashboard statistics.
     *
     * NOT self-only: the body ``user_id`` defaults to the auth user, and the only gate
     * is that the TARGET is a student. Any authenticated caller (student or
     * study-helper) may read another student's stats given a valid student
     * ``user_id``; a non-student / nonexistent target -> 403 ``invalid_profile_types``.
     */
    getStudentDashboardStatsFullappApiDashboardStatsStudentPost: {
        /**
         * @summary Get Student Dashboard Stats
         * @description Get a student's dashboard statistics.
         *
         * NOT self-only: the body ``user_id`` defaults to the auth user, and the only gate
         * is that the TARGET is a student. Any authenticated caller (student or
         * study-helper) may read another student's stats given a valid student
         * ``user_id``; a non-student / nonexistent target -> 403 ``invalid_profile_types``.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters, TMeta, TSignal>, client?: (schema: GetStudentDashboardStatsFullappApiDashboardStatsStudentPostSchema, options: ServiceOperationMutationFnOptions<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>>): Promise<RequestFnResponse<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>>;
        /**
         * @summary Get Student Dashboard Stats
         * @description Get a student's dashboard statistics.
         *
         * NOT self-only: the body ``user_id`` defaults to the auth user, and the only gate
         * is that the TARGET is a student. Any authenticated caller (student or
         * study-helper) may read another student's stats given a valid student
         * ``user_id``; a non-student / nonexistent target -> 403 ``invalid_profile_types``.
         */
        getMutationKey(parameters: DeepReadonly<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters> | void): ServiceOperationMutationKey<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostSchema, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Student Dashboard Stats
         * @description Get a student's dashboard statistics.
         *
         * NOT self-only: the body ``user_id`` defaults to the auth user, and the only gate
         * is that the TARGET is a student. Any authenticated caller (student or
         * study-helper) may read another student's stats given a valid student
         * ``user_id``; a non-student / nonexistent target -> 403 ``invalid_profile_types``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getStudentDashboardStatsFullappApiDashboardStatsStudentPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getStudentDashboardStatsFullappApiDashboardStatsStudentPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, TContext = unknown>(parameters: DeepReadonly<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters>, options?: ServiceOperationUseMutationOptions<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostSchema, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters, TVariables, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, TContext>): UseMutationResult<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Student Dashboard Stats
         * @description Get a student's dashboard statistics.
         *
         * NOT self-only: the body ``user_id`` defaults to the auth user, and the only gate
         * is that the TARGET is a student. Any authenticated caller (student or
         * study-helper) may read another student's stats given a valid student
         * ``user_id``; a non-student / nonexistent target -> 403 ``invalid_profile_types``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getStudentDashboardStatsFullappApiDashboardStatsStudentPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getStudentDashboardStatsFullappApiDashboardStatsStudentPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostSchema, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters, TVariables, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, TContext>): UseMutationResult<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Get Student Dashboard Stats
         * @description Get a student's dashboard statistics.
         *
         * NOT self-only: the body ``user_id`` defaults to the auth user, and the only gate
         * is that the TARGET is a student. Any authenticated caller (student or
         * study-helper) may read another student's stats given a valid student
         * ``user_id``; a non-student / nonexistent target -> 403 ``invalid_profile_types``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const getStudentDashboardStatsFullappApiDashboardStatsStudentPostTotal = qraft.fullappApiService.getStudentDashboardStatsFullappApiDashboardStatsStudentPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const getStudentDashboardStatsFullappApiDashboardStatsStudentPostTotal = qraft.fullappApiService.getStudentDashboardStatsFullappApiDashboardStatsStudentPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, TContext> | MutationFiltersByMutationKey<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostSchema, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Get Student Dashboard Stats
         * @description Get a student's dashboard statistics.
         *
         * NOT self-only: the body ``user_id`` defaults to the auth user, and the only gate
         * is that the TARGET is a student. Any authenticated caller (student or
         * study-helper) may read another student's stats given a valid student
         * ``user_id``; a non-student / nonexistent target -> 403 ``invalid_profile_types``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const getStudentDashboardStatsFullappApiDashboardStatsStudentPostPendingMutationVariables = qraft.fullappApiService.getStudentDashboardStatsFullappApiDashboardStatsStudentPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const getStudentDashboardStatsFullappApiDashboardStatsStudentPostMutationData = qraft.fullappApiService.getStudentDashboardStatsFullappApiDashboardStatsStudentPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, MutationVariables<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, TContext> | MutationFiltersByMutationKey<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostSchema, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, TContext>;
            select?: (mutation: Mutation<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, MutationVariables<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Get Student Dashboard Stats
         * @description Get a student's dashboard statistics.
         *
         * NOT self-only: the body ``user_id`` defaults to the auth user, and the only gate
         * is that the TARGET is a student. Any authenticated caller (student or
         * study-helper) may read another student's stats given a valid student
         * ``user_id``; a non-student / nonexistent target -> 403 ``invalid_profile_types``.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, TContext> | MutationFiltersByMutationKey<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostSchema, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Get Student Dashboard Stats
         * @description Get a student's dashboard statistics.
         *
         * NOT self-only: the body ``user_id`` defaults to the auth user, and the only gate
         * is that the TARGET is a student. Any authenticated caller (student or
         * study-helper) may read another student's stats given a valid student
         * ``user_id``; a non-student / nonexistent target -> 403 ``invalid_profile_types``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.getStudentDashboardStatsFullappApiDashboardStatsStudentPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.getStudentDashboardStatsFullappApiDashboardStatsStudentPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, TContext> | MutationFiltersByMutationKey<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostSchema, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, TContext>): Mutation<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError, MutationVariables<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, TContext> | MutationFiltersByMutationKey<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostSchema, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters, OperationError<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError>, TContext>): Array<Mutation<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError, MutationVariables<GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody, GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters>, TContext>>;
        };
        schema: GetStudentDashboardStatsFullappApiDashboardStatsStudentPostSchema;
        types: {
            parameters: GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters;
            data: GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData;
            error: GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError;
            body: GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody;
        };
    };
    /**
     * @summary Get Study Group Dashboard Stats
     * @description Get dashboard statistics for a study group.
     *
     * ``group_id`` is modelled as optional so a MISSING value yields the 433
     * ``validation_error`` below rather than FastAPI's 422.
     */
    getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPost: {
        /**
         * @summary Get Study Group Dashboard Stats
         * @description Get dashboard statistics for a study group.
         *
         * ``group_id`` is modelled as optional so a MISSING value yields the 433
         * ``validation_error`` below rather than FastAPI's 422.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters, TMeta, TSignal>, client?: (schema: GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostSchema, options: ServiceOperationMutationFnOptions<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>>): Promise<RequestFnResponse<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>>;
        /**
         * @summary Get Study Group Dashboard Stats
         * @description Get dashboard statistics for a study group.
         *
         * ``group_id`` is modelled as optional so a MISSING value yields the 433
         * ``validation_error`` below rather than FastAPI's 422.
         */
        getMutationKey(parameters: DeepReadonly<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters> | void): ServiceOperationMutationKey<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostSchema, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Study Group Dashboard Stats
         * @description Get dashboard statistics for a study group.
         *
         * ``group_id`` is modelled as optional so a MISSING value yields the 433
         * ``validation_error`` below rather than FastAPI's 422.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, TContext = unknown>(parameters: DeepReadonly<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters>, options?: ServiceOperationUseMutationOptions<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostSchema, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters, TVariables, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, TContext>): UseMutationResult<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Study Group Dashboard Stats
         * @description Get dashboard statistics for a study group.
         *
         * ``group_id`` is modelled as optional so a MISSING value yields the 433
         * ``validation_error`` below rather than FastAPI's 422.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostSchema, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters, TVariables, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, TContext>): UseMutationResult<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Get Study Group Dashboard Stats
         * @description Get dashboard statistics for a study group.
         *
         * ``group_id`` is modelled as optional so a MISSING value yields the 433
         * ``validation_error`` below rather than FastAPI's 422.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostTotal = qraft.fullappApiService.getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostTotal = qraft.fullappApiService.getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, TContext> | MutationFiltersByMutationKey<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostSchema, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Get Study Group Dashboard Stats
         * @description Get dashboard statistics for a study group.
         *
         * ``group_id`` is modelled as optional so a MISSING value yields the 433
         * ``validation_error`` below rather than FastAPI's 422.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostPendingMutationVariables = qraft.fullappApiService.getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostMutationData = qraft.fullappApiService.getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, MutationVariables<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, TContext> | MutationFiltersByMutationKey<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostSchema, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, TContext>;
            select?: (mutation: Mutation<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, MutationVariables<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Get Study Group Dashboard Stats
         * @description Get dashboard statistics for a study group.
         *
         * ``group_id`` is modelled as optional so a MISSING value yields the 433
         * ``validation_error`` below rather than FastAPI's 422.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, TContext> | MutationFiltersByMutationKey<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostSchema, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Get Study Group Dashboard Stats
         * @description Get dashboard statistics for a study group.
         *
         * ``group_id`` is modelled as optional so a MISSING value yields the 433
         * ``validation_error`` below rather than FastAPI's 422.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, TContext> | MutationFiltersByMutationKey<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostSchema, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, TContext>): Mutation<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError, MutationVariables<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, TContext> | MutationFiltersByMutationKey<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostSchema, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters, OperationError<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError>, TContext>): Array<Mutation<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError, MutationVariables<GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody, GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters>, TContext>>;
        };
        schema: GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostSchema;
        types: {
            parameters: GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters;
            data: GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData;
            error: GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError;
            body: GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody;
        };
    };
    /**
     * @summary Get Follow Up Requests List
     * @description Get list of follow-up requests for the current user.
     */
    getFollowUpRequestsListFullappApiFollowUpRequestsListPost: {
        /**
         * @summary Get Follow Up Requests List
         * @description Get list of follow-up requests for the current user.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters, TMeta, TSignal>, client?: (schema: GetFollowUpRequestsListFullappApiFollowUpRequestsListPostSchema, options: ServiceOperationMutationFnOptions<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>>): Promise<RequestFnResponse<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>>;
        /**
         * @summary Get Follow Up Requests List
         * @description Get list of follow-up requests for the current user.
         */
        getMutationKey(parameters: DeepReadonly<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters> | void): ServiceOperationMutationKey<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostSchema, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Follow Up Requests List
         * @description Get list of follow-up requests for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getFollowUpRequestsListFullappApiFollowUpRequestsListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getFollowUpRequestsListFullappApiFollowUpRequestsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, TContext = unknown>(parameters: DeepReadonly<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters>, options?: ServiceOperationUseMutationOptions<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostSchema, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters, TVariables, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, TContext>): UseMutationResult<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Follow Up Requests List
         * @description Get list of follow-up requests for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getFollowUpRequestsListFullappApiFollowUpRequestsListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getFollowUpRequestsListFullappApiFollowUpRequestsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostSchema, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters, TVariables, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, TContext>): UseMutationResult<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Get Follow Up Requests List
         * @description Get list of follow-up requests for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const getFollowUpRequestsListFullappApiFollowUpRequestsListPostTotal = qraft.fullappApiService.getFollowUpRequestsListFullappApiFollowUpRequestsListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const getFollowUpRequestsListFullappApiFollowUpRequestsListPostTotal = qraft.fullappApiService.getFollowUpRequestsListFullappApiFollowUpRequestsListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, TContext> | MutationFiltersByMutationKey<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostSchema, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Get Follow Up Requests List
         * @description Get list of follow-up requests for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const getFollowUpRequestsListFullappApiFollowUpRequestsListPostPendingMutationVariables = qraft.fullappApiService.getFollowUpRequestsListFullappApiFollowUpRequestsListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const getFollowUpRequestsListFullappApiFollowUpRequestsListPostMutationData = qraft.fullappApiService.getFollowUpRequestsListFullappApiFollowUpRequestsListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, MutationVariables<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, TContext> | MutationFiltersByMutationKey<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostSchema, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, TContext>;
            select?: (mutation: Mutation<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, MutationVariables<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Get Follow Up Requests List
         * @description Get list of follow-up requests for the current user.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, TContext> | MutationFiltersByMutationKey<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostSchema, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Get Follow Up Requests List
         * @description Get list of follow-up requests for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.getFollowUpRequestsListFullappApiFollowUpRequestsListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.getFollowUpRequestsListFullappApiFollowUpRequestsListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, TContext> | MutationFiltersByMutationKey<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostSchema, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, TContext>): Mutation<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError, MutationVariables<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, TContext> | MutationFiltersByMutationKey<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostSchema, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters, OperationError<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError>, TContext>): Array<Mutation<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError, MutationVariables<GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody, GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters>, TContext>>;
        };
        schema: GetFollowUpRequestsListFullappApiFollowUpRequestsListPostSchema;
        types: {
            parameters: GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters;
            data: GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData;
            error: GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError;
            body: GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody;
        };
    };
    /**
     * @summary Approve Follow Up Request
     * @description Approve a follow-up request, optionally overwriting the student contact info.
     *
     * Student-owner only: ownership is ``row.student_id == auth user``.
     *
     * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
     * ``detail``/``success``, nested ``validations``) is preserved rather than buried
     * under the app-wide ``{"data": ...}`` exception wrapper.
     */
    approveFollowUpRequestFullappApiFollowUpRequestsApprovePost: {
        /**
         * @summary Approve Follow Up Request
         * @description Approve a follow-up request, optionally overwriting the student contact info.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters, TMeta, TSignal>, client?: (schema: ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostSchema, options: ServiceOperationMutationFnOptions<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>>): Promise<RequestFnResponse<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>>;
        /**
         * @summary Approve Follow Up Request
         * @description Approve a follow-up request, optionally overwriting the student contact info.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         */
        getMutationKey(parameters: DeepReadonly<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters> | void): ServiceOperationMutationKey<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostSchema, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Approve Follow Up Request
         * @description Approve a follow-up request, optionally overwriting the student contact info.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.approveFollowUpRequestFullappApiFollowUpRequestsApprovePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.approveFollowUpRequestFullappApiFollowUpRequestsApprovePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, TContext = unknown>(parameters: DeepReadonly<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters>, options?: ServiceOperationUseMutationOptions<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostSchema, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters, TVariables, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, TContext>): UseMutationResult<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Approve Follow Up Request
         * @description Approve a follow-up request, optionally overwriting the student contact info.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.approveFollowUpRequestFullappApiFollowUpRequestsApprovePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.approveFollowUpRequestFullappApiFollowUpRequestsApprovePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostSchema, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters, TVariables, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, TContext>): UseMutationResult<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Approve Follow Up Request
         * @description Approve a follow-up request, optionally overwriting the student contact info.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const approveFollowUpRequestFullappApiFollowUpRequestsApprovePostTotal = qraft.fullappApiService.approveFollowUpRequestFullappApiFollowUpRequestsApprovePost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const approveFollowUpRequestFullappApiFollowUpRequestsApprovePostTotal = qraft.fullappApiService.approveFollowUpRequestFullappApiFollowUpRequestsApprovePost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, TContext> | MutationFiltersByMutationKey<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostSchema, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Approve Follow Up Request
         * @description Approve a follow-up request, optionally overwriting the student contact info.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const approveFollowUpRequestFullappApiFollowUpRequestsApprovePostPendingMutationVariables = qraft.fullappApiService.approveFollowUpRequestFullappApiFollowUpRequestsApprovePost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const approveFollowUpRequestFullappApiFollowUpRequestsApprovePostMutationData = qraft.fullappApiService.approveFollowUpRequestFullappApiFollowUpRequestsApprovePost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, MutationVariables<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, TContext> | MutationFiltersByMutationKey<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostSchema, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, TContext>;
            select?: (mutation: Mutation<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, MutationVariables<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Approve Follow Up Request
         * @description Approve a follow-up request, optionally overwriting the student contact info.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, TContext> | MutationFiltersByMutationKey<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostSchema, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Approve Follow Up Request
         * @description Approve a follow-up request, optionally overwriting the student contact info.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.approveFollowUpRequestFullappApiFollowUpRequestsApprovePost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.approveFollowUpRequestFullappApiFollowUpRequestsApprovePost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, TContext> | MutationFiltersByMutationKey<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostSchema, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, TContext>): Mutation<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError, MutationVariables<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, TContext> | MutationFiltersByMutationKey<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostSchema, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters, OperationError<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError>, TContext>): Array<Mutation<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError, MutationVariables<ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody, ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters>, TContext>>;
        };
        schema: ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostSchema;
        types: {
            parameters: ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters;
            data: ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData;
            error: ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError;
            body: ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody;
        };
    };
    /**
     * @summary Reject Follow Up Request
     * @description Reject a follow-up request with a free-text reason.
     *
     * Student-owner only: ownership is ``row.student_id == auth user``. Order: validate
     * id+reason -> 404 not-found -> 403 forbidden (already rejected, BEFORE ownership)
     * -> 403 invalid_ownership -> mutate + emit.
     *
     * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
     * ``detail``/``success``, nested ``validations``) is preserved rather than buried
     * under the app-wide ``{"data": ...}`` exception wrapper.
     */
    rejectFollowUpRequestFullappApiFollowUpRequestsRejectPost: {
        /**
         * @summary Reject Follow Up Request
         * @description Reject a follow-up request with a free-text reason.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``. Order: validate
         * id+reason -> 404 not-found -> 403 forbidden (already rejected, BEFORE ownership)
         * -> 403 invalid_ownership -> mutate + emit.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters, TMeta, TSignal>, client?: (schema: RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostSchema, options: ServiceOperationMutationFnOptions<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>>): Promise<RequestFnResponse<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>>;
        /**
         * @summary Reject Follow Up Request
         * @description Reject a follow-up request with a free-text reason.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``. Order: validate
         * id+reason -> 404 not-found -> 403 forbidden (already rejected, BEFORE ownership)
         * -> 403 invalid_ownership -> mutate + emit.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         */
        getMutationKey(parameters: DeepReadonly<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters> | void): ServiceOperationMutationKey<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostSchema, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Reject Follow Up Request
         * @description Reject a follow-up request with a free-text reason.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``. Order: validate
         * id+reason -> 404 not-found -> 403 forbidden (already rejected, BEFORE ownership)
         * -> 403 invalid_ownership -> mutate + emit.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.rejectFollowUpRequestFullappApiFollowUpRequestsRejectPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.rejectFollowUpRequestFullappApiFollowUpRequestsRejectPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, TContext = unknown>(parameters: DeepReadonly<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters>, options?: ServiceOperationUseMutationOptions<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostSchema, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters, TVariables, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, TContext>): UseMutationResult<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Reject Follow Up Request
         * @description Reject a follow-up request with a free-text reason.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``. Order: validate
         * id+reason -> 404 not-found -> 403 forbidden (already rejected, BEFORE ownership)
         * -> 403 invalid_ownership -> mutate + emit.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.rejectFollowUpRequestFullappApiFollowUpRequestsRejectPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.rejectFollowUpRequestFullappApiFollowUpRequestsRejectPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostSchema, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters, TVariables, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, TContext>): UseMutationResult<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Reject Follow Up Request
         * @description Reject a follow-up request with a free-text reason.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``. Order: validate
         * id+reason -> 404 not-found -> 403 forbidden (already rejected, BEFORE ownership)
         * -> 403 invalid_ownership -> mutate + emit.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const rejectFollowUpRequestFullappApiFollowUpRequestsRejectPostTotal = qraft.fullappApiService.rejectFollowUpRequestFullappApiFollowUpRequestsRejectPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const rejectFollowUpRequestFullappApiFollowUpRequestsRejectPostTotal = qraft.fullappApiService.rejectFollowUpRequestFullappApiFollowUpRequestsRejectPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostSchema, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Reject Follow Up Request
         * @description Reject a follow-up request with a free-text reason.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``. Order: validate
         * id+reason -> 404 not-found -> 403 forbidden (already rejected, BEFORE ownership)
         * -> 403 invalid_ownership -> mutate + emit.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const rejectFollowUpRequestFullappApiFollowUpRequestsRejectPostPendingMutationVariables = qraft.fullappApiService.rejectFollowUpRequestFullappApiFollowUpRequestsRejectPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const rejectFollowUpRequestFullappApiFollowUpRequestsRejectPostMutationData = qraft.fullappApiService.rejectFollowUpRequestFullappApiFollowUpRequestsRejectPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, MutationVariables<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostSchema, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, TContext>;
            select?: (mutation: Mutation<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, MutationVariables<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Reject Follow Up Request
         * @description Reject a follow-up request with a free-text reason.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``. Order: validate
         * id+reason -> 404 not-found -> 403 forbidden (already rejected, BEFORE ownership)
         * -> 403 invalid_ownership -> mutate + emit.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostSchema, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Reject Follow Up Request
         * @description Reject a follow-up request with a free-text reason.
         *
         * Student-owner only: ownership is ``row.student_id == auth user``. Order: validate
         * id+reason -> 404 not-found -> 403 forbidden (already rejected, BEFORE ownership)
         * -> 403 invalid_ownership -> mutate + emit.
         *
         * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
         * ``detail``/``success``, nested ``validations``) is preserved rather than buried
         * under the app-wide ``{"data": ...}`` exception wrapper.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.rejectFollowUpRequestFullappApiFollowUpRequestsRejectPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.rejectFollowUpRequestFullappApiFollowUpRequestsRejectPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostSchema, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, TContext>): Mutation<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError, MutationVariables<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, TContext> | MutationFiltersByMutationKey<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostSchema, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters, OperationError<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError>, TContext>): Array<Mutation<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError, MutationVariables<RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody, RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters>, TContext>>;
        };
        schema: RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostSchema;
        types: {
            parameters: RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters;
            data: RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData;
            error: RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError;
            body: RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody;
        };
    };
    /**
     * @summary Send
     * @description Send an encouragement to a student on the open board.
     *
     * Flow: caller-type guard (student rejected) -> required-field validation (433
     * ``validation_error``; only null is rejected) -> resolve target student -> four
     * eligibility gates (all 403 ``forbidden``: postal, already adopted, already
     * encouraged by this SH, fully encouraged at cap 3) -> 1500 plain-text char limit
     * (422 ``character_exceeded``) -> format + insert + flip ``fully_encouraged`` at
     * the cap + persist the drip ``scheduled_email_at``.
     *
     * The app discards the response body; only 2xx-vs-error is load-bearing.
     */
    sendFullappApiEncouragementsSendPost: {
        /**
         * @summary Send
         * @description Send an encouragement to a student on the open board.
         *
         * Flow: caller-type guard (student rejected) -> required-field validation (433
         * ``validation_error``; only null is rejected) -> resolve target student -> four
         * eligibility gates (all 403 ``forbidden``: postal, already adopted, already
         * encouraged by this SH, fully encouraged at cap 3) -> 1500 plain-text char limit
         * (422 ``character_exceeded``) -> format + insert + flip ``fully_encouraged`` at
         * the cap + persist the drip ``scheduled_email_at``.
         *
         * The app discards the response body; only 2xx-vs-error is load-bearing.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostParameters, TMeta, TSignal>, client?: (schema: SendFullappApiEncouragementsSendPostSchema, options: ServiceOperationMutationFnOptions<SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostError>>): Promise<RequestFnResponse<SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostError>>;
        /**
         * @summary Send
         * @description Send an encouragement to a student on the open board.
         *
         * Flow: caller-type guard (student rejected) -> required-field validation (433
         * ``validation_error``; only null is rejected) -> resolve target student -> four
         * eligibility gates (all 403 ``forbidden``: postal, already adopted, already
         * encouraged by this SH, fully encouraged at cap 3) -> 1500 plain-text char limit
         * (422 ``character_exceeded``) -> format + insert + flip ``fully_encouraged`` at
         * the cap + persist the drip ``scheduled_email_at``.
         *
         * The app discards the response body; only 2xx-vs-error is load-bearing.
         */
        getMutationKey(parameters: DeepReadonly<SendFullappApiEncouragementsSendPostParameters> | void): ServiceOperationMutationKey<SendFullappApiEncouragementsSendPostSchema, SendFullappApiEncouragementsSendPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Send
         * @description Send an encouragement to a student on the open board.
         *
         * Flow: caller-type guard (student rejected) -> required-field validation (433
         * ``validation_error``; only null is rejected) -> resolve target student -> four
         * eligibility gates (all 403 ``forbidden``: postal, already adopted, already
         * encouraged by this SH, fully encouraged at cap 3) -> 1500 plain-text char limit
         * (422 ``character_exceeded``) -> format + insert + flip ``fully_encouraged`` at
         * the cap + persist the drip ``scheduled_email_at``.
         *
         * The app discards the response body; only 2xx-vs-error is load-bearing.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.sendFullappApiEncouragementsSendPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.sendFullappApiEncouragementsSendPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SendFullappApiEncouragementsSendPostBody, TContext = unknown>(parameters: DeepReadonly<SendFullappApiEncouragementsSendPostParameters>, options?: ServiceOperationUseMutationOptions<SendFullappApiEncouragementsSendPostSchema, SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostParameters, TVariables, OperationError<SendFullappApiEncouragementsSendPostError>, TContext>): UseMutationResult<SendFullappApiEncouragementsSendPostData, OperationError<SendFullappApiEncouragementsSendPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Send
         * @description Send an encouragement to a student on the open board.
         *
         * Flow: caller-type guard (student rejected) -> required-field validation (433
         * ``validation_error``; only null is rejected) -> resolve target student -> four
         * eligibility gates (all 403 ``forbidden``: postal, already adopted, already
         * encouraged by this SH, fully encouraged at cap 3) -> 1500 plain-text char limit
         * (422 ``character_exceeded``) -> format + insert + flip ``fully_encouraged`` at
         * the cap + persist the drip ``scheduled_email_at``.
         *
         * The app discards the response body; only 2xx-vs-error is load-bearing.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.sendFullappApiEncouragementsSendPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.sendFullappApiEncouragementsSendPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SendFullappApiEncouragementsSendPostSchema, SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostParameters, TVariables, OperationError<SendFullappApiEncouragementsSendPostError>, TContext>): UseMutationResult<SendFullappApiEncouragementsSendPostData, OperationError<SendFullappApiEncouragementsSendPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Send
         * @description Send an encouragement to a student on the open board.
         *
         * Flow: caller-type guard (student rejected) -> required-field validation (433
         * ``validation_error``; only null is rejected) -> resolve target student -> four
         * eligibility gates (all 403 ``forbidden``: postal, already adopted, already
         * encouraged by this SH, fully encouraged at cap 3) -> 1500 plain-text char limit
         * (422 ``character_exceeded``) -> format + insert + flip ``fully_encouraged`` at
         * the cap + persist the drip ``scheduled_email_at``.
         *
         * The app discards the response body; only 2xx-vs-error is load-bearing.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const sendFullappApiEncouragementsSendPostTotal = qraft.fullappApiService.sendFullappApiEncouragementsSendPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const sendFullappApiEncouragementsSendPostTotal = qraft.fullappApiService.sendFullappApiEncouragementsSendPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostParameters, OperationError<SendFullappApiEncouragementsSendPostError>, TContext> | MutationFiltersByMutationKey<SendFullappApiEncouragementsSendPostSchema, SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostParameters, OperationError<SendFullappApiEncouragementsSendPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Send
         * @description Send an encouragement to a student on the open board.
         *
         * Flow: caller-type guard (student rejected) -> required-field validation (433
         * ``validation_error``; only null is rejected) -> resolve target student -> four
         * eligibility gates (all 403 ``forbidden``: postal, already adopted, already
         * encouraged by this SH, fully encouraged at cap 3) -> 1500 plain-text char limit
         * (422 ``character_exceeded``) -> format + insert + flip ``fully_encouraged`` at
         * the cap + persist the drip ``scheduled_email_at``.
         *
         * The app discards the response body; only 2xx-vs-error is load-bearing.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const sendFullappApiEncouragementsSendPostPendingMutationVariables = qraft.fullappApiService.sendFullappApiEncouragementsSendPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const sendFullappApiEncouragementsSendPostMutationData = qraft.fullappApiService.sendFullappApiEncouragementsSendPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SendFullappApiEncouragementsSendPostData, OperationError<SendFullappApiEncouragementsSendPostError>, MutationVariables<SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostParameters, OperationError<SendFullappApiEncouragementsSendPostError>, TContext> | MutationFiltersByMutationKey<SendFullappApiEncouragementsSendPostSchema, SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostParameters, OperationError<SendFullappApiEncouragementsSendPostError>, TContext>;
            select?: (mutation: Mutation<SendFullappApiEncouragementsSendPostData, OperationError<SendFullappApiEncouragementsSendPostError>, MutationVariables<SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Send
         * @description Send an encouragement to a student on the open board.
         *
         * Flow: caller-type guard (student rejected) -> required-field validation (433
         * ``validation_error``; only null is rejected) -> resolve target student -> four
         * eligibility gates (all 403 ``forbidden``: postal, already adopted, already
         * encouraged by this SH, fully encouraged at cap 3) -> 1500 plain-text char limit
         * (422 ``character_exceeded``) -> format + insert + flip ``fully_encouraged`` at
         * the cap + persist the drip ``scheduled_email_at``.
         *
         * The app discards the response body; only 2xx-vs-error is load-bearing.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostParameters, OperationError<SendFullappApiEncouragementsSendPostError>, TContext> | MutationFiltersByMutationKey<SendFullappApiEncouragementsSendPostSchema, SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostParameters, OperationError<SendFullappApiEncouragementsSendPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Send
         * @description Send an encouragement to a student on the open board.
         *
         * Flow: caller-type guard (student rejected) -> required-field validation (433
         * ``validation_error``; only null is rejected) -> resolve target student -> four
         * eligibility gates (all 403 ``forbidden``: postal, already adopted, already
         * encouraged by this SH, fully encouraged at cap 3) -> 1500 plain-text char limit
         * (422 ``character_exceeded``) -> format + insert + flip ``fully_encouraged`` at
         * the cap + persist the drip ``scheduled_email_at``.
         *
         * The app discards the response body; only 2xx-vs-error is load-bearing.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.sendFullappApiEncouragementsSendPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.sendFullappApiEncouragementsSendPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostParameters, OperationError<SendFullappApiEncouragementsSendPostError>, TContext> | MutationFiltersByMutationKey<SendFullappApiEncouragementsSendPostSchema, SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostParameters, OperationError<SendFullappApiEncouragementsSendPostError>, TContext>): Mutation<SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostError, MutationVariables<SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostParameters, OperationError<SendFullappApiEncouragementsSendPostError>, TContext> | MutationFiltersByMutationKey<SendFullappApiEncouragementsSendPostSchema, SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostParameters, OperationError<SendFullappApiEncouragementsSendPostError>, TContext>): Array<Mutation<SendFullappApiEncouragementsSendPostData, SendFullappApiEncouragementsSendPostError, MutationVariables<SendFullappApiEncouragementsSendPostBody, SendFullappApiEncouragementsSendPostParameters>, TContext>>;
        };
        schema: SendFullappApiEncouragementsSendPostSchema;
        types: {
            parameters: SendFullappApiEncouragementsSendPostParameters;
            data: SendFullappApiEncouragementsSendPostData;
            error: SendFullappApiEncouragementsSendPostError;
            body: SendFullappApiEncouragementsSendPostBody;
        };
    };
    /**
     * @summary Send Introduction
     * @description Send an introduction. SH-only; gates run in order:
     *
     *   1. missing/null user_id or introduction -> 433 validation_error. '' / 0 pass
     *      and fall through: introduction:'' -> empty content -> 500; user_id:0 /
     *      nonexistent / unadopted -> ownership 403 (never 404).
     *   2. postal-type target -> 403, checked BEFORE ownership.
     *   3. ownership: auth SH must be the student's study_helper -> else 403.
     *   4. already-introduced is PER-CURRENT-SH: 403 only if THIS SH already introduced.
     *      A re-adopted student introduced by a different SH is NOT blocked.
     *
     * The introduction-specific notification/activity flow is unmodeled and deferred.
     * The app discards the response body; success-vs-error is the only load-bearing bit.
     */
    sendIntroductionFullappApiIntroductionsSendPost: {
        /**
         * @summary Send Introduction
         * @description Send an introduction. SH-only; gates run in order:
         *
         *   1. missing/null user_id or introduction -> 433 validation_error. '' / 0 pass
         *      and fall through: introduction:'' -> empty content -> 500; user_id:0 /
         *      nonexistent / unadopted -> ownership 403 (never 404).
         *   2. postal-type target -> 403, checked BEFORE ownership.
         *   3. ownership: auth SH must be the student's study_helper -> else 403.
         *   4. already-introduced is PER-CURRENT-SH: 403 only if THIS SH already introduced.
         *      A re-adopted student introduced by a different SH is NOT blocked.
         *
         * The introduction-specific notification/activity flow is unmodeled and deferred.
         * The app discards the response body; success-vs-error is the only load-bearing bit.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostParameters, TMeta, TSignal>, client?: (schema: SendIntroductionFullappApiIntroductionsSendPostSchema, options: ServiceOperationMutationFnOptions<SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostError>>): Promise<RequestFnResponse<SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostError>>;
        /**
         * @summary Send Introduction
         * @description Send an introduction. SH-only; gates run in order:
         *
         *   1. missing/null user_id or introduction -> 433 validation_error. '' / 0 pass
         *      and fall through: introduction:'' -> empty content -> 500; user_id:0 /
         *      nonexistent / unadopted -> ownership 403 (never 404).
         *   2. postal-type target -> 403, checked BEFORE ownership.
         *   3. ownership: auth SH must be the student's study_helper -> else 403.
         *   4. already-introduced is PER-CURRENT-SH: 403 only if THIS SH already introduced.
         *      A re-adopted student introduced by a different SH is NOT blocked.
         *
         * The introduction-specific notification/activity flow is unmodeled and deferred.
         * The app discards the response body; success-vs-error is the only load-bearing bit.
         */
        getMutationKey(parameters: DeepReadonly<SendIntroductionFullappApiIntroductionsSendPostParameters> | void): ServiceOperationMutationKey<SendIntroductionFullappApiIntroductionsSendPostSchema, SendIntroductionFullappApiIntroductionsSendPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Send Introduction
         * @description Send an introduction. SH-only; gates run in order:
         *
         *   1. missing/null user_id or introduction -> 433 validation_error. '' / 0 pass
         *      and fall through: introduction:'' -> empty content -> 500; user_id:0 /
         *      nonexistent / unadopted -> ownership 403 (never 404).
         *   2. postal-type target -> 403, checked BEFORE ownership.
         *   3. ownership: auth SH must be the student's study_helper -> else 403.
         *   4. already-introduced is PER-CURRENT-SH: 403 only if THIS SH already introduced.
         *      A re-adopted student introduced by a different SH is NOT blocked.
         *
         * The introduction-specific notification/activity flow is unmodeled and deferred.
         * The app discards the response body; success-vs-error is the only load-bearing bit.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.sendIntroductionFullappApiIntroductionsSendPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.sendIntroductionFullappApiIntroductionsSendPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SendIntroductionFullappApiIntroductionsSendPostBody, TContext = unknown>(parameters: DeepReadonly<SendIntroductionFullappApiIntroductionsSendPostParameters>, options?: ServiceOperationUseMutationOptions<SendIntroductionFullappApiIntroductionsSendPostSchema, SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostParameters, TVariables, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, TContext>): UseMutationResult<SendIntroductionFullappApiIntroductionsSendPostData, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Send Introduction
         * @description Send an introduction. SH-only; gates run in order:
         *
         *   1. missing/null user_id or introduction -> 433 validation_error. '' / 0 pass
         *      and fall through: introduction:'' -> empty content -> 500; user_id:0 /
         *      nonexistent / unadopted -> ownership 403 (never 404).
         *   2. postal-type target -> 403, checked BEFORE ownership.
         *   3. ownership: auth SH must be the student's study_helper -> else 403.
         *   4. already-introduced is PER-CURRENT-SH: 403 only if THIS SH already introduced.
         *      A re-adopted student introduced by a different SH is NOT blocked.
         *
         * The introduction-specific notification/activity flow is unmodeled and deferred.
         * The app discards the response body; success-vs-error is the only load-bearing bit.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.sendIntroductionFullappApiIntroductionsSendPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.sendIntroductionFullappApiIntroductionsSendPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SendIntroductionFullappApiIntroductionsSendPostSchema, SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostParameters, TVariables, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, TContext>): UseMutationResult<SendIntroductionFullappApiIntroductionsSendPostData, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Send Introduction
         * @description Send an introduction. SH-only; gates run in order:
         *
         *   1. missing/null user_id or introduction -> 433 validation_error. '' / 0 pass
         *      and fall through: introduction:'' -> empty content -> 500; user_id:0 /
         *      nonexistent / unadopted -> ownership 403 (never 404).
         *   2. postal-type target -> 403, checked BEFORE ownership.
         *   3. ownership: auth SH must be the student's study_helper -> else 403.
         *   4. already-introduced is PER-CURRENT-SH: 403 only if THIS SH already introduced.
         *      A re-adopted student introduced by a different SH is NOT blocked.
         *
         * The introduction-specific notification/activity flow is unmodeled and deferred.
         * The app discards the response body; success-vs-error is the only load-bearing bit.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const sendIntroductionFullappApiIntroductionsSendPostTotal = qraft.fullappApiService.sendIntroductionFullappApiIntroductionsSendPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const sendIntroductionFullappApiIntroductionsSendPostTotal = qraft.fullappApiService.sendIntroductionFullappApiIntroductionsSendPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostParameters, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, TContext> | MutationFiltersByMutationKey<SendIntroductionFullappApiIntroductionsSendPostSchema, SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostParameters, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Send Introduction
         * @description Send an introduction. SH-only; gates run in order:
         *
         *   1. missing/null user_id or introduction -> 433 validation_error. '' / 0 pass
         *      and fall through: introduction:'' -> empty content -> 500; user_id:0 /
         *      nonexistent / unadopted -> ownership 403 (never 404).
         *   2. postal-type target -> 403, checked BEFORE ownership.
         *   3. ownership: auth SH must be the student's study_helper -> else 403.
         *   4. already-introduced is PER-CURRENT-SH: 403 only if THIS SH already introduced.
         *      A re-adopted student introduced by a different SH is NOT blocked.
         *
         * The introduction-specific notification/activity flow is unmodeled and deferred.
         * The app discards the response body; success-vs-error is the only load-bearing bit.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const sendIntroductionFullappApiIntroductionsSendPostPendingMutationVariables = qraft.fullappApiService.sendIntroductionFullappApiIntroductionsSendPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const sendIntroductionFullappApiIntroductionsSendPostMutationData = qraft.fullappApiService.sendIntroductionFullappApiIntroductionsSendPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SendIntroductionFullappApiIntroductionsSendPostData, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, MutationVariables<SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostParameters, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, TContext> | MutationFiltersByMutationKey<SendIntroductionFullappApiIntroductionsSendPostSchema, SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostParameters, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, TContext>;
            select?: (mutation: Mutation<SendIntroductionFullappApiIntroductionsSendPostData, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, MutationVariables<SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Send Introduction
         * @description Send an introduction. SH-only; gates run in order:
         *
         *   1. missing/null user_id or introduction -> 433 validation_error. '' / 0 pass
         *      and fall through: introduction:'' -> empty content -> 500; user_id:0 /
         *      nonexistent / unadopted -> ownership 403 (never 404).
         *   2. postal-type target -> 403, checked BEFORE ownership.
         *   3. ownership: auth SH must be the student's study_helper -> else 403.
         *   4. already-introduced is PER-CURRENT-SH: 403 only if THIS SH already introduced.
         *      A re-adopted student introduced by a different SH is NOT blocked.
         *
         * The introduction-specific notification/activity flow is unmodeled and deferred.
         * The app discards the response body; success-vs-error is the only load-bearing bit.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostParameters, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, TContext> | MutationFiltersByMutationKey<SendIntroductionFullappApiIntroductionsSendPostSchema, SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostParameters, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Send Introduction
         * @description Send an introduction. SH-only; gates run in order:
         *
         *   1. missing/null user_id or introduction -> 433 validation_error. '' / 0 pass
         *      and fall through: introduction:'' -> empty content -> 500; user_id:0 /
         *      nonexistent / unadopted -> ownership 403 (never 404).
         *   2. postal-type target -> 403, checked BEFORE ownership.
         *   3. ownership: auth SH must be the student's study_helper -> else 403.
         *   4. already-introduced is PER-CURRENT-SH: 403 only if THIS SH already introduced.
         *      A re-adopted student introduced by a different SH is NOT blocked.
         *
         * The introduction-specific notification/activity flow is unmodeled and deferred.
         * The app discards the response body; success-vs-error is the only load-bearing bit.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.sendIntroductionFullappApiIntroductionsSendPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.sendIntroductionFullappApiIntroductionsSendPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostParameters, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, TContext> | MutationFiltersByMutationKey<SendIntroductionFullappApiIntroductionsSendPostSchema, SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostParameters, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, TContext>): Mutation<SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostError, MutationVariables<SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostParameters, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, TContext> | MutationFiltersByMutationKey<SendIntroductionFullappApiIntroductionsSendPostSchema, SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostParameters, OperationError<SendIntroductionFullappApiIntroductionsSendPostError>, TContext>): Array<Mutation<SendIntroductionFullappApiIntroductionsSendPostData, SendIntroductionFullappApiIntroductionsSendPostError, MutationVariables<SendIntroductionFullappApiIntroductionsSendPostBody, SendIntroductionFullappApiIntroductionsSendPostParameters>, TContext>>;
        };
        schema: SendIntroductionFullappApiIntroductionsSendPostSchema;
        types: {
            parameters: SendIntroductionFullappApiIntroductionsSendPostParameters;
            data: SendIntroductionFullappApiIntroductionsSendPostData;
            error: SendIntroductionFullappApiIntroductionsSendPostError;
            body: SendIntroductionFullappApiIntroductionsSendPostBody;
        };
    };
    /**
     * @summary Send
     * @description Send a contact-support email.
     *
     * Pure side-effect endpoint: NOT role-sensitive; the auth user is whoever is
     * logged in and the request ``user_id`` is only cosmetic body text.
     *
     * Validate name/email/message present-and-non-blank (else 433
     * ``validation_error``), build a plain-text support email, and send. A falsy send
     * or transport exception surfaces as ``application_error`` (HTTP 404). On success:
     * ``{success:true, data:[]}``.
     */
    sendFullappApiContactSendPost: {
        /**
         * @summary Send
         * @description Send a contact-support email.
         *
         * Pure side-effect endpoint: NOT role-sensitive; the auth user is whoever is
         * logged in and the request ``user_id`` is only cosmetic body text.
         *
         * Validate name/email/message present-and-non-blank (else 433
         * ``validation_error``), build a plain-text support email, and send. A falsy send
         * or transport exception surfaces as ``application_error`` (HTTP 404). On success:
         * ``{success:true, data:[]}``.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SendFullappApiContactSendPostBody, SendFullappApiContactSendPostParameters, TMeta, TSignal>, client?: (schema: SendFullappApiContactSendPostSchema, options: ServiceOperationMutationFnOptions<SendFullappApiContactSendPostBody, SendFullappApiContactSendPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SendFullappApiContactSendPostData, SendFullappApiContactSendPostError>>): Promise<RequestFnResponse<SendFullappApiContactSendPostData, SendFullappApiContactSendPostError>>;
        /**
         * @summary Send
         * @description Send a contact-support email.
         *
         * Pure side-effect endpoint: NOT role-sensitive; the auth user is whoever is
         * logged in and the request ``user_id`` is only cosmetic body text.
         *
         * Validate name/email/message present-and-non-blank (else 433
         * ``validation_error``), build a plain-text support email, and send. A falsy send
         * or transport exception surfaces as ``application_error`` (HTTP 404). On success:
         * ``{success:true, data:[]}``.
         */
        getMutationKey(parameters: DeepReadonly<SendFullappApiContactSendPostParameters> | void): ServiceOperationMutationKey<SendFullappApiContactSendPostSchema, SendFullappApiContactSendPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Send
         * @description Send a contact-support email.
         *
         * Pure side-effect endpoint: NOT role-sensitive; the auth user is whoever is
         * logged in and the request ``user_id`` is only cosmetic body text.
         *
         * Validate name/email/message present-and-non-blank (else 433
         * ``validation_error``), build a plain-text support email, and send. A falsy send
         * or transport exception surfaces as ``application_error`` (HTTP 404). On success:
         * ``{success:true, data:[]}``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.sendFullappApiContactSendPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.sendFullappApiContactSendPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends SendFullappApiContactSendPostBody, TContext = unknown>(parameters: DeepReadonly<SendFullappApiContactSendPostParameters>, options?: ServiceOperationUseMutationOptions<SendFullappApiContactSendPostSchema, SendFullappApiContactSendPostData, SendFullappApiContactSendPostParameters, TVariables, OperationError<SendFullappApiContactSendPostError>, TContext>): UseMutationResult<SendFullappApiContactSendPostData, OperationError<SendFullappApiContactSendPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Send
         * @description Send a contact-support email.
         *
         * Pure side-effect endpoint: NOT role-sensitive; the auth user is whoever is
         * logged in and the request ``user_id`` is only cosmetic body text.
         *
         * Validate name/email/message present-and-non-blank (else 433
         * ``validation_error``), build a plain-text support email, and send. A falsy send
         * or transport exception surfaces as ``application_error`` (HTTP 404). On success:
         * ``{success:true, data:[]}``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.sendFullappApiContactSendPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.sendFullappApiContactSendPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SendFullappApiContactSendPostBody, SendFullappApiContactSendPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SendFullappApiContactSendPostSchema, SendFullappApiContactSendPostData, SendFullappApiContactSendPostParameters, TVariables, OperationError<SendFullappApiContactSendPostError>, TContext>): UseMutationResult<SendFullappApiContactSendPostData, OperationError<SendFullappApiContactSendPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Send
         * @description Send a contact-support email.
         *
         * Pure side-effect endpoint: NOT role-sensitive; the auth user is whoever is
         * logged in and the request ``user_id`` is only cosmetic body text.
         *
         * Validate name/email/message present-and-non-blank (else 433
         * ``validation_error``), build a plain-text support email, and send. A falsy send
         * or transport exception surfaces as ``application_error`` (HTTP 404). On success:
         * ``{success:true, data:[]}``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const sendFullappApiContactSendPostTotal = qraft.fullappApiService.sendFullappApiContactSendPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const sendFullappApiContactSendPostTotal = qraft.fullappApiService.sendFullappApiContactSendPost.useIsMutating({
         *     parameters: {}
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SendFullappApiContactSendPostBody, SendFullappApiContactSendPostData, SendFullappApiContactSendPostParameters, OperationError<SendFullappApiContactSendPostError>, TContext> | MutationFiltersByMutationKey<SendFullappApiContactSendPostSchema, SendFullappApiContactSendPostBody, SendFullappApiContactSendPostData, SendFullappApiContactSendPostParameters, OperationError<SendFullappApiContactSendPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Send
         * @description Send a contact-support email.
         *
         * Pure side-effect endpoint: NOT role-sensitive; the auth user is whoever is
         * logged in and the request ``user_id`` is only cosmetic body text.
         *
         * Validate name/email/message present-and-non-blank (else 433
         * ``validation_error``), build a plain-text support email, and send. A falsy send
         * or transport exception surfaces as ``application_error`` (HTTP 404). On success:
         * ``{success:true, data:[]}``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const sendFullappApiContactSendPostPendingMutationVariables = qraft.fullappApiService.sendFullappApiContactSendPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const sendFullappApiContactSendPostMutationData = qraft.fullappApiService.sendFullappApiContactSendPost.useMutationState({
         *     filters: {
         *         parameters: {}
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SendFullappApiContactSendPostData, OperationError<SendFullappApiContactSendPostError>, MutationVariables<SendFullappApiContactSendPostBody, SendFullappApiContactSendPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SendFullappApiContactSendPostBody, SendFullappApiContactSendPostData, SendFullappApiContactSendPostParameters, OperationError<SendFullappApiContactSendPostError>, TContext> | MutationFiltersByMutationKey<SendFullappApiContactSendPostSchema, SendFullappApiContactSendPostBody, SendFullappApiContactSendPostData, SendFullappApiContactSendPostParameters, OperationError<SendFullappApiContactSendPostError>, TContext>;
            select?: (mutation: Mutation<SendFullappApiContactSendPostData, OperationError<SendFullappApiContactSendPostError>, MutationVariables<SendFullappApiContactSendPostBody, SendFullappApiContactSendPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Send
         * @description Send a contact-support email.
         *
         * Pure side-effect endpoint: NOT role-sensitive; the auth user is whoever is
         * logged in and the request ``user_id`` is only cosmetic body text.
         *
         * Validate name/email/message present-and-non-blank (else 433
         * ``validation_error``), build a plain-text support email, and send. A falsy send
         * or transport exception surfaces as ``application_error`` (HTTP 404). On success:
         * ``{success:true, data:[]}``.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SendFullappApiContactSendPostBody, SendFullappApiContactSendPostData, SendFullappApiContactSendPostParameters, OperationError<SendFullappApiContactSendPostError>, TContext> | MutationFiltersByMutationKey<SendFullappApiContactSendPostSchema, SendFullappApiContactSendPostBody, SendFullappApiContactSendPostData, SendFullappApiContactSendPostParameters, OperationError<SendFullappApiContactSendPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Send
         * @description Send a contact-support email.
         *
         * Pure side-effect endpoint: NOT role-sensitive; the auth user is whoever is
         * logged in and the request ``user_id`` is only cosmetic body text.
         *
         * Validate name/email/message present-and-non-blank (else 433
         * ``validation_error``), build a plain-text support email, and send. A falsy send
         * or transport exception surfaces as ``application_error`` (HTTP 404). On success:
         * ``{success:true, data:[]}``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.sendFullappApiContactSendPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {}
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.sendFullappApiContactSendPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SendFullappApiContactSendPostBody, SendFullappApiContactSendPostData, SendFullappApiContactSendPostParameters, OperationError<SendFullappApiContactSendPostError>, TContext> | MutationFiltersByMutationKey<SendFullappApiContactSendPostSchema, SendFullappApiContactSendPostBody, SendFullappApiContactSendPostData, SendFullappApiContactSendPostParameters, OperationError<SendFullappApiContactSendPostError>, TContext>): Mutation<SendFullappApiContactSendPostData, SendFullappApiContactSendPostError, MutationVariables<SendFullappApiContactSendPostBody, SendFullappApiContactSendPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SendFullappApiContactSendPostBody, SendFullappApiContactSendPostData, SendFullappApiContactSendPostParameters, OperationError<SendFullappApiContactSendPostError>, TContext> | MutationFiltersByMutationKey<SendFullappApiContactSendPostSchema, SendFullappApiContactSendPostBody, SendFullappApiContactSendPostData, SendFullappApiContactSendPostParameters, OperationError<SendFullappApiContactSendPostError>, TContext>): Array<Mutation<SendFullappApiContactSendPostData, SendFullappApiContactSendPostError, MutationVariables<SendFullappApiContactSendPostBody, SendFullappApiContactSendPostParameters>, TContext>>;
        };
        schema: SendFullappApiContactSendPostSchema;
        types: {
            parameters: SendFullappApiContactSendPostParameters;
            data: SendFullappApiContactSendPostData;
            error: SendFullappApiContactSendPostError;
            body: SendFullappApiContactSendPostBody;
        };
    };
    /**
     * @summary Get Current Study Helper
     * @description Get the current student's assigned study helper info.
     *
     * Students only (legacy ``check_profile_type('students')``); a wrong-role
     * caller -> 403 ``invalid_profile_types``. A student with no assigned study
     * helper -> 404 ``resource_not_found``.
     */
    getCurrentStudyHelperFullappApiStudyHelpersCurrentPost: {
        /**
         * @summary Get Current Study Helper
         * @description Get the current student's assigned study helper info.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. A student with no assigned study
         * helper -> 404 ``resource_not_found``.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters, TMeta, TSignal>, client?: (schema: GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostSchema, options: ServiceOperationMutationFnOptions<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>>): Promise<RequestFnResponse<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>>;
        /**
         * @summary Get Current Study Helper
         * @description Get the current student's assigned study helper info.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. A student with no assigned study
         * helper -> 404 ``resource_not_found``.
         */
        getMutationKey(parameters: DeepReadonly<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters> | void): ServiceOperationMutationKey<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostSchema, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Current Study Helper
         * @description Get the current student's assigned study helper info.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. A student with no assigned study
         * helper -> 404 ``resource_not_found``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getCurrentStudyHelperFullappApiStudyHelpersCurrentPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getCurrentStudyHelperFullappApiStudyHelpersCurrentPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, TContext = unknown>(parameters: DeepReadonly<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters>, options?: ServiceOperationUseMutationOptions<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostSchema, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters, TVariables, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, TContext>): UseMutationResult<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Current Study Helper
         * @description Get the current student's assigned study helper info.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. A student with no assigned study
         * helper -> 404 ``resource_not_found``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getCurrentStudyHelperFullappApiStudyHelpersCurrentPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getCurrentStudyHelperFullappApiStudyHelpersCurrentPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostSchema, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters, TVariables, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, TContext>): UseMutationResult<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Get Current Study Helper
         * @description Get the current student's assigned study helper info.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. A student with no assigned study
         * helper -> 404 ``resource_not_found``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const getCurrentStudyHelperFullappApiStudyHelpersCurrentPostTotal = qraft.fullappApiService.getCurrentStudyHelperFullappApiStudyHelpersCurrentPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const getCurrentStudyHelperFullappApiStudyHelpersCurrentPostTotal = qraft.fullappApiService.getCurrentStudyHelperFullappApiStudyHelpersCurrentPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, TContext> | MutationFiltersByMutationKey<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostSchema, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Get Current Study Helper
         * @description Get the current student's assigned study helper info.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. A student with no assigned study
         * helper -> 404 ``resource_not_found``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const getCurrentStudyHelperFullappApiStudyHelpersCurrentPostPendingMutationVariables = qraft.fullappApiService.getCurrentStudyHelperFullappApiStudyHelpersCurrentPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const getCurrentStudyHelperFullappApiStudyHelpersCurrentPostMutationData = qraft.fullappApiService.getCurrentStudyHelperFullappApiStudyHelpersCurrentPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, MutationVariables<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, TContext> | MutationFiltersByMutationKey<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostSchema, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, TContext>;
            select?: (mutation: Mutation<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, MutationVariables<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Get Current Study Helper
         * @description Get the current student's assigned study helper info.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. A student with no assigned study
         * helper -> 404 ``resource_not_found``.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, TContext> | MutationFiltersByMutationKey<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostSchema, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Get Current Study Helper
         * @description Get the current student's assigned study helper info.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. A student with no assigned study
         * helper -> 404 ``resource_not_found``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.getCurrentStudyHelperFullappApiStudyHelpersCurrentPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.getCurrentStudyHelperFullappApiStudyHelpersCurrentPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, TContext> | MutationFiltersByMutationKey<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostSchema, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, TContext>): Mutation<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError, MutationVariables<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, TContext> | MutationFiltersByMutationKey<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostSchema, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters, OperationError<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError>, TContext>): Array<Mutation<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError, MutationVariables<GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody, GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters>, TContext>>;
        };
        schema: GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostSchema;
        types: {
            parameters: GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters;
            data: GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData;
            error: GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError;
            body: GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody;
        };
    };
    /**
     * @summary Get Study Helper List
     * @description Get the current student's study-helper adoption history.
     *
     * Students only (legacy ``check_profile_type('students')``); a wrong-role
     * caller -> 403 ``invalid_profile_types``. Returns one entry per adoption
     * history row ordered by adoption time.
     */
    getStudyHelperListFullappApiStudyHelpersListPost: {
        /**
         * @summary Get Study Helper List
         * @description Get the current student's study-helper adoption history.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. Returns one entry per adoption
         * history row ordered by adoption time.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostParameters, TMeta, TSignal>, client?: (schema: GetStudyHelperListFullappApiStudyHelpersListPostSchema, options: ServiceOperationMutationFnOptions<GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostError>>): Promise<RequestFnResponse<GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostError>>;
        /**
         * @summary Get Study Helper List
         * @description Get the current student's study-helper adoption history.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. Returns one entry per adoption
         * history row ordered by adoption time.
         */
        getMutationKey(parameters: DeepReadonly<GetStudyHelperListFullappApiStudyHelpersListPostParameters> | void): ServiceOperationMutationKey<GetStudyHelperListFullappApiStudyHelpersListPostSchema, GetStudyHelperListFullappApiStudyHelpersListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Study Helper List
         * @description Get the current student's study-helper adoption history.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. Returns one entry per adoption
         * history row ordered by adoption time.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getStudyHelperListFullappApiStudyHelpersListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getStudyHelperListFullappApiStudyHelpersListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends GetStudyHelperListFullappApiStudyHelpersListPostBody, TContext = unknown>(parameters: DeepReadonly<GetStudyHelperListFullappApiStudyHelpersListPostParameters>, options?: ServiceOperationUseMutationOptions<GetStudyHelperListFullappApiStudyHelpersListPostSchema, GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostParameters, TVariables, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, TContext>): UseMutationResult<GetStudyHelperListFullappApiStudyHelpersListPostData, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Study Helper List
         * @description Get the current student's study-helper adoption history.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. Returns one entry per adoption
         * history row ordered by adoption time.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getStudyHelperListFullappApiStudyHelpersListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getStudyHelperListFullappApiStudyHelpersListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GetStudyHelperListFullappApiStudyHelpersListPostSchema, GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostParameters, TVariables, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, TContext>): UseMutationResult<GetStudyHelperListFullappApiStudyHelpersListPostData, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Get Study Helper List
         * @description Get the current student's study-helper adoption history.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. Returns one entry per adoption
         * history row ordered by adoption time.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const getStudyHelperListFullappApiStudyHelpersListPostTotal = qraft.fullappApiService.getStudyHelperListFullappApiStudyHelpersListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const getStudyHelperListFullappApiStudyHelpersListPostTotal = qraft.fullappApiService.getStudyHelperListFullappApiStudyHelpersListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostParameters, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, TContext> | MutationFiltersByMutationKey<GetStudyHelperListFullappApiStudyHelpersListPostSchema, GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostParameters, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Get Study Helper List
         * @description Get the current student's study-helper adoption history.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. Returns one entry per adoption
         * history row ordered by adoption time.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const getStudyHelperListFullappApiStudyHelpersListPostPendingMutationVariables = qraft.fullappApiService.getStudyHelperListFullappApiStudyHelpersListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const getStudyHelperListFullappApiStudyHelpersListPostMutationData = qraft.fullappApiService.getStudyHelperListFullappApiStudyHelpersListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GetStudyHelperListFullappApiStudyHelpersListPostData, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, MutationVariables<GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostParameters, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, TContext> | MutationFiltersByMutationKey<GetStudyHelperListFullappApiStudyHelpersListPostSchema, GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostParameters, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, TContext>;
            select?: (mutation: Mutation<GetStudyHelperListFullappApiStudyHelpersListPostData, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, MutationVariables<GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Get Study Helper List
         * @description Get the current student's study-helper adoption history.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. Returns one entry per adoption
         * history row ordered by adoption time.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostParameters, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, TContext> | MutationFiltersByMutationKey<GetStudyHelperListFullappApiStudyHelpersListPostSchema, GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostParameters, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Get Study Helper List
         * @description Get the current student's study-helper adoption history.
         *
         * Students only (legacy ``check_profile_type('students')``); a wrong-role
         * caller -> 403 ``invalid_profile_types``. Returns one entry per adoption
         * history row ordered by adoption time.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.getStudyHelperListFullappApiStudyHelpersListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.getStudyHelperListFullappApiStudyHelpersListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostParameters, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, TContext> | MutationFiltersByMutationKey<GetStudyHelperListFullappApiStudyHelpersListPostSchema, GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostParameters, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, TContext>): Mutation<GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostError, MutationVariables<GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostParameters, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, TContext> | MutationFiltersByMutationKey<GetStudyHelperListFullappApiStudyHelpersListPostSchema, GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostParameters, OperationError<GetStudyHelperListFullappApiStudyHelpersListPostError>, TContext>): Array<Mutation<GetStudyHelperListFullappApiStudyHelpersListPostData, GetStudyHelperListFullappApiStudyHelpersListPostError, MutationVariables<GetStudyHelperListFullappApiStudyHelpersListPostBody, GetStudyHelperListFullappApiStudyHelpersListPostParameters>, TContext>>;
        };
        schema: GetStudyHelperListFullappApiStudyHelpersListPostSchema;
        types: {
            parameters: GetStudyHelperListFullappApiStudyHelpersListPostParameters;
            data: GetStudyHelperListFullappApiStudyHelpersListPostData;
            error: GetStudyHelperListFullappApiStudyHelpersListPostError;
            body: GetStudyHelperListFullappApiStudyHelpersListPostBody;
        };
    };
    /**
     * @summary Fetch
     * @description POST /search/fetch.
     *
     * No SH-impersonation / user_id path: search operates on the authenticated user
     * only (the course activity gate hardcodes the auth user).
     */
    fetchFullappApiSearchFetchPost: {
        /**
         * @summary Fetch
         * @description POST /search/fetch.
         *
         * No SH-impersonation / user_id path: search operates on the authenticated user
         * only (the course activity gate hardcodes the auth user).
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostParameters, TMeta, TSignal>, client?: (schema: FetchFullappApiSearchFetchPostSchema, options: ServiceOperationMutationFnOptions<FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostError>>): Promise<RequestFnResponse<FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostError>>;
        /**
         * @summary Fetch
         * @description POST /search/fetch.
         *
         * No SH-impersonation / user_id path: search operates on the authenticated user
         * only (the course activity gate hardcodes the auth user).
         */
        getMutationKey(parameters: DeepReadonly<FetchFullappApiSearchFetchPostParameters> | void): ServiceOperationMutationKey<FetchFullappApiSearchFetchPostSchema, FetchFullappApiSearchFetchPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fetch
         * @description POST /search/fetch.
         *
         * No SH-impersonation / user_id path: search operates on the authenticated user
         * only (the course activity gate hardcodes the auth user).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchFullappApiSearchFetchPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchFullappApiSearchFetchPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends FetchFullappApiSearchFetchPostBody, TContext = unknown>(parameters: DeepReadonly<FetchFullappApiSearchFetchPostParameters>, options?: ServiceOperationUseMutationOptions<FetchFullappApiSearchFetchPostSchema, FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostParameters, TVariables, OperationError<FetchFullappApiSearchFetchPostError>, TContext>): UseMutationResult<FetchFullappApiSearchFetchPostData, OperationError<FetchFullappApiSearchFetchPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fetch
         * @description POST /search/fetch.
         *
         * No SH-impersonation / user_id path: search operates on the authenticated user
         * only (the course activity gate hardcodes the auth user).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchFullappApiSearchFetchPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchFullappApiSearchFetchPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<FetchFullappApiSearchFetchPostSchema, FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostParameters, TVariables, OperationError<FetchFullappApiSearchFetchPostError>, TContext>): UseMutationResult<FetchFullappApiSearchFetchPostData, OperationError<FetchFullappApiSearchFetchPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Fetch
         * @description POST /search/fetch.
         *
         * No SH-impersonation / user_id path: search operates on the authenticated user
         * only (the course activity gate hardcodes the auth user).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const fetchFullappApiSearchFetchPostTotal = qraft.fullappApiService.fetchFullappApiSearchFetchPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const fetchFullappApiSearchFetchPostTotal = qraft.fullappApiService.fetchFullappApiSearchFetchPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostParameters, OperationError<FetchFullappApiSearchFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiSearchFetchPostSchema, FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostParameters, OperationError<FetchFullappApiSearchFetchPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Fetch
         * @description POST /search/fetch.
         *
         * No SH-impersonation / user_id path: search operates on the authenticated user
         * only (the course activity gate hardcodes the auth user).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const fetchFullappApiSearchFetchPostPendingMutationVariables = qraft.fullappApiService.fetchFullappApiSearchFetchPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const fetchFullappApiSearchFetchPostMutationData = qraft.fullappApiService.fetchFullappApiSearchFetchPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<FetchFullappApiSearchFetchPostData, OperationError<FetchFullappApiSearchFetchPostError>, MutationVariables<FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostParameters, OperationError<FetchFullappApiSearchFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiSearchFetchPostSchema, FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostParameters, OperationError<FetchFullappApiSearchFetchPostError>, TContext>;
            select?: (mutation: Mutation<FetchFullappApiSearchFetchPostData, OperationError<FetchFullappApiSearchFetchPostError>, MutationVariables<FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Fetch
         * @description POST /search/fetch.
         *
         * No SH-impersonation / user_id path: search operates on the authenticated user
         * only (the course activity gate hardcodes the auth user).
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostParameters, OperationError<FetchFullappApiSearchFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiSearchFetchPostSchema, FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostParameters, OperationError<FetchFullappApiSearchFetchPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Fetch
         * @description POST /search/fetch.
         *
         * No SH-impersonation / user_id path: search operates on the authenticated user
         * only (the course activity gate hardcodes the auth user).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.fetchFullappApiSearchFetchPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.fetchFullappApiSearchFetchPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostParameters, OperationError<FetchFullappApiSearchFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiSearchFetchPostSchema, FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostParameters, OperationError<FetchFullappApiSearchFetchPostError>, TContext>): Mutation<FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostError, MutationVariables<FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostParameters, OperationError<FetchFullappApiSearchFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiSearchFetchPostSchema, FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostParameters, OperationError<FetchFullappApiSearchFetchPostError>, TContext>): Array<Mutation<FetchFullappApiSearchFetchPostData, FetchFullappApiSearchFetchPostError, MutationVariables<FetchFullappApiSearchFetchPostBody, FetchFullappApiSearchFetchPostParameters>, TContext>>;
        };
        schema: FetchFullappApiSearchFetchPostSchema;
        types: {
            parameters: FetchFullappApiSearchFetchPostParameters;
            data: FetchFullappApiSearchFetchPostData;
            error: FetchFullappApiSearchFetchPostError;
            body: FetchFullappApiSearchFetchPostBody;
        };
    };
    /**
     * @summary List Preferences
     * @description List the categorized notification preferences.
     *
     * Returns a bare JSON ARRAY of category objects (the client reads ``r.data``
     * then ``.map``). Each category: ``name`` (slug of label), ``label``, ``items``
     * (keyed by preference name). Items carry ``description``, ``types`` (enabled
     * types not disabled by the pref, in registration order), ``settings``
     * (id(type)-keyed JSON bool), and ``{type}_{name}`` = ``'yes'|'no'``.
     *
     * Categories with no profile-type-eligible items are dropped. Reading
     * lazily-fills and persists missing default keys (read-with-write-back).
     */
    listPreferencesFullappApiPreferencesListPost: {
        /**
         * @summary List Preferences
         * @description List the categorized notification preferences.
         *
         * Returns a bare JSON ARRAY of category objects (the client reads ``r.data``
         * then ``.map``). Each category: ``name`` (slug of label), ``label``, ``items``
         * (keyed by preference name). Items carry ``description``, ``types`` (enabled
         * types not disabled by the pref, in registration order), ``settings``
         * (id(type)-keyed JSON bool), and ``{type}_{name}`` = ``'yes'|'no'``.
         *
         * Categories with no profile-type-eligible items are dropped. Reading
         * lazily-fills and persists missing default keys (read-with-write-back).
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostParameters, TMeta, TSignal>, client?: (schema: ListPreferencesFullappApiPreferencesListPostSchema, options: ServiceOperationMutationFnOptions<ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostError>>): Promise<RequestFnResponse<ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostError>>;
        /**
         * @summary List Preferences
         * @description List the categorized notification preferences.
         *
         * Returns a bare JSON ARRAY of category objects (the client reads ``r.data``
         * then ``.map``). Each category: ``name`` (slug of label), ``label``, ``items``
         * (keyed by preference name). Items carry ``description``, ``types`` (enabled
         * types not disabled by the pref, in registration order), ``settings``
         * (id(type)-keyed JSON bool), and ``{type}_{name}`` = ``'yes'|'no'``.
         *
         * Categories with no profile-type-eligible items are dropped. Reading
         * lazily-fills and persists missing default keys (read-with-write-back).
         */
        getMutationKey(parameters: DeepReadonly<ListPreferencesFullappApiPreferencesListPostParameters> | void): ServiceOperationMutationKey<ListPreferencesFullappApiPreferencesListPostSchema, ListPreferencesFullappApiPreferencesListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary List Preferences
         * @description List the categorized notification preferences.
         *
         * Returns a bare JSON ARRAY of category objects (the client reads ``r.data``
         * then ``.map``). Each category: ``name`` (slug of label), ``label``, ``items``
         * (keyed by preference name). Items carry ``description``, ``types`` (enabled
         * types not disabled by the pref, in registration order), ``settings``
         * (id(type)-keyed JSON bool), and ``{type}_{name}`` = ``'yes'|'no'``.
         *
         * Categories with no profile-type-eligible items are dropped. Reading
         * lazily-fills and persists missing default keys (read-with-write-back).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listPreferencesFullappApiPreferencesListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listPreferencesFullappApiPreferencesListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ListPreferencesFullappApiPreferencesListPostBody, TContext = unknown>(parameters: DeepReadonly<ListPreferencesFullappApiPreferencesListPostParameters>, options?: ServiceOperationUseMutationOptions<ListPreferencesFullappApiPreferencesListPostSchema, ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostParameters, TVariables, OperationError<ListPreferencesFullappApiPreferencesListPostError>, TContext>): UseMutationResult<ListPreferencesFullappApiPreferencesListPostData, OperationError<ListPreferencesFullappApiPreferencesListPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary List Preferences
         * @description List the categorized notification preferences.
         *
         * Returns a bare JSON ARRAY of category objects (the client reads ``r.data``
         * then ``.map``). Each category: ``name`` (slug of label), ``label``, ``items``
         * (keyed by preference name). Items carry ``description``, ``types`` (enabled
         * types not disabled by the pref, in registration order), ``settings``
         * (id(type)-keyed JSON bool), and ``{type}_{name}`` = ``'yes'|'no'``.
         *
         * Categories with no profile-type-eligible items are dropped. Reading
         * lazily-fills and persists missing default keys (read-with-write-back).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listPreferencesFullappApiPreferencesListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listPreferencesFullappApiPreferencesListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ListPreferencesFullappApiPreferencesListPostSchema, ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostParameters, TVariables, OperationError<ListPreferencesFullappApiPreferencesListPostError>, TContext>): UseMutationResult<ListPreferencesFullappApiPreferencesListPostData, OperationError<ListPreferencesFullappApiPreferencesListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary List Preferences
         * @description List the categorized notification preferences.
         *
         * Returns a bare JSON ARRAY of category objects (the client reads ``r.data``
         * then ``.map``). Each category: ``name`` (slug of label), ``label``, ``items``
         * (keyed by preference name). Items carry ``description``, ``types`` (enabled
         * types not disabled by the pref, in registration order), ``settings``
         * (id(type)-keyed JSON bool), and ``{type}_{name}`` = ``'yes'|'no'``.
         *
         * Categories with no profile-type-eligible items are dropped. Reading
         * lazily-fills and persists missing default keys (read-with-write-back).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const listPreferencesFullappApiPreferencesListPostTotal = qraft.fullappApiService.listPreferencesFullappApiPreferencesListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const listPreferencesFullappApiPreferencesListPostTotal = qraft.fullappApiService.listPreferencesFullappApiPreferencesListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostParameters, OperationError<ListPreferencesFullappApiPreferencesListPostError>, TContext> | MutationFiltersByMutationKey<ListPreferencesFullappApiPreferencesListPostSchema, ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostParameters, OperationError<ListPreferencesFullappApiPreferencesListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary List Preferences
         * @description List the categorized notification preferences.
         *
         * Returns a bare JSON ARRAY of category objects (the client reads ``r.data``
         * then ``.map``). Each category: ``name`` (slug of label), ``label``, ``items``
         * (keyed by preference name). Items carry ``description``, ``types`` (enabled
         * types not disabled by the pref, in registration order), ``settings``
         * (id(type)-keyed JSON bool), and ``{type}_{name}`` = ``'yes'|'no'``.
         *
         * Categories with no profile-type-eligible items are dropped. Reading
         * lazily-fills and persists missing default keys (read-with-write-back).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const listPreferencesFullappApiPreferencesListPostPendingMutationVariables = qraft.fullappApiService.listPreferencesFullappApiPreferencesListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const listPreferencesFullappApiPreferencesListPostMutationData = qraft.fullappApiService.listPreferencesFullappApiPreferencesListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ListPreferencesFullappApiPreferencesListPostData, OperationError<ListPreferencesFullappApiPreferencesListPostError>, MutationVariables<ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostParameters, OperationError<ListPreferencesFullappApiPreferencesListPostError>, TContext> | MutationFiltersByMutationKey<ListPreferencesFullappApiPreferencesListPostSchema, ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostParameters, OperationError<ListPreferencesFullappApiPreferencesListPostError>, TContext>;
            select?: (mutation: Mutation<ListPreferencesFullappApiPreferencesListPostData, OperationError<ListPreferencesFullappApiPreferencesListPostError>, MutationVariables<ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary List Preferences
         * @description List the categorized notification preferences.
         *
         * Returns a bare JSON ARRAY of category objects (the client reads ``r.data``
         * then ``.map``). Each category: ``name`` (slug of label), ``label``, ``items``
         * (keyed by preference name). Items carry ``description``, ``types`` (enabled
         * types not disabled by the pref, in registration order), ``settings``
         * (id(type)-keyed JSON bool), and ``{type}_{name}`` = ``'yes'|'no'``.
         *
         * Categories with no profile-type-eligible items are dropped. Reading
         * lazily-fills and persists missing default keys (read-with-write-back).
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostParameters, OperationError<ListPreferencesFullappApiPreferencesListPostError>, TContext> | MutationFiltersByMutationKey<ListPreferencesFullappApiPreferencesListPostSchema, ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostParameters, OperationError<ListPreferencesFullappApiPreferencesListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary List Preferences
         * @description List the categorized notification preferences.
         *
         * Returns a bare JSON ARRAY of category objects (the client reads ``r.data``
         * then ``.map``). Each category: ``name`` (slug of label), ``label``, ``items``
         * (keyed by preference name). Items carry ``description``, ``types`` (enabled
         * types not disabled by the pref, in registration order), ``settings``
         * (id(type)-keyed JSON bool), and ``{type}_{name}`` = ``'yes'|'no'``.
         *
         * Categories with no profile-type-eligible items are dropped. Reading
         * lazily-fills and persists missing default keys (read-with-write-back).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.listPreferencesFullappApiPreferencesListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.listPreferencesFullappApiPreferencesListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostParameters, OperationError<ListPreferencesFullappApiPreferencesListPostError>, TContext> | MutationFiltersByMutationKey<ListPreferencesFullappApiPreferencesListPostSchema, ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostParameters, OperationError<ListPreferencesFullappApiPreferencesListPostError>, TContext>): Mutation<ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostError, MutationVariables<ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostParameters, OperationError<ListPreferencesFullappApiPreferencesListPostError>, TContext> | MutationFiltersByMutationKey<ListPreferencesFullappApiPreferencesListPostSchema, ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostParameters, OperationError<ListPreferencesFullappApiPreferencesListPostError>, TContext>): Array<Mutation<ListPreferencesFullappApiPreferencesListPostData, ListPreferencesFullappApiPreferencesListPostError, MutationVariables<ListPreferencesFullappApiPreferencesListPostBody, ListPreferencesFullappApiPreferencesListPostParameters>, TContext>>;
        };
        schema: ListPreferencesFullappApiPreferencesListPostSchema;
        types: {
            parameters: ListPreferencesFullappApiPreferencesListPostParameters;
            data: ListPreferencesFullappApiPreferencesListPostData;
            error: ListPreferencesFullappApiPreferencesListPostError;
            body: ListPreferencesFullappApiPreferencesListPostBody;
        };
    };
    /**
     * @summary Update
     * @description Update notification preferences.
     *
     * Accepts ``data`` ({type}_{name} -> 'yes'/'no') and/or ``settings``
     * ({name: {type: value}}); validates names against the FULL catalog and types
     * against the FULL 5-type registry (NOT the per-user eligible subset). Invalid
     * values/types/names are silently skipped. An empty body -> 200 with
     * ``updated={}``. Returns ``{user_id, updated}`` where ``updated`` is
     * ``{name: {type: bool}}`` with real JSON booleans. Writes to the auth user's
     * own ``notification_preferences``.
     */
    updateFullappApiPreferencesUpdatePost: {
        /**
         * @summary Update
         * @description Update notification preferences.
         *
         * Accepts ``data`` ({type}_{name} -> 'yes'/'no') and/or ``settings``
         * ({name: {type: value}}); validates names against the FULL catalog and types
         * against the FULL 5-type registry (NOT the per-user eligible subset). Invalid
         * values/types/names are silently skipped. An empty body -> 200 with
         * ``updated={}``. Returns ``{user_id, updated}`` where ``updated`` is
         * ``{name: {type: bool}}`` with real JSON booleans. Writes to the auth user's
         * own ``notification_preferences``.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostParameters, TMeta, TSignal>, client?: (schema: UpdateFullappApiPreferencesUpdatePostSchema, options: ServiceOperationMutationFnOptions<UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostError>>): Promise<RequestFnResponse<UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostError>>;
        /**
         * @summary Update
         * @description Update notification preferences.
         *
         * Accepts ``data`` ({type}_{name} -> 'yes'/'no') and/or ``settings``
         * ({name: {type: value}}); validates names against the FULL catalog and types
         * against the FULL 5-type registry (NOT the per-user eligible subset). Invalid
         * values/types/names are silently skipped. An empty body -> 200 with
         * ``updated={}``. Returns ``{user_id, updated}`` where ``updated`` is
         * ``{name: {type: bool}}`` with real JSON booleans. Writes to the auth user's
         * own ``notification_preferences``.
         */
        getMutationKey(parameters: DeepReadonly<UpdateFullappApiPreferencesUpdatePostParameters> | void): ServiceOperationMutationKey<UpdateFullappApiPreferencesUpdatePostSchema, UpdateFullappApiPreferencesUpdatePostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Update
         * @description Update notification preferences.
         *
         * Accepts ``data`` ({type}_{name} -> 'yes'/'no') and/or ``settings``
         * ({name: {type: value}}); validates names against the FULL catalog and types
         * against the FULL 5-type registry (NOT the per-user eligible subset). Invalid
         * values/types/names are silently skipped. An empty body -> 200 with
         * ``updated={}``. Returns ``{user_id, updated}`` where ``updated`` is
         * ``{name: {type: bool}}`` with real JSON booleans. Writes to the auth user's
         * own ``notification_preferences``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.updateFullappApiPreferencesUpdatePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.updateFullappApiPreferencesUpdatePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends UpdateFullappApiPreferencesUpdatePostBody, TContext = unknown>(parameters: DeepReadonly<UpdateFullappApiPreferencesUpdatePostParameters>, options?: ServiceOperationUseMutationOptions<UpdateFullappApiPreferencesUpdatePostSchema, UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostParameters, TVariables, OperationError<UpdateFullappApiPreferencesUpdatePostError>, TContext>): UseMutationResult<UpdateFullappApiPreferencesUpdatePostData, OperationError<UpdateFullappApiPreferencesUpdatePostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Update
         * @description Update notification preferences.
         *
         * Accepts ``data`` ({type}_{name} -> 'yes'/'no') and/or ``settings``
         * ({name: {type: value}}); validates names against the FULL catalog and types
         * against the FULL 5-type registry (NOT the per-user eligible subset). Invalid
         * values/types/names are silently skipped. An empty body -> 200 with
         * ``updated={}``. Returns ``{user_id, updated}`` where ``updated`` is
         * ``{name: {type: bool}}`` with real JSON booleans. Writes to the auth user's
         * own ``notification_preferences``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.updateFullappApiPreferencesUpdatePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.updateFullappApiPreferencesUpdatePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<UpdateFullappApiPreferencesUpdatePostSchema, UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostParameters, TVariables, OperationError<UpdateFullappApiPreferencesUpdatePostError>, TContext>): UseMutationResult<UpdateFullappApiPreferencesUpdatePostData, OperationError<UpdateFullappApiPreferencesUpdatePostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Update
         * @description Update notification preferences.
         *
         * Accepts ``data`` ({type}_{name} -> 'yes'/'no') and/or ``settings``
         * ({name: {type: value}}); validates names against the FULL catalog and types
         * against the FULL 5-type registry (NOT the per-user eligible subset). Invalid
         * values/types/names are silently skipped. An empty body -> 200 with
         * ``updated={}``. Returns ``{user_id, updated}`` where ``updated`` is
         * ``{name: {type: bool}}`` with real JSON booleans. Writes to the auth user's
         * own ``notification_preferences``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const updateFullappApiPreferencesUpdatePostTotal = qraft.fullappApiService.updateFullappApiPreferencesUpdatePost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const updateFullappApiPreferencesUpdatePostTotal = qraft.fullappApiService.updateFullappApiPreferencesUpdatePost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostParameters, OperationError<UpdateFullappApiPreferencesUpdatePostError>, TContext> | MutationFiltersByMutationKey<UpdateFullappApiPreferencesUpdatePostSchema, UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostParameters, OperationError<UpdateFullappApiPreferencesUpdatePostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Update
         * @description Update notification preferences.
         *
         * Accepts ``data`` ({type}_{name} -> 'yes'/'no') and/or ``settings``
         * ({name: {type: value}}); validates names against the FULL catalog and types
         * against the FULL 5-type registry (NOT the per-user eligible subset). Invalid
         * values/types/names are silently skipped. An empty body -> 200 with
         * ``updated={}``. Returns ``{user_id, updated}`` where ``updated`` is
         * ``{name: {type: bool}}`` with real JSON booleans. Writes to the auth user's
         * own ``notification_preferences``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const updateFullappApiPreferencesUpdatePostPendingMutationVariables = qraft.fullappApiService.updateFullappApiPreferencesUpdatePost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const updateFullappApiPreferencesUpdatePostMutationData = qraft.fullappApiService.updateFullappApiPreferencesUpdatePost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<UpdateFullappApiPreferencesUpdatePostData, OperationError<UpdateFullappApiPreferencesUpdatePostError>, MutationVariables<UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostParameters, OperationError<UpdateFullappApiPreferencesUpdatePostError>, TContext> | MutationFiltersByMutationKey<UpdateFullappApiPreferencesUpdatePostSchema, UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostParameters, OperationError<UpdateFullappApiPreferencesUpdatePostError>, TContext>;
            select?: (mutation: Mutation<UpdateFullappApiPreferencesUpdatePostData, OperationError<UpdateFullappApiPreferencesUpdatePostError>, MutationVariables<UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Update
         * @description Update notification preferences.
         *
         * Accepts ``data`` ({type}_{name} -> 'yes'/'no') and/or ``settings``
         * ({name: {type: value}}); validates names against the FULL catalog and types
         * against the FULL 5-type registry (NOT the per-user eligible subset). Invalid
         * values/types/names are silently skipped. An empty body -> 200 with
         * ``updated={}``. Returns ``{user_id, updated}`` where ``updated`` is
         * ``{name: {type: bool}}`` with real JSON booleans. Writes to the auth user's
         * own ``notification_preferences``.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostParameters, OperationError<UpdateFullappApiPreferencesUpdatePostError>, TContext> | MutationFiltersByMutationKey<UpdateFullappApiPreferencesUpdatePostSchema, UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostParameters, OperationError<UpdateFullappApiPreferencesUpdatePostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Update
         * @description Update notification preferences.
         *
         * Accepts ``data`` ({type}_{name} -> 'yes'/'no') and/or ``settings``
         * ({name: {type: value}}); validates names against the FULL catalog and types
         * against the FULL 5-type registry (NOT the per-user eligible subset). Invalid
         * values/types/names are silently skipped. An empty body -> 200 with
         * ``updated={}``. Returns ``{user_id, updated}`` where ``updated`` is
         * ``{name: {type: bool}}`` with real JSON booleans. Writes to the auth user's
         * own ``notification_preferences``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.updateFullappApiPreferencesUpdatePost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.updateFullappApiPreferencesUpdatePost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostParameters, OperationError<UpdateFullappApiPreferencesUpdatePostError>, TContext> | MutationFiltersByMutationKey<UpdateFullappApiPreferencesUpdatePostSchema, UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostParameters, OperationError<UpdateFullappApiPreferencesUpdatePostError>, TContext>): Mutation<UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostError, MutationVariables<UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostParameters, OperationError<UpdateFullappApiPreferencesUpdatePostError>, TContext> | MutationFiltersByMutationKey<UpdateFullappApiPreferencesUpdatePostSchema, UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostParameters, OperationError<UpdateFullappApiPreferencesUpdatePostError>, TContext>): Array<Mutation<UpdateFullappApiPreferencesUpdatePostData, UpdateFullappApiPreferencesUpdatePostError, MutationVariables<UpdateFullappApiPreferencesUpdatePostBody, UpdateFullappApiPreferencesUpdatePostParameters>, TContext>>;
        };
        schema: UpdateFullappApiPreferencesUpdatePostSchema;
        types: {
            parameters: UpdateFullappApiPreferencesUpdatePostParameters;
            data: UpdateFullappApiPreferencesUpdatePostData;
            error: UpdateFullappApiPreferencesUpdatePostError;
            body: UpdateFullappApiPreferencesUpdatePostBody;
        };
    };
    /**
     * @summary List Threads
     * @description Retrieve a paginated list of message threads for the current user.
     */
    listThreadsFullappApiThreadsListPost: {
        /**
         * @summary List Threads
         * @description Retrieve a paginated list of message threads for the current user.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostParameters, TMeta, TSignal>, client?: (schema: ListThreadsFullappApiThreadsListPostSchema, options: ServiceOperationMutationFnOptions<ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostError>>): Promise<RequestFnResponse<ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostError>>;
        /**
         * @summary List Threads
         * @description Retrieve a paginated list of message threads for the current user.
         */
        getMutationKey(parameters: DeepReadonly<ListThreadsFullappApiThreadsListPostParameters> | void): ServiceOperationMutationKey<ListThreadsFullappApiThreadsListPostSchema, ListThreadsFullappApiThreadsListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary List Threads
         * @description Retrieve a paginated list of message threads for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listThreadsFullappApiThreadsListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listThreadsFullappApiThreadsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ListThreadsFullappApiThreadsListPostBody, TContext = unknown>(parameters: DeepReadonly<ListThreadsFullappApiThreadsListPostParameters>, options?: ServiceOperationUseMutationOptions<ListThreadsFullappApiThreadsListPostSchema, ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostParameters, TVariables, OperationError<ListThreadsFullappApiThreadsListPostError>, TContext>): UseMutationResult<ListThreadsFullappApiThreadsListPostData, OperationError<ListThreadsFullappApiThreadsListPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary List Threads
         * @description Retrieve a paginated list of message threads for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listThreadsFullappApiThreadsListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listThreadsFullappApiThreadsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ListThreadsFullappApiThreadsListPostSchema, ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostParameters, TVariables, OperationError<ListThreadsFullappApiThreadsListPostError>, TContext>): UseMutationResult<ListThreadsFullappApiThreadsListPostData, OperationError<ListThreadsFullappApiThreadsListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary List Threads
         * @description Retrieve a paginated list of message threads for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const listThreadsFullappApiThreadsListPostTotal = qraft.fullappApiService.listThreadsFullappApiThreadsListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const listThreadsFullappApiThreadsListPostTotal = qraft.fullappApiService.listThreadsFullappApiThreadsListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostParameters, OperationError<ListThreadsFullappApiThreadsListPostError>, TContext> | MutationFiltersByMutationKey<ListThreadsFullappApiThreadsListPostSchema, ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostParameters, OperationError<ListThreadsFullappApiThreadsListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary List Threads
         * @description Retrieve a paginated list of message threads for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const listThreadsFullappApiThreadsListPostPendingMutationVariables = qraft.fullappApiService.listThreadsFullappApiThreadsListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const listThreadsFullappApiThreadsListPostMutationData = qraft.fullappApiService.listThreadsFullappApiThreadsListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ListThreadsFullappApiThreadsListPostData, OperationError<ListThreadsFullappApiThreadsListPostError>, MutationVariables<ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostParameters, OperationError<ListThreadsFullappApiThreadsListPostError>, TContext> | MutationFiltersByMutationKey<ListThreadsFullappApiThreadsListPostSchema, ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostParameters, OperationError<ListThreadsFullappApiThreadsListPostError>, TContext>;
            select?: (mutation: Mutation<ListThreadsFullappApiThreadsListPostData, OperationError<ListThreadsFullappApiThreadsListPostError>, MutationVariables<ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary List Threads
         * @description Retrieve a paginated list of message threads for the current user.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostParameters, OperationError<ListThreadsFullappApiThreadsListPostError>, TContext> | MutationFiltersByMutationKey<ListThreadsFullappApiThreadsListPostSchema, ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostParameters, OperationError<ListThreadsFullappApiThreadsListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary List Threads
         * @description Retrieve a paginated list of message threads for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.listThreadsFullappApiThreadsListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.listThreadsFullappApiThreadsListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostParameters, OperationError<ListThreadsFullappApiThreadsListPostError>, TContext> | MutationFiltersByMutationKey<ListThreadsFullappApiThreadsListPostSchema, ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostParameters, OperationError<ListThreadsFullappApiThreadsListPostError>, TContext>): Mutation<ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostError, MutationVariables<ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostParameters, OperationError<ListThreadsFullappApiThreadsListPostError>, TContext> | MutationFiltersByMutationKey<ListThreadsFullappApiThreadsListPostSchema, ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostParameters, OperationError<ListThreadsFullappApiThreadsListPostError>, TContext>): Array<Mutation<ListThreadsFullappApiThreadsListPostData, ListThreadsFullappApiThreadsListPostError, MutationVariables<ListThreadsFullappApiThreadsListPostBody, ListThreadsFullappApiThreadsListPostParameters>, TContext>>;
        };
        schema: ListThreadsFullappApiThreadsListPostSchema;
        types: {
            parameters: ListThreadsFullappApiThreadsListPostParameters;
            data: ListThreadsFullappApiThreadsListPostData;
            error: ListThreadsFullappApiThreadsListPostError;
            body: ListThreadsFullappApiThreadsListPostBody;
        };
    };
    /**
     * @summary Thread Messages
     * @description Retrieve messages for a specific thread.
     */
    threadMessagesFullappApiThreadsMessagesPost: {
        /**
         * @summary Thread Messages
         * @description Retrieve messages for a specific thread.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostParameters, TMeta, TSignal>, client?: (schema: ThreadMessagesFullappApiThreadsMessagesPostSchema, options: ServiceOperationMutationFnOptions<ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostError>>): Promise<RequestFnResponse<ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostError>>;
        /**
         * @summary Thread Messages
         * @description Retrieve messages for a specific thread.
         */
        getMutationKey(parameters: DeepReadonly<ThreadMessagesFullappApiThreadsMessagesPostParameters> | void): ServiceOperationMutationKey<ThreadMessagesFullappApiThreadsMessagesPostSchema, ThreadMessagesFullappApiThreadsMessagesPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Thread Messages
         * @description Retrieve messages for a specific thread.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.threadMessagesFullappApiThreadsMessagesPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.threadMessagesFullappApiThreadsMessagesPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ThreadMessagesFullappApiThreadsMessagesPostBody, TContext = unknown>(parameters: DeepReadonly<ThreadMessagesFullappApiThreadsMessagesPostParameters>, options?: ServiceOperationUseMutationOptions<ThreadMessagesFullappApiThreadsMessagesPostSchema, ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostParameters, TVariables, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, TContext>): UseMutationResult<ThreadMessagesFullappApiThreadsMessagesPostData, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Thread Messages
         * @description Retrieve messages for a specific thread.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.threadMessagesFullappApiThreadsMessagesPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.threadMessagesFullappApiThreadsMessagesPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ThreadMessagesFullappApiThreadsMessagesPostSchema, ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostParameters, TVariables, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, TContext>): UseMutationResult<ThreadMessagesFullappApiThreadsMessagesPostData, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Thread Messages
         * @description Retrieve messages for a specific thread.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const threadMessagesFullappApiThreadsMessagesPostTotal = qraft.fullappApiService.threadMessagesFullappApiThreadsMessagesPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const threadMessagesFullappApiThreadsMessagesPostTotal = qraft.fullappApiService.threadMessagesFullappApiThreadsMessagesPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostParameters, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, TContext> | MutationFiltersByMutationKey<ThreadMessagesFullappApiThreadsMessagesPostSchema, ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostParameters, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Thread Messages
         * @description Retrieve messages for a specific thread.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const threadMessagesFullappApiThreadsMessagesPostPendingMutationVariables = qraft.fullappApiService.threadMessagesFullappApiThreadsMessagesPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const threadMessagesFullappApiThreadsMessagesPostMutationData = qraft.fullappApiService.threadMessagesFullappApiThreadsMessagesPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ThreadMessagesFullappApiThreadsMessagesPostData, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, MutationVariables<ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostParameters, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, TContext> | MutationFiltersByMutationKey<ThreadMessagesFullappApiThreadsMessagesPostSchema, ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostParameters, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, TContext>;
            select?: (mutation: Mutation<ThreadMessagesFullappApiThreadsMessagesPostData, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, MutationVariables<ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Thread Messages
         * @description Retrieve messages for a specific thread.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostParameters, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, TContext> | MutationFiltersByMutationKey<ThreadMessagesFullappApiThreadsMessagesPostSchema, ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostParameters, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Thread Messages
         * @description Retrieve messages for a specific thread.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.threadMessagesFullappApiThreadsMessagesPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.threadMessagesFullappApiThreadsMessagesPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostParameters, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, TContext> | MutationFiltersByMutationKey<ThreadMessagesFullappApiThreadsMessagesPostSchema, ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostParameters, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, TContext>): Mutation<ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostError, MutationVariables<ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostParameters, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, TContext> | MutationFiltersByMutationKey<ThreadMessagesFullappApiThreadsMessagesPostSchema, ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostParameters, OperationError<ThreadMessagesFullappApiThreadsMessagesPostError>, TContext>): Array<Mutation<ThreadMessagesFullappApiThreadsMessagesPostData, ThreadMessagesFullappApiThreadsMessagesPostError, MutationVariables<ThreadMessagesFullappApiThreadsMessagesPostBody, ThreadMessagesFullappApiThreadsMessagesPostParameters>, TContext>>;
        };
        schema: ThreadMessagesFullappApiThreadsMessagesPostSchema;
        types: {
            parameters: ThreadMessagesFullappApiThreadsMessagesPostParameters;
            data: ThreadMessagesFullappApiThreadsMessagesPostData;
            error: ThreadMessagesFullappApiThreadsMessagesPostError;
            body: ThreadMessagesFullappApiThreadsMessagesPostBody;
        };
    };
    /**
     * @summary Search Thread
     * @description Search if there's an existing thread for the given recipients.
     */
    searchThreadFullappApiThreadsSearchPost: {
        /**
         * @summary Search Thread
         * @description Search if there's an existing thread for the given recipients.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostParameters, TMeta, TSignal>, client?: (schema: SearchThreadFullappApiThreadsSearchPostSchema, options: ServiceOperationMutationFnOptions<SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostError>>): Promise<RequestFnResponse<SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostError>>;
        /**
         * @summary Search Thread
         * @description Search if there's an existing thread for the given recipients.
         */
        getMutationKey(parameters: DeepReadonly<SearchThreadFullappApiThreadsSearchPostParameters> | void): ServiceOperationMutationKey<SearchThreadFullappApiThreadsSearchPostSchema, SearchThreadFullappApiThreadsSearchPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Search Thread
         * @description Search if there's an existing thread for the given recipients.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.searchThreadFullappApiThreadsSearchPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.searchThreadFullappApiThreadsSearchPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SearchThreadFullappApiThreadsSearchPostBody, TContext = unknown>(parameters: DeepReadonly<SearchThreadFullappApiThreadsSearchPostParameters>, options?: ServiceOperationUseMutationOptions<SearchThreadFullappApiThreadsSearchPostSchema, SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostParameters, TVariables, OperationError<SearchThreadFullappApiThreadsSearchPostError>, TContext>): UseMutationResult<SearchThreadFullappApiThreadsSearchPostData, OperationError<SearchThreadFullappApiThreadsSearchPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Search Thread
         * @description Search if there's an existing thread for the given recipients.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.searchThreadFullappApiThreadsSearchPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.searchThreadFullappApiThreadsSearchPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SearchThreadFullappApiThreadsSearchPostSchema, SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostParameters, TVariables, OperationError<SearchThreadFullappApiThreadsSearchPostError>, TContext>): UseMutationResult<SearchThreadFullappApiThreadsSearchPostData, OperationError<SearchThreadFullappApiThreadsSearchPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Search Thread
         * @description Search if there's an existing thread for the given recipients.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const searchThreadFullappApiThreadsSearchPostTotal = qraft.fullappApiService.searchThreadFullappApiThreadsSearchPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const searchThreadFullappApiThreadsSearchPostTotal = qraft.fullappApiService.searchThreadFullappApiThreadsSearchPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostParameters, OperationError<SearchThreadFullappApiThreadsSearchPostError>, TContext> | MutationFiltersByMutationKey<SearchThreadFullappApiThreadsSearchPostSchema, SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostParameters, OperationError<SearchThreadFullappApiThreadsSearchPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Search Thread
         * @description Search if there's an existing thread for the given recipients.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const searchThreadFullappApiThreadsSearchPostPendingMutationVariables = qraft.fullappApiService.searchThreadFullappApiThreadsSearchPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const searchThreadFullappApiThreadsSearchPostMutationData = qraft.fullappApiService.searchThreadFullappApiThreadsSearchPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SearchThreadFullappApiThreadsSearchPostData, OperationError<SearchThreadFullappApiThreadsSearchPostError>, MutationVariables<SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostParameters, OperationError<SearchThreadFullappApiThreadsSearchPostError>, TContext> | MutationFiltersByMutationKey<SearchThreadFullappApiThreadsSearchPostSchema, SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostParameters, OperationError<SearchThreadFullappApiThreadsSearchPostError>, TContext>;
            select?: (mutation: Mutation<SearchThreadFullappApiThreadsSearchPostData, OperationError<SearchThreadFullappApiThreadsSearchPostError>, MutationVariables<SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Search Thread
         * @description Search if there's an existing thread for the given recipients.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostParameters, OperationError<SearchThreadFullappApiThreadsSearchPostError>, TContext> | MutationFiltersByMutationKey<SearchThreadFullappApiThreadsSearchPostSchema, SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostParameters, OperationError<SearchThreadFullappApiThreadsSearchPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Search Thread
         * @description Search if there's an existing thread for the given recipients.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.searchThreadFullappApiThreadsSearchPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.searchThreadFullappApiThreadsSearchPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostParameters, OperationError<SearchThreadFullappApiThreadsSearchPostError>, TContext> | MutationFiltersByMutationKey<SearchThreadFullappApiThreadsSearchPostSchema, SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostParameters, OperationError<SearchThreadFullappApiThreadsSearchPostError>, TContext>): Mutation<SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostError, MutationVariables<SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostParameters, OperationError<SearchThreadFullappApiThreadsSearchPostError>, TContext> | MutationFiltersByMutationKey<SearchThreadFullappApiThreadsSearchPostSchema, SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostParameters, OperationError<SearchThreadFullappApiThreadsSearchPostError>, TContext>): Array<Mutation<SearchThreadFullappApiThreadsSearchPostData, SearchThreadFullappApiThreadsSearchPostError, MutationVariables<SearchThreadFullappApiThreadsSearchPostBody, SearchThreadFullappApiThreadsSearchPostParameters>, TContext>>;
        };
        schema: SearchThreadFullappApiThreadsSearchPostSchema;
        types: {
            parameters: SearchThreadFullappApiThreadsSearchPostParameters;
            data: SearchThreadFullappApiThreadsSearchPostData;
            error: SearchThreadFullappApiThreadsSearchPostError;
            body: SearchThreadFullappApiThreadsSearchPostBody;
        };
    };
    /**
     * @summary Compose Thread
     * @description Create a new message thread with specified recipients.
     */
    composeThreadFullappApiThreadsComposePost: {
        /**
         * @summary Compose Thread
         * @description Create a new message thread with specified recipients.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostParameters, TMeta, TSignal>, client?: (schema: ComposeThreadFullappApiThreadsComposePostSchema, options: ServiceOperationMutationFnOptions<ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostError>>): Promise<RequestFnResponse<ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostError>>;
        /**
         * @summary Compose Thread
         * @description Create a new message thread with specified recipients.
         */
        getMutationKey(parameters: DeepReadonly<ComposeThreadFullappApiThreadsComposePostParameters> | void): ServiceOperationMutationKey<ComposeThreadFullappApiThreadsComposePostSchema, ComposeThreadFullappApiThreadsComposePostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Compose Thread
         * @description Create a new message thread with specified recipients.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.composeThreadFullappApiThreadsComposePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.composeThreadFullappApiThreadsComposePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ComposeThreadFullappApiThreadsComposePostBody, TContext = unknown>(parameters: DeepReadonly<ComposeThreadFullappApiThreadsComposePostParameters>, options?: ServiceOperationUseMutationOptions<ComposeThreadFullappApiThreadsComposePostSchema, ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostParameters, TVariables, OperationError<ComposeThreadFullappApiThreadsComposePostError>, TContext>): UseMutationResult<ComposeThreadFullappApiThreadsComposePostData, OperationError<ComposeThreadFullappApiThreadsComposePostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Compose Thread
         * @description Create a new message thread with specified recipients.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.composeThreadFullappApiThreadsComposePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.composeThreadFullappApiThreadsComposePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ComposeThreadFullappApiThreadsComposePostSchema, ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostParameters, TVariables, OperationError<ComposeThreadFullappApiThreadsComposePostError>, TContext>): UseMutationResult<ComposeThreadFullappApiThreadsComposePostData, OperationError<ComposeThreadFullappApiThreadsComposePostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Compose Thread
         * @description Create a new message thread with specified recipients.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const composeThreadFullappApiThreadsComposePostTotal = qraft.fullappApiService.composeThreadFullappApiThreadsComposePost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const composeThreadFullappApiThreadsComposePostTotal = qraft.fullappApiService.composeThreadFullappApiThreadsComposePost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostParameters, OperationError<ComposeThreadFullappApiThreadsComposePostError>, TContext> | MutationFiltersByMutationKey<ComposeThreadFullappApiThreadsComposePostSchema, ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostParameters, OperationError<ComposeThreadFullappApiThreadsComposePostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Compose Thread
         * @description Create a new message thread with specified recipients.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const composeThreadFullappApiThreadsComposePostPendingMutationVariables = qraft.fullappApiService.composeThreadFullappApiThreadsComposePost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const composeThreadFullappApiThreadsComposePostMutationData = qraft.fullappApiService.composeThreadFullappApiThreadsComposePost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ComposeThreadFullappApiThreadsComposePostData, OperationError<ComposeThreadFullappApiThreadsComposePostError>, MutationVariables<ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostParameters, OperationError<ComposeThreadFullappApiThreadsComposePostError>, TContext> | MutationFiltersByMutationKey<ComposeThreadFullappApiThreadsComposePostSchema, ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostParameters, OperationError<ComposeThreadFullappApiThreadsComposePostError>, TContext>;
            select?: (mutation: Mutation<ComposeThreadFullappApiThreadsComposePostData, OperationError<ComposeThreadFullappApiThreadsComposePostError>, MutationVariables<ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Compose Thread
         * @description Create a new message thread with specified recipients.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostParameters, OperationError<ComposeThreadFullappApiThreadsComposePostError>, TContext> | MutationFiltersByMutationKey<ComposeThreadFullappApiThreadsComposePostSchema, ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostParameters, OperationError<ComposeThreadFullappApiThreadsComposePostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Compose Thread
         * @description Create a new message thread with specified recipients.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.composeThreadFullappApiThreadsComposePost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.composeThreadFullappApiThreadsComposePost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostParameters, OperationError<ComposeThreadFullappApiThreadsComposePostError>, TContext> | MutationFiltersByMutationKey<ComposeThreadFullappApiThreadsComposePostSchema, ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostParameters, OperationError<ComposeThreadFullappApiThreadsComposePostError>, TContext>): Mutation<ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostError, MutationVariables<ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostParameters, OperationError<ComposeThreadFullappApiThreadsComposePostError>, TContext> | MutationFiltersByMutationKey<ComposeThreadFullappApiThreadsComposePostSchema, ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostParameters, OperationError<ComposeThreadFullappApiThreadsComposePostError>, TContext>): Array<Mutation<ComposeThreadFullappApiThreadsComposePostData, ComposeThreadFullappApiThreadsComposePostError, MutationVariables<ComposeThreadFullappApiThreadsComposePostBody, ComposeThreadFullappApiThreadsComposePostParameters>, TContext>>;
        };
        schema: ComposeThreadFullappApiThreadsComposePostSchema;
        types: {
            parameters: ComposeThreadFullappApiThreadsComposePostParameters;
            data: ComposeThreadFullappApiThreadsComposePostData;
            error: ComposeThreadFullappApiThreadsComposePostError;
            body: ComposeThreadFullappApiThreadsComposePostBody;
        };
    };
    /**
     * @summary Reply To Thread
     * @description Reply to an existing thread.
     */
    replyToThreadFullappApiThreadsReplyPost: {
        /**
         * @summary Reply To Thread
         * @description Reply to an existing thread.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostParameters, TMeta, TSignal>, client?: (schema: ReplyToThreadFullappApiThreadsReplyPostSchema, options: ServiceOperationMutationFnOptions<ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostError>>): Promise<RequestFnResponse<ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostError>>;
        /**
         * @summary Reply To Thread
         * @description Reply to an existing thread.
         */
        getMutationKey(parameters: DeepReadonly<ReplyToThreadFullappApiThreadsReplyPostParameters> | void): ServiceOperationMutationKey<ReplyToThreadFullappApiThreadsReplyPostSchema, ReplyToThreadFullappApiThreadsReplyPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Reply To Thread
         * @description Reply to an existing thread.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.replyToThreadFullappApiThreadsReplyPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.replyToThreadFullappApiThreadsReplyPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ReplyToThreadFullappApiThreadsReplyPostBody, TContext = unknown>(parameters: DeepReadonly<ReplyToThreadFullappApiThreadsReplyPostParameters>, options?: ServiceOperationUseMutationOptions<ReplyToThreadFullappApiThreadsReplyPostSchema, ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostParameters, TVariables, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, TContext>): UseMutationResult<ReplyToThreadFullappApiThreadsReplyPostData, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Reply To Thread
         * @description Reply to an existing thread.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.replyToThreadFullappApiThreadsReplyPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.replyToThreadFullappApiThreadsReplyPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ReplyToThreadFullappApiThreadsReplyPostSchema, ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostParameters, TVariables, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, TContext>): UseMutationResult<ReplyToThreadFullappApiThreadsReplyPostData, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Reply To Thread
         * @description Reply to an existing thread.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const replyToThreadFullappApiThreadsReplyPostTotal = qraft.fullappApiService.replyToThreadFullappApiThreadsReplyPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const replyToThreadFullappApiThreadsReplyPostTotal = qraft.fullappApiService.replyToThreadFullappApiThreadsReplyPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostParameters, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, TContext> | MutationFiltersByMutationKey<ReplyToThreadFullappApiThreadsReplyPostSchema, ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostParameters, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Reply To Thread
         * @description Reply to an existing thread.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const replyToThreadFullappApiThreadsReplyPostPendingMutationVariables = qraft.fullappApiService.replyToThreadFullappApiThreadsReplyPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const replyToThreadFullappApiThreadsReplyPostMutationData = qraft.fullappApiService.replyToThreadFullappApiThreadsReplyPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ReplyToThreadFullappApiThreadsReplyPostData, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, MutationVariables<ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostParameters, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, TContext> | MutationFiltersByMutationKey<ReplyToThreadFullappApiThreadsReplyPostSchema, ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostParameters, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, TContext>;
            select?: (mutation: Mutation<ReplyToThreadFullappApiThreadsReplyPostData, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, MutationVariables<ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Reply To Thread
         * @description Reply to an existing thread.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostParameters, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, TContext> | MutationFiltersByMutationKey<ReplyToThreadFullappApiThreadsReplyPostSchema, ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostParameters, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Reply To Thread
         * @description Reply to an existing thread.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.replyToThreadFullappApiThreadsReplyPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.replyToThreadFullappApiThreadsReplyPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostParameters, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, TContext> | MutationFiltersByMutationKey<ReplyToThreadFullappApiThreadsReplyPostSchema, ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostParameters, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, TContext>): Mutation<ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostError, MutationVariables<ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostParameters, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, TContext> | MutationFiltersByMutationKey<ReplyToThreadFullappApiThreadsReplyPostSchema, ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostParameters, OperationError<ReplyToThreadFullappApiThreadsReplyPostError>, TContext>): Array<Mutation<ReplyToThreadFullappApiThreadsReplyPostData, ReplyToThreadFullappApiThreadsReplyPostError, MutationVariables<ReplyToThreadFullappApiThreadsReplyPostBody, ReplyToThreadFullappApiThreadsReplyPostParameters>, TContext>>;
        };
        schema: ReplyToThreadFullappApiThreadsReplyPostSchema;
        types: {
            parameters: ReplyToThreadFullappApiThreadsReplyPostParameters;
            data: ReplyToThreadFullappApiThreadsReplyPostData;
            error: ReplyToThreadFullappApiThreadsReplyPostError;
            body: ReplyToThreadFullappApiThreadsReplyPostBody;
        };
    };
    /**
     * @summary Delete Thread
     * @description Delete a thread for all participants.
     */
    deleteThreadFullappApiThreadsDeletePost: {
        /**
         * @summary Delete Thread
         * @description Delete a thread for all participants.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostParameters, TMeta, TSignal>, client?: (schema: DeleteThreadFullappApiThreadsDeletePostSchema, options: ServiceOperationMutationFnOptions<DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostError>>): Promise<RequestFnResponse<DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostError>>;
        /**
         * @summary Delete Thread
         * @description Delete a thread for all participants.
         */
        getMutationKey(parameters: DeepReadonly<DeleteThreadFullappApiThreadsDeletePostParameters> | void): ServiceOperationMutationKey<DeleteThreadFullappApiThreadsDeletePostSchema, DeleteThreadFullappApiThreadsDeletePostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Thread
         * @description Delete a thread for all participants.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deleteThreadFullappApiThreadsDeletePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deleteThreadFullappApiThreadsDeletePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DeleteThreadFullappApiThreadsDeletePostBody, TContext = unknown>(parameters: DeepReadonly<DeleteThreadFullappApiThreadsDeletePostParameters>, options?: ServiceOperationUseMutationOptions<DeleteThreadFullappApiThreadsDeletePostSchema, DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostParameters, TVariables, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, TContext>): UseMutationResult<DeleteThreadFullappApiThreadsDeletePostData, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete Thread
         * @description Delete a thread for all participants.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deleteThreadFullappApiThreadsDeletePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deleteThreadFullappApiThreadsDeletePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeleteThreadFullappApiThreadsDeletePostSchema, DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostParameters, TVariables, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, TContext>): UseMutationResult<DeleteThreadFullappApiThreadsDeletePostData, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Delete Thread
         * @description Delete a thread for all participants.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const deleteThreadFullappApiThreadsDeletePostTotal = qraft.fullappApiService.deleteThreadFullappApiThreadsDeletePost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const deleteThreadFullappApiThreadsDeletePostTotal = qraft.fullappApiService.deleteThreadFullappApiThreadsDeletePost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostParameters, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteThreadFullappApiThreadsDeletePostSchema, DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostParameters, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Delete Thread
         * @description Delete a thread for all participants.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const deleteThreadFullappApiThreadsDeletePostPendingMutationVariables = qraft.fullappApiService.deleteThreadFullappApiThreadsDeletePost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const deleteThreadFullappApiThreadsDeletePostMutationData = qraft.fullappApiService.deleteThreadFullappApiThreadsDeletePost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeleteThreadFullappApiThreadsDeletePostData, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, MutationVariables<DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostParameters, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteThreadFullappApiThreadsDeletePostSchema, DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostParameters, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, TContext>;
            select?: (mutation: Mutation<DeleteThreadFullappApiThreadsDeletePostData, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, MutationVariables<DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Delete Thread
         * @description Delete a thread for all participants.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostParameters, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteThreadFullappApiThreadsDeletePostSchema, DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostParameters, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Delete Thread
         * @description Delete a thread for all participants.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.deleteThreadFullappApiThreadsDeletePost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.deleteThreadFullappApiThreadsDeletePost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostParameters, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteThreadFullappApiThreadsDeletePostSchema, DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostParameters, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, TContext>): Mutation<DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostError, MutationVariables<DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostParameters, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteThreadFullappApiThreadsDeletePostSchema, DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostParameters, OperationError<DeleteThreadFullappApiThreadsDeletePostError>, TContext>): Array<Mutation<DeleteThreadFullappApiThreadsDeletePostData, DeleteThreadFullappApiThreadsDeletePostError, MutationVariables<DeleteThreadFullappApiThreadsDeletePostBody, DeleteThreadFullappApiThreadsDeletePostParameters>, TContext>>;
        };
        schema: DeleteThreadFullappApiThreadsDeletePostSchema;
        types: {
            parameters: DeleteThreadFullappApiThreadsDeletePostParameters;
            data: DeleteThreadFullappApiThreadsDeletePostData;
            error: DeleteThreadFullappApiThreadsDeletePostError;
            body: DeleteThreadFullappApiThreadsDeletePostBody;
        };
    };
    /**
     * @summary Hide Thread
     * @description Hide a thread for the current user only.
     */
    hideThreadFullappApiThreadsHidePost: {
        /**
         * @summary Hide Thread
         * @description Hide a thread for the current user only.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostParameters, TMeta, TSignal>, client?: (schema: HideThreadFullappApiThreadsHidePostSchema, options: ServiceOperationMutationFnOptions<HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostError>>): Promise<RequestFnResponse<HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostError>>;
        /**
         * @summary Hide Thread
         * @description Hide a thread for the current user only.
         */
        getMutationKey(parameters: DeepReadonly<HideThreadFullappApiThreadsHidePostParameters> | void): ServiceOperationMutationKey<HideThreadFullappApiThreadsHidePostSchema, HideThreadFullappApiThreadsHidePostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Hide Thread
         * @description Hide a thread for the current user only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.hideThreadFullappApiThreadsHidePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.hideThreadFullappApiThreadsHidePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends HideThreadFullappApiThreadsHidePostBody, TContext = unknown>(parameters: DeepReadonly<HideThreadFullappApiThreadsHidePostParameters>, options?: ServiceOperationUseMutationOptions<HideThreadFullappApiThreadsHidePostSchema, HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostParameters, TVariables, OperationError<HideThreadFullappApiThreadsHidePostError>, TContext>): UseMutationResult<HideThreadFullappApiThreadsHidePostData, OperationError<HideThreadFullappApiThreadsHidePostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Hide Thread
         * @description Hide a thread for the current user only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.hideThreadFullappApiThreadsHidePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.hideThreadFullappApiThreadsHidePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<HideThreadFullappApiThreadsHidePostSchema, HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostParameters, TVariables, OperationError<HideThreadFullappApiThreadsHidePostError>, TContext>): UseMutationResult<HideThreadFullappApiThreadsHidePostData, OperationError<HideThreadFullappApiThreadsHidePostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Hide Thread
         * @description Hide a thread for the current user only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const hideThreadFullappApiThreadsHidePostTotal = qraft.fullappApiService.hideThreadFullappApiThreadsHidePost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const hideThreadFullappApiThreadsHidePostTotal = qraft.fullappApiService.hideThreadFullappApiThreadsHidePost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostParameters, OperationError<HideThreadFullappApiThreadsHidePostError>, TContext> | MutationFiltersByMutationKey<HideThreadFullappApiThreadsHidePostSchema, HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostParameters, OperationError<HideThreadFullappApiThreadsHidePostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Hide Thread
         * @description Hide a thread for the current user only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const hideThreadFullappApiThreadsHidePostPendingMutationVariables = qraft.fullappApiService.hideThreadFullappApiThreadsHidePost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const hideThreadFullappApiThreadsHidePostMutationData = qraft.fullappApiService.hideThreadFullappApiThreadsHidePost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<HideThreadFullappApiThreadsHidePostData, OperationError<HideThreadFullappApiThreadsHidePostError>, MutationVariables<HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostParameters, OperationError<HideThreadFullappApiThreadsHidePostError>, TContext> | MutationFiltersByMutationKey<HideThreadFullappApiThreadsHidePostSchema, HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostParameters, OperationError<HideThreadFullappApiThreadsHidePostError>, TContext>;
            select?: (mutation: Mutation<HideThreadFullappApiThreadsHidePostData, OperationError<HideThreadFullappApiThreadsHidePostError>, MutationVariables<HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Hide Thread
         * @description Hide a thread for the current user only.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostParameters, OperationError<HideThreadFullappApiThreadsHidePostError>, TContext> | MutationFiltersByMutationKey<HideThreadFullappApiThreadsHidePostSchema, HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostParameters, OperationError<HideThreadFullappApiThreadsHidePostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Hide Thread
         * @description Hide a thread for the current user only.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.hideThreadFullappApiThreadsHidePost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.hideThreadFullappApiThreadsHidePost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostParameters, OperationError<HideThreadFullappApiThreadsHidePostError>, TContext> | MutationFiltersByMutationKey<HideThreadFullappApiThreadsHidePostSchema, HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostParameters, OperationError<HideThreadFullappApiThreadsHidePostError>, TContext>): Mutation<HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostError, MutationVariables<HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostParameters, OperationError<HideThreadFullappApiThreadsHidePostError>, TContext> | MutationFiltersByMutationKey<HideThreadFullappApiThreadsHidePostSchema, HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostParameters, OperationError<HideThreadFullappApiThreadsHidePostError>, TContext>): Array<Mutation<HideThreadFullappApiThreadsHidePostData, HideThreadFullappApiThreadsHidePostError, MutationVariables<HideThreadFullappApiThreadsHidePostBody, HideThreadFullappApiThreadsHidePostParameters>, TContext>>;
        };
        schema: HideThreadFullappApiThreadsHidePostSchema;
        types: {
            parameters: HideThreadFullappApiThreadsHidePostParameters;
            data: HideThreadFullappApiThreadsHidePostData;
            error: HideThreadFullappApiThreadsHidePostError;
            body: HideThreadFullappApiThreadsHidePostBody;
        };
    };
    /**
     * @summary Mark Thread Read
     * @description Mark a thread as read for the current user.
     */
    markThreadReadFullappApiThreadsReadPost: {
        /**
         * @summary Mark Thread Read
         * @description Mark a thread as read for the current user.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostParameters, TMeta, TSignal>, client?: (schema: MarkThreadReadFullappApiThreadsReadPostSchema, options: ServiceOperationMutationFnOptions<MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostError>>): Promise<RequestFnResponse<MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostError>>;
        /**
         * @summary Mark Thread Read
         * @description Mark a thread as read for the current user.
         */
        getMutationKey(parameters: DeepReadonly<MarkThreadReadFullappApiThreadsReadPostParameters> | void): ServiceOperationMutationKey<MarkThreadReadFullappApiThreadsReadPostSchema, MarkThreadReadFullappApiThreadsReadPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark Thread Read
         * @description Mark a thread as read for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markThreadReadFullappApiThreadsReadPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markThreadReadFullappApiThreadsReadPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MarkThreadReadFullappApiThreadsReadPostBody, TContext = unknown>(parameters: DeepReadonly<MarkThreadReadFullappApiThreadsReadPostParameters>, options?: ServiceOperationUseMutationOptions<MarkThreadReadFullappApiThreadsReadPostSchema, MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostParameters, TVariables, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, TContext>): UseMutationResult<MarkThreadReadFullappApiThreadsReadPostData, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark Thread Read
         * @description Mark a thread as read for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markThreadReadFullappApiThreadsReadPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markThreadReadFullappApiThreadsReadPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<MarkThreadReadFullappApiThreadsReadPostSchema, MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostParameters, TVariables, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, TContext>): UseMutationResult<MarkThreadReadFullappApiThreadsReadPostData, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Mark Thread Read
         * @description Mark a thread as read for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const markThreadReadFullappApiThreadsReadPostTotal = qraft.fullappApiService.markThreadReadFullappApiThreadsReadPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const markThreadReadFullappApiThreadsReadPostTotal = qraft.fullappApiService.markThreadReadFullappApiThreadsReadPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostParameters, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, TContext> | MutationFiltersByMutationKey<MarkThreadReadFullappApiThreadsReadPostSchema, MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostParameters, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Mark Thread Read
         * @description Mark a thread as read for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const markThreadReadFullappApiThreadsReadPostPendingMutationVariables = qraft.fullappApiService.markThreadReadFullappApiThreadsReadPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const markThreadReadFullappApiThreadsReadPostMutationData = qraft.fullappApiService.markThreadReadFullappApiThreadsReadPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<MarkThreadReadFullappApiThreadsReadPostData, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, MutationVariables<MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostParameters, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, TContext> | MutationFiltersByMutationKey<MarkThreadReadFullappApiThreadsReadPostSchema, MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostParameters, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, TContext>;
            select?: (mutation: Mutation<MarkThreadReadFullappApiThreadsReadPostData, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, MutationVariables<MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Mark Thread Read
         * @description Mark a thread as read for the current user.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostParameters, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, TContext> | MutationFiltersByMutationKey<MarkThreadReadFullappApiThreadsReadPostSchema, MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostParameters, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Mark Thread Read
         * @description Mark a thread as read for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.markThreadReadFullappApiThreadsReadPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.markThreadReadFullappApiThreadsReadPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostParameters, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, TContext> | MutationFiltersByMutationKey<MarkThreadReadFullappApiThreadsReadPostSchema, MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostParameters, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, TContext>): Mutation<MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostError, MutationVariables<MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostParameters, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, TContext> | MutationFiltersByMutationKey<MarkThreadReadFullappApiThreadsReadPostSchema, MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostParameters, OperationError<MarkThreadReadFullappApiThreadsReadPostError>, TContext>): Array<Mutation<MarkThreadReadFullappApiThreadsReadPostData, MarkThreadReadFullappApiThreadsReadPostError, MutationVariables<MarkThreadReadFullappApiThreadsReadPostBody, MarkThreadReadFullappApiThreadsReadPostParameters>, TContext>>;
        };
        schema: MarkThreadReadFullappApiThreadsReadPostSchema;
        types: {
            parameters: MarkThreadReadFullappApiThreadsReadPostParameters;
            data: MarkThreadReadFullappApiThreadsReadPostData;
            error: MarkThreadReadFullappApiThreadsReadPostError;
            body: MarkThreadReadFullappApiThreadsReadPostBody;
        };
    };
    /**
     * @summary Mark Thread Unread
     * @description Mark a thread as unread for the current user.
     */
    markThreadUnreadFullappApiThreadsUnreadPost: {
        /**
         * @summary Mark Thread Unread
         * @description Mark a thread as unread for the current user.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostParameters, TMeta, TSignal>, client?: (schema: MarkThreadUnreadFullappApiThreadsUnreadPostSchema, options: ServiceOperationMutationFnOptions<MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostError>>): Promise<RequestFnResponse<MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostError>>;
        /**
         * @summary Mark Thread Unread
         * @description Mark a thread as unread for the current user.
         */
        getMutationKey(parameters: DeepReadonly<MarkThreadUnreadFullappApiThreadsUnreadPostParameters> | void): ServiceOperationMutationKey<MarkThreadUnreadFullappApiThreadsUnreadPostSchema, MarkThreadUnreadFullappApiThreadsUnreadPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark Thread Unread
         * @description Mark a thread as unread for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markThreadUnreadFullappApiThreadsUnreadPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markThreadUnreadFullappApiThreadsUnreadPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MarkThreadUnreadFullappApiThreadsUnreadPostBody, TContext = unknown>(parameters: DeepReadonly<MarkThreadUnreadFullappApiThreadsUnreadPostParameters>, options?: ServiceOperationUseMutationOptions<MarkThreadUnreadFullappApiThreadsUnreadPostSchema, MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostParameters, TVariables, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, TContext>): UseMutationResult<MarkThreadUnreadFullappApiThreadsUnreadPostData, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Mark Thread Unread
         * @description Mark a thread as unread for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markThreadUnreadFullappApiThreadsUnreadPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.markThreadUnreadFullappApiThreadsUnreadPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<MarkThreadUnreadFullappApiThreadsUnreadPostSchema, MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostParameters, TVariables, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, TContext>): UseMutationResult<MarkThreadUnreadFullappApiThreadsUnreadPostData, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Mark Thread Unread
         * @description Mark a thread as unread for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const markThreadUnreadFullappApiThreadsUnreadPostTotal = qraft.fullappApiService.markThreadUnreadFullappApiThreadsUnreadPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const markThreadUnreadFullappApiThreadsUnreadPostTotal = qraft.fullappApiService.markThreadUnreadFullappApiThreadsUnreadPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostParameters, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, TContext> | MutationFiltersByMutationKey<MarkThreadUnreadFullappApiThreadsUnreadPostSchema, MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostParameters, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Mark Thread Unread
         * @description Mark a thread as unread for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const markThreadUnreadFullappApiThreadsUnreadPostPendingMutationVariables = qraft.fullappApiService.markThreadUnreadFullappApiThreadsUnreadPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const markThreadUnreadFullappApiThreadsUnreadPostMutationData = qraft.fullappApiService.markThreadUnreadFullappApiThreadsUnreadPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<MarkThreadUnreadFullappApiThreadsUnreadPostData, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, MutationVariables<MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostParameters, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, TContext> | MutationFiltersByMutationKey<MarkThreadUnreadFullappApiThreadsUnreadPostSchema, MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostParameters, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, TContext>;
            select?: (mutation: Mutation<MarkThreadUnreadFullappApiThreadsUnreadPostData, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, MutationVariables<MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Mark Thread Unread
         * @description Mark a thread as unread for the current user.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostParameters, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, TContext> | MutationFiltersByMutationKey<MarkThreadUnreadFullappApiThreadsUnreadPostSchema, MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostParameters, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Mark Thread Unread
         * @description Mark a thread as unread for the current user.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.markThreadUnreadFullappApiThreadsUnreadPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.markThreadUnreadFullappApiThreadsUnreadPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostParameters, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, TContext> | MutationFiltersByMutationKey<MarkThreadUnreadFullappApiThreadsUnreadPostSchema, MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostParameters, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, TContext>): Mutation<MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostError, MutationVariables<MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostParameters, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, TContext> | MutationFiltersByMutationKey<MarkThreadUnreadFullappApiThreadsUnreadPostSchema, MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostParameters, OperationError<MarkThreadUnreadFullappApiThreadsUnreadPostError>, TContext>): Array<Mutation<MarkThreadUnreadFullappApiThreadsUnreadPostData, MarkThreadUnreadFullappApiThreadsUnreadPostError, MutationVariables<MarkThreadUnreadFullappApiThreadsUnreadPostBody, MarkThreadUnreadFullappApiThreadsUnreadPostParameters>, TContext>>;
        };
        schema: MarkThreadUnreadFullappApiThreadsUnreadPostSchema;
        types: {
            parameters: MarkThreadUnreadFullappApiThreadsUnreadPostParameters;
            data: MarkThreadUnreadFullappApiThreadsUnreadPostData;
            error: MarkThreadUnreadFullappApiThreadsUnreadPostError;
            body: MarkThreadUnreadFullappApiThreadsUnreadPostBody;
        };
    };
    /**
     * @summary Add
     * @description Create a user-owned canned response.
     *
     * Missing/null type/target_id/content -> 433 ``validation_error``; empty string /
     * 0 / unknown type pass validation (only null is rejected) and the row is
     * inserted. Returns ``{id, is_builtin(int 0), content}``.
     */
    addFullappApiCannedResponsesAddPost: {
        /**
         * @summary Add
         * @description Create a user-owned canned response.
         *
         * Missing/null type/target_id/content -> 433 ``validation_error``; empty string /
         * 0 / unknown type pass validation (only null is rejected) and the row is
         * inserted. Returns ``{id, is_builtin(int 0), content}``.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostParameters, TMeta, TSignal>, client?: (schema: AddFullappApiCannedResponsesAddPostSchema, options: ServiceOperationMutationFnOptions<AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostError>>): Promise<RequestFnResponse<AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostError>>;
        /**
         * @summary Add
         * @description Create a user-owned canned response.
         *
         * Missing/null type/target_id/content -> 433 ``validation_error``; empty string /
         * 0 / unknown type pass validation (only null is rejected) and the row is
         * inserted. Returns ``{id, is_builtin(int 0), content}``.
         */
        getMutationKey(parameters: DeepReadonly<AddFullappApiCannedResponsesAddPostParameters> | void): ServiceOperationMutationKey<AddFullappApiCannedResponsesAddPostSchema, AddFullappApiCannedResponsesAddPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Add
         * @description Create a user-owned canned response.
         *
         * Missing/null type/target_id/content -> 433 ``validation_error``; empty string /
         * 0 / unknown type pass validation (only null is rejected) and the row is
         * inserted. Returns ``{id, is_builtin(int 0), content}``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.addFullappApiCannedResponsesAddPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.addFullappApiCannedResponsesAddPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AddFullappApiCannedResponsesAddPostBody, TContext = unknown>(parameters: DeepReadonly<AddFullappApiCannedResponsesAddPostParameters>, options?: ServiceOperationUseMutationOptions<AddFullappApiCannedResponsesAddPostSchema, AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostParameters, TVariables, OperationError<AddFullappApiCannedResponsesAddPostError>, TContext>): UseMutationResult<AddFullappApiCannedResponsesAddPostData, OperationError<AddFullappApiCannedResponsesAddPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Add
         * @description Create a user-owned canned response.
         *
         * Missing/null type/target_id/content -> 433 ``validation_error``; empty string /
         * 0 / unknown type pass validation (only null is rejected) and the row is
         * inserted. Returns ``{id, is_builtin(int 0), content}``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.addFullappApiCannedResponsesAddPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.addFullappApiCannedResponsesAddPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AddFullappApiCannedResponsesAddPostSchema, AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostParameters, TVariables, OperationError<AddFullappApiCannedResponsesAddPostError>, TContext>): UseMutationResult<AddFullappApiCannedResponsesAddPostData, OperationError<AddFullappApiCannedResponsesAddPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Add
         * @description Create a user-owned canned response.
         *
         * Missing/null type/target_id/content -> 433 ``validation_error``; empty string /
         * 0 / unknown type pass validation (only null is rejected) and the row is
         * inserted. Returns ``{id, is_builtin(int 0), content}``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const addFullappApiCannedResponsesAddPostTotal = qraft.fullappApiService.addFullappApiCannedResponsesAddPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const addFullappApiCannedResponsesAddPostTotal = qraft.fullappApiService.addFullappApiCannedResponsesAddPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostParameters, OperationError<AddFullappApiCannedResponsesAddPostError>, TContext> | MutationFiltersByMutationKey<AddFullappApiCannedResponsesAddPostSchema, AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostParameters, OperationError<AddFullappApiCannedResponsesAddPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Add
         * @description Create a user-owned canned response.
         *
         * Missing/null type/target_id/content -> 433 ``validation_error``; empty string /
         * 0 / unknown type pass validation (only null is rejected) and the row is
         * inserted. Returns ``{id, is_builtin(int 0), content}``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const addFullappApiCannedResponsesAddPostPendingMutationVariables = qraft.fullappApiService.addFullappApiCannedResponsesAddPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const addFullappApiCannedResponsesAddPostMutationData = qraft.fullappApiService.addFullappApiCannedResponsesAddPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AddFullappApiCannedResponsesAddPostData, OperationError<AddFullappApiCannedResponsesAddPostError>, MutationVariables<AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostParameters, OperationError<AddFullappApiCannedResponsesAddPostError>, TContext> | MutationFiltersByMutationKey<AddFullappApiCannedResponsesAddPostSchema, AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostParameters, OperationError<AddFullappApiCannedResponsesAddPostError>, TContext>;
            select?: (mutation: Mutation<AddFullappApiCannedResponsesAddPostData, OperationError<AddFullappApiCannedResponsesAddPostError>, MutationVariables<AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Add
         * @description Create a user-owned canned response.
         *
         * Missing/null type/target_id/content -> 433 ``validation_error``; empty string /
         * 0 / unknown type pass validation (only null is rejected) and the row is
         * inserted. Returns ``{id, is_builtin(int 0), content}``.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostParameters, OperationError<AddFullappApiCannedResponsesAddPostError>, TContext> | MutationFiltersByMutationKey<AddFullappApiCannedResponsesAddPostSchema, AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostParameters, OperationError<AddFullappApiCannedResponsesAddPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Add
         * @description Create a user-owned canned response.
         *
         * Missing/null type/target_id/content -> 433 ``validation_error``; empty string /
         * 0 / unknown type pass validation (only null is rejected) and the row is
         * inserted. Returns ``{id, is_builtin(int 0), content}``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.addFullappApiCannedResponsesAddPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.addFullappApiCannedResponsesAddPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostParameters, OperationError<AddFullappApiCannedResponsesAddPostError>, TContext> | MutationFiltersByMutationKey<AddFullappApiCannedResponsesAddPostSchema, AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostParameters, OperationError<AddFullappApiCannedResponsesAddPostError>, TContext>): Mutation<AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostError, MutationVariables<AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostParameters, OperationError<AddFullappApiCannedResponsesAddPostError>, TContext> | MutationFiltersByMutationKey<AddFullappApiCannedResponsesAddPostSchema, AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostParameters, OperationError<AddFullappApiCannedResponsesAddPostError>, TContext>): Array<Mutation<AddFullappApiCannedResponsesAddPostData, AddFullappApiCannedResponsesAddPostError, MutationVariables<AddFullappApiCannedResponsesAddPostBody, AddFullappApiCannedResponsesAddPostParameters>, TContext>>;
        };
        schema: AddFullappApiCannedResponsesAddPostSchema;
        types: {
            parameters: AddFullappApiCannedResponsesAddPostParameters;
            data: AddFullappApiCannedResponsesAddPostData;
            error: AddFullappApiCannedResponsesAddPostError;
            body: AddFullappApiCannedResponsesAddPostBody;
        };
    };
    /**
     * @summary Fetch
     * @description Return the auth user's own + built-in + target-agnostic rows for the given
     * type/target_id as a bare array, fixed page size 5.
     *
     * Missing/null type/target_id -> 433; empty/unknown values pass and just match no
     * rows.
     */
    fetchFullappApiCannedResponsesFetchPost: {
        /**
         * @summary Fetch
         * @description Return the auth user's own + built-in + target-agnostic rows for the given
         * type/target_id as a bare array, fixed page size 5.
         *
         * Missing/null type/target_id -> 433; empty/unknown values pass and just match no
         * rows.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostParameters, TMeta, TSignal>, client?: (schema: FetchFullappApiCannedResponsesFetchPostSchema, options: ServiceOperationMutationFnOptions<FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostError>>): Promise<RequestFnResponse<FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostError>>;
        /**
         * @summary Fetch
         * @description Return the auth user's own + built-in + target-agnostic rows for the given
         * type/target_id as a bare array, fixed page size 5.
         *
         * Missing/null type/target_id -> 433; empty/unknown values pass and just match no
         * rows.
         */
        getMutationKey(parameters: DeepReadonly<FetchFullappApiCannedResponsesFetchPostParameters> | void): ServiceOperationMutationKey<FetchFullappApiCannedResponsesFetchPostSchema, FetchFullappApiCannedResponsesFetchPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fetch
         * @description Return the auth user's own + built-in + target-agnostic rows for the given
         * type/target_id as a bare array, fixed page size 5.
         *
         * Missing/null type/target_id -> 433; empty/unknown values pass and just match no
         * rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchFullappApiCannedResponsesFetchPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchFullappApiCannedResponsesFetchPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends FetchFullappApiCannedResponsesFetchPostBody, TContext = unknown>(parameters: DeepReadonly<FetchFullappApiCannedResponsesFetchPostParameters>, options?: ServiceOperationUseMutationOptions<FetchFullappApiCannedResponsesFetchPostSchema, FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostParameters, TVariables, OperationError<FetchFullappApiCannedResponsesFetchPostError>, TContext>): UseMutationResult<FetchFullappApiCannedResponsesFetchPostData, OperationError<FetchFullappApiCannedResponsesFetchPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fetch
         * @description Return the auth user's own + built-in + target-agnostic rows for the given
         * type/target_id as a bare array, fixed page size 5.
         *
         * Missing/null type/target_id -> 433; empty/unknown values pass and just match no
         * rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchFullappApiCannedResponsesFetchPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchFullappApiCannedResponsesFetchPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<FetchFullappApiCannedResponsesFetchPostSchema, FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostParameters, TVariables, OperationError<FetchFullappApiCannedResponsesFetchPostError>, TContext>): UseMutationResult<FetchFullappApiCannedResponsesFetchPostData, OperationError<FetchFullappApiCannedResponsesFetchPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Fetch
         * @description Return the auth user's own + built-in + target-agnostic rows for the given
         * type/target_id as a bare array, fixed page size 5.
         *
         * Missing/null type/target_id -> 433; empty/unknown values pass and just match no
         * rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const fetchFullappApiCannedResponsesFetchPostTotal = qraft.fullappApiService.fetchFullappApiCannedResponsesFetchPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const fetchFullappApiCannedResponsesFetchPostTotal = qraft.fullappApiService.fetchFullappApiCannedResponsesFetchPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostParameters, OperationError<FetchFullappApiCannedResponsesFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiCannedResponsesFetchPostSchema, FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostParameters, OperationError<FetchFullappApiCannedResponsesFetchPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Fetch
         * @description Return the auth user's own + built-in + target-agnostic rows for the given
         * type/target_id as a bare array, fixed page size 5.
         *
         * Missing/null type/target_id -> 433; empty/unknown values pass and just match no
         * rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const fetchFullappApiCannedResponsesFetchPostPendingMutationVariables = qraft.fullappApiService.fetchFullappApiCannedResponsesFetchPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const fetchFullappApiCannedResponsesFetchPostMutationData = qraft.fullappApiService.fetchFullappApiCannedResponsesFetchPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<FetchFullappApiCannedResponsesFetchPostData, OperationError<FetchFullappApiCannedResponsesFetchPostError>, MutationVariables<FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostParameters, OperationError<FetchFullappApiCannedResponsesFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiCannedResponsesFetchPostSchema, FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostParameters, OperationError<FetchFullappApiCannedResponsesFetchPostError>, TContext>;
            select?: (mutation: Mutation<FetchFullappApiCannedResponsesFetchPostData, OperationError<FetchFullappApiCannedResponsesFetchPostError>, MutationVariables<FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Fetch
         * @description Return the auth user's own + built-in + target-agnostic rows for the given
         * type/target_id as a bare array, fixed page size 5.
         *
         * Missing/null type/target_id -> 433; empty/unknown values pass and just match no
         * rows.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostParameters, OperationError<FetchFullappApiCannedResponsesFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiCannedResponsesFetchPostSchema, FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostParameters, OperationError<FetchFullappApiCannedResponsesFetchPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Fetch
         * @description Return the auth user's own + built-in + target-agnostic rows for the given
         * type/target_id as a bare array, fixed page size 5.
         *
         * Missing/null type/target_id -> 433; empty/unknown values pass and just match no
         * rows.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.fetchFullappApiCannedResponsesFetchPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.fetchFullappApiCannedResponsesFetchPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostParameters, OperationError<FetchFullappApiCannedResponsesFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiCannedResponsesFetchPostSchema, FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostParameters, OperationError<FetchFullappApiCannedResponsesFetchPostError>, TContext>): Mutation<FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostError, MutationVariables<FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostParameters, OperationError<FetchFullappApiCannedResponsesFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchFullappApiCannedResponsesFetchPostSchema, FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostParameters, OperationError<FetchFullappApiCannedResponsesFetchPostError>, TContext>): Array<Mutation<FetchFullappApiCannedResponsesFetchPostData, FetchFullappApiCannedResponsesFetchPostError, MutationVariables<FetchFullappApiCannedResponsesFetchPostBody, FetchFullappApiCannedResponsesFetchPostParameters>, TContext>>;
        };
        schema: FetchFullappApiCannedResponsesFetchPostSchema;
        types: {
            parameters: FetchFullappApiCannedResponsesFetchPostParameters;
            data: FetchFullappApiCannedResponsesFetchPostData;
            error: FetchFullappApiCannedResponsesFetchPostError;
            body: FetchFullappApiCannedResponsesFetchPostBody;
        };
    };
    /**
     * @summary Edit
     * @description Owner-scoped content overwrite.
     *
     * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
     * (invalid_ownership). A present, truthy, non-numeric id is the only ``is_numeric``
     * 433; ``id:""`` falls through to 404.
     */
    editFullappApiCannedResponsesEditPost: {
        /**
         * @summary Edit
         * @description Owner-scoped content overwrite.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). A present, truthy, non-numeric id is the only ``is_numeric``
         * 433; ``id:""`` falls through to 404.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostParameters, TMeta, TSignal>, client?: (schema: EditFullappApiCannedResponsesEditPostSchema, options: ServiceOperationMutationFnOptions<EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostError>>): Promise<RequestFnResponse<EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostError>>;
        /**
         * @summary Edit
         * @description Owner-scoped content overwrite.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). A present, truthy, non-numeric id is the only ``is_numeric``
         * 433; ``id:""`` falls through to 404.
         */
        getMutationKey(parameters: DeepReadonly<EditFullappApiCannedResponsesEditPostParameters> | void): ServiceOperationMutationKey<EditFullappApiCannedResponsesEditPostSchema, EditFullappApiCannedResponsesEditPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Edit
         * @description Owner-scoped content overwrite.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). A present, truthy, non-numeric id is the only ``is_numeric``
         * 433; ``id:""`` falls through to 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.editFullappApiCannedResponsesEditPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.editFullappApiCannedResponsesEditPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends EditFullappApiCannedResponsesEditPostBody, TContext = unknown>(parameters: DeepReadonly<EditFullappApiCannedResponsesEditPostParameters>, options?: ServiceOperationUseMutationOptions<EditFullappApiCannedResponsesEditPostSchema, EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostParameters, TVariables, OperationError<EditFullappApiCannedResponsesEditPostError>, TContext>): UseMutationResult<EditFullappApiCannedResponsesEditPostData, OperationError<EditFullappApiCannedResponsesEditPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Edit
         * @description Owner-scoped content overwrite.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). A present, truthy, non-numeric id is the only ``is_numeric``
         * 433; ``id:""`` falls through to 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.editFullappApiCannedResponsesEditPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.editFullappApiCannedResponsesEditPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<EditFullappApiCannedResponsesEditPostSchema, EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostParameters, TVariables, OperationError<EditFullappApiCannedResponsesEditPostError>, TContext>): UseMutationResult<EditFullappApiCannedResponsesEditPostData, OperationError<EditFullappApiCannedResponsesEditPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Edit
         * @description Owner-scoped content overwrite.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). A present, truthy, non-numeric id is the only ``is_numeric``
         * 433; ``id:""`` falls through to 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const editFullappApiCannedResponsesEditPostTotal = qraft.fullappApiService.editFullappApiCannedResponsesEditPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const editFullappApiCannedResponsesEditPostTotal = qraft.fullappApiService.editFullappApiCannedResponsesEditPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostParameters, OperationError<EditFullappApiCannedResponsesEditPostError>, TContext> | MutationFiltersByMutationKey<EditFullappApiCannedResponsesEditPostSchema, EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostParameters, OperationError<EditFullappApiCannedResponsesEditPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Edit
         * @description Owner-scoped content overwrite.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). A present, truthy, non-numeric id is the only ``is_numeric``
         * 433; ``id:""`` falls through to 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const editFullappApiCannedResponsesEditPostPendingMutationVariables = qraft.fullappApiService.editFullappApiCannedResponsesEditPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const editFullappApiCannedResponsesEditPostMutationData = qraft.fullappApiService.editFullappApiCannedResponsesEditPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<EditFullappApiCannedResponsesEditPostData, OperationError<EditFullappApiCannedResponsesEditPostError>, MutationVariables<EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostParameters, OperationError<EditFullappApiCannedResponsesEditPostError>, TContext> | MutationFiltersByMutationKey<EditFullappApiCannedResponsesEditPostSchema, EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostParameters, OperationError<EditFullappApiCannedResponsesEditPostError>, TContext>;
            select?: (mutation: Mutation<EditFullappApiCannedResponsesEditPostData, OperationError<EditFullappApiCannedResponsesEditPostError>, MutationVariables<EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Edit
         * @description Owner-scoped content overwrite.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). A present, truthy, non-numeric id is the only ``is_numeric``
         * 433; ``id:""`` falls through to 404.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostParameters, OperationError<EditFullappApiCannedResponsesEditPostError>, TContext> | MutationFiltersByMutationKey<EditFullappApiCannedResponsesEditPostSchema, EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostParameters, OperationError<EditFullappApiCannedResponsesEditPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Edit
         * @description Owner-scoped content overwrite.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). A present, truthy, non-numeric id is the only ``is_numeric``
         * 433; ``id:""`` falls through to 404.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.editFullappApiCannedResponsesEditPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.editFullappApiCannedResponsesEditPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostParameters, OperationError<EditFullappApiCannedResponsesEditPostError>, TContext> | MutationFiltersByMutationKey<EditFullappApiCannedResponsesEditPostSchema, EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostParameters, OperationError<EditFullappApiCannedResponsesEditPostError>, TContext>): Mutation<EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostError, MutationVariables<EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostParameters, OperationError<EditFullappApiCannedResponsesEditPostError>, TContext> | MutationFiltersByMutationKey<EditFullappApiCannedResponsesEditPostSchema, EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostParameters, OperationError<EditFullappApiCannedResponsesEditPostError>, TContext>): Array<Mutation<EditFullappApiCannedResponsesEditPostData, EditFullappApiCannedResponsesEditPostError, MutationVariables<EditFullappApiCannedResponsesEditPostBody, EditFullappApiCannedResponsesEditPostParameters>, TContext>>;
        };
        schema: EditFullappApiCannedResponsesEditPostSchema;
        types: {
            parameters: EditFullappApiCannedResponsesEditPostParameters;
            data: EditFullappApiCannedResponsesEditPostData;
            error: EditFullappApiCannedResponsesEditPostError;
            body: EditFullappApiCannedResponsesEditPostBody;
        };
    };
    /**
     * @summary Delete
     * @description Owner-scoped soft delete.
     *
     * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
     * (invalid_ownership). ``id:""``/0/nonexistent fall through to 404. Success returns
     * ``{success:true, data:[]}`` (empty array).
     */
    deleteFullappApiCannedResponsesDeletePost: {
        /**
         * @summary Delete
         * @description Owner-scoped soft delete.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). ``id:""``/0/nonexistent fall through to 404. Success returns
         * ``{success:true, data:[]}`` (empty array).
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostParameters, TMeta, TSignal>, client?: (schema: DeleteFullappApiCannedResponsesDeletePostSchema, options: ServiceOperationMutationFnOptions<DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostError>>): Promise<RequestFnResponse<DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostError>>;
        /**
         * @summary Delete
         * @description Owner-scoped soft delete.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). ``id:""``/0/nonexistent fall through to 404. Success returns
         * ``{success:true, data:[]}`` (empty array).
         */
        getMutationKey(parameters: DeepReadonly<DeleteFullappApiCannedResponsesDeletePostParameters> | void): ServiceOperationMutationKey<DeleteFullappApiCannedResponsesDeletePostSchema, DeleteFullappApiCannedResponsesDeletePostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete
         * @description Owner-scoped soft delete.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). ``id:""``/0/nonexistent fall through to 404. Success returns
         * ``{success:true, data:[]}`` (empty array).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deleteFullappApiCannedResponsesDeletePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deleteFullappApiCannedResponsesDeletePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DeleteFullappApiCannedResponsesDeletePostBody, TContext = unknown>(parameters: DeepReadonly<DeleteFullappApiCannedResponsesDeletePostParameters>, options?: ServiceOperationUseMutationOptions<DeleteFullappApiCannedResponsesDeletePostSchema, DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostParameters, TVariables, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, TContext>): UseMutationResult<DeleteFullappApiCannedResponsesDeletePostData, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Delete
         * @description Owner-scoped soft delete.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). ``id:""``/0/nonexistent fall through to 404. Success returns
         * ``{success:true, data:[]}`` (empty array).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deleteFullappApiCannedResponsesDeletePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.deleteFullappApiCannedResponsesDeletePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DeleteFullappApiCannedResponsesDeletePostSchema, DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostParameters, TVariables, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, TContext>): UseMutationResult<DeleteFullappApiCannedResponsesDeletePostData, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Delete
         * @description Owner-scoped soft delete.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). ``id:""``/0/nonexistent fall through to 404. Success returns
         * ``{success:true, data:[]}`` (empty array).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const deleteFullappApiCannedResponsesDeletePostTotal = qraft.fullappApiService.deleteFullappApiCannedResponsesDeletePost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const deleteFullappApiCannedResponsesDeletePostTotal = qraft.fullappApiService.deleteFullappApiCannedResponsesDeletePost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostParameters, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteFullappApiCannedResponsesDeletePostSchema, DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostParameters, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Delete
         * @description Owner-scoped soft delete.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). ``id:""``/0/nonexistent fall through to 404. Success returns
         * ``{success:true, data:[]}`` (empty array).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const deleteFullappApiCannedResponsesDeletePostPendingMutationVariables = qraft.fullappApiService.deleteFullappApiCannedResponsesDeletePost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const deleteFullappApiCannedResponsesDeletePostMutationData = qraft.fullappApiService.deleteFullappApiCannedResponsesDeletePost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DeleteFullappApiCannedResponsesDeletePostData, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, MutationVariables<DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostParameters, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteFullappApiCannedResponsesDeletePostSchema, DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostParameters, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, TContext>;
            select?: (mutation: Mutation<DeleteFullappApiCannedResponsesDeletePostData, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, MutationVariables<DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Delete
         * @description Owner-scoped soft delete.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). ``id:""``/0/nonexistent fall through to 404. Success returns
         * ``{success:true, data:[]}`` (empty array).
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostParameters, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteFullappApiCannedResponsesDeletePostSchema, DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostParameters, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Delete
         * @description Owner-scoped soft delete.
         *
         * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
         * (invalid_ownership). ``id:""``/0/nonexistent fall through to 404. Success returns
         * ``{success:true, data:[]}`` (empty array).
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.deleteFullappApiCannedResponsesDeletePost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.deleteFullappApiCannedResponsesDeletePost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostParameters, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteFullappApiCannedResponsesDeletePostSchema, DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostParameters, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, TContext>): Mutation<DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostError, MutationVariables<DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostParameters, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, TContext> | MutationFiltersByMutationKey<DeleteFullappApiCannedResponsesDeletePostSchema, DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostParameters, OperationError<DeleteFullappApiCannedResponsesDeletePostError>, TContext>): Array<Mutation<DeleteFullappApiCannedResponsesDeletePostData, DeleteFullappApiCannedResponsesDeletePostError, MutationVariables<DeleteFullappApiCannedResponsesDeletePostBody, DeleteFullappApiCannedResponsesDeletePostParameters>, TContext>>;
        };
        schema: DeleteFullappApiCannedResponsesDeletePostSchema;
        types: {
            parameters: DeleteFullappApiCannedResponsesDeletePostParameters;
            data: DeleteFullappApiCannedResponsesDeletePostData;
            error: DeleteFullappApiCannedResponsesDeletePostError;
            body: DeleteFullappApiCannedResponsesDeletePostBody;
        };
    };
    /** @summary Fetch Datatable Info */
    fetchDatatableInfoFullappApiDatatablesFetchPost: {
        /** @summary Fetch Datatable Info */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostParameters, TMeta, TSignal>, client?: (schema: FetchDatatableInfoFullappApiDatatablesFetchPostSchema, options: ServiceOperationMutationFnOptions<FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostError>>): Promise<RequestFnResponse<FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostError>>;
        /** @summary Fetch Datatable Info */
        getMutationKey(parameters: DeepReadonly<FetchDatatableInfoFullappApiDatatablesFetchPostParameters> | void): ServiceOperationMutationKey<FetchDatatableInfoFullappApiDatatablesFetchPostSchema, FetchDatatableInfoFullappApiDatatablesFetchPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fetch Datatable Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchDatatableInfoFullappApiDatatablesFetchPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchDatatableInfoFullappApiDatatablesFetchPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends FetchDatatableInfoFullappApiDatatablesFetchPostBody, TContext = unknown>(parameters: DeepReadonly<FetchDatatableInfoFullappApiDatatablesFetchPostParameters>, options?: ServiceOperationUseMutationOptions<FetchDatatableInfoFullappApiDatatablesFetchPostSchema, FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostParameters, TVariables, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, TContext>): UseMutationResult<FetchDatatableInfoFullappApiDatatablesFetchPostData, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fetch Datatable Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchDatatableInfoFullappApiDatatablesFetchPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.fetchDatatableInfoFullappApiDatatablesFetchPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<FetchDatatableInfoFullappApiDatatablesFetchPostSchema, FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostParameters, TVariables, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, TContext>): UseMutationResult<FetchDatatableInfoFullappApiDatatablesFetchPostData, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Fetch Datatable Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const fetchDatatableInfoFullappApiDatatablesFetchPostTotal = qraft.fullappApiService.fetchDatatableInfoFullappApiDatatablesFetchPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const fetchDatatableInfoFullappApiDatatablesFetchPostTotal = qraft.fullappApiService.fetchDatatableInfoFullappApiDatatablesFetchPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostParameters, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchDatatableInfoFullappApiDatatablesFetchPostSchema, FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostParameters, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Fetch Datatable Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const fetchDatatableInfoFullappApiDatatablesFetchPostPendingMutationVariables = qraft.fullappApiService.fetchDatatableInfoFullappApiDatatablesFetchPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const fetchDatatableInfoFullappApiDatatablesFetchPostMutationData = qraft.fullappApiService.fetchDatatableInfoFullappApiDatatablesFetchPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<FetchDatatableInfoFullappApiDatatablesFetchPostData, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, MutationVariables<FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostParameters, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchDatatableInfoFullappApiDatatablesFetchPostSchema, FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostParameters, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, TContext>;
            select?: (mutation: Mutation<FetchDatatableInfoFullappApiDatatablesFetchPostData, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, MutationVariables<FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Fetch Datatable Info */
        isMutating<TContext>(filters?: MutationFiltersByParameters<FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostParameters, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchDatatableInfoFullappApiDatatablesFetchPostSchema, FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostParameters, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Fetch Datatable Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.fetchDatatableInfoFullappApiDatatablesFetchPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.fetchDatatableInfoFullappApiDatatablesFetchPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostParameters, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchDatatableInfoFullappApiDatatablesFetchPostSchema, FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostParameters, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, TContext>): Mutation<FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostError, MutationVariables<FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostParameters, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchDatatableInfoFullappApiDatatablesFetchPostSchema, FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostParameters, OperationError<FetchDatatableInfoFullappApiDatatablesFetchPostError>, TContext>): Array<Mutation<FetchDatatableInfoFullappApiDatatablesFetchPostData, FetchDatatableInfoFullappApiDatatablesFetchPostError, MutationVariables<FetchDatatableInfoFullappApiDatatablesFetchPostBody, FetchDatatableInfoFullappApiDatatablesFetchPostParameters>, TContext>>;
        };
        schema: FetchDatatableInfoFullappApiDatatablesFetchPostSchema;
        types: {
            parameters: FetchDatatableInfoFullappApiDatatablesFetchPostParameters;
            data: FetchDatatableInfoFullappApiDatatablesFetchPostData;
            error: FetchDatatableInfoFullappApiDatatablesFetchPostError;
            body: FetchDatatableInfoFullappApiDatatablesFetchPostBody;
        };
    };
    /** @summary Datatable Info */
    datatableInfoFullappApiDatatablesInfoPost: {
        /** @summary Datatable Info */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostParameters, TMeta, TSignal>, client?: (schema: DatatableInfoFullappApiDatatablesInfoPostSchema, options: ServiceOperationMutationFnOptions<DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostError>>): Promise<RequestFnResponse<DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostError>>;
        /** @summary Datatable Info */
        getMutationKey(parameters: DeepReadonly<DatatableInfoFullappApiDatatablesInfoPostParameters> | void): ServiceOperationMutationKey<DatatableInfoFullappApiDatatablesInfoPostSchema, DatatableInfoFullappApiDatatablesInfoPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Datatable Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.datatableInfoFullappApiDatatablesInfoPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.datatableInfoFullappApiDatatablesInfoPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DatatableInfoFullappApiDatatablesInfoPostBody, TContext = unknown>(parameters: DeepReadonly<DatatableInfoFullappApiDatatablesInfoPostParameters>, options?: ServiceOperationUseMutationOptions<DatatableInfoFullappApiDatatablesInfoPostSchema, DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostParameters, TVariables, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, TContext>): UseMutationResult<DatatableInfoFullappApiDatatablesInfoPostData, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Datatable Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.datatableInfoFullappApiDatatablesInfoPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.datatableInfoFullappApiDatatablesInfoPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DatatableInfoFullappApiDatatablesInfoPostSchema, DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostParameters, TVariables, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, TContext>): UseMutationResult<DatatableInfoFullappApiDatatablesInfoPostData, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Datatable Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const datatableInfoFullappApiDatatablesInfoPostTotal = qraft.fullappApiService.datatableInfoFullappApiDatatablesInfoPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const datatableInfoFullappApiDatatablesInfoPostTotal = qraft.fullappApiService.datatableInfoFullappApiDatatablesInfoPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostParameters, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, TContext> | MutationFiltersByMutationKey<DatatableInfoFullappApiDatatablesInfoPostSchema, DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostParameters, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Datatable Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const datatableInfoFullappApiDatatablesInfoPostPendingMutationVariables = qraft.fullappApiService.datatableInfoFullappApiDatatablesInfoPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const datatableInfoFullappApiDatatablesInfoPostMutationData = qraft.fullappApiService.datatableInfoFullappApiDatatablesInfoPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DatatableInfoFullappApiDatatablesInfoPostData, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, MutationVariables<DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostParameters, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, TContext> | MutationFiltersByMutationKey<DatatableInfoFullappApiDatatablesInfoPostSchema, DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostParameters, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, TContext>;
            select?: (mutation: Mutation<DatatableInfoFullappApiDatatablesInfoPostData, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, MutationVariables<DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Datatable Info */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostParameters, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, TContext> | MutationFiltersByMutationKey<DatatableInfoFullappApiDatatablesInfoPostSchema, DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostParameters, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Datatable Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.datatableInfoFullappApiDatatablesInfoPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.datatableInfoFullappApiDatatablesInfoPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostParameters, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, TContext> | MutationFiltersByMutationKey<DatatableInfoFullappApiDatatablesInfoPostSchema, DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostParameters, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, TContext>): Mutation<DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostError, MutationVariables<DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostParameters, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, TContext> | MutationFiltersByMutationKey<DatatableInfoFullappApiDatatablesInfoPostSchema, DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostParameters, OperationError<DatatableInfoFullappApiDatatablesInfoPostError>, TContext>): Array<Mutation<DatatableInfoFullappApiDatatablesInfoPostData, DatatableInfoFullappApiDatatablesInfoPostError, MutationVariables<DatatableInfoFullappApiDatatablesInfoPostBody, DatatableInfoFullappApiDatatablesInfoPostParameters>, TContext>>;
        };
        schema: DatatableInfoFullappApiDatatablesInfoPostSchema;
        types: {
            parameters: DatatableInfoFullappApiDatatablesInfoPostParameters;
            data: DatatableInfoFullappApiDatatablesInfoPostData;
            error: DatatableInfoFullappApiDatatablesInfoPostError;
            body: DatatableInfoFullappApiDatatablesInfoPostBody;
        };
    };
    /** @summary Announcement Detail */
    announcementDetailFullappApiAnnouncementsDetailPost: {
        /** @summary Announcement Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters, TMeta, TSignal>, client?: (schema: AnnouncementDetailFullappApiAnnouncementsDetailPostSchema, options: ServiceOperationMutationFnOptions<AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostError>>): Promise<RequestFnResponse<AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostError>>;
        /** @summary Announcement Detail */
        getMutationKey(parameters: DeepReadonly<AnnouncementDetailFullappApiAnnouncementsDetailPostParameters> | void): ServiceOperationMutationKey<AnnouncementDetailFullappApiAnnouncementsDetailPostSchema, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Announcement Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.announcementDetailFullappApiAnnouncementsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.announcementDetailFullappApiAnnouncementsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AnnouncementDetailFullappApiAnnouncementsDetailPostBody, TContext = unknown>(parameters: DeepReadonly<AnnouncementDetailFullappApiAnnouncementsDetailPostParameters>, options?: ServiceOperationUseMutationOptions<AnnouncementDetailFullappApiAnnouncementsDetailPostSchema, AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters, TVariables, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, TContext>): UseMutationResult<AnnouncementDetailFullappApiAnnouncementsDetailPostData, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Announcement Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.announcementDetailFullappApiAnnouncementsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.announcementDetailFullappApiAnnouncementsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AnnouncementDetailFullappApiAnnouncementsDetailPostSchema, AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters, TVariables, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, TContext>): UseMutationResult<AnnouncementDetailFullappApiAnnouncementsDetailPostData, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Announcement Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const announcementDetailFullappApiAnnouncementsDetailPostTotal = qraft.fullappApiService.announcementDetailFullappApiAnnouncementsDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const announcementDetailFullappApiAnnouncementsDetailPostTotal = qraft.fullappApiService.announcementDetailFullappApiAnnouncementsDetailPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, TContext> | MutationFiltersByMutationKey<AnnouncementDetailFullappApiAnnouncementsDetailPostSchema, AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Announcement Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const announcementDetailFullappApiAnnouncementsDetailPostPendingMutationVariables = qraft.fullappApiService.announcementDetailFullappApiAnnouncementsDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const announcementDetailFullappApiAnnouncementsDetailPostMutationData = qraft.fullappApiService.announcementDetailFullappApiAnnouncementsDetailPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AnnouncementDetailFullappApiAnnouncementsDetailPostData, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, MutationVariables<AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, TContext> | MutationFiltersByMutationKey<AnnouncementDetailFullappApiAnnouncementsDetailPostSchema, AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, TContext>;
            select?: (mutation: Mutation<AnnouncementDetailFullappApiAnnouncementsDetailPostData, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, MutationVariables<AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Announcement Detail */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, TContext> | MutationFiltersByMutationKey<AnnouncementDetailFullappApiAnnouncementsDetailPostSchema, AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Announcement Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.announcementDetailFullappApiAnnouncementsDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.announcementDetailFullappApiAnnouncementsDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, TContext> | MutationFiltersByMutationKey<AnnouncementDetailFullappApiAnnouncementsDetailPostSchema, AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, TContext>): Mutation<AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostError, MutationVariables<AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, TContext> | MutationFiltersByMutationKey<AnnouncementDetailFullappApiAnnouncementsDetailPostSchema, AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters, OperationError<AnnouncementDetailFullappApiAnnouncementsDetailPostError>, TContext>): Array<Mutation<AnnouncementDetailFullappApiAnnouncementsDetailPostData, AnnouncementDetailFullappApiAnnouncementsDetailPostError, MutationVariables<AnnouncementDetailFullappApiAnnouncementsDetailPostBody, AnnouncementDetailFullappApiAnnouncementsDetailPostParameters>, TContext>>;
        };
        schema: AnnouncementDetailFullappApiAnnouncementsDetailPostSchema;
        types: {
            parameters: AnnouncementDetailFullappApiAnnouncementsDetailPostParameters;
            data: AnnouncementDetailFullappApiAnnouncementsDetailPostData;
            error: AnnouncementDetailFullappApiAnnouncementsDetailPostError;
            body: AnnouncementDetailFullappApiAnnouncementsDetailPostBody;
        };
    };
    /** @summary Announcement Update */
    announcementUpdateFullappApiAnnouncementsUpdatePost: {
        /** @summary Announcement Update */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters, TMeta, TSignal>, client?: (schema: AnnouncementUpdateFullappApiAnnouncementsUpdatePostSchema, options: ServiceOperationMutationFnOptions<AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>>): Promise<RequestFnResponse<AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>>;
        /** @summary Announcement Update */
        getMutationKey(parameters: DeepReadonly<AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters> | void): ServiceOperationMutationKey<AnnouncementUpdateFullappApiAnnouncementsUpdatePostSchema, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Announcement Update
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.announcementUpdateFullappApiAnnouncementsUpdatePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.announcementUpdateFullappApiAnnouncementsUpdatePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, TContext = unknown>(parameters: DeepReadonly<AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters>, options?: ServiceOperationUseMutationOptions<AnnouncementUpdateFullappApiAnnouncementsUpdatePostSchema, AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters, TVariables, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, TContext>): UseMutationResult<AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Announcement Update
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.announcementUpdateFullappApiAnnouncementsUpdatePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.announcementUpdateFullappApiAnnouncementsUpdatePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AnnouncementUpdateFullappApiAnnouncementsUpdatePostSchema, AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters, TVariables, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, TContext>): UseMutationResult<AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Announcement Update
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const announcementUpdateFullappApiAnnouncementsUpdatePostTotal = qraft.fullappApiService.announcementUpdateFullappApiAnnouncementsUpdatePost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const announcementUpdateFullappApiAnnouncementsUpdatePostTotal = qraft.fullappApiService.announcementUpdateFullappApiAnnouncementsUpdatePost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, TContext> | MutationFiltersByMutationKey<AnnouncementUpdateFullappApiAnnouncementsUpdatePostSchema, AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Announcement Update
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const announcementUpdateFullappApiAnnouncementsUpdatePostPendingMutationVariables = qraft.fullappApiService.announcementUpdateFullappApiAnnouncementsUpdatePost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const announcementUpdateFullappApiAnnouncementsUpdatePostMutationData = qraft.fullappApiService.announcementUpdateFullappApiAnnouncementsUpdatePost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, MutationVariables<AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, TContext> | MutationFiltersByMutationKey<AnnouncementUpdateFullappApiAnnouncementsUpdatePostSchema, AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, TContext>;
            select?: (mutation: Mutation<AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, MutationVariables<AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Announcement Update */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, TContext> | MutationFiltersByMutationKey<AnnouncementUpdateFullappApiAnnouncementsUpdatePostSchema, AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Announcement Update
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.announcementUpdateFullappApiAnnouncementsUpdatePost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.announcementUpdateFullappApiAnnouncementsUpdatePost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, TContext> | MutationFiltersByMutationKey<AnnouncementUpdateFullappApiAnnouncementsUpdatePostSchema, AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, TContext>): Mutation<AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostError, MutationVariables<AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, TContext> | MutationFiltersByMutationKey<AnnouncementUpdateFullappApiAnnouncementsUpdatePostSchema, AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters, OperationError<AnnouncementUpdateFullappApiAnnouncementsUpdatePostError>, TContext>): Array<Mutation<AnnouncementUpdateFullappApiAnnouncementsUpdatePostData, AnnouncementUpdateFullappApiAnnouncementsUpdatePostError, MutationVariables<AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody, AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters>, TContext>>;
        };
        schema: AnnouncementUpdateFullappApiAnnouncementsUpdatePostSchema;
        types: {
            parameters: AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters;
            data: AnnouncementUpdateFullappApiAnnouncementsUpdatePostData;
            error: AnnouncementUpdateFullappApiAnnouncementsUpdatePostError;
            body: AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody;
        };
    };
    /** @summary Get Submission Detail */
    getSubmissionDetailFullappApiSubmissionsDetailPost: {
        /** @summary Get Submission Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters, TMeta, TSignal>, client?: (schema: GetSubmissionDetailFullappApiSubmissionsDetailPostSchema, options: ServiceOperationMutationFnOptions<GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostError>>): Promise<RequestFnResponse<GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostError>>;
        /** @summary Get Submission Detail */
        getMutationKey(parameters: DeepReadonly<GetSubmissionDetailFullappApiSubmissionsDetailPostParameters> | void): ServiceOperationMutationKey<GetSubmissionDetailFullappApiSubmissionsDetailPostSchema, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Submission Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getSubmissionDetailFullappApiSubmissionsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getSubmissionDetailFullappApiSubmissionsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends GetSubmissionDetailFullappApiSubmissionsDetailPostBody, TContext = unknown>(parameters: DeepReadonly<GetSubmissionDetailFullappApiSubmissionsDetailPostParameters>, options?: ServiceOperationUseMutationOptions<GetSubmissionDetailFullappApiSubmissionsDetailPostSchema, GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters, TVariables, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, TContext>): UseMutationResult<GetSubmissionDetailFullappApiSubmissionsDetailPostData, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Get Submission Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getSubmissionDetailFullappApiSubmissionsDetailPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.getSubmissionDetailFullappApiSubmissionsDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GetSubmissionDetailFullappApiSubmissionsDetailPostSchema, GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters, TVariables, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, TContext>): UseMutationResult<GetSubmissionDetailFullappApiSubmissionsDetailPostData, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Get Submission Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const getSubmissionDetailFullappApiSubmissionsDetailPostTotal = qraft.fullappApiService.getSubmissionDetailFullappApiSubmissionsDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const getSubmissionDetailFullappApiSubmissionsDetailPostTotal = qraft.fullappApiService.getSubmissionDetailFullappApiSubmissionsDetailPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, TContext> | MutationFiltersByMutationKey<GetSubmissionDetailFullappApiSubmissionsDetailPostSchema, GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Get Submission Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const getSubmissionDetailFullappApiSubmissionsDetailPostPendingMutationVariables = qraft.fullappApiService.getSubmissionDetailFullappApiSubmissionsDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const getSubmissionDetailFullappApiSubmissionsDetailPostMutationData = qraft.fullappApiService.getSubmissionDetailFullappApiSubmissionsDetailPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GetSubmissionDetailFullappApiSubmissionsDetailPostData, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, MutationVariables<GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, TContext> | MutationFiltersByMutationKey<GetSubmissionDetailFullappApiSubmissionsDetailPostSchema, GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, TContext>;
            select?: (mutation: Mutation<GetSubmissionDetailFullappApiSubmissionsDetailPostData, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, MutationVariables<GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Get Submission Detail */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, TContext> | MutationFiltersByMutationKey<GetSubmissionDetailFullappApiSubmissionsDetailPostSchema, GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Get Submission Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.getSubmissionDetailFullappApiSubmissionsDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.getSubmissionDetailFullappApiSubmissionsDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, TContext> | MutationFiltersByMutationKey<GetSubmissionDetailFullappApiSubmissionsDetailPostSchema, GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, TContext>): Mutation<GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostError, MutationVariables<GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, TContext> | MutationFiltersByMutationKey<GetSubmissionDetailFullappApiSubmissionsDetailPostSchema, GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters, OperationError<GetSubmissionDetailFullappApiSubmissionsDetailPostError>, TContext>): Array<Mutation<GetSubmissionDetailFullappApiSubmissionsDetailPostData, GetSubmissionDetailFullappApiSubmissionsDetailPostError, MutationVariables<GetSubmissionDetailFullappApiSubmissionsDetailPostBody, GetSubmissionDetailFullappApiSubmissionsDetailPostParameters>, TContext>>;
        };
        schema: GetSubmissionDetailFullappApiSubmissionsDetailPostSchema;
        types: {
            parameters: GetSubmissionDetailFullappApiSubmissionsDetailPostParameters;
            data: GetSubmissionDetailFullappApiSubmissionsDetailPostData;
            error: GetSubmissionDetailFullappApiSubmissionsDetailPostError;
            body: GetSubmissionDetailFullappApiSubmissionsDetailPostBody;
        };
    };
    /** @summary Grade Submission */
    gradeSubmissionFullappApiSubmissionsGradePost: {
        /** @summary Grade Submission */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostParameters, TMeta, TSignal>, client?: (schema: GradeSubmissionFullappApiSubmissionsGradePostSchema, options: ServiceOperationMutationFnOptions<GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostError>>): Promise<RequestFnResponse<GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostError>>;
        /** @summary Grade Submission */
        getMutationKey(parameters: DeepReadonly<GradeSubmissionFullappApiSubmissionsGradePostParameters> | void): ServiceOperationMutationKey<GradeSubmissionFullappApiSubmissionsGradePostSchema, GradeSubmissionFullappApiSubmissionsGradePostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Grade Submission
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.gradeSubmissionFullappApiSubmissionsGradePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.gradeSubmissionFullappApiSubmissionsGradePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends GradeSubmissionFullappApiSubmissionsGradePostBody, TContext = unknown>(parameters: DeepReadonly<GradeSubmissionFullappApiSubmissionsGradePostParameters>, options?: ServiceOperationUseMutationOptions<GradeSubmissionFullappApiSubmissionsGradePostSchema, GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostParameters, TVariables, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, TContext>): UseMutationResult<GradeSubmissionFullappApiSubmissionsGradePostData, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Grade Submission
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.gradeSubmissionFullappApiSubmissionsGradePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.gradeSubmissionFullappApiSubmissionsGradePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<GradeSubmissionFullappApiSubmissionsGradePostSchema, GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostParameters, TVariables, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, TContext>): UseMutationResult<GradeSubmissionFullappApiSubmissionsGradePostData, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Grade Submission
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const gradeSubmissionFullappApiSubmissionsGradePostTotal = qraft.fullappApiService.gradeSubmissionFullappApiSubmissionsGradePost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const gradeSubmissionFullappApiSubmissionsGradePostTotal = qraft.fullappApiService.gradeSubmissionFullappApiSubmissionsGradePost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostParameters, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, TContext> | MutationFiltersByMutationKey<GradeSubmissionFullappApiSubmissionsGradePostSchema, GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostParameters, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Grade Submission
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const gradeSubmissionFullappApiSubmissionsGradePostPendingMutationVariables = qraft.fullappApiService.gradeSubmissionFullappApiSubmissionsGradePost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const gradeSubmissionFullappApiSubmissionsGradePostMutationData = qraft.fullappApiService.gradeSubmissionFullappApiSubmissionsGradePost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<GradeSubmissionFullappApiSubmissionsGradePostData, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, MutationVariables<GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostParameters, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, TContext> | MutationFiltersByMutationKey<GradeSubmissionFullappApiSubmissionsGradePostSchema, GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostParameters, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, TContext>;
            select?: (mutation: Mutation<GradeSubmissionFullappApiSubmissionsGradePostData, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, MutationVariables<GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Grade Submission */
        isMutating<TContext>(filters?: MutationFiltersByParameters<GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostParameters, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, TContext> | MutationFiltersByMutationKey<GradeSubmissionFullappApiSubmissionsGradePostSchema, GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostParameters, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Grade Submission
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.gradeSubmissionFullappApiSubmissionsGradePost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.gradeSubmissionFullappApiSubmissionsGradePost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostParameters, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, TContext> | MutationFiltersByMutationKey<GradeSubmissionFullappApiSubmissionsGradePostSchema, GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostParameters, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, TContext>): Mutation<GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostError, MutationVariables<GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostParameters, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, TContext> | MutationFiltersByMutationKey<GradeSubmissionFullappApiSubmissionsGradePostSchema, GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostParameters, OperationError<GradeSubmissionFullappApiSubmissionsGradePostError>, TContext>): Array<Mutation<GradeSubmissionFullappApiSubmissionsGradePostData, GradeSubmissionFullappApiSubmissionsGradePostError, MutationVariables<GradeSubmissionFullappApiSubmissionsGradePostBody, GradeSubmissionFullappApiSubmissionsGradePostParameters>, TContext>>;
        };
        schema: GradeSubmissionFullappApiSubmissionsGradePostSchema;
        types: {
            parameters: GradeSubmissionFullappApiSubmissionsGradePostParameters;
            data: GradeSubmissionFullappApiSubmissionsGradePostData;
            error: GradeSubmissionFullappApiSubmissionsGradePostError;
            body: GradeSubmissionFullappApiSubmissionsGradePostBody;
        };
    };
    /** @summary List Submissions */
    listSubmissionsFullappApiSubmissionsListPost: {
        /** @summary List Submissions */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostParameters, TMeta, TSignal>, client?: (schema: ListSubmissionsFullappApiSubmissionsListPostSchema, options: ServiceOperationMutationFnOptions<ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostError>>): Promise<RequestFnResponse<ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostError>>;
        /** @summary List Submissions */
        getMutationKey(parameters: DeepReadonly<ListSubmissionsFullappApiSubmissionsListPostParameters> | void): ServiceOperationMutationKey<ListSubmissionsFullappApiSubmissionsListPostSchema, ListSubmissionsFullappApiSubmissionsListPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary List Submissions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listSubmissionsFullappApiSubmissionsListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listSubmissionsFullappApiSubmissionsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ListSubmissionsFullappApiSubmissionsListPostBody, TContext = unknown>(parameters: DeepReadonly<ListSubmissionsFullappApiSubmissionsListPostParameters>, options?: ServiceOperationUseMutationOptions<ListSubmissionsFullappApiSubmissionsListPostSchema, ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostParameters, TVariables, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, TContext>): UseMutationResult<ListSubmissionsFullappApiSubmissionsListPostData, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary List Submissions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listSubmissionsFullappApiSubmissionsListPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.fullappApiService.listSubmissionsFullappApiSubmissionsListPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ListSubmissionsFullappApiSubmissionsListPostSchema, ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostParameters, TVariables, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, TContext>): UseMutationResult<ListSubmissionsFullappApiSubmissionsListPostData, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary List Submissions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const listSubmissionsFullappApiSubmissionsListPostTotal = qraft.fullappApiService.listSubmissionsFullappApiSubmissionsListPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const listSubmissionsFullappApiSubmissionsListPostTotal = qraft.fullappApiService.listSubmissionsFullappApiSubmissionsListPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostParameters, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, TContext> | MutationFiltersByMutationKey<ListSubmissionsFullappApiSubmissionsListPostSchema, ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostParameters, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary List Submissions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const listSubmissionsFullappApiSubmissionsListPostPendingMutationVariables = qraft.fullappApiService.listSubmissionsFullappApiSubmissionsListPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const listSubmissionsFullappApiSubmissionsListPostMutationData = qraft.fullappApiService.listSubmissionsFullappApiSubmissionsListPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ListSubmissionsFullappApiSubmissionsListPostData, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, MutationVariables<ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostParameters, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, TContext> | MutationFiltersByMutationKey<ListSubmissionsFullappApiSubmissionsListPostSchema, ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostParameters, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, TContext>;
            select?: (mutation: Mutation<ListSubmissionsFullappApiSubmissionsListPostData, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, MutationVariables<ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary List Submissions */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostParameters, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, TContext> | MutationFiltersByMutationKey<ListSubmissionsFullappApiSubmissionsListPostSchema, ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostParameters, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary List Submissions
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.fullappApiService.listSubmissionsFullappApiSubmissionsListPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.fullappApiService.listSubmissionsFullappApiSubmissionsListPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostParameters, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, TContext> | MutationFiltersByMutationKey<ListSubmissionsFullappApiSubmissionsListPostSchema, ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostParameters, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, TContext>): Mutation<ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostError, MutationVariables<ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostParameters, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, TContext> | MutationFiltersByMutationKey<ListSubmissionsFullappApiSubmissionsListPostSchema, ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostParameters, OperationError<ListSubmissionsFullappApiSubmissionsListPostError>, TContext>): Array<Mutation<ListSubmissionsFullappApiSubmissionsListPostData, ListSubmissionsFullappApiSubmissionsListPostError, MutationVariables<ListSubmissionsFullappApiSubmissionsListPostBody, ListSubmissionsFullappApiSubmissionsListPostParameters>, TContext>>;
        };
        schema: ListSubmissionsFullappApiSubmissionsListPostSchema;
        types: {
            parameters: ListSubmissionsFullappApiSubmissionsListPostParameters;
            data: ListSubmissionsFullappApiSubmissionsListPostData;
            error: ListSubmissionsFullappApiSubmissionsListPostError;
            body: ListSubmissionsFullappApiSubmissionsListPostBody;
        };
    };
}
/**
 * @summary Admin Forced
 * @description Admin/dev impersonation login: return a target user's auth token + profile.
 *
 * The target is restricted to the student/study-helper groups. The token is
 * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
 * gate guarded non-local envs only and the app never sends a passcode, so this
 * is treated as the dev/local-bypass path.
 */
export const adminForcedFullappApiAuthAdminForcedPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/auth/admin_forced",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminForcedFullappApiAuthAdminForcedPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["adminForcedFullappApiAuthAdminForcedPost"];
};
/**
 * @summary Forget Password
 * @description Request a password reset (pre-auth, device-verified only).
 *
 * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
 * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
 * so this endpoint builds the envelope directly via ``JSONResponse``.
 */
export const forgetPasswordFullappApiAuthForgetPasswordPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/auth/forget_password",
        mediaType: ["application/json"]
    }
} as {
    schema: ForgetPasswordFullappApiAuthForgetPasswordPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["forgetPasswordFullappApiAuthForgetPasswordPost"];
};
/**
 * @summary Login
 * @description Email/password login.
 *
 * Order: validate user_login/password -> verify password (wrong password is
 * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
 * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
 * device token.
 *
 * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
 * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
 * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
 */
export const loginFullappApiAuthLoginPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/auth/login",
        mediaType: ["application/json"]
    }
} as {
    schema: LoginFullappApiAuthLoginPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["loginFullappApiAuthLoginPost"];
};
/**
 * @summary Register User
 * @description Register a new student.
 *
 * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
 * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
 * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
 * builds the envelope directly via ``JSONResponse`` rather than the shared
 * ``{data: ...}`` handler.
 */
export const registerUserFullappApiAuthRegisterPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/auth/register",
        mediaType: ["application/json"]
    }
} as {
    schema: RegisterUserFullappApiAuthRegisterPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["registerUserFullappApiAuthRegisterPost"];
};
/** @summary Logout */
export const logoutFullappApiAuthLogoutPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/auth/logout"
    }
} as {
    schema: LogoutFullappApiAuthLogoutPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["logoutFullappApiAuthLogoutPost"];
};
/** @summary Register Device */
export const registerDeviceFullappApiDevicesRegisterPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/devices/register",
        mediaType: ["application/json"]
    }
} as {
    schema: RegisterDeviceFullappApiDevicesRegisterPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["registerDeviceFullappApiDevicesRegisterPost"];
};
/**
 * @summary Installs
 * @description Return the fullapp active-install count over the last 60 days.
 *
 * Requires a valid x-wbs-fullapp-token (app identity) and a valid device token
 * (DeviceDependency) but NOT a logged-in user (login_required=false in legacy).
 * The response `data` is a bare int scalar.
 */
export const installsFullappApiAppInfosInstallsPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/app-infos/installs"
    }
} as {
    schema: InstallsFullappApiAppInfosInstallsPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["installsFullappApiAppInfosInstallsPost"];
};
/** @summary Translations */
export const translationsFullappApiLanguagesTranslationsPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/languages/translations",
        mediaType: ["application/json"]
    }
} as {
    schema: TranslationsFullappApiLanguagesTranslationsPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["translationsFullappApiLanguagesTranslationsPost"];
};
/** @summary Translations */
export const translationsFullappApiLanguagesTranslationsGet = {
    schema: {
        method: "get",
        url: "/fullapp-api/languages/translations",
        mediaType: ["application/json"]
    }
} as {
    schema: TranslationsFullappApiLanguagesTranslationsGetSchema;
    [QraftServiceOperationsToken]: FullappApiService["translationsFullappApiLanguagesTranslationsGet"];
};
/** @summary All Languages */
export const allLanguagesFullappApiLanguagesAllPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/languages/all"
    }
} as {
    schema: AllLanguagesFullappApiLanguagesAllPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["allLanguagesFullappApiLanguagesAllPost"];
};
/** @summary All Languages */
export const allLanguagesFullappApiLanguagesAllGet = {
    schema: {
        method: "get",
        url: "/fullapp-api/languages/all"
    }
} as {
    schema: AllLanguagesFullappApiLanguagesAllGetSchema;
    [QraftServiceOperationsToken]: FullappApiService["allLanguagesFullappApiLanguagesAllGet"];
};
/** @summary Detail */
export const detailFullappApiPagesDetailPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/pages/detail",
        mediaType: ["application/json"]
    }
} as {
    schema: DetailFullappApiPagesDetailPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["detailFullappApiPagesDetailPost"];
};
/**
 * @summary Study Helper
 * @description Pre-auth WebView links for a study-helper (groups + group follow-up-requests).
 *
 * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
 * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
 * only and would drop the top-level ``success``.
 */
export const studyHelperFullappApiInAppLinksStudyHelperPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/in-app-links/study_helper",
        mediaType: ["application/json"]
    }
} as {
    schema: StudyHelperFullappApiInAppLinksStudyHelperPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["studyHelperFullappApiInAppLinksStudyHelperPost"];
};
/**
 * @summary Student
 * @description Pre-auth WebView links for a student (study-helper-board + follow-ups).
 *
 * Errors are rendered directly as ``{success:false, data:{...}}`` (the shape the
 * app reads): the app-wide HTTPException handler wraps ``detail`` under ``data``
 * only and would drop the top-level ``success``.
 */
export const studentFullappApiInAppLinksStudentPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/in-app-links/student",
        mediaType: ["application/json"]
    }
} as {
    schema: StudentFullappApiInAppLinksStudentPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["studentFullappApiInAppLinksStudentPost"];
};
/** @summary Student News Detail */
export const studentNewsDetailFullappApiStudentNewsDetailPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/student-news/detail",
        mediaType: ["application/json"]
    }
} as {
    schema: StudentNewsDetailFullappApiStudentNewsDetailPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["studentNewsDetailFullappApiStudentNewsDetailPost"];
};
/** @summary Student News List */
export const studentNewsListFullappApiStudentNewsListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/student-news/list",
        mediaType: ["application/json"]
    }
} as {
    schema: StudentNewsListFullappApiStudentNewsListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["studentNewsListFullappApiStudentNewsListPost"];
};
/** @summary Study Helper News Detail */
export const studyHelperNewsDetailFullappApiStudyHelperNewsDetailPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/study-helper-news/detail",
        mediaType: ["application/json"]
    }
} as {
    schema: StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["studyHelperNewsDetailFullappApiStudyHelperNewsDetailPost"];
};
/** @summary Study Helper News List */
export const studyHelperNewsListFullappApiStudyHelperNewsListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/study-helper-news/list",
        mediaType: ["application/json"]
    }
} as {
    schema: StudyHelperNewsListFullappApiStudyHelperNewsListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["studyHelperNewsListFullappApiStudyHelperNewsListPost"];
};
/** @summary Student Tutorials Detail */
export const studentTutorialsDetailFullappApiStudentTutorialsDetailPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/student-tutorials/detail",
        mediaType: ["application/json"]
    }
} as {
    schema: StudentTutorialsDetailFullappApiStudentTutorialsDetailPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["studentTutorialsDetailFullappApiStudentTutorialsDetailPost"];
};
/** @summary Student Tutorials List */
export const studentTutorialsListFullappApiStudentTutorialsListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/student-tutorials/list",
        mediaType: ["application/json"]
    }
} as {
    schema: StudentTutorialsListFullappApiStudentTutorialsListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["studentTutorialsListFullappApiStudentTutorialsListPost"];
};
/** @summary Study Helper Tutorials Detail */
export const studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/study-helper-tutorials/detail",
        mediaType: ["application/json"]
    }
} as {
    schema: StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPost"];
};
/** @summary Study Helper Tutorials List */
export const studyHelperTutorialsListFullappApiStudyHelperTutorialsListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/study-helper-tutorials/list",
        mediaType: ["application/json"]
    }
} as {
    schema: StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["studyHelperTutorialsListFullappApiStudyHelperTutorialsListPost"];
};
/** @summary Adopt Student */
export const adoptStudentFullappApiAdoptionsAdoptPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/adoptions/adopt",
        mediaType: ["application/json"]
    }
} as {
    schema: AdoptStudentFullappApiAdoptionsAdoptPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["adoptStudentFullappApiAdoptionsAdoptPost"];
};
/** @summary Connect Adopt Student */
export const connectAdoptStudentFullappApiAdoptionsConnectAdoptionPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/adoptions/connect_adoption",
        mediaType: ["application/json"]
    }
} as {
    schema: ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["connectAdoptStudentFullappApiAdoptionsConnectAdoptionPost"];
};
/** @summary Get Adoption Info */
export const getAdoptionInfoFullappApiAdoptionsInfoPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/adoptions/info",
        mediaType: ["application/json"]
    }
} as {
    schema: GetAdoptionInfoFullappApiAdoptionsInfoPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["getAdoptionInfoFullappApiAdoptionsInfoPost"];
};
/** @summary Pass On Student Fullapp */
export const passOnStudentFullappFullappApiAdoptionsPassonPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/adoptions/passon",
        mediaType: ["application/json"]
    }
} as {
    schema: PassOnStudentFullappFullappApiAdoptionsPassonPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["passOnStudentFullappFullappApiAdoptionsPassonPost"];
};
/** @summary Check Adoptability */
export const checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/adoptions/check_adoptability",
        mediaType: ["application/json"]
    }
} as {
    schema: CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPost"];
};
/** @summary Get Adoption Request Info */
export const getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/adoption-requests/info",
        mediaType: ["application/json"]
    }
} as {
    schema: GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPost"];
};
/** @summary Accept Adoption Request Fullapp */
export const acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/adoption-requests/accept",
        mediaType: ["application/json"]
    }
} as {
    schema: AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPost"];
};
/** @summary Decline Adoption Request Fullapp */
export const declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePost = {
    schema: {
        method: "post",
        url: "/fullapp-api/adoption-requests/decline",
        mediaType: ["application/json"]
    }
} as {
    schema: DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostSchema;
    [QraftServiceOperationsToken]: FullappApiService["declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePost"];
};
/** @summary Fullapp User Me */
export const fullappUserMeFullappApiUsersMeGet = {
    schema: {
        method: "get",
        url: "/fullapp-api/users/me"
    }
} as {
    schema: FullappUserMeFullappApiUsersMeGetSchema;
    [QraftServiceOperationsToken]: FullappApiService["fullappUserMeFullappApiUsersMeGet"];
};
/** @summary Fullapp User Me */
export const fullappUserMeFullappApiUsersMePost = {
    schema: {
        method: "post",
        url: "/fullapp-api/users/me"
    }
} as {
    schema: FullappUserMeFullappApiUsersMePostSchema;
    [QraftServiceOperationsToken]: FullappApiService["fullappUserMeFullappApiUsersMePost"];
};
/** @summary Fullapp Change Password */
export const fullappChangePasswordFullappApiUsersChangePasswordPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/users/change_password",
        mediaType: ["application/json"]
    }
} as {
    schema: FullappChangePasswordFullappApiUsersChangePasswordPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["fullappChangePasswordFullappApiUsersChangePasswordPost"];
};
/** @summary Fullapp Update Profiles */
export const fullappUpdateProfilesFullappApiUsersUpdateProfilesPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/users/update_profiles",
        mediaType: ["application/json"]
    }
} as {
    schema: FullappUpdateProfilesFullappApiUsersUpdateProfilesPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["fullappUpdateProfilesFullappApiUsersUpdateProfilesPost"];
};
/** @summary Fullapp User Info */
export const fullappUserInfoFullappApiUsersInfoPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/users/info",
        mediaType: ["application/json"]
    }
} as {
    schema: FullappUserInfoFullappApiUsersInfoPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["fullappUserInfoFullappApiUsersInfoPost"];
};
/**
 * @summary Fullapp Upload Avatar
 * @description Upload the current user's avatar (the app's one multipart endpoint).
 *
 * Stores the image at ``avatars/{id}/full.{ext}`` and points ``User.avatar`` at
 * it; the per-request commit middleware persists the change. Returns the new
 * avatar URL, matching the legacy ``{id, avatar}`` shape.
 */
export const fullappUploadAvatarFullappApiUsersAvatarPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/users/avatar",
        mediaType: ["multipart/form-data"]
    }
} as {
    schema: FullappUploadAvatarFullappApiUsersAvatarPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["fullappUploadAvatarFullappApiUsersAvatarPost"];
};
/** @summary Fullapp Sms Status */
export const fullappSmsStatusFullappApiSmsStatusPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/sms/status"
    }
} as {
    schema: FullappSmsStatusFullappApiSmsStatusPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["fullappSmsStatusFullappApiSmsStatusPost"];
};
/** @summary Fullapp Whatsapp Status */
export const fullappWhatsappStatusFullappApiWhatsappStatusPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/whatsapp/status"
    }
} as {
    schema: FullappWhatsappStatusFullappApiWhatsappStatusPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["fullappWhatsappStatusFullappApiWhatsappStatusPost"];
};
/**
 * @summary Get Onboarding Status
 * @description Get current user's onboarding status.
 *
 * Status should be checked when:
 *
 * App start (if logged in)
 * Course Completed
 * Another Onboarding Completed (some will chain)
 * Logged In/Registered
 */
export const getOnboardingStatusFullappApiOnboardingsStatusPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/onboardings/status"
    }
} as {
    schema: GetOnboardingStatusFullappApiOnboardingsStatusPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["getOnboardingStatusFullappApiOnboardingsStatusPost"];
};
/**
 * @summary Get Onboarding Details
 * @description Get an onboarding slides detail.
 */
export const getOnboardingDetailsFullappApiOnboardingsDetailPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/onboardings/detail",
        mediaType: ["application/json"]
    }
} as {
    schema: GetOnboardingDetailsFullappApiOnboardingsDetailPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["getOnboardingDetailsFullappApiOnboardingsDetailPost"];
};
/**
 * @summary Onboarding Submit
 * @description Submit an onboarding slide.
 *
 * Not role-gated: it targets the authenticated user, and a study helper may submit
 * targeting themselves. A body `user_id` is ignored.
 */
export const onboardingSubmitFullappApiOnboardingsSubmitPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/onboardings/submit",
        mediaType: ["application/json"]
    }
} as {
    schema: OnboardingSubmitFullappApiOnboardingsSubmitPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["onboardingSubmitFullappApiOnboardingsSubmitPost"];
};
/**
 * @summary Xprofiles List
 * @description List the selected or all xprofile field settings.
 *
 * Filtering only applies when the parsed id list is non-empty, so empty / absent /
 * non-numeric input returns all fields, and a requested id that does not exist is
 * silently ignored (never a 404).
 */
export const xprofilesListFullappApiXprofilesListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/xprofiles/list",
        mediaType: ["application/json"]
    }
} as {
    schema: XprofilesListFullappApiXprofilesListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["xprofilesListFullappApiXprofilesListPost"];
};
/** @summary Courses List */
export const coursesListFullappApiCoursesListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/courses/list",
        mediaType: ["application/json"]
    }
} as {
    schema: CoursesListFullappApiCoursesListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["coursesListFullappApiCoursesListPost"];
};
/** @summary Course Detail */
export const courseDetailFullappApiCoursesDetailPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/courses/detail",
        mediaType: ["application/json"]
    }
} as {
    schema: CourseDetailFullappApiCoursesDetailPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["courseDetailFullappApiCoursesDetailPost"];
};
/** @summary Lessons List */
export const lessonsListFullappApiLessonsListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/lessons/list",
        mediaType: ["application/json"]
    }
} as {
    schema: LessonsListFullappApiLessonsListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["lessonsListFullappApiLessonsListPost"];
};
/** @summary Lesson Detail */
export const lessonDetailFullappApiLessonsDetailPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/lessons/detail",
        mediaType: ["application/json"]
    }
} as {
    schema: LessonDetailFullappApiLessonsDetailPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["lessonDetailFullappApiLessonsDetailPost"];
};
/** @summary Topics List */
export const topicsListFullappApiTopicsListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/topics/list",
        mediaType: ["application/json"]
    }
} as {
    schema: TopicsListFullappApiTopicsListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["topicsListFullappApiTopicsListPost"];
};
/** @summary Topic Detail */
export const topicDetailFullappApiTopicsDetailPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/topics/detail",
        mediaType: ["application/json"]
    }
} as {
    schema: TopicDetailFullappApiTopicsDetailPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["topicDetailFullappApiTopicsDetailPost"];
};
/** @summary Quiz Detail */
export const quizDetailFullappApiQuizzesDetailPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/quizzes/detail",
        mediaType: ["application/json"]
    }
} as {
    schema: QuizDetailFullappApiQuizzesDetailPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["quizDetailFullappApiQuizzesDetailPost"];
};
/**
 * @summary Guides List
 * @description Published bible-study guides ordered by menu_order ASC, scoped to the request
 * language. Not role-sensitive.
 */
export const guidesListFullappApiGuidesListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/guides/list",
        mediaType: ["application/json"]
    }
} as {
    schema: GuidesListFullappApiGuidesListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["guidesListFullappApiGuidesListPost"];
};
/**
 * @summary Guides Detail
 * @description Guide detail (title/order/intro/content/excerpt). Not role-sensitive: no
 * user_id / resolve_student.
 */
export const guidesDetailFullappApiGuidesDetailPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/guides/detail",
        mediaType: ["application/json"]
    }
} as {
    schema: GuidesDetailFullappApiGuidesDetailPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["guidesDetailFullappApiGuidesDetailPost"];
};
/** @summary List Certificates */
export const listCertificatesFullappApiCertificatesListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/certificates/list",
        mediaType: ["application/json"]
    }
} as {
    schema: ListCertificatesFullappApiCertificatesListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["listCertificatesFullappApiCertificatesListPost"];
};
/** @summary Award Certificate */
export const awardCertificateFullappApiCertificatesAwardPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/certificates/award",
        mediaType: ["application/json"]
    }
} as {
    schema: AwardCertificateFullappApiCertificatesAwardPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["awardCertificateFullappApiCertificatesAwardPost"];
};
/** @summary Topic Mark Complete */
export const topicMarkCompleteFullappApiTopicsMarkCompletePost = {
    schema: {
        method: "post",
        url: "/fullapp-api/topics/mark_complete",
        mediaType: ["application/json"]
    }
} as {
    schema: TopicMarkCompleteFullappApiTopicsMarkCompletePostSchema;
    [QraftServiceOperationsToken]: FullappApiService["topicMarkCompleteFullappApiTopicsMarkCompletePost"];
};
/** @summary Submit Quiz */
export const submitQuizFullappApiQuizzesSubmitPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/quizzes/submit",
        mediaType: ["application/json"]
    }
} as {
    schema: SubmitQuizFullappApiQuizzesSubmitPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["submitQuizFullappApiQuizzesSubmitPost"];
};
/** @summary Course Unlock */
export const courseUnlockFullappApiCoursesUnlockPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/courses/unlock",
        mediaType: ["application/json"]
    }
} as {
    schema: CourseUnlockFullappApiCoursesUnlockPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["courseUnlockFullappApiCoursesUnlockPost"];
};
/**
 * @summary List Bibles
 * @description Get all Bible testaments with their books and chapter counts.
 */
export const listBiblesFullappApiBiblesListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/bibles/list"
    }
} as {
    schema: ListBiblesFullappApiBiblesListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["listBiblesFullappApiBiblesListPost"];
};
/**
 * @summary Get Chapters
 * @description Get a book with all its chapters.
 */
export const getChaptersFullappApiBiblesChaptersPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/bibles/chapters",
        mediaType: ["application/json"]
    }
} as {
    schema: GetChaptersFullappApiBiblesChaptersPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["getChaptersFullappApiBiblesChaptersPost"];
};
/**
 * @summary Get Chapter Detail
 * @description Get detailed chapter content with verses.
 */
export const getChapterDetailFullappApiChaptersDetailPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/chapters/detail",
        mediaType: ["application/json"]
    }
} as {
    schema: GetChapterDetailFullappApiChaptersDetailPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["getChapterDetailFullappApiChaptersDetailPost"];
};
/** @summary Register */
export const registerFullappApiPushNotificationsRegisterPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/push-notifications/register",
        mediaType: ["application/json"]
    }
} as {
    schema: RegisterFullappApiPushNotificationsRegisterPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["registerFullappApiPushNotificationsRegisterPost"];
};
/**
 * @summary Status
 * @description Read the current (device, user) push-notification status.
 *
 * Returns ``token`` plus ``enabled = !notification_disabled``. A missing row
 * yields ``enabled=false``/``token=null`` (the app only reads ``enabled``).
 */
export const statusFullappApiPushNotificationsStatusPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/push-notifications/status",
        mediaType: ["application/json"]
    }
} as {
    schema: StatusFullappApiPushNotificationsStatusPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["statusFullappApiPushNotificationsStatusPost"];
};
/** @summary Deregister */
export const deregisterFullappApiPushNotificationsDeregisterPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/push-notifications/deregister",
        mediaType: ["application/json"]
    }
} as {
    schema: DeregisterFullappApiPushNotificationsDeregisterPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["deregisterFullappApiPushNotificationsDeregisterPost"];
};
/**
 * @summary Fetch
 * @description Fetch the auth user's notifications.
 *
 * Returns a flat JSON array (the app flattens ``r.data``), filtered by ``is_new``
 * (1=unread, 0=read) and paginated by ``per_page``/``page``, newest first. Always
 * the auth user's own rows; there is no ``user_id`` param.
 */
export const fetchFullappApiNotificationsFetchPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/notifications/fetch",
        mediaType: ["application/json"]
    }
} as {
    schema: FetchFullappApiNotificationsFetchPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["fetchFullappApiNotificationsFetchPost"];
};
/**
 * @summary Mark
 * @description Mark the auth user's notification read (``is_new`` -> 0) and echo ``{id, is_new}``.
 *
 * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
 * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
 * Idempotent: a second call still returns ``is_new:0``.
 */
export const markFullappApiNotificationsMarkPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/notifications/mark",
        mediaType: ["application/json"]
    }
} as {
    schema: MarkFullappApiNotificationsMarkPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["markFullappApiNotificationsMarkPost"];
};
/**
 * @summary Mark Unread
 * @description Inverse of ``mark``: mark the notification unread (``is_new`` -> 1) and echo
 * ``{id, is_new}``.
 *
 * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
 * ``invalid_ownership``. ``id:0``/``"0"``/``""`` pass validation and collapse to 403.
 * Idempotent: a second call still returns ``is_new:1``.
 */
export const markUnreadFullappApiNotificationsMarkUnreadPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/notifications/mark_unread",
        mediaType: ["application/json"]
    }
} as {
    schema: MarkUnreadFullappApiNotificationsMarkUnreadPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["markUnreadFullappApiNotificationsMarkUnreadPost"];
};
/**
 * @summary Mark By Props
 * @description Bulk-mark unread notifications matching component_name+component_action+item_id
 * (+ optional secondary_item_id) as read.
 *
 * Missing/null required fields -> 433 ``validation_error``; empty string / 0 pass.
 * Ownership is implicit via user_id scoping. Returns a flat array of
 * ``{id, is_new: 0}``; an empty match -> ``[]`` (no error).
 */
export const markByPropsFullappApiNotificationsMarkByPropsPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/notifications/mark_by_props",
        mediaType: ["application/json"]
    }
} as {
    schema: MarkByPropsFullappApiNotificationsMarkByPropsPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["markByPropsFullappApiNotificationsMarkByPropsPost"];
};
/**
 * @summary Delete
 * @description Hard-delete the auth user's notification by id.
 *
 * Missing/null id -> 433 ``validation_error``; missing-row or wrong-owner -> 403
 * ``invalid_ownership``. Success returns an empty data envelope.
 */
export const deleteFullappApiNotificationsDeletePost = {
    schema: {
        method: "post",
        url: "/fullapp-api/notifications/delete",
        mediaType: ["application/json"]
    }
} as {
    schema: DeleteFullappApiNotificationsDeletePostSchema;
    [QraftServiceOperationsToken]: FullappApiService["deleteFullappApiNotificationsDeletePost"];
};
/** @summary Student */
export const studentFullappApiDashboardWidgetsStudentPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/dashboard-widgets/student",
        mediaType: ["application/json"]
    }
} as {
    schema: StudentFullappApiDashboardWidgetsStudentPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["studentFullappApiDashboardWidgetsStudentPost"];
};
/**
 * @summary Study Group
 * @description Render errors as a top-level ``success:false`` with the error body under
 * ``detail``. Raising the HTTPException would hit the app-wide handler that wraps
 * the detail under ``data`` only, but the app's reader expects ``success`` +
 * ``detail`` at the top level, so we render it directly.
 */
export const studyGroupFullappApiDashboardWidgetsStudyGroupPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/dashboard-widgets/study_group",
        mediaType: ["application/json"]
    }
} as {
    schema: StudyGroupFullappApiDashboardWidgetsStudyGroupPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["studyGroupFullappApiDashboardWidgetsStudyGroupPost"];
};
/**
 * @summary Get Student Dashboard Stats
 * @description Get a student's dashboard statistics.
 *
 * NOT self-only: the body ``user_id`` defaults to the auth user, and the only gate
 * is that the TARGET is a student. Any authenticated caller (student or
 * study-helper) may read another student's stats given a valid student
 * ``user_id``; a non-student / nonexistent target -> 403 ``invalid_profile_types``.
 */
export const getStudentDashboardStatsFullappApiDashboardStatsStudentPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/dashboard-stats/student",
        mediaType: ["application/json"]
    }
} as {
    schema: GetStudentDashboardStatsFullappApiDashboardStatsStudentPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["getStudentDashboardStatsFullappApiDashboardStatsStudentPost"];
};
/**
 * @summary Get Study Group Dashboard Stats
 * @description Get dashboard statistics for a study group.
 *
 * ``group_id`` is modelled as optional so a MISSING value yields the 433
 * ``validation_error`` below rather than FastAPI's 422.
 */
export const getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/dashboard-stats/study_group",
        mediaType: ["application/json"]
    }
} as {
    schema: GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPost"];
};
/**
 * @summary Get Follow Up Requests List
 * @description Get list of follow-up requests for the current user.
 */
export const getFollowUpRequestsListFullappApiFollowUpRequestsListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/follow-up-requests/list"
    }
} as {
    schema: GetFollowUpRequestsListFullappApiFollowUpRequestsListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["getFollowUpRequestsListFullappApiFollowUpRequestsListPost"];
};
/**
 * @summary Approve Follow Up Request
 * @description Approve a follow-up request, optionally overwriting the student contact info.
 *
 * Student-owner only: ownership is ``row.student_id == auth user``.
 *
 * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
 * ``detail``/``success``, nested ``validations``) is preserved rather than buried
 * under the app-wide ``{"data": ...}`` exception wrapper.
 */
export const approveFollowUpRequestFullappApiFollowUpRequestsApprovePost = {
    schema: {
        method: "post",
        url: "/fullapp-api/follow-up-requests/approve",
        mediaType: ["application/json"]
    }
} as {
    schema: ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostSchema;
    [QraftServiceOperationsToken]: FullappApiService["approveFollowUpRequestFullappApiFollowUpRequestsApprovePost"];
};
/**
 * @summary Reject Follow Up Request
 * @description Reject a follow-up request with a free-text reason.
 *
 * Student-owner only: ownership is ``row.student_id == auth user``. Order: validate
 * id+reason -> 404 not-found -> 403 forbidden (already rejected, BEFORE ownership)
 * -> 403 invalid_ownership -> mutate + emit.
 *
 * Errors are emitted as a direct ``JSONResponse`` so the body (top-level
 * ``detail``/``success``, nested ``validations``) is preserved rather than buried
 * under the app-wide ``{"data": ...}`` exception wrapper.
 */
export const rejectFollowUpRequestFullappApiFollowUpRequestsRejectPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/follow-up-requests/reject",
        mediaType: ["application/json"]
    }
} as {
    schema: RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["rejectFollowUpRequestFullappApiFollowUpRequestsRejectPost"];
};
/**
 * @summary Send
 * @description Send an encouragement to a student on the open board.
 *
 * Flow: caller-type guard (student rejected) -> required-field validation (433
 * ``validation_error``; only null is rejected) -> resolve target student -> four
 * eligibility gates (all 403 ``forbidden``: postal, already adopted, already
 * encouraged by this SH, fully encouraged at cap 3) -> 1500 plain-text char limit
 * (422 ``character_exceeded``) -> format + insert + flip ``fully_encouraged`` at
 * the cap + persist the drip ``scheduled_email_at``.
 *
 * The app discards the response body; only 2xx-vs-error is load-bearing.
 */
export const sendFullappApiEncouragementsSendPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/encouragements/send",
        mediaType: ["application/json"]
    }
} as {
    schema: SendFullappApiEncouragementsSendPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["sendFullappApiEncouragementsSendPost"];
};
/**
 * @summary Send Introduction
 * @description Send an introduction. SH-only; gates run in order:
 *
 *   1. missing/null user_id or introduction -> 433 validation_error. '' / 0 pass
 *      and fall through: introduction:'' -> empty content -> 500; user_id:0 /
 *      nonexistent / unadopted -> ownership 403 (never 404).
 *   2. postal-type target -> 403, checked BEFORE ownership.
 *   3. ownership: auth SH must be the student's study_helper -> else 403.
 *   4. already-introduced is PER-CURRENT-SH: 403 only if THIS SH already introduced.
 *      A re-adopted student introduced by a different SH is NOT blocked.
 *
 * The introduction-specific notification/activity flow is unmodeled and deferred.
 * The app discards the response body; success-vs-error is the only load-bearing bit.
 */
export const sendIntroductionFullappApiIntroductionsSendPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/introductions/send",
        mediaType: ["application/json"]
    }
} as {
    schema: SendIntroductionFullappApiIntroductionsSendPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["sendIntroductionFullappApiIntroductionsSendPost"];
};
/**
 * @summary Send
 * @description Send a contact-support email.
 *
 * Pure side-effect endpoint: NOT role-sensitive; the auth user is whoever is
 * logged in and the request ``user_id`` is only cosmetic body text.
 *
 * Validate name/email/message present-and-non-blank (else 433
 * ``validation_error``), build a plain-text support email, and send. A falsy send
 * or transport exception surfaces as ``application_error`` (HTTP 404). On success:
 * ``{success:true, data:[]}``.
 */
export const sendFullappApiContactSendPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/contact/send",
        mediaType: ["application/json"]
    }
} as {
    schema: SendFullappApiContactSendPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["sendFullappApiContactSendPost"];
};
/**
 * @summary Get Current Study Helper
 * @description Get the current student's assigned study helper info.
 *
 * Students only (legacy ``check_profile_type('students')``); a wrong-role
 * caller -> 403 ``invalid_profile_types``. A student with no assigned study
 * helper -> 404 ``resource_not_found``.
 */
export const getCurrentStudyHelperFullappApiStudyHelpersCurrentPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/study-helpers/current"
    }
} as {
    schema: GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["getCurrentStudyHelperFullappApiStudyHelpersCurrentPost"];
};
/**
 * @summary Get Study Helper List
 * @description Get the current student's study-helper adoption history.
 *
 * Students only (legacy ``check_profile_type('students')``); a wrong-role
 * caller -> 403 ``invalid_profile_types``. Returns one entry per adoption
 * history row ordered by adoption time.
 */
export const getStudyHelperListFullappApiStudyHelpersListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/study-helpers/list"
    }
} as {
    schema: GetStudyHelperListFullappApiStudyHelpersListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["getStudyHelperListFullappApiStudyHelpersListPost"];
};
/**
 * @summary Fetch
 * @description POST /search/fetch.
 *
 * No SH-impersonation / user_id path: search operates on the authenticated user
 * only (the course activity gate hardcodes the auth user).
 */
export const fetchFullappApiSearchFetchPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/search/fetch",
        mediaType: ["application/json"]
    }
} as {
    schema: FetchFullappApiSearchFetchPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["fetchFullappApiSearchFetchPost"];
};
/**
 * @summary List Preferences
 * @description List the categorized notification preferences.
 *
 * Returns a bare JSON ARRAY of category objects (the client reads ``r.data``
 * then ``.map``). Each category: ``name`` (slug of label), ``label``, ``items``
 * (keyed by preference name). Items carry ``description``, ``types`` (enabled
 * types not disabled by the pref, in registration order), ``settings``
 * (id(type)-keyed JSON bool), and ``{type}_{name}`` = ``'yes'|'no'``.
 *
 * Categories with no profile-type-eligible items are dropped. Reading
 * lazily-fills and persists missing default keys (read-with-write-back).
 */
export const listPreferencesFullappApiPreferencesListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/preferences/list",
        mediaType: ["application/json"]
    }
} as {
    schema: ListPreferencesFullappApiPreferencesListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["listPreferencesFullappApiPreferencesListPost"];
};
/**
 * @summary Update
 * @description Update notification preferences.
 *
 * Accepts ``data`` ({type}_{name} -> 'yes'/'no') and/or ``settings``
 * ({name: {type: value}}); validates names against the FULL catalog and types
 * against the FULL 5-type registry (NOT the per-user eligible subset). Invalid
 * values/types/names are silently skipped. An empty body -> 200 with
 * ``updated={}``. Returns ``{user_id, updated}`` where ``updated`` is
 * ``{name: {type: bool}}`` with real JSON booleans. Writes to the auth user's
 * own ``notification_preferences``.
 */
export const updateFullappApiPreferencesUpdatePost = {
    schema: {
        method: "post",
        url: "/fullapp-api/preferences/update",
        mediaType: ["application/json"]
    }
} as {
    schema: UpdateFullappApiPreferencesUpdatePostSchema;
    [QraftServiceOperationsToken]: FullappApiService["updateFullappApiPreferencesUpdatePost"];
};
/**
 * @summary List Threads
 * @description Retrieve a paginated list of message threads for the current user.
 */
export const listThreadsFullappApiThreadsListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/threads/list",
        mediaType: ["application/json"]
    }
} as {
    schema: ListThreadsFullappApiThreadsListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["listThreadsFullappApiThreadsListPost"];
};
/**
 * @summary Thread Messages
 * @description Retrieve messages for a specific thread.
 */
export const threadMessagesFullappApiThreadsMessagesPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/threads/messages",
        mediaType: ["application/json"]
    }
} as {
    schema: ThreadMessagesFullappApiThreadsMessagesPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["threadMessagesFullappApiThreadsMessagesPost"];
};
/**
 * @summary Search Thread
 * @description Search if there's an existing thread for the given recipients.
 */
export const searchThreadFullappApiThreadsSearchPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/threads/search",
        mediaType: ["application/json"]
    }
} as {
    schema: SearchThreadFullappApiThreadsSearchPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["searchThreadFullappApiThreadsSearchPost"];
};
/**
 * @summary Compose Thread
 * @description Create a new message thread with specified recipients.
 */
export const composeThreadFullappApiThreadsComposePost = {
    schema: {
        method: "post",
        url: "/fullapp-api/threads/compose",
        mediaType: ["application/json"]
    }
} as {
    schema: ComposeThreadFullappApiThreadsComposePostSchema;
    [QraftServiceOperationsToken]: FullappApiService["composeThreadFullappApiThreadsComposePost"];
};
/**
 * @summary Reply To Thread
 * @description Reply to an existing thread.
 */
export const replyToThreadFullappApiThreadsReplyPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/threads/reply",
        mediaType: ["application/json"]
    }
} as {
    schema: ReplyToThreadFullappApiThreadsReplyPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["replyToThreadFullappApiThreadsReplyPost"];
};
/**
 * @summary Delete Thread
 * @description Delete a thread for all participants.
 */
export const deleteThreadFullappApiThreadsDeletePost = {
    schema: {
        method: "post",
        url: "/fullapp-api/threads/delete",
        mediaType: ["application/json"]
    }
} as {
    schema: DeleteThreadFullappApiThreadsDeletePostSchema;
    [QraftServiceOperationsToken]: FullappApiService["deleteThreadFullappApiThreadsDeletePost"];
};
/**
 * @summary Hide Thread
 * @description Hide a thread for the current user only.
 */
export const hideThreadFullappApiThreadsHidePost = {
    schema: {
        method: "post",
        url: "/fullapp-api/threads/hide",
        mediaType: ["application/json"]
    }
} as {
    schema: HideThreadFullappApiThreadsHidePostSchema;
    [QraftServiceOperationsToken]: FullappApiService["hideThreadFullappApiThreadsHidePost"];
};
/**
 * @summary Mark Thread Read
 * @description Mark a thread as read for the current user.
 */
export const markThreadReadFullappApiThreadsReadPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/threads/read",
        mediaType: ["application/json"]
    }
} as {
    schema: MarkThreadReadFullappApiThreadsReadPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["markThreadReadFullappApiThreadsReadPost"];
};
/**
 * @summary Mark Thread Unread
 * @description Mark a thread as unread for the current user.
 */
export const markThreadUnreadFullappApiThreadsUnreadPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/threads/unread",
        mediaType: ["application/json"]
    }
} as {
    schema: MarkThreadUnreadFullappApiThreadsUnreadPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["markThreadUnreadFullappApiThreadsUnreadPost"];
};
/**
 * @summary Add
 * @description Create a user-owned canned response.
 *
 * Missing/null type/target_id/content -> 433 ``validation_error``; empty string /
 * 0 / unknown type pass validation (only null is rejected) and the row is
 * inserted. Returns ``{id, is_builtin(int 0), content}``.
 */
export const addFullappApiCannedResponsesAddPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/canned-responses/add",
        mediaType: ["application/json"]
    }
} as {
    schema: AddFullappApiCannedResponsesAddPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["addFullappApiCannedResponsesAddPost"];
};
/**
 * @summary Fetch
 * @description Return the auth user's own + built-in + target-agnostic rows for the given
 * type/target_id as a bare array, fixed page size 5.
 *
 * Missing/null type/target_id -> 433; empty/unknown values pass and just match no
 * rows.
 */
export const fetchFullappApiCannedResponsesFetchPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/canned-responses/fetch",
        mediaType: ["application/json"]
    }
} as {
    schema: FetchFullappApiCannedResponsesFetchPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["fetchFullappApiCannedResponsesFetchPost"];
};
/**
 * @summary Edit
 * @description Owner-scoped content overwrite.
 *
 * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
 * (invalid_ownership). A present, truthy, non-numeric id is the only ``is_numeric``
 * 433; ``id:""`` falls through to 404.
 */
export const editFullappApiCannedResponsesEditPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/canned-responses/edit",
        mediaType: ["application/json"]
    }
} as {
    schema: EditFullappApiCannedResponsesEditPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["editFullappApiCannedResponsesEditPost"];
};
/**
 * @summary Delete
 * @description Owner-scoped soft delete.
 *
 * Guard order: validation -> not-found -> built-in (forbidden) -> ownership
 * (invalid_ownership). ``id:""``/0/nonexistent fall through to 404. Success returns
 * ``{success:true, data:[]}`` (empty array).
 */
export const deleteFullappApiCannedResponsesDeletePost = {
    schema: {
        method: "post",
        url: "/fullapp-api/canned-responses/delete",
        mediaType: ["application/json"]
    }
} as {
    schema: DeleteFullappApiCannedResponsesDeletePostSchema;
    [QraftServiceOperationsToken]: FullappApiService["deleteFullappApiCannedResponsesDeletePost"];
};
/** @summary Fetch Datatable Info */
export const fetchDatatableInfoFullappApiDatatablesFetchPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/datatables/fetch",
        mediaType: ["application/json"]
    }
} as {
    schema: FetchDatatableInfoFullappApiDatatablesFetchPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["fetchDatatableInfoFullappApiDatatablesFetchPost"];
};
/** @summary Datatable Info */
export const datatableInfoFullappApiDatatablesInfoPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/datatables/info",
        mediaType: ["application/json"]
    }
} as {
    schema: DatatableInfoFullappApiDatatablesInfoPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["datatableInfoFullappApiDatatablesInfoPost"];
};
/** @summary Announcement Detail */
export const announcementDetailFullappApiAnnouncementsDetailPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/announcements/detail"
    }
} as {
    schema: AnnouncementDetailFullappApiAnnouncementsDetailPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["announcementDetailFullappApiAnnouncementsDetailPost"];
};
/** @summary Announcement Update */
export const announcementUpdateFullappApiAnnouncementsUpdatePost = {
    schema: {
        method: "post",
        url: "/fullapp-api/announcements/update",
        mediaType: ["application/json"]
    }
} as {
    schema: AnnouncementUpdateFullappApiAnnouncementsUpdatePostSchema;
    [QraftServiceOperationsToken]: FullappApiService["announcementUpdateFullappApiAnnouncementsUpdatePost"];
};
/** @summary Get Submission Detail */
export const getSubmissionDetailFullappApiSubmissionsDetailPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/submissions/detail",
        mediaType: ["application/json"]
    }
} as {
    schema: GetSubmissionDetailFullappApiSubmissionsDetailPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["getSubmissionDetailFullappApiSubmissionsDetailPost"];
};
/** @summary Grade Submission */
export const gradeSubmissionFullappApiSubmissionsGradePost = {
    schema: {
        method: "post",
        url: "/fullapp-api/submissions/grade",
        mediaType: ["application/json"]
    }
} as {
    schema: GradeSubmissionFullappApiSubmissionsGradePostSchema;
    [QraftServiceOperationsToken]: FullappApiService["gradeSubmissionFullappApiSubmissionsGradePost"];
};
/** @summary List Submissions */
export const listSubmissionsFullappApiSubmissionsListPost = {
    schema: {
        method: "post",
        url: "/fullapp-api/submissions/list",
        mediaType: ["application/json"]
    }
} as {
    schema: ListSubmissionsFullappApiSubmissionsListPostSchema;
    [QraftServiceOperationsToken]: FullappApiService["listSubmissionsFullappApiSubmissionsListPost"];
};
export const fullappApiService = {
    adminForcedFullappApiAuthAdminForcedPost,
    forgetPasswordFullappApiAuthForgetPasswordPost,
    loginFullappApiAuthLoginPost,
    registerUserFullappApiAuthRegisterPost,
    logoutFullappApiAuthLogoutPost,
    registerDeviceFullappApiDevicesRegisterPost,
    installsFullappApiAppInfosInstallsPost,
    translationsFullappApiLanguagesTranslationsPost,
    translationsFullappApiLanguagesTranslationsGet,
    allLanguagesFullappApiLanguagesAllPost,
    allLanguagesFullappApiLanguagesAllGet,
    detailFullappApiPagesDetailPost,
    studyHelperFullappApiInAppLinksStudyHelperPost,
    studentFullappApiInAppLinksStudentPost,
    studentNewsDetailFullappApiStudentNewsDetailPost,
    studentNewsListFullappApiStudentNewsListPost,
    studyHelperNewsDetailFullappApiStudyHelperNewsDetailPost,
    studyHelperNewsListFullappApiStudyHelperNewsListPost,
    studentTutorialsDetailFullappApiStudentTutorialsDetailPost,
    studentTutorialsListFullappApiStudentTutorialsListPost,
    studyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPost,
    studyHelperTutorialsListFullappApiStudyHelperTutorialsListPost,
    adoptStudentFullappApiAdoptionsAdoptPost,
    connectAdoptStudentFullappApiAdoptionsConnectAdoptionPost,
    getAdoptionInfoFullappApiAdoptionsInfoPost,
    passOnStudentFullappFullappApiAdoptionsPassonPost,
    checkAdoptabilityFullappApiAdoptionsCheckAdoptabilityPost,
    getAdoptionRequestInfoFullappApiAdoptionRequestsInfoPost,
    acceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPost,
    declineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePost,
    fullappUserMeFullappApiUsersMeGet,
    fullappUserMeFullappApiUsersMePost,
    fullappChangePasswordFullappApiUsersChangePasswordPost,
    fullappUpdateProfilesFullappApiUsersUpdateProfilesPost,
    fullappUserInfoFullappApiUsersInfoPost,
    fullappUploadAvatarFullappApiUsersAvatarPost,
    fullappSmsStatusFullappApiSmsStatusPost,
    fullappWhatsappStatusFullappApiWhatsappStatusPost,
    getOnboardingStatusFullappApiOnboardingsStatusPost,
    getOnboardingDetailsFullappApiOnboardingsDetailPost,
    onboardingSubmitFullappApiOnboardingsSubmitPost,
    xprofilesListFullappApiXprofilesListPost,
    coursesListFullappApiCoursesListPost,
    courseDetailFullappApiCoursesDetailPost,
    lessonsListFullappApiLessonsListPost,
    lessonDetailFullappApiLessonsDetailPost,
    topicsListFullappApiTopicsListPost,
    topicDetailFullappApiTopicsDetailPost,
    quizDetailFullappApiQuizzesDetailPost,
    guidesListFullappApiGuidesListPost,
    guidesDetailFullappApiGuidesDetailPost,
    listCertificatesFullappApiCertificatesListPost,
    awardCertificateFullappApiCertificatesAwardPost,
    topicMarkCompleteFullappApiTopicsMarkCompletePost,
    submitQuizFullappApiQuizzesSubmitPost,
    courseUnlockFullappApiCoursesUnlockPost,
    listBiblesFullappApiBiblesListPost,
    getChaptersFullappApiBiblesChaptersPost,
    getChapterDetailFullappApiChaptersDetailPost,
    registerFullappApiPushNotificationsRegisterPost,
    statusFullappApiPushNotificationsStatusPost,
    deregisterFullappApiPushNotificationsDeregisterPost,
    fetchFullappApiNotificationsFetchPost,
    markFullappApiNotificationsMarkPost,
    markUnreadFullappApiNotificationsMarkUnreadPost,
    markByPropsFullappApiNotificationsMarkByPropsPost,
    deleteFullappApiNotificationsDeletePost,
    studentFullappApiDashboardWidgetsStudentPost,
    studyGroupFullappApiDashboardWidgetsStudyGroupPost,
    getStudentDashboardStatsFullappApiDashboardStatsStudentPost,
    getStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPost,
    getFollowUpRequestsListFullappApiFollowUpRequestsListPost,
    approveFollowUpRequestFullappApiFollowUpRequestsApprovePost,
    rejectFollowUpRequestFullappApiFollowUpRequestsRejectPost,
    sendFullappApiEncouragementsSendPost,
    sendIntroductionFullappApiIntroductionsSendPost,
    sendFullappApiContactSendPost,
    getCurrentStudyHelperFullappApiStudyHelpersCurrentPost,
    getStudyHelperListFullappApiStudyHelpersListPost,
    fetchFullappApiSearchFetchPost,
    listPreferencesFullappApiPreferencesListPost,
    updateFullappApiPreferencesUpdatePost,
    listThreadsFullappApiThreadsListPost,
    threadMessagesFullappApiThreadsMessagesPost,
    searchThreadFullappApiThreadsSearchPost,
    composeThreadFullappApiThreadsComposePost,
    replyToThreadFullappApiThreadsReplyPost,
    deleteThreadFullappApiThreadsDeletePost,
    hideThreadFullappApiThreadsHidePost,
    markThreadReadFullappApiThreadsReadPost,
    markThreadUnreadFullappApiThreadsUnreadPost,
    addFullappApiCannedResponsesAddPost,
    fetchFullappApiCannedResponsesFetchPost,
    editFullappApiCannedResponsesEditPost,
    deleteFullappApiCannedResponsesDeletePost,
    fetchDatatableInfoFullappApiDatatablesFetchPost,
    datatableInfoFullappApiDatatablesInfoPost,
    announcementDetailFullappApiAnnouncementsDetailPost,
    announcementUpdateFullappApiAnnouncementsUpdatePost,
    getSubmissionDetailFullappApiSubmissionsDetailPost,
    gradeSubmissionFullappApiSubmissionsGradePost,
    listSubmissionsFullappApiSubmissionsListPost
} as const;
type AdminForcedFullappApiAuthAdminForcedPostSchema = {
    method: "post";
    url: "/fullapp-api/auth/admin_forced";
    mediaType: [
        "application/json"
    ];
};
type AdminForcedFullappApiAuthAdminForcedPostParameters = paths["/fullapp-api/auth/admin_forced"]["post"]["parameters"];
type AdminForcedFullappApiAuthAdminForcedPostData = paths["/fullapp-api/auth/admin_forced"]["post"]["responses"]["200"]["content"]["application/json"];
type AdminForcedFullappApiAuthAdminForcedPostError = paths["/fullapp-api/auth/admin_forced"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/auth/admin_forced"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/auth/admin_forced"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/auth/admin_forced"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminForcedFullappApiAuthAdminForcedPostBody = paths["/fullapp-api/auth/admin_forced"]["post"]["requestBody"]["content"]["application/json"];
type ForgetPasswordFullappApiAuthForgetPasswordPostSchema = {
    method: "post";
    url: "/fullapp-api/auth/forget_password";
    mediaType: [
        "application/json"
    ];
};
type ForgetPasswordFullappApiAuthForgetPasswordPostParameters = paths["/fullapp-api/auth/forget_password"]["post"]["parameters"];
type ForgetPasswordFullappApiAuthForgetPasswordPostData = paths["/fullapp-api/auth/forget_password"]["post"]["responses"]["200"]["content"]["application/json"];
type ForgetPasswordFullappApiAuthForgetPasswordPostError = paths["/fullapp-api/auth/forget_password"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/auth/forget_password"]["post"]["responses"]["422"]["content"]["application/json"];
type ForgetPasswordFullappApiAuthForgetPasswordPostBody = paths["/fullapp-api/auth/forget_password"]["post"]["requestBody"]["content"]["application/json"];
type LoginFullappApiAuthLoginPostSchema = {
    method: "post";
    url: "/fullapp-api/auth/login";
    mediaType: [
        "application/json"
    ];
};
type LoginFullappApiAuthLoginPostParameters = paths["/fullapp-api/auth/login"]["post"]["parameters"];
type LoginFullappApiAuthLoginPostData = paths["/fullapp-api/auth/login"]["post"]["responses"]["200"]["content"]["application/json"];
type LoginFullappApiAuthLoginPostError = paths["/fullapp-api/auth/login"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/auth/login"]["post"]["responses"]["422"]["content"]["application/json"];
type LoginFullappApiAuthLoginPostBody = paths["/fullapp-api/auth/login"]["post"]["requestBody"]["content"]["application/json"];
type RegisterUserFullappApiAuthRegisterPostSchema = {
    method: "post";
    url: "/fullapp-api/auth/register";
    mediaType: [
        "application/json"
    ];
};
type RegisterUserFullappApiAuthRegisterPostParameters = paths["/fullapp-api/auth/register"]["post"]["parameters"];
type RegisterUserFullappApiAuthRegisterPostData = paths["/fullapp-api/auth/register"]["post"]["responses"]["200"]["content"]["application/json"];
type RegisterUserFullappApiAuthRegisterPostError = paths["/fullapp-api/auth/register"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/auth/register"]["post"]["responses"]["422"]["content"]["application/json"];
type RegisterUserFullappApiAuthRegisterPostBody = paths["/fullapp-api/auth/register"]["post"]["requestBody"]["content"]["application/json"];
type LogoutFullappApiAuthLogoutPostSchema = {
    method: "post";
    url: "/fullapp-api/auth/logout";
};
type LogoutFullappApiAuthLogoutPostParameters = paths["/fullapp-api/auth/logout"]["post"]["parameters"];
type LogoutFullappApiAuthLogoutPostData = paths["/fullapp-api/auth/logout"]["post"]["responses"]["200"]["content"]["application/json"];
type LogoutFullappApiAuthLogoutPostError = paths["/fullapp-api/auth/logout"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/auth/logout"]["post"]["responses"]["422"]["content"]["application/json"];
type LogoutFullappApiAuthLogoutPostBody = undefined;
type RegisterDeviceFullappApiDevicesRegisterPostSchema = {
    method: "post";
    url: "/fullapp-api/devices/register";
    mediaType: [
        "application/json"
    ];
};
type RegisterDeviceFullappApiDevicesRegisterPostParameters = {
    query?: never;
    header?: never;
    path?: never;
};
type RegisterDeviceFullappApiDevicesRegisterPostData = paths["/fullapp-api/devices/register"]["post"]["responses"]["200"]["content"]["application/json"];
type RegisterDeviceFullappApiDevicesRegisterPostError = paths["/fullapp-api/devices/register"]["post"]["responses"]["422"]["content"]["application/json"];
type RegisterDeviceFullappApiDevicesRegisterPostBody = paths["/fullapp-api/devices/register"]["post"]["requestBody"]["content"]["application/json"];
type InstallsFullappApiAppInfosInstallsPostSchema = {
    method: "post";
    url: "/fullapp-api/app-infos/installs";
};
type InstallsFullappApiAppInfosInstallsPostParameters = paths["/fullapp-api/app-infos/installs"]["post"]["parameters"];
type InstallsFullappApiAppInfosInstallsPostData = paths["/fullapp-api/app-infos/installs"]["post"]["responses"]["200"]["content"]["application/json"];
type InstallsFullappApiAppInfosInstallsPostError = paths["/fullapp-api/app-infos/installs"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/app-infos/installs"]["post"]["responses"]["422"]["content"]["application/json"];
type InstallsFullappApiAppInfosInstallsPostBody = undefined;
type TranslationsFullappApiLanguagesTranslationsPostSchema = {
    method: "post";
    url: "/fullapp-api/languages/translations";
    mediaType: [
        "application/json"
    ];
};
type TranslationsFullappApiLanguagesTranslationsPostParameters = paths["/fullapp-api/languages/translations"]["post"]["parameters"];
type TranslationsFullappApiLanguagesTranslationsPostData = paths["/fullapp-api/languages/translations"]["post"]["responses"]["200"]["content"]["application/json"];
type TranslationsFullappApiLanguagesTranslationsPostError = paths["/fullapp-api/languages/translations"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/languages/translations"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/languages/translations"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/languages/translations"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/languages/translations"]["post"]["responses"]["503"]["content"]["application/json"];
type TranslationsFullappApiLanguagesTranslationsPostBody = paths["/fullapp-api/languages/translations"]["post"]["requestBody"]["content"]["application/json"];
type TranslationsFullappApiLanguagesTranslationsGetSchema = {
    method: "get";
    url: "/fullapp-api/languages/translations";
    mediaType: [
        "application/json"
    ];
};
type TranslationsFullappApiLanguagesTranslationsGetParameters = paths["/fullapp-api/languages/translations"]["get"]["parameters"];
type TranslationsFullappApiLanguagesTranslationsGetData = paths["/fullapp-api/languages/translations"]["get"]["responses"]["200"]["content"]["application/json"];
type TranslationsFullappApiLanguagesTranslationsGetError = paths["/fullapp-api/languages/translations"]["get"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/languages/translations"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/languages/translations"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/languages/translations"]["get"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/languages/translations"]["get"]["responses"]["503"]["content"]["application/json"];
type TranslationsFullappApiLanguagesTranslationsGetBody = paths["/fullapp-api/languages/translations"]["get"]["requestBody"]["content"]["application/json"];
type AllLanguagesFullappApiLanguagesAllPostSchema = {
    method: "post";
    url: "/fullapp-api/languages/all";
};
type AllLanguagesFullappApiLanguagesAllPostParameters = paths["/fullapp-api/languages/all"]["post"]["parameters"];
type AllLanguagesFullappApiLanguagesAllPostData = paths["/fullapp-api/languages/all"]["post"]["responses"]["200"]["content"]["application/json"];
type AllLanguagesFullappApiLanguagesAllPostError = paths["/fullapp-api/languages/all"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/languages/all"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/languages/all"]["post"]["responses"]["503"]["content"]["application/json"];
type AllLanguagesFullappApiLanguagesAllPostBody = undefined;
type AllLanguagesFullappApiLanguagesAllGetSchema = {
    method: "get";
    url: "/fullapp-api/languages/all";
};
type AllLanguagesFullappApiLanguagesAllGetParameters = paths["/fullapp-api/languages/all"]["get"]["parameters"];
type AllLanguagesFullappApiLanguagesAllGetData = paths["/fullapp-api/languages/all"]["get"]["responses"]["200"]["content"]["application/json"];
type AllLanguagesFullappApiLanguagesAllGetError = paths["/fullapp-api/languages/all"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/languages/all"]["get"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/languages/all"]["get"]["responses"]["503"]["content"]["application/json"];
type DetailFullappApiPagesDetailPostSchema = {
    method: "post";
    url: "/fullapp-api/pages/detail";
    mediaType: [
        "application/json"
    ];
};
type DetailFullappApiPagesDetailPostParameters = paths["/fullapp-api/pages/detail"]["post"]["parameters"];
type DetailFullappApiPagesDetailPostData = paths["/fullapp-api/pages/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type DetailFullappApiPagesDetailPostError = paths["/fullapp-api/pages/detail"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/pages/detail"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/pages/detail"]["post"]["responses"]["433"]["content"]["application/json"];
type DetailFullappApiPagesDetailPostBody = paths["/fullapp-api/pages/detail"]["post"]["requestBody"]["content"]["application/json"];
type StudyHelperFullappApiInAppLinksStudyHelperPostSchema = {
    method: "post";
    url: "/fullapp-api/in-app-links/study_helper";
    mediaType: [
        "application/json"
    ];
};
type StudyHelperFullappApiInAppLinksStudyHelperPostParameters = paths["/fullapp-api/in-app-links/study_helper"]["post"]["parameters"];
type StudyHelperFullappApiInAppLinksStudyHelperPostData = paths["/fullapp-api/in-app-links/study_helper"]["post"]["responses"]["200"]["content"]["application/json"];
type StudyHelperFullappApiInAppLinksStudyHelperPostError = paths["/fullapp-api/in-app-links/study_helper"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/in-app-links/study_helper"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/in-app-links/study_helper"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/in-app-links/study_helper"]["post"]["responses"]["433"]["content"]["application/json"];
type StudyHelperFullappApiInAppLinksStudyHelperPostBody = paths["/fullapp-api/in-app-links/study_helper"]["post"]["requestBody"]["content"]["application/json"];
type StudentFullappApiInAppLinksStudentPostSchema = {
    method: "post";
    url: "/fullapp-api/in-app-links/student";
    mediaType: [
        "application/json"
    ];
};
type StudentFullappApiInAppLinksStudentPostParameters = paths["/fullapp-api/in-app-links/student"]["post"]["parameters"];
type StudentFullappApiInAppLinksStudentPostData = paths["/fullapp-api/in-app-links/student"]["post"]["responses"]["200"]["content"]["application/json"];
type StudentFullappApiInAppLinksStudentPostError = paths["/fullapp-api/in-app-links/student"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/in-app-links/student"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/in-app-links/student"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/in-app-links/student"]["post"]["responses"]["433"]["content"]["application/json"];
type StudentFullappApiInAppLinksStudentPostBody = paths["/fullapp-api/in-app-links/student"]["post"]["requestBody"]["content"]["application/json"];
type StudentNewsDetailFullappApiStudentNewsDetailPostSchema = {
    method: "post";
    url: "/fullapp-api/student-news/detail";
    mediaType: [
        "application/json"
    ];
};
type StudentNewsDetailFullappApiStudentNewsDetailPostParameters = paths["/fullapp-api/student-news/detail"]["post"]["parameters"];
type StudentNewsDetailFullappApiStudentNewsDetailPostData = paths["/fullapp-api/student-news/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type StudentNewsDetailFullappApiStudentNewsDetailPostError = paths["/fullapp-api/student-news/detail"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/student-news/detail"]["post"]["responses"]["422"]["content"]["application/json"];
type StudentNewsDetailFullappApiStudentNewsDetailPostBody = paths["/fullapp-api/student-news/detail"]["post"]["requestBody"]["content"]["application/json"];
type StudentNewsListFullappApiStudentNewsListPostSchema = {
    method: "post";
    url: "/fullapp-api/student-news/list";
    mediaType: [
        "application/json"
    ];
};
type StudentNewsListFullappApiStudentNewsListPostParameters = paths["/fullapp-api/student-news/list"]["post"]["parameters"];
type StudentNewsListFullappApiStudentNewsListPostData = paths["/fullapp-api/student-news/list"]["post"]["responses"]["200"]["content"]["application/json"];
type StudentNewsListFullappApiStudentNewsListPostError = paths["/fullapp-api/student-news/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/student-news/list"]["post"]["responses"]["422"]["content"]["application/json"];
type StudentNewsListFullappApiStudentNewsListPostBody = paths["/fullapp-api/student-news/list"]["post"]["requestBody"]["content"]["application/json"];
type StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostSchema = {
    method: "post";
    url: "/fullapp-api/study-helper-news/detail";
    mediaType: [
        "application/json"
    ];
};
type StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostParameters = paths["/fullapp-api/study-helper-news/detail"]["post"]["parameters"];
type StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostData = paths["/fullapp-api/study-helper-news/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostError = paths["/fullapp-api/study-helper-news/detail"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/study-helper-news/detail"]["post"]["responses"]["422"]["content"]["application/json"];
type StudyHelperNewsDetailFullappApiStudyHelperNewsDetailPostBody = paths["/fullapp-api/study-helper-news/detail"]["post"]["requestBody"]["content"]["application/json"];
type StudyHelperNewsListFullappApiStudyHelperNewsListPostSchema = {
    method: "post";
    url: "/fullapp-api/study-helper-news/list";
    mediaType: [
        "application/json"
    ];
};
type StudyHelperNewsListFullappApiStudyHelperNewsListPostParameters = paths["/fullapp-api/study-helper-news/list"]["post"]["parameters"];
type StudyHelperNewsListFullappApiStudyHelperNewsListPostData = paths["/fullapp-api/study-helper-news/list"]["post"]["responses"]["200"]["content"]["application/json"];
type StudyHelperNewsListFullappApiStudyHelperNewsListPostError = paths["/fullapp-api/study-helper-news/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/study-helper-news/list"]["post"]["responses"]["422"]["content"]["application/json"];
type StudyHelperNewsListFullappApiStudyHelperNewsListPostBody = paths["/fullapp-api/study-helper-news/list"]["post"]["requestBody"]["content"]["application/json"];
type StudentTutorialsDetailFullappApiStudentTutorialsDetailPostSchema = {
    method: "post";
    url: "/fullapp-api/student-tutorials/detail";
    mediaType: [
        "application/json"
    ];
};
type StudentTutorialsDetailFullappApiStudentTutorialsDetailPostParameters = paths["/fullapp-api/student-tutorials/detail"]["post"]["parameters"];
type StudentTutorialsDetailFullappApiStudentTutorialsDetailPostData = paths["/fullapp-api/student-tutorials/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type StudentTutorialsDetailFullappApiStudentTutorialsDetailPostError = paths["/fullapp-api/student-tutorials/detail"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/student-tutorials/detail"]["post"]["responses"]["422"]["content"]["application/json"];
type StudentTutorialsDetailFullappApiStudentTutorialsDetailPostBody = paths["/fullapp-api/student-tutorials/detail"]["post"]["requestBody"]["content"]["application/json"];
type StudentTutorialsListFullappApiStudentTutorialsListPostSchema = {
    method: "post";
    url: "/fullapp-api/student-tutorials/list";
    mediaType: [
        "application/json"
    ];
};
type StudentTutorialsListFullappApiStudentTutorialsListPostParameters = paths["/fullapp-api/student-tutorials/list"]["post"]["parameters"];
type StudentTutorialsListFullappApiStudentTutorialsListPostData = paths["/fullapp-api/student-tutorials/list"]["post"]["responses"]["200"]["content"]["application/json"];
type StudentTutorialsListFullappApiStudentTutorialsListPostError = paths["/fullapp-api/student-tutorials/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/student-tutorials/list"]["post"]["responses"]["422"]["content"]["application/json"];
type StudentTutorialsListFullappApiStudentTutorialsListPostBody = paths["/fullapp-api/student-tutorials/list"]["post"]["requestBody"]["content"]["application/json"];
type StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostSchema = {
    method: "post";
    url: "/fullapp-api/study-helper-tutorials/detail";
    mediaType: [
        "application/json"
    ];
};
type StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostParameters = paths["/fullapp-api/study-helper-tutorials/detail"]["post"]["parameters"];
type StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostData = paths["/fullapp-api/study-helper-tutorials/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostError = paths["/fullapp-api/study-helper-tutorials/detail"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/study-helper-tutorials/detail"]["post"]["responses"]["422"]["content"]["application/json"];
type StudyHelperTutorialsDetailFullappApiStudyHelperTutorialsDetailPostBody = paths["/fullapp-api/study-helper-tutorials/detail"]["post"]["requestBody"]["content"]["application/json"];
type StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostSchema = {
    method: "post";
    url: "/fullapp-api/study-helper-tutorials/list";
    mediaType: [
        "application/json"
    ];
};
type StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostParameters = paths["/fullapp-api/study-helper-tutorials/list"]["post"]["parameters"];
type StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostData = paths["/fullapp-api/study-helper-tutorials/list"]["post"]["responses"]["200"]["content"]["application/json"];
type StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostError = paths["/fullapp-api/study-helper-tutorials/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/study-helper-tutorials/list"]["post"]["responses"]["422"]["content"]["application/json"];
type StudyHelperTutorialsListFullappApiStudyHelperTutorialsListPostBody = paths["/fullapp-api/study-helper-tutorials/list"]["post"]["requestBody"]["content"]["application/json"];
type AdoptStudentFullappApiAdoptionsAdoptPostSchema = {
    method: "post";
    url: "/fullapp-api/adoptions/adopt";
    mediaType: [
        "application/json"
    ];
};
type AdoptStudentFullappApiAdoptionsAdoptPostParameters = paths["/fullapp-api/adoptions/adopt"]["post"]["parameters"];
type AdoptStudentFullappApiAdoptionsAdoptPostData = paths["/fullapp-api/adoptions/adopt"]["post"]["responses"]["200"]["content"]["application/json"];
type AdoptStudentFullappApiAdoptionsAdoptPostError = paths["/fullapp-api/adoptions/adopt"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/adoptions/adopt"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/adoptions/adopt"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/adoptions/adopt"]["post"]["responses"]["422"]["content"]["application/json"];
type AdoptStudentFullappApiAdoptionsAdoptPostBody = paths["/fullapp-api/adoptions/adopt"]["post"]["requestBody"]["content"]["application/json"];
type ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostSchema = {
    method: "post";
    url: "/fullapp-api/adoptions/connect_adoption";
    mediaType: [
        "application/json"
    ];
};
type ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostParameters = paths["/fullapp-api/adoptions/connect_adoption"]["post"]["parameters"];
type ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostData = paths["/fullapp-api/adoptions/connect_adoption"]["post"]["responses"]["200"]["content"]["application/json"];
type ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostError = paths["/fullapp-api/adoptions/connect_adoption"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/adoptions/connect_adoption"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/adoptions/connect_adoption"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/adoptions/connect_adoption"]["post"]["responses"]["422"]["content"]["application/json"];
type ConnectAdoptStudentFullappApiAdoptionsConnectAdoptionPostBody = paths["/fullapp-api/adoptions/connect_adoption"]["post"]["requestBody"]["content"]["application/json"];
type GetAdoptionInfoFullappApiAdoptionsInfoPostSchema = {
    method: "post";
    url: "/fullapp-api/adoptions/info";
    mediaType: [
        "application/json"
    ];
};
type GetAdoptionInfoFullappApiAdoptionsInfoPostParameters = paths["/fullapp-api/adoptions/info"]["post"]["parameters"];
type GetAdoptionInfoFullappApiAdoptionsInfoPostData = paths["/fullapp-api/adoptions/info"]["post"]["responses"]["200"]["content"]["application/json"];
type GetAdoptionInfoFullappApiAdoptionsInfoPostError = paths["/fullapp-api/adoptions/info"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/adoptions/info"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/adoptions/info"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/adoptions/info"]["post"]["responses"]["422"]["content"]["application/json"];
type GetAdoptionInfoFullappApiAdoptionsInfoPostBody = paths["/fullapp-api/adoptions/info"]["post"]["requestBody"]["content"]["application/json"];
type PassOnStudentFullappFullappApiAdoptionsPassonPostSchema = {
    method: "post";
    url: "/fullapp-api/adoptions/passon";
    mediaType: [
        "application/json"
    ];
};
type PassOnStudentFullappFullappApiAdoptionsPassonPostParameters = paths["/fullapp-api/adoptions/passon"]["post"]["parameters"];
type PassOnStudentFullappFullappApiAdoptionsPassonPostData = paths["/fullapp-api/adoptions/passon"]["post"]["responses"]["200"]["content"]["application/json"];
type PassOnStudentFullappFullappApiAdoptionsPassonPostError = paths["/fullapp-api/adoptions/passon"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/adoptions/passon"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/adoptions/passon"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/adoptions/passon"]["post"]["responses"]["422"]["content"]["application/json"];
type PassOnStudentFullappFullappApiAdoptionsPassonPostBody = paths["/fullapp-api/adoptions/passon"]["post"]["requestBody"]["content"]["application/json"];
type CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostSchema = {
    method: "post";
    url: "/fullapp-api/adoptions/check_adoptability";
    mediaType: [
        "application/json"
    ];
};
type CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostParameters = paths["/fullapp-api/adoptions/check_adoptability"]["post"]["parameters"];
type CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostData = paths["/fullapp-api/adoptions/check_adoptability"]["post"]["responses"]["200"]["content"]["application/json"];
type CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostError = paths["/fullapp-api/adoptions/check_adoptability"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/adoptions/check_adoptability"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/adoptions/check_adoptability"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/adoptions/check_adoptability"]["post"]["responses"]["422"]["content"]["application/json"];
type CheckAdoptabilityFullappApiAdoptionsCheckAdoptabilityPostBody = paths["/fullapp-api/adoptions/check_adoptability"]["post"]["requestBody"]["content"]["application/json"];
type GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostSchema = {
    method: "post";
    url: "/fullapp-api/adoption-requests/info";
    mediaType: [
        "application/json"
    ];
};
type GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostParameters = paths["/fullapp-api/adoption-requests/info"]["post"]["parameters"];
type GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostData = paths["/fullapp-api/adoption-requests/info"]["post"]["responses"]["200"]["content"]["application/json"];
type GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostError = paths["/fullapp-api/adoption-requests/info"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/adoption-requests/info"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/adoption-requests/info"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/adoption-requests/info"]["post"]["responses"]["422"]["content"]["application/json"];
type GetAdoptionRequestInfoFullappApiAdoptionRequestsInfoPostBody = paths["/fullapp-api/adoption-requests/info"]["post"]["requestBody"]["content"]["application/json"];
type AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostSchema = {
    method: "post";
    url: "/fullapp-api/adoption-requests/accept";
    mediaType: [
        "application/json"
    ];
};
type AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostParameters = paths["/fullapp-api/adoption-requests/accept"]["post"]["parameters"];
type AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostData = paths["/fullapp-api/adoption-requests/accept"]["post"]["responses"]["200"]["content"]["application/json"];
type AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostError = paths["/fullapp-api/adoption-requests/accept"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/adoption-requests/accept"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/adoption-requests/accept"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/adoption-requests/accept"]["post"]["responses"]["409"]["content"]["application/json"] | paths["/fullapp-api/adoption-requests/accept"]["post"]["responses"]["422"]["content"]["application/json"];
type AcceptAdoptionRequestFullappFullappApiAdoptionRequestsAcceptPostBody = paths["/fullapp-api/adoption-requests/accept"]["post"]["requestBody"]["content"]["application/json"];
type DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostSchema = {
    method: "post";
    url: "/fullapp-api/adoption-requests/decline";
    mediaType: [
        "application/json"
    ];
};
type DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostParameters = paths["/fullapp-api/adoption-requests/decline"]["post"]["parameters"];
type DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostData = paths["/fullapp-api/adoption-requests/decline"]["post"]["responses"]["200"]["content"]["application/json"];
type DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostError = paths["/fullapp-api/adoption-requests/decline"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/adoption-requests/decline"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/adoption-requests/decline"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/adoption-requests/decline"]["post"]["responses"]["422"]["content"]["application/json"];
type DeclineAdoptionRequestFullappFullappApiAdoptionRequestsDeclinePostBody = paths["/fullapp-api/adoption-requests/decline"]["post"]["requestBody"]["content"]["application/json"];
type FullappUserMeFullappApiUsersMeGetSchema = {
    method: "get";
    url: "/fullapp-api/users/me";
};
type FullappUserMeFullappApiUsersMeGetParameters = paths["/fullapp-api/users/me"]["get"]["parameters"];
type FullappUserMeFullappApiUsersMeGetData = paths["/fullapp-api/users/me"]["get"]["responses"]["200"]["content"]["application/json"];
type FullappUserMeFullappApiUsersMeGetError = paths["/fullapp-api/users/me"]["get"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/users/me"]["get"]["responses"]["422"]["content"]["application/json"];
type FullappUserMeFullappApiUsersMePostSchema = {
    method: "post";
    url: "/fullapp-api/users/me";
};
type FullappUserMeFullappApiUsersMePostParameters = paths["/fullapp-api/users/me"]["post"]["parameters"];
type FullappUserMeFullappApiUsersMePostData = paths["/fullapp-api/users/me"]["post"]["responses"]["200"]["content"]["application/json"];
type FullappUserMeFullappApiUsersMePostError = paths["/fullapp-api/users/me"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/users/me"]["post"]["responses"]["422"]["content"]["application/json"];
type FullappUserMeFullappApiUsersMePostBody = undefined;
type FullappChangePasswordFullappApiUsersChangePasswordPostSchema = {
    method: "post";
    url: "/fullapp-api/users/change_password";
    mediaType: [
        "application/json"
    ];
};
type FullappChangePasswordFullappApiUsersChangePasswordPostParameters = paths["/fullapp-api/users/change_password"]["post"]["parameters"];
type FullappChangePasswordFullappApiUsersChangePasswordPostData = paths["/fullapp-api/users/change_password"]["post"]["responses"]["200"]["content"]["application/json"];
type FullappChangePasswordFullappApiUsersChangePasswordPostError = paths["/fullapp-api/users/change_password"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/users/change_password"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/users/change_password"]["post"]["responses"]["433"]["content"]["application/json"];
type FullappChangePasswordFullappApiUsersChangePasswordPostBody = paths["/fullapp-api/users/change_password"]["post"]["requestBody"]["content"]["application/json"];
type FullappUpdateProfilesFullappApiUsersUpdateProfilesPostSchema = {
    method: "post";
    url: "/fullapp-api/users/update_profiles";
    mediaType: [
        "application/json"
    ];
};
type FullappUpdateProfilesFullappApiUsersUpdateProfilesPostParameters = paths["/fullapp-api/users/update_profiles"]["post"]["parameters"];
type FullappUpdateProfilesFullappApiUsersUpdateProfilesPostData = paths["/fullapp-api/users/update_profiles"]["post"]["responses"]["200"]["content"]["application/json"];
type FullappUpdateProfilesFullappApiUsersUpdateProfilesPostError = paths["/fullapp-api/users/update_profiles"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/users/update_profiles"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/users/update_profiles"]["post"]["responses"]["433"]["content"]["application/json"];
type FullappUpdateProfilesFullappApiUsersUpdateProfilesPostBody = paths["/fullapp-api/users/update_profiles"]["post"]["requestBody"]["content"]["application/json"];
type FullappUserInfoFullappApiUsersInfoPostSchema = {
    method: "post";
    url: "/fullapp-api/users/info";
    mediaType: [
        "application/json"
    ];
};
type FullappUserInfoFullappApiUsersInfoPostParameters = paths["/fullapp-api/users/info"]["post"]["parameters"];
type FullappUserInfoFullappApiUsersInfoPostData = paths["/fullapp-api/users/info"]["post"]["responses"]["200"]["content"]["application/json"];
type FullappUserInfoFullappApiUsersInfoPostError = paths["/fullapp-api/users/info"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/users/info"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/users/info"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/users/info"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/users/info"]["post"]["responses"]["433"]["content"]["application/json"];
type FullappUserInfoFullappApiUsersInfoPostBody = paths["/fullapp-api/users/info"]["post"]["requestBody"]["content"]["application/json"];
type FullappUploadAvatarFullappApiUsersAvatarPostSchema = {
    method: "post";
    url: "/fullapp-api/users/avatar";
    mediaType: [
        "multipart/form-data"
    ];
};
type FullappUploadAvatarFullappApiUsersAvatarPostParameters = paths["/fullapp-api/users/avatar"]["post"]["parameters"];
type FullappUploadAvatarFullappApiUsersAvatarPostData = paths["/fullapp-api/users/avatar"]["post"]["responses"]["200"]["content"]["application/json"];
type FullappUploadAvatarFullappApiUsersAvatarPostError = paths["/fullapp-api/users/avatar"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/users/avatar"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/users/avatar"]["post"]["responses"]["433"]["content"]["application/json"];
type FullappUploadAvatarFullappApiUsersAvatarPostBody = NonNullable<paths["/fullapp-api/users/avatar"]["post"]["requestBody"]>["content"]["multipart/form-data"] | FormData;
type FullappSmsStatusFullappApiSmsStatusPostSchema = {
    method: "post";
    url: "/fullapp-api/sms/status";
};
type FullappSmsStatusFullappApiSmsStatusPostParameters = paths["/fullapp-api/sms/status"]["post"]["parameters"];
type FullappSmsStatusFullappApiSmsStatusPostData = paths["/fullapp-api/sms/status"]["post"]["responses"]["200"]["content"]["application/json"];
type FullappSmsStatusFullappApiSmsStatusPostError = paths["/fullapp-api/sms/status"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/sms/status"]["post"]["responses"]["422"]["content"]["application/json"];
type FullappSmsStatusFullappApiSmsStatusPostBody = undefined;
type FullappWhatsappStatusFullappApiWhatsappStatusPostSchema = {
    method: "post";
    url: "/fullapp-api/whatsapp/status";
};
type FullappWhatsappStatusFullappApiWhatsappStatusPostParameters = paths["/fullapp-api/whatsapp/status"]["post"]["parameters"];
type FullappWhatsappStatusFullappApiWhatsappStatusPostData = paths["/fullapp-api/whatsapp/status"]["post"]["responses"]["200"]["content"]["application/json"];
type FullappWhatsappStatusFullappApiWhatsappStatusPostError = paths["/fullapp-api/whatsapp/status"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/whatsapp/status"]["post"]["responses"]["422"]["content"]["application/json"];
type FullappWhatsappStatusFullappApiWhatsappStatusPostBody = undefined;
type GetOnboardingStatusFullappApiOnboardingsStatusPostSchema = {
    method: "post";
    url: "/fullapp-api/onboardings/status";
};
type GetOnboardingStatusFullappApiOnboardingsStatusPostParameters = paths["/fullapp-api/onboardings/status"]["post"]["parameters"];
type GetOnboardingStatusFullappApiOnboardingsStatusPostData = paths["/fullapp-api/onboardings/status"]["post"]["responses"]["200"]["content"]["application/json"];
type GetOnboardingStatusFullappApiOnboardingsStatusPostError = paths["/fullapp-api/onboardings/status"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/onboardings/status"]["post"]["responses"]["422"]["content"]["application/json"];
type GetOnboardingStatusFullappApiOnboardingsStatusPostBody = undefined;
type GetOnboardingDetailsFullappApiOnboardingsDetailPostSchema = {
    method: "post";
    url: "/fullapp-api/onboardings/detail";
    mediaType: [
        "application/json"
    ];
};
type GetOnboardingDetailsFullappApiOnboardingsDetailPostParameters = paths["/fullapp-api/onboardings/detail"]["post"]["parameters"];
type GetOnboardingDetailsFullappApiOnboardingsDetailPostData = paths["/fullapp-api/onboardings/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type GetOnboardingDetailsFullappApiOnboardingsDetailPostError = paths["/fullapp-api/onboardings/detail"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/onboardings/detail"]["post"]["responses"]["422"]["content"]["application/json"];
type GetOnboardingDetailsFullappApiOnboardingsDetailPostBody = paths["/fullapp-api/onboardings/detail"]["post"]["requestBody"]["content"]["application/json"];
type OnboardingSubmitFullappApiOnboardingsSubmitPostSchema = {
    method: "post";
    url: "/fullapp-api/onboardings/submit";
    mediaType: [
        "application/json"
    ];
};
type OnboardingSubmitFullappApiOnboardingsSubmitPostParameters = paths["/fullapp-api/onboardings/submit"]["post"]["parameters"];
type OnboardingSubmitFullappApiOnboardingsSubmitPostData = paths["/fullapp-api/onboardings/submit"]["post"]["responses"]["200"]["content"]["application/json"];
type OnboardingSubmitFullappApiOnboardingsSubmitPostError = paths["/fullapp-api/onboardings/submit"]["post"]["responses"]["401"]["content"]["application/json"] | null | paths["/fullapp-api/onboardings/submit"]["post"]["responses"]["422"]["content"]["application/json"];
type OnboardingSubmitFullappApiOnboardingsSubmitPostBody = paths["/fullapp-api/onboardings/submit"]["post"]["requestBody"]["content"]["application/json"];
type XprofilesListFullappApiXprofilesListPostSchema = {
    method: "post";
    url: "/fullapp-api/xprofiles/list";
    mediaType: [
        "application/json"
    ];
};
type XprofilesListFullappApiXprofilesListPostParameters = paths["/fullapp-api/xprofiles/list"]["post"]["parameters"];
type XprofilesListFullappApiXprofilesListPostData = paths["/fullapp-api/xprofiles/list"]["post"]["responses"]["200"]["content"]["application/json"];
type XprofilesListFullappApiXprofilesListPostError = paths["/fullapp-api/xprofiles/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/xprofiles/list"]["post"]["responses"]["422"]["content"]["application/json"];
type XprofilesListFullappApiXprofilesListPostBody = paths["/fullapp-api/xprofiles/list"]["post"]["requestBody"]["content"]["application/json"];
type CoursesListFullappApiCoursesListPostSchema = {
    method: "post";
    url: "/fullapp-api/courses/list";
    mediaType: [
        "application/json"
    ];
};
type CoursesListFullappApiCoursesListPostParameters = paths["/fullapp-api/courses/list"]["post"]["parameters"];
type CoursesListFullappApiCoursesListPostData = paths["/fullapp-api/courses/list"]["post"]["responses"]["200"]["content"]["application/json"];
type CoursesListFullappApiCoursesListPostError = paths["/fullapp-api/courses/list"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/courses/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/courses/list"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/courses/list"]["post"]["responses"]["422"]["content"]["application/json"];
type CoursesListFullappApiCoursesListPostBody = paths["/fullapp-api/courses/list"]["post"]["requestBody"]["content"]["application/json"];
type CourseDetailFullappApiCoursesDetailPostSchema = {
    method: "post";
    url: "/fullapp-api/courses/detail";
    mediaType: [
        "application/json"
    ];
};
type CourseDetailFullappApiCoursesDetailPostParameters = paths["/fullapp-api/courses/detail"]["post"]["parameters"];
type CourseDetailFullappApiCoursesDetailPostData = paths["/fullapp-api/courses/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type CourseDetailFullappApiCoursesDetailPostError = paths["/fullapp-api/courses/detail"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/courses/detail"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/courses/detail"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/courses/detail"]["post"]["responses"]["422"]["content"]["application/json"];
type CourseDetailFullappApiCoursesDetailPostBody = paths["/fullapp-api/courses/detail"]["post"]["requestBody"]["content"]["application/json"];
type LessonsListFullappApiLessonsListPostSchema = {
    method: "post";
    url: "/fullapp-api/lessons/list";
    mediaType: [
        "application/json"
    ];
};
type LessonsListFullappApiLessonsListPostParameters = paths["/fullapp-api/lessons/list"]["post"]["parameters"];
type LessonsListFullappApiLessonsListPostData = paths["/fullapp-api/lessons/list"]["post"]["responses"]["200"]["content"]["application/json"];
type LessonsListFullappApiLessonsListPostError = paths["/fullapp-api/lessons/list"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/lessons/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/lessons/list"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/lessons/list"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/lessons/list"]["post"]["responses"]["422"]["content"]["application/json"];
type LessonsListFullappApiLessonsListPostBody = paths["/fullapp-api/lessons/list"]["post"]["requestBody"]["content"]["application/json"];
type LessonDetailFullappApiLessonsDetailPostSchema = {
    method: "post";
    url: "/fullapp-api/lessons/detail";
    mediaType: [
        "application/json"
    ];
};
type LessonDetailFullappApiLessonsDetailPostParameters = paths["/fullapp-api/lessons/detail"]["post"]["parameters"];
type LessonDetailFullappApiLessonsDetailPostData = paths["/fullapp-api/lessons/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type LessonDetailFullappApiLessonsDetailPostError = paths["/fullapp-api/lessons/detail"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/lessons/detail"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/lessons/detail"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/lessons/detail"]["post"]["responses"]["422"]["content"]["application/json"];
type LessonDetailFullappApiLessonsDetailPostBody = paths["/fullapp-api/lessons/detail"]["post"]["requestBody"]["content"]["application/json"];
type TopicsListFullappApiTopicsListPostSchema = {
    method: "post";
    url: "/fullapp-api/topics/list";
    mediaType: [
        "application/json"
    ];
};
type TopicsListFullappApiTopicsListPostParameters = paths["/fullapp-api/topics/list"]["post"]["parameters"];
type TopicsListFullappApiTopicsListPostData = paths["/fullapp-api/topics/list"]["post"]["responses"]["200"]["content"]["application/json"];
type TopicsListFullappApiTopicsListPostError = paths["/fullapp-api/topics/list"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/topics/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/topics/list"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/topics/list"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/topics/list"]["post"]["responses"]["422"]["content"]["application/json"];
type TopicsListFullappApiTopicsListPostBody = paths["/fullapp-api/topics/list"]["post"]["requestBody"]["content"]["application/json"];
type TopicDetailFullappApiTopicsDetailPostSchema = {
    method: "post";
    url: "/fullapp-api/topics/detail";
    mediaType: [
        "application/json"
    ];
};
type TopicDetailFullappApiTopicsDetailPostParameters = paths["/fullapp-api/topics/detail"]["post"]["parameters"];
type TopicDetailFullappApiTopicsDetailPostData = paths["/fullapp-api/topics/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type TopicDetailFullappApiTopicsDetailPostError = paths["/fullapp-api/topics/detail"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/topics/detail"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/topics/detail"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/topics/detail"]["post"]["responses"]["422"]["content"]["application/json"];
type TopicDetailFullappApiTopicsDetailPostBody = paths["/fullapp-api/topics/detail"]["post"]["requestBody"]["content"]["application/json"];
type QuizDetailFullappApiQuizzesDetailPostSchema = {
    method: "post";
    url: "/fullapp-api/quizzes/detail";
    mediaType: [
        "application/json"
    ];
};
type QuizDetailFullappApiQuizzesDetailPostParameters = paths["/fullapp-api/quizzes/detail"]["post"]["parameters"];
type QuizDetailFullappApiQuizzesDetailPostData = paths["/fullapp-api/quizzes/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type QuizDetailFullappApiQuizzesDetailPostError = paths["/fullapp-api/quizzes/detail"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/quizzes/detail"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/quizzes/detail"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/quizzes/detail"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/quizzes/detail"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/quizzes/detail"]["post"]["responses"]["500"]["content"]["application/json"];
type QuizDetailFullappApiQuizzesDetailPostBody = paths["/fullapp-api/quizzes/detail"]["post"]["requestBody"]["content"]["application/json"];
type GuidesListFullappApiGuidesListPostSchema = {
    method: "post";
    url: "/fullapp-api/guides/list";
    mediaType: [
        "application/json"
    ];
};
type GuidesListFullappApiGuidesListPostParameters = paths["/fullapp-api/guides/list"]["post"]["parameters"];
type GuidesListFullappApiGuidesListPostData = paths["/fullapp-api/guides/list"]["post"]["responses"]["200"]["content"]["application/json"];
type GuidesListFullappApiGuidesListPostError = paths["/fullapp-api/guides/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/guides/list"]["post"]["responses"]["422"]["content"]["application/json"];
type GuidesListFullappApiGuidesListPostBody = paths["/fullapp-api/guides/list"]["post"]["requestBody"]["content"]["application/json"];
type GuidesDetailFullappApiGuidesDetailPostSchema = {
    method: "post";
    url: "/fullapp-api/guides/detail";
    mediaType: [
        "application/json"
    ];
};
type GuidesDetailFullappApiGuidesDetailPostParameters = paths["/fullapp-api/guides/detail"]["post"]["parameters"];
type GuidesDetailFullappApiGuidesDetailPostData = paths["/fullapp-api/guides/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type GuidesDetailFullappApiGuidesDetailPostError = paths["/fullapp-api/guides/detail"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/guides/detail"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/guides/detail"]["post"]["responses"]["422"]["content"]["application/json"];
type GuidesDetailFullappApiGuidesDetailPostBody = paths["/fullapp-api/guides/detail"]["post"]["requestBody"]["content"]["application/json"];
type ListCertificatesFullappApiCertificatesListPostSchema = {
    method: "post";
    url: "/fullapp-api/certificates/list";
    mediaType: [
        "application/json"
    ];
};
type ListCertificatesFullappApiCertificatesListPostParameters = paths["/fullapp-api/certificates/list"]["post"]["parameters"];
type ListCertificatesFullappApiCertificatesListPostData = paths["/fullapp-api/certificates/list"]["post"]["responses"]["200"]["content"]["application/json"];
type ListCertificatesFullappApiCertificatesListPostError = paths["/fullapp-api/certificates/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/certificates/list"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/certificates/list"]["post"]["responses"]["433"]["content"]["application/json"];
type ListCertificatesFullappApiCertificatesListPostBody = paths["/fullapp-api/certificates/list"]["post"]["requestBody"]["content"]["application/json"];
type AwardCertificateFullappApiCertificatesAwardPostSchema = {
    method: "post";
    url: "/fullapp-api/certificates/award";
    mediaType: [
        "application/json"
    ];
};
type AwardCertificateFullappApiCertificatesAwardPostParameters = paths["/fullapp-api/certificates/award"]["post"]["parameters"];
type AwardCertificateFullappApiCertificatesAwardPostData = paths["/fullapp-api/certificates/award"]["post"]["responses"]["200"]["content"]["application/json"];
type AwardCertificateFullappApiCertificatesAwardPostError = paths["/fullapp-api/certificates/award"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/certificates/award"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/certificates/award"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/certificates/award"]["post"]["responses"]["433"]["content"]["application/json"];
type AwardCertificateFullappApiCertificatesAwardPostBody = paths["/fullapp-api/certificates/award"]["post"]["requestBody"]["content"]["application/json"];
type TopicMarkCompleteFullappApiTopicsMarkCompletePostSchema = {
    method: "post";
    url: "/fullapp-api/topics/mark_complete";
    mediaType: [
        "application/json"
    ];
};
type TopicMarkCompleteFullappApiTopicsMarkCompletePostParameters = paths["/fullapp-api/topics/mark_complete"]["post"]["parameters"];
type TopicMarkCompleteFullappApiTopicsMarkCompletePostData = paths["/fullapp-api/topics/mark_complete"]["post"]["responses"]["200"]["content"]["application/json"];
type TopicMarkCompleteFullappApiTopicsMarkCompletePostError = paths["/fullapp-api/topics/mark_complete"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/topics/mark_complete"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/topics/mark_complete"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/topics/mark_complete"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/topics/mark_complete"]["post"]["responses"]["422"]["content"]["application/json"];
type TopicMarkCompleteFullappApiTopicsMarkCompletePostBody = paths["/fullapp-api/topics/mark_complete"]["post"]["requestBody"]["content"]["application/json"];
type SubmitQuizFullappApiQuizzesSubmitPostSchema = {
    method: "post";
    url: "/fullapp-api/quizzes/submit";
    mediaType: [
        "application/json"
    ];
};
type SubmitQuizFullappApiQuizzesSubmitPostParameters = paths["/fullapp-api/quizzes/submit"]["post"]["parameters"];
type SubmitQuizFullappApiQuizzesSubmitPostData = paths["/fullapp-api/quizzes/submit"]["post"]["responses"]["200"]["content"]["application/json"];
type SubmitQuizFullappApiQuizzesSubmitPostError = paths["/fullapp-api/quizzes/submit"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/quizzes/submit"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/quizzes/submit"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/quizzes/submit"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/quizzes/submit"]["post"]["responses"]["420"]["content"]["application/json"] | paths["/fullapp-api/quizzes/submit"]["post"]["responses"]["422"]["content"]["application/json"];
type SubmitQuizFullappApiQuizzesSubmitPostBody = paths["/fullapp-api/quizzes/submit"]["post"]["requestBody"]["content"]["application/json"];
type CourseUnlockFullappApiCoursesUnlockPostSchema = {
    method: "post";
    url: "/fullapp-api/courses/unlock";
    mediaType: [
        "application/json"
    ];
};
type CourseUnlockFullappApiCoursesUnlockPostParameters = paths["/fullapp-api/courses/unlock"]["post"]["parameters"];
type CourseUnlockFullappApiCoursesUnlockPostData = paths["/fullapp-api/courses/unlock"]["post"]["responses"]["200"]["content"]["application/json"];
type CourseUnlockFullappApiCoursesUnlockPostError = paths["/fullapp-api/courses/unlock"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/courses/unlock"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/courses/unlock"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/courses/unlock"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/courses/unlock"]["post"]["responses"]["422"]["content"]["application/json"];
type CourseUnlockFullappApiCoursesUnlockPostBody = paths["/fullapp-api/courses/unlock"]["post"]["requestBody"]["content"]["application/json"];
type ListBiblesFullappApiBiblesListPostSchema = {
    method: "post";
    url: "/fullapp-api/bibles/list";
};
type ListBiblesFullappApiBiblesListPostParameters = paths["/fullapp-api/bibles/list"]["post"]["parameters"];
type ListBiblesFullappApiBiblesListPostData = paths["/fullapp-api/bibles/list"]["post"]["responses"]["200"]["content"]["application/json"];
type ListBiblesFullappApiBiblesListPostError = paths["/fullapp-api/bibles/list"]["post"]["responses"]["422"]["content"]["application/json"];
type ListBiblesFullappApiBiblesListPostBody = undefined;
type GetChaptersFullappApiBiblesChaptersPostSchema = {
    method: "post";
    url: "/fullapp-api/bibles/chapters";
    mediaType: [
        "application/json"
    ];
};
type GetChaptersFullappApiBiblesChaptersPostParameters = {
    query?: never;
    header?: never;
    path?: never;
};
type GetChaptersFullappApiBiblesChaptersPostData = paths["/fullapp-api/bibles/chapters"]["post"]["responses"]["200"]["content"]["application/json"];
type GetChaptersFullappApiBiblesChaptersPostError = paths["/fullapp-api/bibles/chapters"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/bibles/chapters"]["post"]["responses"]["422"]["content"]["application/json"];
type GetChaptersFullappApiBiblesChaptersPostBody = paths["/fullapp-api/bibles/chapters"]["post"]["requestBody"]["content"]["application/json"];
type GetChapterDetailFullappApiChaptersDetailPostSchema = {
    method: "post";
    url: "/fullapp-api/chapters/detail";
    mediaType: [
        "application/json"
    ];
};
type GetChapterDetailFullappApiChaptersDetailPostParameters = {
    query?: never;
    header?: never;
    path?: never;
};
type GetChapterDetailFullappApiChaptersDetailPostData = paths["/fullapp-api/chapters/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type GetChapterDetailFullappApiChaptersDetailPostError = paths["/fullapp-api/chapters/detail"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/chapters/detail"]["post"]["responses"]["422"]["content"]["application/json"];
type GetChapterDetailFullappApiChaptersDetailPostBody = paths["/fullapp-api/chapters/detail"]["post"]["requestBody"]["content"]["application/json"];
type RegisterFullappApiPushNotificationsRegisterPostSchema = {
    method: "post";
    url: "/fullapp-api/push-notifications/register";
    mediaType: [
        "application/json"
    ];
};
type RegisterFullappApiPushNotificationsRegisterPostParameters = paths["/fullapp-api/push-notifications/register"]["post"]["parameters"];
type RegisterFullappApiPushNotificationsRegisterPostData = paths["/fullapp-api/push-notifications/register"]["post"]["responses"]["200"]["content"]["application/json"];
type RegisterFullappApiPushNotificationsRegisterPostError = paths["/fullapp-api/push-notifications/register"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/push-notifications/register"]["post"]["responses"]["422"]["content"]["application/json"];
type RegisterFullappApiPushNotificationsRegisterPostBody = paths["/fullapp-api/push-notifications/register"]["post"]["requestBody"]["content"]["application/json"];
type StatusFullappApiPushNotificationsStatusPostSchema = {
    method: "post";
    url: "/fullapp-api/push-notifications/status";
    mediaType: [
        "application/json"
    ];
};
type StatusFullappApiPushNotificationsStatusPostParameters = paths["/fullapp-api/push-notifications/status"]["post"]["parameters"];
type StatusFullappApiPushNotificationsStatusPostData = paths["/fullapp-api/push-notifications/status"]["post"]["responses"]["200"]["content"]["application/json"];
type StatusFullappApiPushNotificationsStatusPostError = paths["/fullapp-api/push-notifications/status"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/push-notifications/status"]["post"]["responses"]["422"]["content"]["application/json"];
type StatusFullappApiPushNotificationsStatusPostBody = paths["/fullapp-api/push-notifications/status"]["post"]["requestBody"]["content"]["application/json"];
type DeregisterFullappApiPushNotificationsDeregisterPostSchema = {
    method: "post";
    url: "/fullapp-api/push-notifications/deregister";
    mediaType: [
        "application/json"
    ];
};
type DeregisterFullappApiPushNotificationsDeregisterPostParameters = {
    query?: never;
    header?: never;
    path?: never;
};
type DeregisterFullappApiPushNotificationsDeregisterPostData = paths["/fullapp-api/push-notifications/deregister"]["post"]["responses"]["200"]["content"]["application/json"];
type DeregisterFullappApiPushNotificationsDeregisterPostError = paths["/fullapp-api/push-notifications/deregister"]["post"]["responses"]["422"]["content"]["application/json"];
type DeregisterFullappApiPushNotificationsDeregisterPostBody = paths["/fullapp-api/push-notifications/deregister"]["post"]["requestBody"]["content"]["application/json"];
type FetchFullappApiNotificationsFetchPostSchema = {
    method: "post";
    url: "/fullapp-api/notifications/fetch";
    mediaType: [
        "application/json"
    ];
};
type FetchFullappApiNotificationsFetchPostParameters = paths["/fullapp-api/notifications/fetch"]["post"]["parameters"];
type FetchFullappApiNotificationsFetchPostData = paths["/fullapp-api/notifications/fetch"]["post"]["responses"]["200"]["content"]["application/json"];
type FetchFullappApiNotificationsFetchPostError = paths["/fullapp-api/notifications/fetch"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/notifications/fetch"]["post"]["responses"]["422"]["content"]["application/json"];
type FetchFullappApiNotificationsFetchPostBody = paths["/fullapp-api/notifications/fetch"]["post"]["requestBody"]["content"]["application/json"];
type MarkFullappApiNotificationsMarkPostSchema = {
    method: "post";
    url: "/fullapp-api/notifications/mark";
    mediaType: [
        "application/json"
    ];
};
type MarkFullappApiNotificationsMarkPostParameters = paths["/fullapp-api/notifications/mark"]["post"]["parameters"];
type MarkFullappApiNotificationsMarkPostData = paths["/fullapp-api/notifications/mark"]["post"]["responses"]["200"]["content"]["application/json"];
type MarkFullappApiNotificationsMarkPostError = paths["/fullapp-api/notifications/mark"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/notifications/mark"]["post"]["responses"]["422"]["content"]["application/json"];
type MarkFullappApiNotificationsMarkPostBody = paths["/fullapp-api/notifications/mark"]["post"]["requestBody"]["content"]["application/json"];
type MarkUnreadFullappApiNotificationsMarkUnreadPostSchema = {
    method: "post";
    url: "/fullapp-api/notifications/mark_unread";
    mediaType: [
        "application/json"
    ];
};
type MarkUnreadFullappApiNotificationsMarkUnreadPostParameters = paths["/fullapp-api/notifications/mark_unread"]["post"]["parameters"];
type MarkUnreadFullappApiNotificationsMarkUnreadPostData = paths["/fullapp-api/notifications/mark_unread"]["post"]["responses"]["200"]["content"]["application/json"];
type MarkUnreadFullappApiNotificationsMarkUnreadPostError = paths["/fullapp-api/notifications/mark_unread"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/notifications/mark_unread"]["post"]["responses"]["422"]["content"]["application/json"];
type MarkUnreadFullappApiNotificationsMarkUnreadPostBody = paths["/fullapp-api/notifications/mark_unread"]["post"]["requestBody"]["content"]["application/json"];
type MarkByPropsFullappApiNotificationsMarkByPropsPostSchema = {
    method: "post";
    url: "/fullapp-api/notifications/mark_by_props";
    mediaType: [
        "application/json"
    ];
};
type MarkByPropsFullappApiNotificationsMarkByPropsPostParameters = paths["/fullapp-api/notifications/mark_by_props"]["post"]["parameters"];
type MarkByPropsFullappApiNotificationsMarkByPropsPostData = paths["/fullapp-api/notifications/mark_by_props"]["post"]["responses"]["200"]["content"]["application/json"];
type MarkByPropsFullappApiNotificationsMarkByPropsPostError = paths["/fullapp-api/notifications/mark_by_props"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/notifications/mark_by_props"]["post"]["responses"]["422"]["content"]["application/json"];
type MarkByPropsFullappApiNotificationsMarkByPropsPostBody = paths["/fullapp-api/notifications/mark_by_props"]["post"]["requestBody"]["content"]["application/json"];
type DeleteFullappApiNotificationsDeletePostSchema = {
    method: "post";
    url: "/fullapp-api/notifications/delete";
    mediaType: [
        "application/json"
    ];
};
type DeleteFullappApiNotificationsDeletePostParameters = paths["/fullapp-api/notifications/delete"]["post"]["parameters"];
type DeleteFullappApiNotificationsDeletePostData = paths["/fullapp-api/notifications/delete"]["post"]["responses"]["200"]["content"]["application/json"];
type DeleteFullappApiNotificationsDeletePostError = paths["/fullapp-api/notifications/delete"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/notifications/delete"]["post"]["responses"]["422"]["content"]["application/json"];
type DeleteFullappApiNotificationsDeletePostBody = paths["/fullapp-api/notifications/delete"]["post"]["requestBody"]["content"]["application/json"];
type StudentFullappApiDashboardWidgetsStudentPostSchema = {
    method: "post";
    url: "/fullapp-api/dashboard-widgets/student";
    mediaType: [
        "application/json"
    ];
};
type StudentFullappApiDashboardWidgetsStudentPostParameters = paths["/fullapp-api/dashboard-widgets/student"]["post"]["parameters"];
type StudentFullappApiDashboardWidgetsStudentPostData = paths["/fullapp-api/dashboard-widgets/student"]["post"]["responses"]["200"]["content"]["application/json"];
type StudentFullappApiDashboardWidgetsStudentPostError = paths["/fullapp-api/dashboard-widgets/student"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/dashboard-widgets/student"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/dashboard-widgets/student"]["post"]["responses"]["422"]["content"]["application/json"];
type StudentFullappApiDashboardWidgetsStudentPostBody = paths["/fullapp-api/dashboard-widgets/student"]["post"]["requestBody"]["content"]["application/json"];
type StudyGroupFullappApiDashboardWidgetsStudyGroupPostSchema = {
    method: "post";
    url: "/fullapp-api/dashboard-widgets/study_group";
    mediaType: [
        "application/json"
    ];
};
type StudyGroupFullappApiDashboardWidgetsStudyGroupPostParameters = paths["/fullapp-api/dashboard-widgets/study_group"]["post"]["parameters"];
type StudyGroupFullappApiDashboardWidgetsStudyGroupPostData = paths["/fullapp-api/dashboard-widgets/study_group"]["post"]["responses"]["200"]["content"]["application/json"];
type StudyGroupFullappApiDashboardWidgetsStudyGroupPostError = paths["/fullapp-api/dashboard-widgets/study_group"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/dashboard-widgets/study_group"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/dashboard-widgets/study_group"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/dashboard-widgets/study_group"]["post"]["responses"]["433"]["content"]["application/json"];
type StudyGroupFullappApiDashboardWidgetsStudyGroupPostBody = paths["/fullapp-api/dashboard-widgets/study_group"]["post"]["requestBody"]["content"]["application/json"];
type GetStudentDashboardStatsFullappApiDashboardStatsStudentPostSchema = {
    method: "post";
    url: "/fullapp-api/dashboard-stats/student";
    mediaType: [
        "application/json"
    ];
};
type GetStudentDashboardStatsFullappApiDashboardStatsStudentPostParameters = paths["/fullapp-api/dashboard-stats/student"]["post"]["parameters"];
type GetStudentDashboardStatsFullappApiDashboardStatsStudentPostData = paths["/fullapp-api/dashboard-stats/student"]["post"]["responses"]["200"]["content"]["application/json"];
type GetStudentDashboardStatsFullappApiDashboardStatsStudentPostError = paths["/fullapp-api/dashboard-stats/student"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/dashboard-stats/student"]["post"]["responses"]["422"]["content"]["application/json"];
type GetStudentDashboardStatsFullappApiDashboardStatsStudentPostBody = NonNullable<paths["/fullapp-api/dashboard-stats/student"]["post"]["requestBody"]>["content"]["application/json"];
type GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostSchema = {
    method: "post";
    url: "/fullapp-api/dashboard-stats/study_group";
    mediaType: [
        "application/json"
    ];
};
type GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostParameters = paths["/fullapp-api/dashboard-stats/study_group"]["post"]["parameters"];
type GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostData = paths["/fullapp-api/dashboard-stats/study_group"]["post"]["responses"]["200"]["content"]["application/json"];
type GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostError = paths["/fullapp-api/dashboard-stats/study_group"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/dashboard-stats/study_group"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/dashboard-stats/study_group"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/dashboard-stats/study_group"]["post"]["responses"]["433"]["content"]["application/json"];
type GetStudyGroupDashboardStatsFullappApiDashboardStatsStudyGroupPostBody = NonNullable<paths["/fullapp-api/dashboard-stats/study_group"]["post"]["requestBody"]>["content"]["application/json"];
type GetFollowUpRequestsListFullappApiFollowUpRequestsListPostSchema = {
    method: "post";
    url: "/fullapp-api/follow-up-requests/list";
};
type GetFollowUpRequestsListFullappApiFollowUpRequestsListPostParameters = paths["/fullapp-api/follow-up-requests/list"]["post"]["parameters"];
type GetFollowUpRequestsListFullappApiFollowUpRequestsListPostData = paths["/fullapp-api/follow-up-requests/list"]["post"]["responses"]["200"]["content"]["application/json"];
type GetFollowUpRequestsListFullappApiFollowUpRequestsListPostError = paths["/fullapp-api/follow-up-requests/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/follow-up-requests/list"]["post"]["responses"]["422"]["content"]["application/json"];
type GetFollowUpRequestsListFullappApiFollowUpRequestsListPostBody = undefined;
type ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostSchema = {
    method: "post";
    url: "/fullapp-api/follow-up-requests/approve";
    mediaType: [
        "application/json"
    ];
};
type ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostParameters = paths["/fullapp-api/follow-up-requests/approve"]["post"]["parameters"];
type ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostData = paths["/fullapp-api/follow-up-requests/approve"]["post"]["responses"]["200"]["content"]["application/json"];
type ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostError = paths["/fullapp-api/follow-up-requests/approve"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/follow-up-requests/approve"]["post"]["responses"]["422"]["content"]["application/json"];
type ApproveFollowUpRequestFullappApiFollowUpRequestsApprovePostBody = paths["/fullapp-api/follow-up-requests/approve"]["post"]["requestBody"]["content"]["application/json"];
type RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostSchema = {
    method: "post";
    url: "/fullapp-api/follow-up-requests/reject";
    mediaType: [
        "application/json"
    ];
};
type RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostParameters = paths["/fullapp-api/follow-up-requests/reject"]["post"]["parameters"];
type RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostData = paths["/fullapp-api/follow-up-requests/reject"]["post"]["responses"]["200"]["content"]["application/json"];
type RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostError = paths["/fullapp-api/follow-up-requests/reject"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/follow-up-requests/reject"]["post"]["responses"]["422"]["content"]["application/json"];
type RejectFollowUpRequestFullappApiFollowUpRequestsRejectPostBody = paths["/fullapp-api/follow-up-requests/reject"]["post"]["requestBody"]["content"]["application/json"];
type SendFullappApiEncouragementsSendPostSchema = {
    method: "post";
    url: "/fullapp-api/encouragements/send";
    mediaType: [
        "application/json"
    ];
};
type SendFullappApiEncouragementsSendPostParameters = paths["/fullapp-api/encouragements/send"]["post"]["parameters"];
type SendFullappApiEncouragementsSendPostData = paths["/fullapp-api/encouragements/send"]["post"]["responses"]["200"]["content"]["application/json"];
type SendFullappApiEncouragementsSendPostError = paths["/fullapp-api/encouragements/send"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/encouragements/send"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/encouragements/send"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/encouragements/send"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/encouragements/send"]["post"]["responses"]["433"]["content"]["application/json"];
type SendFullappApiEncouragementsSendPostBody = paths["/fullapp-api/encouragements/send"]["post"]["requestBody"]["content"]["application/json"];
type SendIntroductionFullappApiIntroductionsSendPostSchema = {
    method: "post";
    url: "/fullapp-api/introductions/send";
    mediaType: [
        "application/json"
    ];
};
type SendIntroductionFullappApiIntroductionsSendPostParameters = paths["/fullapp-api/introductions/send"]["post"]["parameters"];
type SendIntroductionFullappApiIntroductionsSendPostData = paths["/fullapp-api/introductions/send"]["post"]["responses"]["200"]["content"]["application/json"];
type SendIntroductionFullappApiIntroductionsSendPostError = paths["/fullapp-api/introductions/send"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/introductions/send"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/introductions/send"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/introductions/send"]["post"]["responses"]["433"]["content"]["application/json"] | paths["/fullapp-api/introductions/send"]["post"]["responses"]["500"]["content"]["application/json"];
type SendIntroductionFullappApiIntroductionsSendPostBody = paths["/fullapp-api/introductions/send"]["post"]["requestBody"]["content"]["application/json"];
type SendFullappApiContactSendPostSchema = {
    method: "post";
    url: "/fullapp-api/contact/send";
    mediaType: [
        "application/json"
    ];
};
type SendFullappApiContactSendPostParameters = {
    query?: never;
    header?: never;
    path?: never;
};
type SendFullappApiContactSendPostData = paths["/fullapp-api/contact/send"]["post"]["responses"]["200"]["content"]["application/json"];
type SendFullappApiContactSendPostError = paths["/fullapp-api/contact/send"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/contact/send"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/contact/send"]["post"]["responses"]["433"]["content"]["application/json"];
type SendFullappApiContactSendPostBody = paths["/fullapp-api/contact/send"]["post"]["requestBody"]["content"]["application/json"];
type GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostSchema = {
    method: "post";
    url: "/fullapp-api/study-helpers/current";
};
type GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostParameters = paths["/fullapp-api/study-helpers/current"]["post"]["parameters"];
type GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostData = paths["/fullapp-api/study-helpers/current"]["post"]["responses"]["200"]["content"]["application/json"];
type GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostError = paths["/fullapp-api/study-helpers/current"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/study-helpers/current"]["post"]["responses"]["422"]["content"]["application/json"];
type GetCurrentStudyHelperFullappApiStudyHelpersCurrentPostBody = undefined;
type GetStudyHelperListFullappApiStudyHelpersListPostSchema = {
    method: "post";
    url: "/fullapp-api/study-helpers/list";
};
type GetStudyHelperListFullappApiStudyHelpersListPostParameters = paths["/fullapp-api/study-helpers/list"]["post"]["parameters"];
type GetStudyHelperListFullappApiStudyHelpersListPostData = paths["/fullapp-api/study-helpers/list"]["post"]["responses"]["200"]["content"]["application/json"];
type GetStudyHelperListFullappApiStudyHelpersListPostError = paths["/fullapp-api/study-helpers/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/study-helpers/list"]["post"]["responses"]["422"]["content"]["application/json"];
type GetStudyHelperListFullappApiStudyHelpersListPostBody = undefined;
type FetchFullappApiSearchFetchPostSchema = {
    method: "post";
    url: "/fullapp-api/search/fetch";
    mediaType: [
        "application/json"
    ];
};
type FetchFullappApiSearchFetchPostParameters = paths["/fullapp-api/search/fetch"]["post"]["parameters"];
type FetchFullappApiSearchFetchPostData = paths["/fullapp-api/search/fetch"]["post"]["responses"]["200"]["content"]["application/json"];
type FetchFullappApiSearchFetchPostError = paths["/fullapp-api/search/fetch"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/search/fetch"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/search/fetch"]["post"]["responses"]["433"]["content"]["application/json"];
type FetchFullappApiSearchFetchPostBody = paths["/fullapp-api/search/fetch"]["post"]["requestBody"]["content"]["application/json"];
type ListPreferencesFullappApiPreferencesListPostSchema = {
    method: "post";
    url: "/fullapp-api/preferences/list";
    mediaType: [
        "application/json"
    ];
};
type ListPreferencesFullappApiPreferencesListPostParameters = paths["/fullapp-api/preferences/list"]["post"]["parameters"];
type ListPreferencesFullappApiPreferencesListPostData = paths["/fullapp-api/preferences/list"]["post"]["responses"]["200"]["content"]["application/json"];
type ListPreferencesFullappApiPreferencesListPostError = paths["/fullapp-api/preferences/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/preferences/list"]["post"]["responses"]["422"]["content"]["application/json"];
type ListPreferencesFullappApiPreferencesListPostBody = paths["/fullapp-api/preferences/list"]["post"]["requestBody"]["content"]["application/json"];
type UpdateFullappApiPreferencesUpdatePostSchema = {
    method: "post";
    url: "/fullapp-api/preferences/update";
    mediaType: [
        "application/json"
    ];
};
type UpdateFullappApiPreferencesUpdatePostParameters = paths["/fullapp-api/preferences/update"]["post"]["parameters"];
type UpdateFullappApiPreferencesUpdatePostData = paths["/fullapp-api/preferences/update"]["post"]["responses"]["200"]["content"]["application/json"];
type UpdateFullappApiPreferencesUpdatePostError = paths["/fullapp-api/preferences/update"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/preferences/update"]["post"]["responses"]["422"]["content"]["application/json"];
type UpdateFullappApiPreferencesUpdatePostBody = paths["/fullapp-api/preferences/update"]["post"]["requestBody"]["content"]["application/json"];
type ListThreadsFullappApiThreadsListPostSchema = {
    method: "post";
    url: "/fullapp-api/threads/list";
    mediaType: [
        "application/json"
    ];
};
type ListThreadsFullappApiThreadsListPostParameters = paths["/fullapp-api/threads/list"]["post"]["parameters"];
type ListThreadsFullappApiThreadsListPostData = paths["/fullapp-api/threads/list"]["post"]["responses"]["200"]["content"]["application/json"];
type ListThreadsFullappApiThreadsListPostError = paths["/fullapp-api/threads/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/threads/list"]["post"]["responses"]["422"]["content"]["application/json"];
type ListThreadsFullappApiThreadsListPostBody = paths["/fullapp-api/threads/list"]["post"]["requestBody"]["content"]["application/json"];
type ThreadMessagesFullappApiThreadsMessagesPostSchema = {
    method: "post";
    url: "/fullapp-api/threads/messages";
    mediaType: [
        "application/json"
    ];
};
type ThreadMessagesFullappApiThreadsMessagesPostParameters = paths["/fullapp-api/threads/messages"]["post"]["parameters"];
type ThreadMessagesFullappApiThreadsMessagesPostData = paths["/fullapp-api/threads/messages"]["post"]["responses"]["200"]["content"]["application/json"];
type ThreadMessagesFullappApiThreadsMessagesPostError = paths["/fullapp-api/threads/messages"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/threads/messages"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/threads/messages"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/threads/messages"]["post"]["responses"]["422"]["content"]["application/json"];
type ThreadMessagesFullappApiThreadsMessagesPostBody = paths["/fullapp-api/threads/messages"]["post"]["requestBody"]["content"]["application/json"];
type SearchThreadFullappApiThreadsSearchPostSchema = {
    method: "post";
    url: "/fullapp-api/threads/search";
    mediaType: [
        "application/json"
    ];
};
type SearchThreadFullappApiThreadsSearchPostParameters = paths["/fullapp-api/threads/search"]["post"]["parameters"];
type SearchThreadFullappApiThreadsSearchPostData = paths["/fullapp-api/threads/search"]["post"]["responses"]["200"]["content"]["application/json"];
type SearchThreadFullappApiThreadsSearchPostError = paths["/fullapp-api/threads/search"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/threads/search"]["post"]["responses"]["422"]["content"]["application/json"];
type SearchThreadFullappApiThreadsSearchPostBody = paths["/fullapp-api/threads/search"]["post"]["requestBody"]["content"]["application/json"];
type ComposeThreadFullappApiThreadsComposePostSchema = {
    method: "post";
    url: "/fullapp-api/threads/compose";
    mediaType: [
        "application/json"
    ];
};
type ComposeThreadFullappApiThreadsComposePostParameters = paths["/fullapp-api/threads/compose"]["post"]["parameters"];
type ComposeThreadFullappApiThreadsComposePostData = paths["/fullapp-api/threads/compose"]["post"]["responses"]["200"]["content"]["application/json"];
type ComposeThreadFullappApiThreadsComposePostError = paths["/fullapp-api/threads/compose"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/threads/compose"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/threads/compose"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/threads/compose"]["post"]["responses"]["422"]["content"]["application/json"];
type ComposeThreadFullappApiThreadsComposePostBody = paths["/fullapp-api/threads/compose"]["post"]["requestBody"]["content"]["application/json"];
type ReplyToThreadFullappApiThreadsReplyPostSchema = {
    method: "post";
    url: "/fullapp-api/threads/reply";
    mediaType: [
        "application/json"
    ];
};
type ReplyToThreadFullappApiThreadsReplyPostParameters = paths["/fullapp-api/threads/reply"]["post"]["parameters"];
type ReplyToThreadFullappApiThreadsReplyPostData = paths["/fullapp-api/threads/reply"]["post"]["responses"]["200"]["content"]["application/json"];
type ReplyToThreadFullappApiThreadsReplyPostError = paths["/fullapp-api/threads/reply"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/threads/reply"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/threads/reply"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/threads/reply"]["post"]["responses"]["422"]["content"]["application/json"];
type ReplyToThreadFullappApiThreadsReplyPostBody = paths["/fullapp-api/threads/reply"]["post"]["requestBody"]["content"]["application/json"];
type DeleteThreadFullappApiThreadsDeletePostSchema = {
    method: "post";
    url: "/fullapp-api/threads/delete";
    mediaType: [
        "application/json"
    ];
};
type DeleteThreadFullappApiThreadsDeletePostParameters = paths["/fullapp-api/threads/delete"]["post"]["parameters"];
type DeleteThreadFullappApiThreadsDeletePostData = paths["/fullapp-api/threads/delete"]["post"]["responses"]["200"]["content"]["application/json"];
type DeleteThreadFullappApiThreadsDeletePostError = paths["/fullapp-api/threads/delete"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/threads/delete"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/threads/delete"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/threads/delete"]["post"]["responses"]["422"]["content"]["application/json"];
type DeleteThreadFullappApiThreadsDeletePostBody = paths["/fullapp-api/threads/delete"]["post"]["requestBody"]["content"]["application/json"];
type HideThreadFullappApiThreadsHidePostSchema = {
    method: "post";
    url: "/fullapp-api/threads/hide";
    mediaType: [
        "application/json"
    ];
};
type HideThreadFullappApiThreadsHidePostParameters = paths["/fullapp-api/threads/hide"]["post"]["parameters"];
type HideThreadFullappApiThreadsHidePostData = paths["/fullapp-api/threads/hide"]["post"]["responses"]["200"]["content"]["application/json"];
type HideThreadFullappApiThreadsHidePostError = paths["/fullapp-api/threads/hide"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/threads/hide"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/threads/hide"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/threads/hide"]["post"]["responses"]["422"]["content"]["application/json"];
type HideThreadFullappApiThreadsHidePostBody = paths["/fullapp-api/threads/hide"]["post"]["requestBody"]["content"]["application/json"];
type MarkThreadReadFullappApiThreadsReadPostSchema = {
    method: "post";
    url: "/fullapp-api/threads/read";
    mediaType: [
        "application/json"
    ];
};
type MarkThreadReadFullappApiThreadsReadPostParameters = paths["/fullapp-api/threads/read"]["post"]["parameters"];
type MarkThreadReadFullappApiThreadsReadPostData = paths["/fullapp-api/threads/read"]["post"]["responses"]["200"]["content"]["application/json"];
type MarkThreadReadFullappApiThreadsReadPostError = paths["/fullapp-api/threads/read"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/threads/read"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/threads/read"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/threads/read"]["post"]["responses"]["422"]["content"]["application/json"];
type MarkThreadReadFullappApiThreadsReadPostBody = paths["/fullapp-api/threads/read"]["post"]["requestBody"]["content"]["application/json"];
type MarkThreadUnreadFullappApiThreadsUnreadPostSchema = {
    method: "post";
    url: "/fullapp-api/threads/unread";
    mediaType: [
        "application/json"
    ];
};
type MarkThreadUnreadFullappApiThreadsUnreadPostParameters = paths["/fullapp-api/threads/unread"]["post"]["parameters"];
type MarkThreadUnreadFullappApiThreadsUnreadPostData = paths["/fullapp-api/threads/unread"]["post"]["responses"]["200"]["content"]["application/json"];
type MarkThreadUnreadFullappApiThreadsUnreadPostError = paths["/fullapp-api/threads/unread"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/threads/unread"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/threads/unread"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/threads/unread"]["post"]["responses"]["422"]["content"]["application/json"];
type MarkThreadUnreadFullappApiThreadsUnreadPostBody = paths["/fullapp-api/threads/unread"]["post"]["requestBody"]["content"]["application/json"];
type AddFullappApiCannedResponsesAddPostSchema = {
    method: "post";
    url: "/fullapp-api/canned-responses/add";
    mediaType: [
        "application/json"
    ];
};
type AddFullappApiCannedResponsesAddPostParameters = paths["/fullapp-api/canned-responses/add"]["post"]["parameters"];
type AddFullappApiCannedResponsesAddPostData = paths["/fullapp-api/canned-responses/add"]["post"]["responses"]["200"]["content"]["application/json"];
type AddFullappApiCannedResponsesAddPostError = paths["/fullapp-api/canned-responses/add"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/canned-responses/add"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/canned-responses/add"]["post"]["responses"]["433"]["content"]["application/json"];
type AddFullappApiCannedResponsesAddPostBody = paths["/fullapp-api/canned-responses/add"]["post"]["requestBody"]["content"]["application/json"];
type FetchFullappApiCannedResponsesFetchPostSchema = {
    method: "post";
    url: "/fullapp-api/canned-responses/fetch";
    mediaType: [
        "application/json"
    ];
};
type FetchFullappApiCannedResponsesFetchPostParameters = paths["/fullapp-api/canned-responses/fetch"]["post"]["parameters"];
type FetchFullappApiCannedResponsesFetchPostData = paths["/fullapp-api/canned-responses/fetch"]["post"]["responses"]["200"]["content"]["application/json"];
type FetchFullappApiCannedResponsesFetchPostError = paths["/fullapp-api/canned-responses/fetch"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/canned-responses/fetch"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/canned-responses/fetch"]["post"]["responses"]["433"]["content"]["application/json"];
type FetchFullappApiCannedResponsesFetchPostBody = paths["/fullapp-api/canned-responses/fetch"]["post"]["requestBody"]["content"]["application/json"];
type EditFullappApiCannedResponsesEditPostSchema = {
    method: "post";
    url: "/fullapp-api/canned-responses/edit";
    mediaType: [
        "application/json"
    ];
};
type EditFullappApiCannedResponsesEditPostParameters = paths["/fullapp-api/canned-responses/edit"]["post"]["parameters"];
type EditFullappApiCannedResponsesEditPostData = paths["/fullapp-api/canned-responses/edit"]["post"]["responses"]["200"]["content"]["application/json"];
type EditFullappApiCannedResponsesEditPostError = paths["/fullapp-api/canned-responses/edit"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/canned-responses/edit"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/canned-responses/edit"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/canned-responses/edit"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/canned-responses/edit"]["post"]["responses"]["433"]["content"]["application/json"];
type EditFullappApiCannedResponsesEditPostBody = paths["/fullapp-api/canned-responses/edit"]["post"]["requestBody"]["content"]["application/json"];
type DeleteFullappApiCannedResponsesDeletePostSchema = {
    method: "post";
    url: "/fullapp-api/canned-responses/delete";
    mediaType: [
        "application/json"
    ];
};
type DeleteFullappApiCannedResponsesDeletePostParameters = paths["/fullapp-api/canned-responses/delete"]["post"]["parameters"];
type DeleteFullappApiCannedResponsesDeletePostData = paths["/fullapp-api/canned-responses/delete"]["post"]["responses"]["200"]["content"]["application/json"];
type DeleteFullappApiCannedResponsesDeletePostError = paths["/fullapp-api/canned-responses/delete"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/canned-responses/delete"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/canned-responses/delete"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/fullapp-api/canned-responses/delete"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/fullapp-api/canned-responses/delete"]["post"]["responses"]["433"]["content"]["application/json"];
type DeleteFullappApiCannedResponsesDeletePostBody = paths["/fullapp-api/canned-responses/delete"]["post"]["requestBody"]["content"]["application/json"];
type FetchDatatableInfoFullappApiDatatablesFetchPostSchema = {
    method: "post";
    url: "/fullapp-api/datatables/fetch";
    mediaType: [
        "application/json"
    ];
};
type FetchDatatableInfoFullappApiDatatablesFetchPostParameters = paths["/fullapp-api/datatables/fetch"]["post"]["parameters"];
type FetchDatatableInfoFullappApiDatatablesFetchPostData = paths["/fullapp-api/datatables/fetch"]["post"]["responses"]["200"]["content"]["application/json"];
type FetchDatatableInfoFullappApiDatatablesFetchPostError = paths["/fullapp-api/datatables/fetch"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/datatables/fetch"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/datatables/fetch"]["post"]["responses"]["422"]["content"]["application/json"];
type FetchDatatableInfoFullappApiDatatablesFetchPostBody = paths["/fullapp-api/datatables/fetch"]["post"]["requestBody"]["content"]["application/json"];
type DatatableInfoFullappApiDatatablesInfoPostSchema = {
    method: "post";
    url: "/fullapp-api/datatables/info";
    mediaType: [
        "application/json"
    ];
};
type DatatableInfoFullappApiDatatablesInfoPostParameters = paths["/fullapp-api/datatables/info"]["post"]["parameters"];
type DatatableInfoFullappApiDatatablesInfoPostData = paths["/fullapp-api/datatables/info"]["post"]["responses"]["200"]["content"]["application/json"];
type DatatableInfoFullappApiDatatablesInfoPostError = paths["/fullapp-api/datatables/info"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/fullapp-api/datatables/info"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/datatables/info"]["post"]["responses"]["422"]["content"]["application/json"];
type DatatableInfoFullappApiDatatablesInfoPostBody = paths["/fullapp-api/datatables/info"]["post"]["requestBody"]["content"]["application/json"];
type AnnouncementDetailFullappApiAnnouncementsDetailPostSchema = {
    method: "post";
    url: "/fullapp-api/announcements/detail";
};
type AnnouncementDetailFullappApiAnnouncementsDetailPostParameters = paths["/fullapp-api/announcements/detail"]["post"]["parameters"];
type AnnouncementDetailFullappApiAnnouncementsDetailPostData = paths["/fullapp-api/announcements/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type AnnouncementDetailFullappApiAnnouncementsDetailPostError = paths["/fullapp-api/announcements/detail"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/announcements/detail"]["post"]["responses"]["422"]["content"]["application/json"];
type AnnouncementDetailFullappApiAnnouncementsDetailPostBody = undefined;
type AnnouncementUpdateFullappApiAnnouncementsUpdatePostSchema = {
    method: "post";
    url: "/fullapp-api/announcements/update";
    mediaType: [
        "application/json"
    ];
};
type AnnouncementUpdateFullappApiAnnouncementsUpdatePostParameters = paths["/fullapp-api/announcements/update"]["post"]["parameters"];
type AnnouncementUpdateFullappApiAnnouncementsUpdatePostData = paths["/fullapp-api/announcements/update"]["post"]["responses"]["200"]["content"]["application/json"];
type AnnouncementUpdateFullappApiAnnouncementsUpdatePostError = paths["/fullapp-api/announcements/update"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/announcements/update"]["post"]["responses"]["422"]["content"]["application/json"];
type AnnouncementUpdateFullappApiAnnouncementsUpdatePostBody = paths["/fullapp-api/announcements/update"]["post"]["requestBody"]["content"]["application/json"];
type GetSubmissionDetailFullappApiSubmissionsDetailPostSchema = {
    method: "post";
    url: "/fullapp-api/submissions/detail";
    mediaType: [
        "application/json"
    ];
};
type GetSubmissionDetailFullappApiSubmissionsDetailPostParameters = paths["/fullapp-api/submissions/detail"]["post"]["parameters"];
type GetSubmissionDetailFullappApiSubmissionsDetailPostData = paths["/fullapp-api/submissions/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type GetSubmissionDetailFullappApiSubmissionsDetailPostError = paths["/fullapp-api/submissions/detail"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/submissions/detail"]["post"]["responses"]["422"]["content"]["application/json"];
type GetSubmissionDetailFullappApiSubmissionsDetailPostBody = paths["/fullapp-api/submissions/detail"]["post"]["requestBody"]["content"]["application/json"];
type GradeSubmissionFullappApiSubmissionsGradePostSchema = {
    method: "post";
    url: "/fullapp-api/submissions/grade";
    mediaType: [
        "application/json"
    ];
};
type GradeSubmissionFullappApiSubmissionsGradePostParameters = paths["/fullapp-api/submissions/grade"]["post"]["parameters"];
type GradeSubmissionFullappApiSubmissionsGradePostData = paths["/fullapp-api/submissions/grade"]["post"]["responses"]["200"]["content"]["application/json"];
type GradeSubmissionFullappApiSubmissionsGradePostError = paths["/fullapp-api/submissions/grade"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/submissions/grade"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/fullapp-api/submissions/grade"]["post"]["responses"]["422"]["content"]["application/json"];
type GradeSubmissionFullappApiSubmissionsGradePostBody = paths["/fullapp-api/submissions/grade"]["post"]["requestBody"]["content"]["application/json"];
type ListSubmissionsFullappApiSubmissionsListPostSchema = {
    method: "post";
    url: "/fullapp-api/submissions/list";
    mediaType: [
        "application/json"
    ];
};
type ListSubmissionsFullappApiSubmissionsListPostParameters = paths["/fullapp-api/submissions/list"]["post"]["parameters"];
type ListSubmissionsFullappApiSubmissionsListPostData = paths["/fullapp-api/submissions/list"]["post"]["responses"]["200"]["content"]["application/json"];
type ListSubmissionsFullappApiSubmissionsListPostError = paths["/fullapp-api/submissions/list"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/fullapp-api/submissions/list"]["post"]["responses"]["422"]["content"]["application/json"];
type ListSubmissionsFullappApiSubmissionsListPostBody = paths["/fullapp-api/submissions/list"]["post"]["requestBody"]["content"]["application/json"];
